let digitalFloraData = [

  {
    plant: 1,
    "id": "terminalia-arjuna",

    "scientific_name": "Terminalia arjuna ",
    "aname": "(Roxb. ex DC.) Wight & Arn.",

    "common_name": "Arjuna Tree",

    "local_name": "Tella Maddi, Arjun Tree",

    "family": "Combretaceae",

    "image": "/Flora/plant1.jpeg",
    gallery: {

      bark: "/Flora/plant1a.jpeg",
      //leaf: "/Flora/plant1.jpg",
      flower: "/Flora/plant1b.jpeg",
      fruit: "/Flora/plant1c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },
    "qr_url": "https://rukap.edu.in/digital-flora/Terminalia-arjuna",
    'qr_code': '/Flora/qrcodes/Terminalia-arjuna.png',

    "botanical_profile": {
      "scientific_name": "Terminalia arjuna ",
      "aname": "(Roxb. ex DC.) Wight & Arn.",
      "common_name": "Arjuna Tree",
      "local_name": "Tella Maddi, Arjuna Tree",
      "family": "Combretaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Combretaceae",
      "genus": "Terminalia",
      "species": "arjuna"
    },

    "morphological_characters": "T. arjuna is a large deciduous tree with pubescent branchlets. Leaves are alternate to sub-opposite, oblong or obovate-oblanceolate, thick and coriaceous, with 14–16 pairs of parallel nerves. Lamina is glabrous with obtuse to subcordate base, crenate-serrate margin, and obtuse apex. Inflorescence occurs as short axillary spikes or small terminal panicles. Flowers are dull yellow and arranged in panicles of spikes with linear bracteoles. Fruits are drupes, distinctly 5-angled and 5-winged with equal woody wings. The species is commonly found along riverbanks and streams and is also widely planted.",
    "digital_identification": {
      "habit": "Large deciduous tree",
      "branchlets": "Pubescent",
      "leaves": "Alternate to sub-opposite, oblong or obovate-oblanceolate",
      "inflorescence": "Terminal panicle or axillary spike",
      "flowers": "Dull yellow",
      "fruit": "5-winged drupe"
    },

    "phytochemical_constituents": "T. arjuna bark contains several medicinally important phytochemicals including tannins, cardenolides, triterpenoid saponins such as arjunic acid, arjunolic acid, arjungenin, and arjun glycosides. It also contains flavonoids like arjunone, arjunolone, and luteolin, along with gallic acid, ellagic acid, oligomeric proanthocyanidins, and phytosterols.",

    "medicinal_importance": "T. arjuna is a highly valued medicinal plant known especially for its cardioprotective properties. The bark is extensively used in the treatment of coronary artery disease, heart failure, hypertension, and hypercholesterolemia. It exhibits antioxidant, antiviral, antimutagenic, anti-inflammatory, and wound healing activities. The plant is also used traditionally for treating fractures, ulcers, urinary disorders, asthma, tumors, skin diseases, excessive sweating, and intoxication. Bark paste is externally applied for skin ailments and scorpion stings, while fresh leaf juice is used to relieve earache and promote healing.",

    "economic_importance": "T. arjuna is economically important due to its applications in herbal medicine, sericulture, timber production, and environmental management. Its bark is widely used in Ayurvedic formulations for heart-related disorders. Leaves serve as feed for Tasar silkworms, supporting silk production and rural livelihoods. The wood is utilized for furniture, agricultural implements, boats, plywood, fuel, and charcoal. The species is also planted for afforestation, riverbank stabilization, soil conservation, and wasteland development.",

    "conservation_status": {
      "iucn_status": "Least Concern",
      "assessment_year": 2025
    },

    "references": [
      {
        "authors": "Choudhary, M. & Arya, I. D.",
        "year": 2022,
        "title": "A complete review on tissue culture of Terminalia arjuna: A medicinally and economically important tree",
        "journal": "Biological Forum – An International Journal",
        "volume": "14",
        "issue": "1",
        "pages": "495–501"
      },
      {
        "authors": "IUCN SSC Global Tree Specialist Group & Botanic Gardens Conservation International (BGCI)",
        "year": 2025,
        "title": "Terminalia arjuna",
        "source": "The IUCN Red List of Threatened Species 2025"
      },
      {
        "authors": "Naji, A. K., Rasheed, H., Mahmood, R., & Abbas, I. K.",
        "year": 2025,
        "title": "Therapeutic properties of Terminalia arjuna: An overview",
        "journal": "Journal of Asian Multicultural Research for Medical and Health Science Study",
        "volume": "6",
        "issue": "1",
        "pages": "24–31"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Pawan Kumar Scientific Publishers"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  }
  ,
  {
    plant: 2,
    "id": "dalbergia-sissoo",

    "scientific_name": "Dalbergia sissoo ",
    "aname": "Roxb. ex DC.",

    "common_name": "Indian Rosewood",

    "local_name": "Iruguducettu, North Indian Rosewood & Indian dalbergia",

    "family": "Fabaceae",

    "image": "/Flora/plant2.jpeg",
    gallery: {

      bark: "/Flora/plant2a.jpeg",
      // leaf: "/Flora/plant1c.jpg",
      flower: "/Flora/plant2c.jpeg",
      fruit: "/Flora/plant2b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/dalbergia-sissoo",
    'qr_code': '/Flora/qrcodes/Dalbergia-sisso.png',

    "botanical_profile": {
      "scientific_name": "Dalbergia sissoo Roxb. ex DC.",
      "aname": "Roxb. ex DC.",
      "local_name": "Iruguducettu, North Indian Rosewood & Indian dalbergia",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiospermae",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "subfamily": "Papilionoideae",
      "genus": "Dalbergia",
      "species": "Sissoo"
    },

    "morphological_characters": "Habit trees, branchlets pilose. Leaves imparipinnate, leaflets 3-5 alternate, obovate-suborbicular, glabrous, coriaceous, base cuneate, margin entire, and apex cuspidate-acuminate. Inflorescenece is an axillary panicle. Flowers creamish in terminal panicles, stamens 9, monadelphous, ovary pubescent. Legumes oblong, glabrous, apex acute, and apiculate, faintly nerves. Seeds 1 or 2. It is commonly planted as avenue trees.",

    "digital_identification": {
      "habit": "Trees",
      "leaves": "Imparipinnate, leaflets 3-5, alternate",
      "flowers": "Creamish in terminal panicles, stamens 9",
      "legumes": "Oblong, glabrous",
      "seeds": "1 or 2"
    },

    "phytochemical_constituents": "D. sissoo contains a wide range of phytochemicals, mainly flavonoids and neoflavonoids such as dalbergin, dalbergenone, and isoflavones. It also includes tannins, saponins, alkaloids, glycosides, phenolic compounds, coumarins, and quinones. In addition, primary metabolites like proteins, carbohydrates, amino acids, and fatty acids are present.",

    "medicinal_importance": "it possesses significant medicinal importance due to its wide range of pharmacological activities. Various parts of the plant, including leaves, bark, and roots, are traditionally used to treat diarrhea, dysentery, ulcers, skin diseases, and stomach disorders. The plant exhibits anti-inflammatory, analgesic, antimicrobial, antioxidant, and antidiabetic properties.",

    "economic_importance": "it is commonly known as Indian rosewood (Sheesham), is of great economic importance due to its high-quality timber and multiple industrial applications. The wood is hard, durable, and resistant to decay, making it highly valuable in the manufacture of furniture, plywood, construction materials, carvings, and musical instruments.",

    "conservation_status": {
      "iucn_status": "Least Concern",
      "assessment_year": 2019
    },

    "references": [
      {
        "authors": "Lakhey, P., Pathak, J. & Adhikari, B.",
        "year": 2020,
        "title": "Dalbergia sissoo",
        "source": "The IUCN Red List of Threatened Species"
      },
      {
        "authors": "Hossen, M. F., Nijhu, R. S., & Khatun, A.",
        "year": 2023,
        "title": "A phytochemical and pharmacological review on Dalbergia sissoo: A potential medicinal plant",
        "journal": "Journal of Pharmacognosy and Phytochemistry"
      }
    ]
  }
  ,
  {
    plant: 3,
    "id": "cassia-fistula",

    "scientific_name": "Cassia fistula ",
    "aname": "L.",

    "common_name": "Golden Shower Tree",

    "local_name": "Rela Chettu, Golden Shower Tree",

    "family": "Fabaceae",

    "image": "/Flora/plant 3.jpeg",
    gallery: {

      bark: "/Flora/plant 3a.jpeg",
      //leaf: "/Flora/plant1.jpg",
      flower: "/Flora/plant 3b.jpeg",
      fruit: "/Flora/plant 3c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Cassia-fistula",
    'qr_code': '/Flora/qrcodes/Cassia-fistula.png',
   

    "botanical_profile": {
      "scientific_name": "Cassia fistula",
      "aname": "L.",
      "common_name": "Golden Shower Tree",
      "local_name": "Rela Chettu, Golden Shower Tree",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "subfamily": "Caesalpinioideae",
      "genus": "Cassia",
      "species": "fistula"
    },

    "morphological_characters": "C. fistula is a medium-sized deciduous tree with glabrous branches. Leaves are alternate and paripinnately compound with 4–8 opposite pairs of leaflets. Leaflets are oblong to broadly ovate, thick and coriaceous, with distinctly plaited and arching nerves, glabrous upper surface, and pubescent lower surface, subacute to cuneate base, entire margin, and gradually tapering emarginate apex. Flowers are bright golden-yellow and borne in long, lax, pendulous branched racemes measuring about 20–40 cm. Fruits are cylindrical, indehiscent pods, dark blackish-brown in colour, about 40 × 4 cm in size, containing numerous orbicular and flattened seeds. The species is commonly cultivated in gardens and avenue plantations and also occurs in deciduous forests.",

    "digital_identification": {
      "habit": "Medium-sized deciduous tree",
      "branches": "Glabrous",
      "leaves": "Alternate, paripinnately compound",
      "leaflets": "Opposite, oblong, coriaceous, glabrous above and pubescent below",
      "flowers": "Bright golden-yellow, pendulous branched racemes",
      "fruits": "Cylindrical indehiscent pods, dark blackish-brown",
      "seeds": "Orbicular and flattened"
    },

    "phytochemical_constituents": "C. fistula contains a wide range of primary and secondary metabolites including phenolic compounds, anthraquinones such as chrysophanol and rhein derivatives, flavonoids like kaempferol, flavan-3-ols, proanthocyanidins, tannins, polyphenols, glycosides, fatty acids, amino acids, phytosterols including β-sitosterol, terpenoids, and long-chain hydrocarbons. These compounds occur in different plant parts such as pods, seeds, bark, leaves, and flowers.",

    "medicinal_importance": "C. fistula possesses diverse medicinal properties and is widely used in traditional medicine. It acts as a mild laxative and purgative, particularly safe for children, and is used in treating intestinal disorders and ulcers. The plant exhibits antioxidant, anti-inflammatory, antimicrobial, anticarcinogenic, neuroprotective, and cardioprotective activities. It also demonstrates leukotriene biosynthesis inhibition and is beneficial in managing oxidative stress-related disorders.",

    "economic_importance": "C. fistula is extensively cultivated as an ornamental tree because of its attractive golden-yellow flowers. It is widely utilized in herbal medicine and pharmaceutical preparations. Plant extracts are used as natural antioxidants in food systems and in agricultural pest and disease management. The fruits and pulp are nutritious and rich in carbohydrates and minerals. Due to its ornamental, medicinal, nutritional, and agricultural uses, the species has considerable economic value.",

    "conservation_status": {
      "iucn_status": "Least Concern",
      "assessment_year": 2018
    },

    "references": [
      {
        "authors": "Bahorun, T., Neergheen, V. S., & Aruoma, O. I.",
        "year": 2005,
        "title": "Phytochemical constituents of Cassia fistula",
        "journal": "African Journal of Biotechnology",
        "volume": "4",
        "issue": "13",
        "pages": "1530–1540"
      },
      {
        "authors": "Botanic Gardens Conservation International & IUCN SSC Global Tree Specialist Group",
        "year": 2018,
        "title": "Cassia fistula",
        "source": "The IUCN Red List of Threatened Species 2018"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers"
      }
    ]
  }
  ,
  {
    plant: 4,
    "id": "Pterocarpus-santalinus",

    "scientific_name": " Pterocarpus-santalinus ",
    "aname": "Linn. f.",

    "common_name": "Red Sandalwood",

    "local_name": "Erra Chandanamu",

    "family": "Fabaceae",

    image: "/Flora/plant 4.jpeg",
    gallery: {

      bark: "/Flora/plant 4b.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant 4a.jpeg",
      fruit: "/Flora/plant 4c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },
    "qr_url": "https://rukap.edu.in/digital-flora/Pterocarpus-santalinus",
    'qr_code': '/Flora/qrcodes/Pterocarpus-santalinus.png',

    "botanical_profile": {
      "scientific_name": "Pterocarpus santalinus ",
      "aname": "Linn. f.",
      "common_name": "Red Sandalwood",
      "local_name": "Erra Chandanamu",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Pterocarpus",
      "species": "santalinus"
    },

    "morphological_characters": "P. santalinus is a tall deciduous tree with deeply cleft brownish-black bark and glabrous branchlets. Leaves are 3-foliolate with ovate-orbicular or oblong leaflets having obtuse to subcordate base, entire margin, and emarginate apex. Inflorescence occurs as simple or sparingly branched racemes with axillary flowers. Fruits are round pods provided with a broad wing. The species is endemic to the hills of Kadapa, Nellore, Chittoor, and Prakasam districts of Andhra Pradesh.",

    "digital_identification": {
      "habit": "Tall deciduous tree",
      "bark": "Deeply cleft, brownish black",
      "leaves": "3-foliolate, oblong leaflets, entire margin",
      "inflorescence": "Simple or sparingly branched racemes",
      "flowers": "Axillary",
      "fruit": "Round pods with broad wing"
    },

    "phytochemical_constituents": "P. santalinus contains diverse phytochemical compounds including alkaloids, phenols, flavonoids, saponins, glycosides, tannins, steroids, triterpenoids, carbohydrates, anthocyanins, and glycerides. Important bioactive compounds include isoflavonoids, terpenoids, phenolic compounds, β-sitosterol, lupeol, epicatechin, santalin A, santalin B, pterocarpol, pterocarptriol, ispterocarpolone, pterocarpin, aurone glycosides, and isoflavone glycosides. Antitumor lignans such as savinin and calocedrin have also been reported.",

    "medicinal_importance": "P. santalinus is widely used in traditional medicine for treating ulcers, eye diseases, vomiting, diabetes, skin diseases, dysentery, hemorrhage, headaches, inflammation, infections, and gastric ulcers. The plant exhibits antihyperglycemic, antipyretic, antioxidant, antimicrobial, anti-inflammatory, anthelmintic, hepatoprotective, gastroprotective, anticancer, antiplasmodial, and wound-healing activities. Wood paste is externally applied for boils, wounds, and skin eruptions, while decoctions are administered internally for gastrointestinal disorders. It is also traditionally used for snake bites and scorpion stings.",

    "economic_importance": "P. santalinus is economically important for its valuable red timber, durability, and fine grain. The wood is extensively used in furniture making, carvings, agricultural implements, and house construction. A special wavy-grained variety is highly prized in Japan for making traditional musical instruments such as the shamisen. The heartwood yields a natural dye called santalin used in foods, cosmetics, textiles, and pharmaceutical preparations. Due to its high commercial demand and restricted distribution, the species is considered economically valuable but endangered.",

    "conservation_status": {
      "iucn_status": "Endangered",
      "assessment_year": 2021
    },

    "references": [
      {
        "authors": "Ahmedullah, M.",
        "year": 2021,
        "title": "Pterocarpus santalinus",
        "source": "The IUCN Red List of Threatened Species 2021"
      },
      {
        "authors": "Arunakumara, K. K. I. U., Walpola, B. C., Subasinghe, S., & Yoon, M. H.",
        "year": 2011,
        "title": "Pterocarpus santalinus Linn. f. (Rath handun): A review of its botany, uses, phytochemistry and pharmacology",
        "journal": "Journal of Applied Biological Chemistry",
        "volume": "54",
        "issue": "4",
        "pages": "495–500"
      },
      {
        "authors": "Azamthulla, M., Balasubramanian, R., & Kavimani, S.",
        "year": 2015,
        "title": "A review on Pterocarpus santalinus Linn.",
        "journal": "World Journal of Pharmaceutical Research",
        "volume": "4",
        "issue": "2",
        "pages": "282–292"
      },
      {
        "authors": "Biswas, T. K., Maity, L. N., & Mukherjee, B.",
        "year": 2004,
        "title": "Wound healing potential of Pterocarpus santalinus Linn: A pharmacological evaluation",
        "journal": "International Journal of Lower Extremity Wounds",
        "volume": "3",
        "issue": "3",
        "pages": "143–150"
      },
      {
        "authors": "Dahat, Y., Saha, P., Mathew, J. T., Chaudhary, S. K., Srivastava, A. K., & Kumar, D.",
        "year": 2021,
        "title": "Traditional uses, phytochemistry and pharmacological attributes of Pterocarpus santalinus and future directions: A review",
        "journal": "Journal of Ethnopharmacology",
        "volume": "276",
        "pages": "114127"
      },
      {
        "authors": "Kumar, D.",
        "year": 2011,
        "title": "Anti-inflammatory, analgesic, and antioxidant activities of methanolic wood extract of Pterocarpus santalinus L.",
        "journal": "Journal of Pharmacology and Pharmacotherapeutics",
        "volume": "2",
        "issue": "3",
        "pages": "200–202"
      },
      {
        "authors": "Narayan, S., Devi, R. S., Srinivasan, P., & Shyamala Devi, C. S.",
        "year": 2005,
        "title": "Pterocarpus santalinus: A traditional herbal drug as a protectant against ibuprofen induced gastric ulcers",
        "journal": "Phytotherapy Research",
        "volume": "19",
        "issue": "11",
        "pages": "958–962"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Pawan Kumar Scientific Publications"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  }
  ,
  {
    plant: 5,
    "id": "Butea-monosperma",

    "scientific_name": "Butea monosperma ",
    "aname": "(Lam.) Taub.",

    "common_name": "Flame of the Forest",

    "local_name": "Moduga",

    "family": "Fabaceae",

    "image": "/Flora/plant 5a.jpeg",
    gallery: {

      bark: "/Flora/plant 5.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Butea-monosperma",
    'qr_code': '/Flora/qrcodes/Butea-monosperma.png',

    "botanical_profile": {
      "scientific_name": "Butea monosperma ",
      "aname": "(Lam.) Taub.",
      "common_name": "Flame of the Forest",
      "local_name": "Moduga",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiospermae",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Butea",
      "species": "monosperma"
    },

    "morphological_characters": "B. monosperma is a medium-sized deciduous tree with rough, fibrous, thick ash-grey bark and densely tomentose branchlets. Leaves are 3-foliolate with rhomboid-ovate leaflets that are velvety on both surfaces, entire, obtuse to retuse at apex, and cuneate at base. Inflorescence occurs as racemes bearing yellowish-red flowers. Fruits are oblong pods measuring about 15 × 4 cm containing obovate seeds. The species occurs occasionally in forests.",

    "digital_identification": {
      "habit": "Medium-sized deciduous tree",
      "bark": "Rough, fibrous, thick and ash-grey",
      "branchlets": "Densely tomentose",
      "leaves": "3-foliolate",
      "leaflets": "Rhomboid-ovate, velvety on both surfaces, cuneate base",
      "inflorescence": "Racemes",
      "flowers": "Yellowish-red",
      "fruit": "Oblong pods",
      "seed": "Obovate"
    },

    "phytochemical_constituents": "B. monosperma contains numerous bioactive phytochemical compounds including flavonoids such as palasitrin, prunetin, butein, butin, and isobutrin; chalcones and aurones; glycosides like monospermoside and isomonospermoside; phenolic compounds, alkaloids, steroids, amino acids, tannins, saponins, and reducing sugars. Important phytochemicals present in the flowers, bark, seeds, and leaves contribute to the medicinal properties of the plant.",

    "medicinal_importance": "B. monosperma is widely used in traditional medicine for treating inflammation, skin diseases, ulcers, diarrhea, diabetes, parasitic infections, wounds, and liver disorders. The plant exhibits antioxidant, anti-inflammatory, antimicrobial, antifungal, antidiabetic, hepatoprotective, antiulcer, antiviral, anticonvulsant, anticancer, anthelmintic, wound-healing, antifertility, and antiestrogenic activities. Flowers are especially valued for antioxidant and wound-healing properties, while seeds are traditionally used as anthelmintic agents.",

    "economic_importance": "B. monosperma is economically important as a multipurpose tree. Flowers are used as a natural dye for fabrics and traditional Holi colors. The gum known as Bengal kino is utilized in pharmaceutical and tanning industries. Wood is used as fuel and for small timber works. Leaves are commonly used for making biodegradable plates and cups and also serve as fodder for livestock. Different plant parts are widely used in herbal medicine preparations, supporting rural and tribal livelihoods.",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2020
    },

    "references": [
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian medicinal plants: An illustrated dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Pathak, J., Lakhey, P., & Adhikari, B.",
        "year": 2020,
        "title": "Butea monosperma",
        "source": "The IUCN Red List of Threatened Species 2020"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Tiwari, P., Verma, R., & Ahirwar, D.",
        "year": 2019,
        "title": "Phytochemical investigation and pharmacological activities of Butea monosperma: A review",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "8",
        "issue": "3",
        "pages": "2100–2105"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool, Andhra Pradesh",
        "publisher": "Bishen Singh Mahendra Pal Singh"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      }
    ]
  }
  ,
  {
    plant: 6,
    "id": "Albizia-lebbeck",

    "scientific_name": "*Albizia lebbeck* ",
    "aname": "(L.) Benth.",

    "common_name": "Indian Siris",

    "local_name": "Dirisena Chettu",

    "family": "Fabaceae",

    "image": "/Flora/plant6.jpeg",
    gallery: {

      bark: "/Flora/plant6a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant6b.jpeg",
      fruit: "/Flora/plant6c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Albizia-lebbeck",
    'qr_code': '/Flora/qrcodes/Albizia-lebbeck.png',

    "botanical_profile": {
      "scientific_name": "*Albizia lebbeck* ",
      "aname": "(L.) Benth.",
      "common_name": "Indian Siris",
      "local_name": "Dirisena Chettu, Women’s tongue tree",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "sub_family": "Mimosoideae",
      "genus": "Albizia",
      "species": "lebbeck"
    },

    "morphological_characters": "A. lebbeck is a large deciduous tree with puberulous to glabrous branchlets. Leaves are bipinnate, 15–25 cm long, with a gland near the base of the petiole and another below the uppermost pair of pinnae. Pinnae are usually 2 pairs with 4–8 pairs of oblong to obovate leaflets that are glabrous above and pubescent beneath. Inflorescence is axillary, pedunculate, and arranged in globular clusters. Flowers are white to cream-colored and fragrant. Pods are oblong or elliptic, flat, compressed, glabrous, yellow, and slightly reticulate above the seeds. Seeds are spherical or reniform, smooth, glabrous, and yellowish-brown. The species is commonly cultivated, naturalized in plains districts, and widely planted as an avenue tree along roadsides (Pullaiah et al., 1997; Gamble, 1935; Kirtikar & Basu, 2006).",

    "digital_identification": {
      "habit": "Large deciduous tree",
      "stem": "Smooth or slightly hairy branches",
      "leaves": "Bipinnate; rachis 15–25 cm long with glands",
      "pinnae": "Usually 2 pairs",
      "leaflets": "4–8 pairs, oblong to obovate, asymmetrical base",
      "leaf_surface": "Glabrous above and pubescent beneath",
      "flowers": "Fragrant, white to cream-colored",
      "inflorescence": "Axillary, pedunculate, globular clusters",
      "fruit": "Flat yellow pods",
      "seed": "4–12 per pod, spherical or reniform"
    },

    "phytochemical_constituents_and_medicinal_importance": "A. lebbeck contains diverse phytochemicals including alkaloids, flavonoids, saponins, phenolics, glycosides, terpenoids, phytosterols, steroids, anthraquinones, tannins, proteins, amino acids, carbohydrates, and reducing sugars. Important compounds reported from different plant parts include budmunchiamines, quercetin, kaempferol, luteolin, isookanin, oleanolic acid, lupeol, albiziasaponins, lebbeckosides, phytol, stigmastadiene, and various fatty acids. Leaves also contain essential oils rich in 2-pentylfuran and geranyl acetone (Balkrishna et al., 2022; Warrier et al., 1993). These phytochemical constituents are responsible for numerous biological and pharmacological activities of the plant. Flavonoids and phenolic compounds mainly contribute to antioxidant, anti-inflammatory, antimicrobial, and anticancer activities, while saponins and glycosides exhibit antiasthmatic, antiallergic, antidiabetic, and hepatoprotective effects. Alkaloids and terpenoids are associated with anticonvulsant, neuroprotective, analgesic, and immunomodulatory properties. Tannins possess antimicrobial, wound-healing, antiulcer, and antidiarrhoeal activities. Due to these diverse pharmacological properties, A. lebbeck is extensively used in Ayurveda, Siddha, and Unani medicine for treating asthma, bronchitis, skin diseases, ulcers, diarrhea, arthritis, allergies, infections, and inflammatory disorders (Gupta et al., 2011; Nadkarni, 2009; Kirtikar & Basu, 2006).",

    "economic_importance": "A. lebbeck is an economically important multipurpose tree widely used in agroforestry systems, avenue plantations, and reforestation programs due to its rapid growth, adaptability, and nitrogen-fixing ability. The wood is used for furniture, plywood, agricultural implements, construction materials, and fuelwood. Leaves and pods serve as livestock fodder, while flowers are valuable for honey production. The bark yields tannins used in local industries and different plant parts are utilized in herbal medicine preparations. The species also contributes to soil fertility improvement, erosion control, and environmental management (Balkrishna et al., 2022; Orwa et al., 2009; Warrier et al., 1993).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2020,
      "details": " A. lebbeck was assessed for The IUCN Red List of Threatened Species in 2019 and categorized as Least Concern due to its wide distribution and stable population (Plummer, 2020)."
    },

    "references": [
      {
        "authors": "Balkrishna, A., Sharma, N., Sharma, V., & Sharma, R. K.",
        "year": 2022,
        "title": "Phytochemical composition and pharmacological significance of Albizia lebbeck: A review",
        "journal": "Journal of Herbal Medicine",
        "volume": "32",
        "pages": "100523"
      },
      {
        "authors": "Gamble, J. S.",
        "year": 1935,
        "title": "Flora of the Presidency of Madras",
        "publisher": "Adlard & Son Ltd."
      },
      {
        "authors": "Gupta, R. S., Kachhawa, J. B. S., & Chaudhary, R.",
        "year": 2011,
        "title": "Phytochemical and pharmacological profile of Albizia lebbeck: A review",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "9",
        "issue": "2",
        "pages": "24–31"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian medicinal plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian materia medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Plummer, J.",
        "year": 2020,
        "title": "Albizia lebbeck",
        "source": "The IUCN Red List of Threatened Species 2020: e.T18435916A18435924"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., Chennaiah, E., Moulali, D. A., & Rao, D. M.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1993,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      }
    ]
  }
  ,
  {
    plant: 7,

    id: "Ficus-benghalensis",

    scientific_name: "Ficus benghalensis ",
    "aname": "L.",
    common_name: "Banyan Tree",

    local_name: "Marri",

    family: "Moraceae",

    image: "/Flora/plant7.jpeg",

    gallery: {
      bark: "/Flora/plant7a.jpeg",
      // leaf: "/plants/Ficus_benghalensis/leaf.jpg",
      //flower: "/plants/Ficus_benghalensis/flower.jpg",
      fruit: "/Flora/plant7c.jpeg",
      //seed: "/plants/Ficus_benghalensis/seed.jpg",
      aerialroots: "/Flora/plant7c.jpeg",
    },

    qr_url: "https://rukap.edu.in/digital-flora/Ficus-benghalensis",
    'qr_code': '/Flora/qrcodes/Ficus-benghalensis.png',

    botanical_profile: {
      scientific_name: "Ficus benghalensis ",
      "aname": "L.",
      common_name: "Banyan Tree",
      local_name: "Marri",
      family: "Moraceae",
    },

    taxonomic_classification: {
      kingdom: "Plantae",
      division: "Angiosperms",
      class: "Dicotyledonae",
      sub_class: "Monochlamydeae",
      series: "Unisexuales",
      order: "Urticales",
      family: "Moraceae",
      genus: "Ficus",
      species: "benghalensis",
    },

    morphological_characters:
      "F. benghalensis is a very large evergreen tree with a broad spreading crown. The tree produces numerous aerial roots from the trunk and branches. These roots descend into the soil and become supportive trunks, allowing the tree to spread widely and survive for many years. Bark is greyish white and smooth, while young parts are softly pubescent. Leaves are simple, alternate, elliptic-ovate, coriaceous, with rounded to sub-cordate base, entire margin, and obtuse apex. Inflorescence is hypanthodium. Flowers are tiny, unisexual, and enclosed within a fleshy hollow syconium. Fruits are axillary, sessile, globose figs, usually borne in pairs, green when young and red at maturity. The species commonly occurs in plains, forests, village groves, temples, and roadsides throughout India.",

    digital_identification: {
      habit: "Very large evergreen tree",
      trunk: "Massive cylindric trunk with numerous aerial roots",
      bark: "Greyish white, smooth, softly pubescent when young",
      leaves: "Elliptic-ovate, alternate, coriaceous, entire margin",
      inflorescence: "Hypanthodium",
      flowers: "Tiny, unisexual",
      fruit: "Globose figs, axillary, sessile, red when ripe",
    },

    phytochemical_constituents:
      "F. benghalensis contains flavonoids, tannins, phenolic compounds, terpenoids, triterpenoids, sterols, saponins, coumarins, glycosides, carbohydrates, and amino acids. Important bioactive compounds include quercetin, rutin, gallic acid, leucocyanidin, leucopelargonidin, lupeol, β-sitosterol, and bengalenosides.",

    medicinal_importance:
      "F. benghalensis possesses antioxidant, antidiabetic, antimicrobial, anti-inflammatory, wound healing, hepatoprotective, immunomodulatory, anticancer, antiulcer, and antihyperlipidemic activities. Traditionally, the plant is widely used in Ayurveda, Siddha, and Unani systems for treating diabetes, diarrhea, dysentery, asthma, skin diseases, ulcers, infections, and inflammatory disorders.",

    economic_importance:
      "F. benghalensis has high economic importance in pharmaceutical, cosmetic, nutraceutical, and traditional healthcare industries. Different plant parts are used in herbal medicines, Ayurvedic formulations, skincare products, and dietary supplements. The species is also important in nanotechnology for green synthesis of nanoparticles. Additionally, it is widely cultivated as an ornamental and shade tree, contributing to biodiversity conservation, environmental sustainability, carbon sequestration, and cultural heritage.",

    conservation_status: {
      iucn_status: "Not Evaluated",
      assessment_year: null,
      abbreviation: "NE",
      details: "This species has not yet been evaluated by the IUCN Red List."
    },

    references: [
      {
        authors: "Gamble, J. S.",
        year: 1935,
        title: "Flora of the Presidency of Madras",
        publisher: "Adlard & Son Ltd."
      },
      {
        authors: "Pullaiah, T. & Ali Moulali, D.",
        year: 1997,
        title: "Flora of Andhra Pradesh (Vol. 2)",
        publisher: "Pawan Kumar Scientific Publishers"
      },
      {
        authors: "Kirtikar, K. R. & Basu, B. D.",
        year: 1999,
        title: "Indian Medicinal Plants (Vol. 3)",
        publisher: "International Book Distributors"
      },
      {
        authors: "Nadkarni, A. K.",
        year: 2007,
        title: "Indian Materia Medica (Vol. 1)",
        publisher: "Popular Prakashan"
      },
      {
        authors: "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        year: 1996,
        title: "Indian Medicinal Plants: A Compendium of 500 Species (Vol. 3)",
        publisher: "Orient Longman"
      },
      {
        authors: "Sharma, P., Kumar, P., & Singh, R.",
        year: 2019,
        title: "Phytochemical and pharmacological importance of Ficus benghalensis: A review",
        journal: "Journal of Medicinal Plants Studies",
        volume: "7",
        issue: "3",
        pages: "45–50"
      },
      {
        authors: "Singh, P., Dhankhar, J., Kapoor, R. K., Kumar, D., Bhatia, S., Al-Harrasi, A., & Sharma, A.",
        year: 2023,
        title: "Ficus benghalensis—A comprehensive review on pharmacological research, nanotechnological applications, and patents",
        journal: "Journal of Applied Pharmaceutical Science",
        volume: "13",
        issue: "10",
        pages: "59–82"
      },
      {
        authors: "Singh, R., Verma, S., & Kumar, A.",
        year: 2023,
        title: "Phytochemical constituents and therapeutic applications of Ficus benghalensis",
        journal: "International Journal of Pharmaceutical Sciences and Research",
        volume: "14",
        issue: "2",
        pages: "210–218"
      }
    ]
  },
  {
    plant: 8,

    id: "Hardwickia-binata",

    scientific_name: "Hardwickia binata ",
    "aname": "Roxb.",
    common_name: "Indian Blackwood",

    local_name: "Yepi, Narepi",

    family: "Fabaceae",

    image: "/Flora/plant8.jpeg",

    gallery: {
      bark: "/Flora/plant8a.jpeg",
      // leaf: "/plants/Hardwickia_binata/leaf.jpg",
      //flower: "/plants/Hardwickia_binata/flower.jpg",
      fruit: "/Flora/plant8b.jpeg",
      //seed: "/plants/Hardwickia_binata/seed.jpg",
    },

    qr_url: "https://rukap.edu.in/digital-flora/Hardwickia-binata",
    'qr_code': '/Flora/qrcodes/Hardwickia-binata.png',

    botanical_profile: {
      scientific_name: "Hardwickia binata ",
      aname: "Roxb.",
      common_name: "Indian Blackwood",
      local_name: "Yepi, Narepi",
      family: "Fabaceae",
    },

    taxonomic_classification: {
      kingdom: "Plantae",
      division: "Angiospermae",
      class: "Dicotyledonae",
      sub_class: "Polypetalae",
      series: "Calyciflorae",
      order: "Rosales",
      family: "Fabaceae",
      genus: "Hardwickia",
      species: "binata",
    },

    morphological_characters:
      "H. binata is a large deciduous tree with thick dark-grey to greyish-brown bark that is deeply fissured and rough externally. Branchlets are glaucous. Leaves are 2-foliolate with ovate-trapezoid, thick coriaceous and glabrous leaflets having oblique cuneate bases, entire margins and obtuse apices. Flowers are pale yellow and borne in axillary and terminal panicled racemes. Fruits are flattened, winged and glabrous pods containing a single orbicular flattened seed. The species commonly occurs in deciduous forests of Andhra Pradesh and peninsular India.",

    digital_identification: {
      habit: "Large deciduous tree",
      bark: "Dark grey to greyish-brown, deeply fissured and rough",
      branchlets: "Glaucous",
      leaves: "2-foliolate",
      leaflets: "Ovate-trapezoid, coriaceous and glabrous",
      flowers: "Pale yellow",
      inflorescence: "Axillary and terminal panicled racemes",
      fruit: "Flattened, winged and glabrous pod",
      seed: "Single orbicular flattened seed",
    },

    phytochemical_constituents:
      "H. binata contains phenolic compounds, flavonoids, tannins, saponins, glycosides, carbohydrates, proteins, amino acids, steroids, phytosterols, lipids, fixed oils, quinones and volatile oils. Major compounds include β-sitosterol, (+)-catechin, (+)-epicatechin, taxifolin, eriodictyol and the diterpenoid harbinatic acid.",

    medicinal_importance:
      "Different plant parts including bark, leaves, roots and seeds are traditionally used to treat diarrhea, leprosy, indigestion, worm infections, leucorrhoea, chronic cystitis and gonorrhea. Pharmacological studies have reported antimicrobial, antifungal, anti-inflammatory, analgesic, cardioprotective, antitumor and anticancer activities.",

    economic_importance:
      "The species is valued for its extremely hard and durable timber used in agricultural implements, wheel work, furniture, cart making and construction. It is also a source of fibre, resin, balsam and oleo-resin. The bark has heavy-metal adsorption properties, making it useful for environmental applications. It contributes significantly to rural economies and forest-based industries.",

    conservation_status: {
      iucn_status: "Least Concern",
      assessment_year: 2019,
      abbreviation: "LC",
      details:
        "Assessed by the IUCN Red List and categorized as Least Concern because of its wide distribution and stable population.",
    },

    references: [
      {
        authors: "Barstow, M.",
        year: 2019,
        title: "Hardwickia binata",
        source: "The IUCN Red List of Threatened Species 2019",
      },
      {
        authors: "Chopra, R. N., Nayar, S. L., & Chopra, I. C.",
        year: 1956,
        title: "Glossary of Indian Medicinal Plants",
        publisher: "Council of Scientific and Industrial Research",
      },
      {
        authors: "Kirtikar, K. R., & Basu, B. D.",
        year: 1999,
        title: "Indian Medicinal Plants (Vol. 2)",
        publisher: "International Book Distributors",
      },
      {
        authors: "Nadkarni, K. M.",
        year: 2007,
        title: "Indian Materia Medica (Vol. 1)",
        publisher: "Popular Prakashan",
      },
      {
        authors: "Pullaiah, T., & Chennaiah, E.",
        year: 1997,
        title: "Flora of Andhra Pradesh (Vol. 1)",
        publisher: "Scientific Publishers",
      },
      {
        authors: "Reddy, C. S., Reddy, K. N., Jadhav, S. N., & Pattanaik, C.",
        year: 2008,
        title: "Tree Wealth of Andhra Pradesh, India",
        journal: "Journal of Forestry Research",
        volume: "19",
        issue: "3",
        pages: "223–228",
      },
      {
        authors: "Shingade, S. P., & Kakde, R. B.",
        year: 2021,
        title: "A Review on Hardwickia binata Roxb.",
        journal: "Pharmacognosy Reviews",
        volume: "15",
        issue: "29",
        pages: "65–68",
      },
      {
        authors: "Singh, M. P., & Himadri Panda",
        year: 2005,
        title: "Medicinal Herbs with Their Formulations",
        publisher: "Daya Publishing House",
      },
      {
        authors: "The Wealth of India",
        year: 2003,
        title: "Raw Materials (Vol. 5: H–K)",
        publisher: "NISCAIR, CSIR",
      },
      {
        authors: "Varier, P. S.",
        year: 1995,
        title: "Indian Medicinal Plants: A Compendium of 500 Species (Vol. 3)",
        publisher: "Orient Longman",
      },
      {
        authors: "The Wealth of India",
        year: 1972,
        title: "Hardwickia binata Roxb.",
        publisher: "Publications and Information Directorate, CSIR",
      },
    ],
  },
  {
    plant: 9,
    "id": "Leucaena-leucocephala",

    "scientific_name": "Leucaena leucocephala ",
    "aname": "(Lam.) de Wit",

    "common_name": "White Leadtree",

    "local_name": "Subabul",

    "family": "Fabaceae",

    "image": "/Flora/plant9.jpeg",
    gallery: {

      bark: "/Flora/plant9a.jpeg",
      // leaf: "/Flora/plant9/leaf.jpg",
      flower: "/Flora/plant9b.jpeg",
      fruit: "/Flora/plant9c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Leucaena-leucocephala",
    'qr_code': '/Flora/qrcodes/Leucaena-leucocephala.png',

    "botanical_profile": {
      "scientific_name": "Leucaena leucocephala ",
      "aname": "(Lam.) de Wit",
      "common_name": "White Leadtree",
      "local_name": "Subabul",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Leucaena",
      "species": "leucocephala"
    },

    "morphological_characters": "L. leucocephala is a deciduous tree up to 10 m tall or sometimes a large shrub. Leaves are long and bipinnate with 3–8 pairs of pinnae. Leaflets are linear-oblong, membranous, glabrous above and sparsely hairy beneath, with rounded bases, entire margins and acute apices. Inflorescence is capitate or globular. Flowers are white and arranged in globose heads that are usually solitary in the leaf axils. Pods are flat, glabrous, linear-oblong, strap-shaped and pale to dark brown at maturity (Gamble, 1935; Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Deciduous tree or large shrub",
      "leaves": "Long, bipinnate",
      "leaflets": "Linear-oblong, membranous",
      "inflorescence": "Capitate or globular",
      "flowers": "White coloured globose heads",
      "fruit": "Flat, strap-shaped pod",
      "pod_colour": "Pale to dark brown"
    },

    "phytochemical_constituents": "L. leucocephala leaves contain important phytochemicals such as phylobatanins, alkaloids, cardiac glycosides, tannins, flavonoids, saponins and glycosides. The plant is rich in phenolic acids including benzoic acid, gallic acid, caffeic acid, syringic acid, vanillic acid, chlorogenic acid, cinnamic acid, p-hydroxybenzoic acid, p-coumaric acid, o-coumaric acid, ferulic acid, rosmarinic acid and ellagic acid. Major flavonoids include quercetin, myricetin, kaempferol, naringenin, rutin and catechin. Other bioactive compounds such as resveratrol, catechol, pyrogallol, quinol and 3-hydroxytyrosol have also been reported. Additional constituents include steroids, phenols, coumarins, carbohydrates and amino acids which contribute to its pharmacological properties (Elbanoby et al., 2022; Zayed et al., 2016; Kumar et al., 2010).",

    "medicinal_importance": "Due to the presence of diverse phytoconstituents, L. leucocephala possesses significant medicinal properties. Leaf extracts exhibit antioxidant, antimicrobial, anticancer, cancer-preventive, anti-inflammatory, antiarthritic, antiacne, antieczemic, antitumor, diuretic, antiandrogenic and hypocholesterolemic activities. The plant also shows insecticidal, nematicidal and pesticidal properties and is widely studied for its therapeutic applications in traditional and modern medicine (Zayed et al., 2016; Elbanoby et al., 2022; Parrotta, 1992).",

    "economic_importance": "L. leucocephala is an economically important multipurpose agroforestry tree widely cultivated in tropical and subtropical regions. It is mainly used as a high-protein fodder crop that improves livestock growth and milk production. The species enhances soil fertility through biological nitrogen fixation and serves as green manure in sustainable agriculture. Owing to its rapid growth and high biomass production, it is an important source of fuel wood, charcoal and pulpwood. The wood is also utilized for poles, small timber and rural construction. In agroforestry systems, the tree functions as a shade tree, hedge, windbreak and live fence. It also contributes to land reclamation, soil erosion control and carbon sequestration, thereby supporting environmental sustainability and rural economies (Sharma et al., 2022; Parrotta, 1992; National Academy of Sciences, 1984).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "details": "L. leucocephala is not currently listed under any threatened category of the IUCN Red List and is generally considered abundant and widely distributed in tropical and subtropical regions. In several areas, the species is regarded as invasive because of its rapid growth and prolific seed production (Sharma et al., 2022)."
    },

    "references": [
      {
        "authors": "Elbanoby, M. I., Alharthi, S. S., Elbehairi, S. E. I., et al.",
        "year": 2022,
        "title": "Phytochemical profiling and biological activities of Leucaena leucocephala",
        "journal": "Molecules"
      },
      {
        "authors": "Gamble, J. S.",
        "year": 1935,
        "title": "Flora of the Presidency of Madras (Vols. 1–3)",
        "publisher": "Adlard & Son Ltd."
      },
      {
        "authors": "Kumar, A., Dora, J., & Singh, A.",
        "year": 2010,
        "title": "A review on Leucaena leucocephala for pharmacological and toxicological studies",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research"
      },
      {
        "authors": "National Academy of Sciences",
        "year": 1984,
        "title": "Leucaena: Promising forage and tree crop for the tropics",
        "publisher": "National Academy Press"
      },
      {
        "authors": "Parrotta, J. A.",
        "year": 1992,
        "title": "Leucaena leucocephala (Lam.) de Wit. Leguminosae (Mimosoideae)",
        "publisher": "USDA Forest Service, International Institute of Tropical Forestry"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1, p. 358)",
        "publisher": "Pawan Kumar Scientific Publishers"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sharma, P., Kaur, A., Batish, D. R., Kaur, S., & Chauhan, B. S.",
        "year": 2022,
        "title": "Critical insights into the ecological and invasive attributes of Leucaena leucocephala, a tropical agroforestry species",
        "journal": "Frontiers in Agronomy",
        "volume": "4",
        "pages": "890992"
      },
      {
        "authors": "Zayed, M. Z., Eisa, W. H., & Abdel-Moneim, A. M. E.",
        "year": 2016,
        "title": "Phytochemical constituents and biological activities of Leucaena leucocephala",
        "journal": "International Journal of Pharmacognosy and Phytochemical Research"
      }
    ]
  },
  {
    plant: 10,
    "id": "Ficus-religiosa",

    "scientific_name": "Ficus religiosa ",
    "aname": "L.",

    "common_name": "Peepal",

    "local_name": "Ravi, Ragi, Peepal",

    "family": "Moraceae",

    "image": "/Flora/plant10 (1).jpeg",
    gallery: {

      bark: "/Flora/plant10 (3).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant10 (2).jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/ficus-religiosa",
    'qr_code': '/Flora/qrcodes/Ficus-religiosa.png',

    "botanical_profile": {
      "scientific_name": "Ficus religiosa ",
      "aname": "L.",
      "local_name": "Ravi, Ragi, Peepal",
      "family": "Moraceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Monochlamydeae",
      "series": "Unisexuales",
      "order": "Urticales",
      "family": "Moraceae",
      "genus": "Ficus",
      "species": "religiosa"
    },

    "morphological_characters": "Habit large glabrous trees, trunk cylindric; bark greenish. Leaves broadly ovate, narrowed upwards, alternate, base broad rounded or truncate, rarely cordate in young leaves, margin entire, apex produced into a linear lanceolate tail, sub-coriaceous, glabrous on both sides, shining. Fruit figs monoecious, axillary, sessile, paired, obovoid or depressed globose, ripening dark purple or black; fig wall thick. Achenes smooth. It is commonly and widely planted on village sites and in avenues (Pullaiah et al., 1997).",

    "digital_identification": {
      "habit": "Large glabrous tree",
      "bark": "Greenish",
      "leaves": "Ovate, alternate",
      "inflorescence": "Axillary",
      "fruit": "Figs, monoecious and sessile"
    },

    "phytochemical_constituents": "F. religiosa contains a wide variety of bioactive phytochemicals including flavonoids, tannins, phenolic compounds, alkaloids, saponins, glycosides, terpenoids, and steroids. Specific compounds reported include β-sitosterol, β-sitosteryl-D-glucoside, stigmasterol, lanosterol, lupen-3-one, methyl oleanolate, n-octacosanol, and furanocoumarins such as bergapten. Flavonols including quercetin, kaempferol, and myricetin have also been identified, along with proteins, amino acids, carbohydrates, vitamins, and minerals (Joseph & Raj, 2011; Singh et al., 2012; Sonawane et al., 2015; Verma & Gupta, 2015).",

    "medicinal_importance": "F. religiosa is an important medicinal tree widely used in Ayurveda, Siddha, and Unani systems of medicine. Various parts such as bark, leaves, fruits, seeds, roots, and latex are used to treat gastrointestinal disorders, respiratory diseases, skin ailments, fever, ulcers, wounds, heart diseases, and infections. The plant exhibits antioxidant, antimicrobial, anti-inflammatory, antidiabetic, anticonvulsant, wound-healing, immunomodulatory, and neuroprotective activities (Joseph & Raj, 2011; Singh et al., 2012; Sonawane et al., 2015; Verma & Gupta, 2015).",

    "economic_importance": "F. religiosa possesses significant religious, cultural, and economic importance. It is commonly planted near temples, roadsides, parks, and village sites as an ornamental and avenue tree. The species contributes to air purification, shade provision, carbon sequestration, and biodiversity conservation. Plant products are also used in cosmetic preparations, dyes, fodder, and food-related applications (Joseph & Raj, 2011; Singh et al., 2012; Sonawane et al., 2015).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2021,
      "reference": "(Lakhey et al., 2022)"
    },

    "references": [
      {
        "authors": "Joseph, B., & Raj, S. J.",
        "year": 2011,
        "title": "Pharmacognostic and phytochemical properties of Ficus religiosa: An overview",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume_issue": "6(1)",
        "pages": "49–52"
      },
      {
        "authors": "Lakhey et al.",
        "year": 2022,
        "title": "Ficus religiosa",
        "source": "The IUCN Red List of Threatened Species"
      },
      {
        "authors": "Pullaiah, T., Chennaiah, E., & Rao, D. M.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vols. 1–3)",
        "source": "Scientific Publishers"
      },

      {
        "authors": "Singh, D., Chaudhuri, P. K., & Upadhyay, G.",
        "year": 2012,
        "title": "Phytochemical and pharmacological studies of Ficus religiosa",
        "journal": "Journal of Medicinal Plants Research",
        "volume_issue": "6(33)",
        "pages": "4923–4930"
      },
      {
        "authors": "Sonawane, V. C., et al.",
        "year": 2015,
        "title": "Phytochemical and pharmacological profile of Ficus religiosa: A review",
        "journal": "Research Journal of Pharmacognosy and Phytochemistry",
        "volume_issue": "7(4)",
        "pages": "239–245"
      },
      {
        "authors": "Verma, R. S., & Gupta, R. K.",
        "year": 2015,
        "title": "Phytochemical and therapeutic studies on Ficus religiosa",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume_issue": "32(1)",
        "pages": "118–127"

      }
    ]
  },

  {
    plant: 11,
    "id": "bauhinia-purpurea",

    "scientific_name": "Bauhinia purpurea ",
    "aname": "L.",

    "common_name": "Butterfly Tree",

    "local_name": "Mandari, Bodanta & Butterfly Tree",

    "family": "Fabaceae",

    "image": "/Flora/plant11.jpeg",
    gallery: {

      bark: "/Flora/plant11a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant11b.jpeg",
      fruit: "/Flora/plant11c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/bauhinia-purpurea",
    'qr_code': '/Flora/qrcodes/Bauhinia-purpurea.png',

    "botanical_profile": {
      "scientific_name": "Bauhinia purpurea ",
      "aname": "L.",
      "local_name": "Mandari, Bodanta & Butterfly Tree",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Bauhinia",
      "species": "purpurea"
    },

    "morphological_characters": "Habit trees, branchlets warty. Leaves suborbicular, coriaceous, deeply lobed; leaflets oblong, obtuse or subacute at apex, connate about half way up and sometimes overlapping. Flowers rose to pink. Inflorescence terminal or axillary racemes or panicles, stamens 5, fertile only 3. Pods linear, flat, apiculate, reddish-brown, woody, pendent. Seeds 10, globose, smooth, glabrous. It is common in all districts in dry deciduous forests, chiefly along water courses, often cultivated in gardens (Pullaiah & Ali Moulali, 1997).",

    "digital_identification": {
      "habit": "Tree",
      "branches": "Warty",
      "leaves": "Suborbicular, coriaceous and deeply lobed",
      "leaflets": "Oblong, subacute at apex and connate",
      "flowers": "Rose to pink, stamens 5, fertile only 3",
      "inflorescence": "Terminal or axillary racemes",
      "fruit": "Pods, linear, flat, reddish-brown, woody and pendent",
      "seed": "Globose, smooth, glabrous with 10 seeds"
    },

    "phytochemical_constituents": "A wide range of chemical compounds including 5,6-Dihydroxy-7-methoxyflavone 6-O-β-D-xylopyranoside, bis [3’,4’-dihydroxy-6-methoxy-7,8-furano-5’,6’-mono-methylalloxy]-5-C-5-biflavonyl and (4’-hydroxy-7-methyl 3-C-α-L-rhamnopyranosyl)-5-C-5-(4’-hydroxy-7-methyl-3-C-α-D-glucopyranosyl) bioflavonoid, bibenzyls, dibenzooxepins, mixture of phytol fatty esters, lutein, β-sitosterol, isoquercitin and astragalin etc. have been reported from B. purpurea (Kumar & Chandrashekar, 2011; Gupta et al., 2005; Zakaria et al., 2007).",

    "medicinal_importance": "B. purpurea is a species of flowering plant used in several traditional systems of medicine to cure various diseases. This plant has been known to possess antibacterial, antidiabetic, analgesic, anti-inflammatory, anti-diarrheal, anticancerous, nephroprotective, thyroid hormone regulating, wound healing, antioxidant, and antifungal activities (Kumar & Chandrashekar, 2011; Rajkapoor et al., 2006; Zakaria et al., 2007; Warrier et al., 1993; Jain, 1991).",

    "economic_importance": "B. purpurea (Purple Camel’s Foot) holds high economic value as a multi-purpose tree, providing significant medicinal, nutritional, and ornamental benefits. It is widely cultivated as an avenue and ornamental plant because of its attractive pink flowers and adaptability. Various plant parts are also used in traditional medicine and local healthcare systems (Kumar & Chandrashekar, 2011; Kirtikar & Basu, 2006; Nadkarni, 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2025,
      "reference": "(Brewer, 2025)"
    },

    "references": [
      {
        "authors": "Brewer, R.",
        "year": 2025,
        "title": "Bauhinia purpurea",
        "source": "The IUCN Red List of Threatened Species",
        "identifier": "e.T19891953A196017100"
      },
      {
        "authors": "Gupta, M., Mazumder, U. K., Kumar, R. S., Kumar, T. S., & Gomathi, P.",
        "year": 2005,
        "title": "Antioxidant and hepatoprotective effects of Bauhinia purpurea leaf extract",
        "journal": "Asian Pacific Journal of Tropical Medicine",
        "volume_issue": "1(2)",
        "pages": "123–129"
      },
      {
        "authors": "Jain, S. K.",
        "year": 1991,
        "title": "Dictionary of Indian folk medicine and ethnobotany",
        "publisher": "Deep Publications"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian medicinal plants",
        "volume": "Vol. 2",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Kumar, T., & Chandrashekar, K. S.",
        "year": 2011,
        "title": "Bauhinia purpurea Linn.: A review of its ethnobotany, phytochemical and pharmacological profile",
        "journal": "Research Journal of Medicinal Plants",
        "volume_issue": "5(4)",
        "pages": "420–431"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica",
        "volume": "Vol. 1",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "Vol. 2",
        "pages": "329–330",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Rajkapoor, B., Jayakar, B., Murugesh, N., & Sakthisekaran, D.",
        "year": 2006,
        "title": "Chemoprevention and cytotoxic effect of Bauhinia purpurea against N-nitrosodiethylamine induced liver tumors and human cancer cell lines",
        "journal": "Journal of Ethnopharmacology",
        "volume_issue": "104(3)",
        "pages": "407–409"
      },
      {
        "authors": "Sharma, P. C., Yelne, M. B., & Dennis, T. J.",
        "year": 2001,
        "title": "Database on medicinal plants used in Ayurveda",
        "volume": "Vol. 3",
        "publisher": "Central Council for Research in Ayurveda and Siddha"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1993,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "volume": "Vol. 1",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Zakaria, Z. A., Wen, L. Y., Rahman, N. I. A., Ayub, A. H. A., Sulaiman, M. R., & Gopalan, H. K.",
        "year": 2007,
        "title": "Antinociceptive, anti-inflammatory and antipyretic properties of the aqueous extract of Bauhinia purpurea leaves in experimental animals",
        "journal": "Medical Principles and Practice",
        "volume_issue": "16(6)",
        "pages": "443–449"
      }
    ]
  },

  {
    plant: 12,
    "id": "aegle-marmelos",

    "scientific_name": "Aegle marmelos ",
    "aname": "(L.) Corrêa",

    "common_name": "Bael Tree",

    "local_name": "Maredu, Bael",

    "family": "Rutaceae",

    "image": "/Flora/plant12.jpeg",
    gallery: {

      bark: "/Flora/plant12a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant12b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Aegle-marmelos",
    'qr_code': '/Flora/qrcodes/Aegle-marmelos.png',

    "botanical_profile": {
      "scientific_name": "Aegle marmelos ",
      "aname": "(L.) Corrêa",
      "common_name": "Bael Tree",
      "local_name": "Maredu, Bael",
      "family": "Rutaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Rutaceae",
      "genus": "Aegle",
      "species": "marmelos"
    },

    "morphological_characters": "A. marmelos is an armed, densely foliaceous medium-sized tree with pubescent branchlets and straight axillary spines occurring singly or in pairs (Pullaiah & Chennaiah, 1997). Bark is grey-white with longitudinal wrinkles. Leaves are trifoliate, rarely 5-foliolate, with ovate to elliptic leaflets that are glabrous with cuneate or rounded base and obtuse apex (Morton, 1987). Inflorescence occurs as axillary panicles bearing white, fragrant, hermaphrodite flowers. Fruits are large globose or ovoid berries with a hard woody rind enclosing aromatic pulp and numerous compressed seeds (Sharma et al., 2011). The species commonly occurs in forests, temple premises and household backyards throughout India (Sarkar et al., 2020).",

    "digital_identification": {
      "habit": "Medium-sized foliaceous tree",
      "branchlets": "Pubescent, spiny",
      "bark": "Grey-white with wrinkles",
      "leaves": "3-foliolate, ovate to elliptic",
      "inflorescence": "Axillary panicles",
      "flowers": "White, hermaphrodite",
      "fruit": "Globose woody berry",
      "seed": "Numerous, compressed"
    },

    "phytochemical_constituents": "A. marmelos contains diverse phytochemicals including alkaloids, flavonoids, phenolic compounds, terpenoids, tannins, glycosides, carotenoids, coumarins and saponins (Baliga et al., 2011; Sarkar et al., 2020). Important bioactive compounds include aegeline, marmelosin, marmeline, marmesinin, umbelliferone, rutin, lupeol, β-sitosterol, γ-sitosterol, caffeic acid, chlorogenic acid, protocatechuic acid and p-coumaric acid (Maity et al., 2009). Lignan glucosides and oligomeric polyphenols are also reported from bark and fruit pulp (Singh et al., 2011).",

    "medicinal_importance": "A. marmelos is an important medicinal plant extensively used in traditional medicine. Leaves are employed in treating fever, dysentery, dyspepsia, nausea and inflammatory swellings (Sharma et al., 2011). Fruits possess antidiarrhoeal, antimicrobial, gastroprotective, hepatoprotective, cardioprotective and antidiabetic activities (Monika et al., 2023). Unripe fruits are particularly useful against chronic diarrhea and intestinal disorders (Brijesh et al., 2009). Extracts of the plant exhibit antioxidant, anticancer, anti-inflammatory and radioprotective properties due to the presence of flavonoids and phenolic compounds (Baliga et al., 2013; Rahman et al., 2014). Seeds also demonstrate hypolipidemic and antidiabetic effects (Monika et al., 2023).",

    "economic_importance": "A. marmelos has considerable economic importance in food, pharmaceutical and nutraceutical industries. Fruits are consumed fresh and processed into beverages, murabba, candies, jam, powder and dehydrated products (Mahato & Kumar, 2022). Leaves are sacred and widely used in worship rituals dedicated to Lord Shiva. Seed gum possesses adhesive and waterproofing properties useful in industrial applications (Sarkar et al., 2020). The plant is cultivated in temple gardens and home gardens due to its medicinal, cultural and nutritional significance (Baliga et al., 2011).",

    "conservation_status": {
      "IUCN_status": "Near Threatened",
      "assessment_year": 2020,
      "details": "Aegle marmelos was assessed in the IUCN Red List of Threatened Species and categorized as Near Threatened under criteria A2acd (Plummer, 2020)."
    },

    "references": [
      {
        "authors": "Baliga, M. S., Bhat, H. P., Joseph, N., & Fazal, F.",
        "year": 2011,
        "title": "Phytochemistry and medicinal uses of the bael fruit (Aegle marmelos Correa): A concise review",
        "journal": "Food Research International",
        "volume": "44",
        "issue": "7",
        "pages": "1768–1775"
      },
      {
        "authors": "Baliga, M. S., Thilakchand, K. R., Rai, M. P., Rao, S., & Venkatesh, P.",
        "year": 2013,
        "title": "Aegle marmelos (L.) Correa (Bael) and its phytochemicals in the treatment and prevention of cancer",
        "journal": "Integrative Cancer Therapies",
        "volume": "12",
        "issue": "3",
        "pages": "187–196"
      },
      {
        "authors": "Brijesh, S., Daswani, P., Tetali, P., Antia, N., & Birdi, T.",
        "year": 2009,
        "title": "Studies on the antidiarrhoeal activity of Aegle marmelos unripe fruit: Validating its traditional usage",
        "journal": "BMC Complementary and Alternative Medicine",
        "volume": "9",
        "pages": "47"
      },
      {
        "authors": "Mahato, H., & Kumar, B.",
        "year": 2022,
        "title": "Medicinal uses with immense economic potential and nutritional properties of Aegle marmelos: A concise review"
      },
      {
        "authors": "Maity, P., Hansda, D., Bandyopadhyay, U., & Mishra, D. K.",
        "year": 2009,
        "title": "Biological activities of crude extracts and chemical constituents of bael, i(L.) Corr.",
        "journal": "Indian Journal of Experimental Biology",
        "volume": "47",
        "issue": "11",
        "pages": "849–861"
      },
      {
        "authors": "Monika, S., Thirumal, M., & Kumar, P. R.",
        "year": 2023,
        "title": "Phytochemical and biological review of Aegle marmelos Linn.",
        "journal": "Future Science OA",
        "volume": "9",
        "issue": "3",
        "pages": "FSO849"
      },
      {
        "authors": "Morton, J. F.",
        "year": 1987,
        "title": "Bael",
        "source": "Fruits of Warm Climates"
      },
      {
        "authors": "Plummer, J.",
        "year": 2020,
        "title": "Aegle marmelos",
        "source": "The IUCN Red List of Threatened Species 2020"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rahman, S., Parvin, R., Islam, M. R., & Rahman, M. S.",
        "year": 2014,
        "title": "Antioxidant and antibacterial activity of Aegle marmelos leaf extracts",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "4",
        "issue": "Suppl 1",
        "pages": "S163–S166"
      },
      {
        "authors": "Sarkar, T., Salauddin, M., & Chakraborty, R.",
        "year": 2020,
        "title": "In-depth pharmacological and nutritional properties of bael (Aegle marmelos): A critical review",
        "journal": "Journal of Agriculture and Food Research",
        "volume": "2",
        "pages": "100081"
      },
      {
        "authors": "Sharma, G. N., Dubey, S. K., Sati, N., & Sanadya, J.",
        "year": 2011,
        "title": "Medicinal values of bael (Aegle marmelos) (L.) Corr.: A review",
        "journal": "International Journal of Current Pharmaceutical Review and Research",
        "volume": "2",
        "issue": "1",
        "pages": "12–22"
      },
      {
        "authors": "Singh, R., Singh, B., Singh, S., Kumar, N., Kumar, S., & Arora, S.",
        "year": 2011,
        "title": "Umbelliferone – An antioxidant isolated from Aegle marmelos Correa",
        "journal": "Food Chemistry",
        "volume": "120",
        "issue": "3",
        "pages": "825–830"
      }
    ]
  },
  {
    plant: 13,
    "id": "Pongamia-pinnata",

    "scientific_name": "Pongamia pinnata ",
    "aname": "(L.) Pierre",

    "common_name": "Indian Beech Tree",

    "local_name": "Kanuga, Karanja",

    "family": "Fabaceae",

    "image": "/Flora/plant13.jpeg",
    gallery: {

      bark: "/Flora/plant13a.jpeg",
      // leaf: "/Flora/plant13/leaf.jpg",
      flower: "/Flora/plant13b.jpeg",
      fruit: "/Flora/plant13c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Pongamia-pinnata",
    'qr_code': '/Flora/qrcodes/Pongamia-pinnata.png',

    "botanical_profile": {
      "scientific_name": "Pongamia pinnata ",
      "aname": "(L.) Pierre",
      "common_name": "Indian Beech Tree",
      "local_name": "Kanuga, Karanja",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Pongamia",
      "species": "pinnata"
    },

    "morphological_characters": "P. pinnata is an evergreen medium-sized tree with glabrescent branchlets. Leaves are odd-pinnate with 3–5 pairs of opposite ovate-obovate leaflets that are coriaceous, glabrous and glossy above, with obtuse-cuneate base and acuminate apex (Gamble & Fischer, 1918; Pullaiah & Chennaiah, 1997). Inflorescences occur as axillary racemes bearing purplish-white flowers arranged in lax pseudoracemes or panicles (Matthew, 1983). Fruits are obliquely oblong, compressed, woody and indehiscent pods with a short beak (Kirtikar & Basu, 2006). The species commonly occurs along river banks and is widely planted near villages and roadsides throughout India (Pullaiah & Chennaiah, 1997).",

    "digital_identification": {
      "habit": "Evergreen medium-sized tree",
      "branchlets": "Glabrescent",
      "leaves": "Odd-pinnate, ovate-obovate leaflets",
      "leaf_surface": "Glossy and glabrous",
      "inflorescence": "Axillary raceme",
      "flowers": "Purplish-white",
      "fruit": "Woody indehiscent pod",
      "seed": "Compressed"
    },

    "phytochemical_constituents": "P. pinnata contains diverse phytochemicals including flavonoids, furanoflavones, chalcones, flavans, terpenoids, steroids, fatty acids, glycosides and phenolic compounds (Al Muqarrabun et al., 2013). Major bioactive constituents include karanjin, pongamol, pinnatin, kanjone, glabrin, rutin, quercetin and β-sitosterol (Sajid et al., 2012). These phytochemicals are responsible for antioxidant, antimicrobial, anti-inflammatory, antidiabetic and insecticidal activities (Al Muqarrabun et al., 2013).",

    "medicinal_importance": "P. pinnata is widely used in traditional medicine for treating skin diseases, ulcers, piles, diabetes, rheumatism, tumors and wounds (Kirtikar & Basu, 2006). Roots are used in treating gonorrhea, dental infections and skin disorders, while leaves and seeds possess antiseptic and healing properties (Warrier et al., 1995). Scientific studies have demonstrated antimicrobial, antioxidant, anti-inflammatory, antidiabetic, anti-parasitic and cytotoxic activities in various plant extracts (Muqarrabun et al., 2013; Sajid et al., 2012).",

    "economic_importance": "P. pinnata is economically important as a major oil-yielding tree used in biodiesel and biofuel production (Scott et al., 2008). Due to its nitrogen-fixing ability, the plant improves soil fertility and supports sustainable agriculture (Kesari & Rangan, 2010). Wood, seed cake and leaves are useful in farming, traditional medicine and rural industries (Muqarrabun et al., 2013). Plant extracts are also used in the preparation of eco-friendly pesticides and medicinal products (Kirtikar & Basu, 2006).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2012,
      "details": "P. pinnata was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Groom, 2012)."
    },

    "references": [
      {
        "authors": "Al Muqarrabun, L. M. R., Ahmat, N., Ruzaina, S. A. S., Ismail, N. H., & Sahidin, I.",
        "year": 2013,
        "title": "Medicinal uses, phytochemistry and pharmacology of Pongamia pinnata (L.) Pierre: A review",
        "journal": "Journal of Ethnopharmacology",
        "volume": "150",
        "issue": "2",
        "pages": "395–420",
        "doi": "https://doi.org/10.1016/j.jep.2013.08.041"
      },
      {
        "authors": "Gamble, J. S., & Fischer, C. E. C.",
        "year": 1918,
        "title": "Flora of the Presidency of Madras",
        "publisher": "Adlard & Son Ltd."
      },
      {
        "authors": "Groom, A.",
        "year": 2012,
        "title": "Pongamia pinnata",
        "source": "The IUCN Red List of Threatened Species 2012",
        "doi": "https://dx.doi.org/10.2305/IUCN.UK.2012.RLTS.T168724A20129906.en"
      },
      {
        "authors": "Kesari, V., & Rangan, L.",
        "year": 2010,
        "title": "Development of Pongamia pinnata as an alternative biofuel crop: Current status and scope of plantations in India",
        "journal": "Journal of Crop Science and Biotechnology",
        "volume": "13",
        "issue": "3",
        "pages": "127–137",
        "doi": "https://doi.org/10.1007/s12892-010-0013-3"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian medicinal plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Matthew, K. M.",
        "year": 1983,
        "title": "The Flora of the Tamil Nadu Carnatic",
        "publisher": "The Rapinat Herbarium"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Pawan Kumar Scientific Publishers"
      },
      {
        "authors": "Sajid, M., Khan, M. R., Shah, N. A., Shah, S. A., Majid, M., Ismail, H., Younis, T., & Zahra, Z.",
        "year": 2012,
        "title": "Phytochemical, antioxidant and antimicrobial activities of Pongamia pinnata",
        "journal": "African Journal of Pharmacy and Pharmacology",
        "volume": "6",
        "issue": "30",
        "pages": "2220–2229",
        "doi": "https://doi.org/10.5897/AJPP12.642"
      },
      {
        "authors": "Scott, P. T., Pregelj, L., Chen, N., Hadler, J. S., Djordjevic, M. A., & Gresshoff, P. M.",
        "year": 2008,
        "title": "Pongamia pinnata: An untapped resource for the biofuels industry of the future",
        "journal": "BioEnergy Research",
        "volume": "1",
        "issue": "1",
        "pages": "2–11",
        "doi": "https://doi.org/10.1007/s12155-008-9003-0"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 14,
    "id": "Duranta-erecta",

    "scientific_name": "Duranta erecta ",
    "aname": "L.",

    "common_name": "Golden Dewdrop",

    "local_name": "Golden Dewdrop, Sky Flower",

    "image": "/Flora/plant14a (3).jpeg",
    gallery: {

      bark: "/Flora/plant14a (1).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant14a (2).jpeg",
      // fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/ Duranta-erecta ",
    'qr_code': '/Flora/qrcodes/Duranta-erecta.png',

    "botanical_profile": {
      "scientific_name": "Duranta erecta ",
      "aname": "L.",
      "common_name": "Golden Dewdrop",
      "local_name": "Golden Dewdrop, Sky Flower",
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Lamiales",
      "family": "Verbenaceae",
      "genus": "Duranta",
      "species": "erecta"
    },

    "morphological_characters": "D. erecta L. is a small ornamental tree or shrub with young shoots pubescent or sub-glabrous and branches slightly angular. Leaves are obovate-elliptic with cuneate bases, dentate or slightly serrate margins, and acute apices. Inflorescence consists of drooping racemes that are usually terminal and rarely axillary or panicled. Flowers are blue or violet-blue in colour. Calyx is 5-ribbed with small 5-toothed lobes, while corolla lobes are five and unequal. Stamens are four in number. Fruits are globose drupes, about 4–5 mm across, distinctly furrowed and enclosed within an accrescent calyx. The species is commonly cultivated as a hedge plant and often escapes into the wild (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small tree or shrub",
      "bark": "Pubescent or sub-glabrous",
      "branches": "Slightly angular",
      "leaves": "Obovate-elliptic, base cuneate, apex acute",
      "leaf_margin": "Dentate or slightly serrate",
      "inflorescence": "Drooping terminal racemes",
      "flowers": "Blue or violet-blue",
      "calyx": "5-ribbed with small 5-toothed lobes",
      "corolla": "Five unequal lobes",
      "stamens": "4",
      "fruit": "Globose drupe"
    },

    "phytochemical_constituents": "Phytochemical investigations of D. erecta revealed the presence of nearly 64 identified compounds including iridoid glycosides, phenylethanoid glycosides, flavonoids, steroids, phenolics, terpenoids, and saponins. Important bioactive metabolites such as acteoside, durantol, pectolinaringenin, repenins, scutellarein, and repennoside are responsible for several medicinal properties of the plant (Subsongsang & Jiraungkoorskul, 2016; Srivastava & Shanker, 2022).",

    "medicinal_importance": "D. erecta and its major metabolite acteoside possess diverse pharmacological activities including antimalarial, antimicrobial, antioxidant, anticancer, antinephritic, hepatoprotective, neuroprotective, and antiviral effects. Traditionally, the whole plant has been used for treating infertility, neurological disorders, pneumonia, fever, malaria, and parasitic infections. The plant is also employed as a vermifuge, febrifuge, diuretic, and antiparasitic agent in India, Bangladesh, Nigeria, and other tropical countries (Subsongsang & Jiraungkoorskul, 2016; Srivastava & Shanker, 2022; Xiao et al., 2022).",

    "economic_importance": "D. erecta has significant ornamental value and is extensively cultivated in tropical and subtropical regions for landscaping, hedging, and decorative gardening due to its attractive flowers and golden berries. The plant also contributes economically through traditional medicine and herbal industries where its extracts are utilized for various therapeutic purposes. Bioactive compounds such as acteoside have potential applications in phytopharmaceutical and cosmeceutical industries. Certain plant parts are additionally used as natural insect repellents and botanical pesticides in sustainable agriculture (Subsongsang & Jiraungkoorskul, 2016; Srivastava & Shanker, 2022).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "D. erecta was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Botanic Gardens Conservation International, 2019)."
    },

    "references": [
      {
        "authors": "Botanic Gardens Conservation International (BGCI), & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Duranta erecta",
        "source": "The IUCN Red List of Threatened Species 2019",
        "doi": "https://doi.org/10.2305/IUCN.UK.2019-2.RLTS.T145351548A145351550.en"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "publisher": "Scientific Publishers",
        "pages": "743"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Srivastava, M., & Shanker, K.",
        "year": 2022,
        "title": "Duranta erecta Linn: A critical review on phytochemistry, traditional uses, pharmacology, and toxicity from phytopharmaceutical perspective",
        "journal": "Journal of Ethnopharmacology",
        "volume": "293",
        "pages": "115274",
        "doi": "https://doi.org/10.1016/j.jep.2022.115274"
      },
      {
        "authors": "Srivastava, M., Shanker, K., Gupta, M. M., & Khanuja, S. P. S.",
        "year": 2019,
        "title": "Simultaneous quantification of five bioactive phenylethanoid, iridoid, and flavonol glycosides in Duranta erecta L.",
        "journal": "Journal of Pharmaceutical and Biomedical Analysis",
        "volume": "174",
        "pages": "711–717",
        "doi": "https://doi.org/10.1016/j.jpba.2019.06.044"
      },
      {
        "authors": "Subsongsang, R., & Jiraungkoorskul, W.",
        "year": 2016,
        "title": "An updated review on phytochemical properties of Golden Dewdrop (Duranta erecta)",
        "journal": "Pharmacognosy Reviews",
        "volume": "10",
        "issue": "20",
        "pages": "115–117",
        "doi": "https://doi.org/10.4103/0973-7847.194042"
      },
      {
        "authors": "Xiao, Y., Ren, Q., & Wu, L.",
        "year": 2022,
        "title": "The pharmacokinetic properties and pharmacological activities of acteoside: A review",
        "journal": "Biomedicine & Pharmacotherapy",
        "volume": "153",
        "pages": "113296",
        "doi": "https://doi.org/10.1016/j.biopha.2022.113296"
      }
    ]
  },
  {
    plant: 15,
    "id": "Thespesia-populnea",

    "scientific_name": "Thespesia populnea ",
    "aname": "(L.) Sol. ex Corrêa",

    "common_name": "Portia Tree",

    "local_name": "Munigangareni, Portia Tree and Indian Tulip Tree",

    "image": "/Flora/plant15.jpeg",
    gallery: {

      bark: "/Flora/plant15a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant15b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Thespesia-populnea",
    'qr_code': '/Flora/qrcodes/Thespesia-populnea.png',

    "botanical_profile": {
      "scientific_name": "Thespesia populnea ",
      "aname": "(L.) Sol. ex Corrêa",
      "common_name": "Portia Tree",
      "local_name": "Munigangareni, Portia Tree and Indian Tulip Tree",
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Thalamiflorae",
      "order": "Malvales",
      "family": "Malvaceae",
      "genus": "Thespesia",
      "species": "populnea"
    },

    "morphological_characters": "T. populnea is an evergreen tree with cordate leaves that are characteristically 7–9 nerved. Inflorescence is axillary, solitary, or paired. Flowers are yellow and gradually turn purplish-pink when withering. The calyx is tubular with five lobes, while petals are five and obovate in shape. Ovary is 5-locular with three ovules per locule and axile placentation. Stigma is club-shaped and distinctly 5-furrowed. Fruits are globose capsules, five-valved, and become black upon ripening. The species is commonly found in villages, roadsides, parks, and Muslim burial grounds (Pullaiah & Venkata Raju, 1995; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Evergreen tree",
      "root_system": "Tap root system",
      "leaves": "Simple, alternate, cordate and palmate",
      "inflorescence": "Axillary, solitary or paired",
      "flowers": "Yellow, purplish-pink when withering",
      "fruit": "Globose capsule",
      "seed": "Greyish-brown and ovoid"
    },

    "phytochemical_constituents": "T. populnea contains several important phytochemicals such as kaempferol and its glycosides, herbacetin and its glucoside, populneol, populnin, populnatin, quercetin, rutin, gossypetin, gossypol, β-sitosterol and its glucosides. Other reported constituents include lupeol, lupenone, alkanes, myricyl alcohol, sesquiterpenoidal quinones such as mansonone C, D, E, and F, thespone, thespesone, amino acids, and carbohydrates (Varadharajan et al., 2012; Battu Ganga Rao et al., 2018).",

    "medicinal_importance": "T. populnea possesses anti-inflammatory, antibacterial, antioxidant, and wound-healing properties and is traditionally used to treat asthma, cough, skin diseases, dysentery, haemorrhoids, and inflammatory disorders. The yellow sap from young fruits is used against ringworm and other skin infections, while leaves are applied as hot poultices to swollen joints. Roots are used as a tonic, and fruits, flowers, and leaves are externally applied for scabies and psoriasis (Kirtikar & Basu, 1999; Varadharajan et al., 2012; Battu Ganga Rao et al., 2018).",

    "economic_importance": "T. populnea is an economically important multipurpose tree widely cultivated in coastal regions of India. Its wood is durable, termite-resistant, and easy to polish, making it useful for furniture, agricultural implements, boat building, and small canoes. The tree also yields tannin and dye, and several plant parts are used in traditional medicine, contributing to rural livelihoods and forest-based industries (Orwa et al., 2009; Kannan & Warrier, 2023).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2017,
      "details": "T. populnea was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Rivers & Mark, 2017)."
    },

    "references": [
      {
        "authors": "Battu Ganga Rao, B., et al.",
        "year": 2018,
        "title": "Medicinal importance of Thespesia populnea: A review",
        "journal": "Journal of Global Trends in Pharmaceutical Sciences",
        "volume": "9",
        "issue": "1",
        "pages": "4787–4792"
      },
      {
        "authors": "Kannan, C. S., Warrier, R. R., & Muthupandiyan, S.",
        "year": 2023,
        "title": "Economic importance and multipurpose uses of coastal tree species in India",
        "journal": "International Journal of Current Research",
        "volume": "15",
        "issue": "8",
        "pages": "25561–25565"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 1)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., & Venkata Raju, R. R.",
        "year": 1995,
        "title": "Flora of Kurnool",
        "publisher": "Bishen Singh Mahendra Pal Singh",
        "pages": "43"
      },
      {
        "authors": "Rivers, M. C., & Mark, J.",
        "year": 2017,
        "title": "Thespesia populnea",
        "source": "The IUCN Red List of Threatened Species 2017",
        "doi": "https://doi.org/10.2305/IUCN.UK.2017-3.RLTS.T61788175A61788179.en"
      },
      {
        "authors": "Varadharajan, V., et al.",
        "year": 2012,
        "title": "Phytochemical and pharmacological properties of Thespesia populnea: A review",
        "journal": "Research Journal of Pharmaceutical, Biological and Chemical Sciences",
        "volume": "3",
        "issue": "1",
        "pages": "414–422"
      }
    ]
  },
  {
    plant: 16,
    "id": "Delonix-regia",

    "scientific_name": "Delonix regia ",

    "aname": "(Bojer ex Hook.) Raf.",
    "common_name": "Flame Tree",

    "local_name": "Erra Sunkesula, Gulmohar and Flame Tree",

    "image": "/Flora/plant16 (1).jpeg",
    gallery: {

      bark: "/Flora/plant16 (2).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant16 (3).jpeg",
      fruit: "/Flora/plant16 (4).jpeg",
      seed: "/Flora/plant16 (5).jpeg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Delonix-regia",
    'qr_code': '/Flora/qrcodes/Delonix-regia.png',

    "botanical_profile": {
      "scientific_name": "Delonix regia ",
      "aname": "(Bojer ex Hook.) Raf.",
      "common_name": "Flame Tree",
      "local_name": "Erra Sunkesula, Gulmohar and Flame Tree",
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",

      "family": "Fabaceae",
      "sub_family": "Caesalpinioideae",
      "genus": "Delonix",
      "species": "regia"
    },

    "morphological_characters": "D. regia is a deciduous tree with grey to pale-brown bark. Leaves are 10–30 cm long with 8–20 pairs of pinnae and 12–30 pairs of oblong leaflets that are glabrous or nearly so, with oblique bases, entire margins, and obtuse apices. Flowers are bright red and arranged in terminal simple or branched racemes. Fruits are broadly linear woody pods measuring about 25–50 × 3–4 cm, dark-brown or reddish-brown, flat, and beaked. Seeds are oblong, glabrous, smooth, and white or creamy-white in colour. The species is widely planted in gardens and along roadsides for ornamental purposes (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Deciduous tree",
      "bark": "Grey to pale-brown",
      "leaves_leaflets": "Pinnae with oblong leaflets, base oblique, entire margin, apex obtuse",
      "flowers": "Bright red",
      "inflorescence": "Terminal simple or branched racemes",
      "fruit": "Woody dark-brown flat beaked pod",
      "seed": "Oblong, glabrous and smooth"
    },

    "phytochemical_constituents": "Phytochemical screening of D. regia revealed the presence of tannins, terpenoids, alkaloids, glycosides, sterols, flavonoids, carotenoids, anthocyanins, phenolic acids, and saponins. Important bioactive compounds reported from various plant parts include lupeol, epilupeol, β-sitosterol, stigmasterol, p-methoxy benzaldehyde, scopoletin, oleanolic acid acetate, ursolic acid, quercetin, quercitrin, isoquercitrin, rutin, kaempferol, and amino acid L-azetidine-2-carboxylic acid. Flowers contain abundant anthocyanins and carotenoids, while kaempferol and saponins present in leaves contribute to antiulcer and cytotoxic activities (Parekh et al., 2005; Kumar et al., 2010; Shabir et al., 2011; Govindappa et al., 2011; Jain et al., 2021).",

    "medicinal_importance": "D. regia possesses significant medicinal value and exhibits diverse pharmacological activities. Flowers demonstrate antidiarrheal, anthelmintic, antidiuretic, larvicidal, antihemolytic, wound healing, antiarthritic, gastroprotective, antioxidant, and antimicrobial activities due to the presence of flavonoids, anthocyanins, carotenoids, and phenolic compounds. Leaves exhibit antiemetic, antimicrobial, anti-inflammatory, antioxidant, antiulcer, and cytotoxic properties mainly because of kaempferol, tannins, saponins, and other phenolic constituents. Seeds possess nutritional, haemagglutination, and hypoglycemic properties and are rich in proteins, amino acids, fatty acids, and bioactive compounds. Extracts from different plant parts also exhibit analgesic, hepatoprotective, antimalarial, and free radical scavenging activities (Parekh et al., 2005; Govindappa et al., 2011; Shabir et al., 2011; Ahmed et al., 2015; Saroj et al., 2022).",

    "economic_importance": "The wood and large pods of D. regia are used as fuel and possess a calorific value of about 4600 kcal/kg. Flowers provide excellent bee forage for apiculture. The tree yields thick water-soluble gum used in textile and food industries and as a tablet binder in pharmaceutical preparations. Wood is durable, water-resistant, coarse-grained, and suitable for polishing, making it useful for furniture and timber purposes. Seeds are used as decorative beads and yield fatty oil important in tanning industries. The species is extensively planted in tropical and subtropical regions as an ornamental and shade tree in parks, streets, tea plantations, dairy farms, and compounds. It is also utilized as live fence posts, host plants for lac insects, and for soil erosion control in semi-arid regions (Saroj et al., 2022; Orwa et al., 2009; Kirtikar & Basu, 1999; Warrier et al., 1995).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2014,
      "details": "D. regia was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Rivers, 2014)."
    },

    "references": [
      {
        "authors": "Ahmed, F., Rahman, M. M., & Ahmed, N.",
        "year": 2015,
        "title": "Pharmacological activities and medicinal uses of Delonix regia: A review",
        "journal": "International Journal of Pharmaceutical Sciences and Research",
        "volume": "6",
        "issue": "10",
        "pages": "4243–4250"
      },
      {
        "authors": "Govindappa, M., Sadananda, T. S., Channabasava, R., & Raghavendra, V. B.",
        "year": 2011,
        "title": "In vitro anti-inflammatory, lipoxygenase, xanthine oxidase and acetycholinesterase inhibitory activity of Delonix regia extracts",
        "journal": "International Journal of Pharma and Bio Sciences",
        "volume": "2",
        "issue": "2",
        "pages": "1–9"
      },
      {
        "authors": "Jain, S. N., Vaidya, A., Jain, N., & Kumar, V.",
        "year": 2021,
        "title": "Bioactive compounds of Royal Poinciana (Delonix regia (Hook.) Raf.)",
        "source": "Bioactive compounds in underutilized vegetables and legumes",
        "pages": "1–20",
        "publisher": "Springer",
        "doi": "https://doi.org/10.1007/978-3-030-57476-5_1"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 1)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Kumar, R., Patel, D. K., Laloo, D., & Hemalatha, S.",
        "year": 2010,
        "title": "Natural medicines from plant source used for therapy of inflammatory diseases: A review",
        "journal": "International Journal of Phytomedicine",
        "volume": "2",
        "issue": "3",
        "pages": "248–260"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Parekh, J., Karathia, N., & Chanda, S.",
        "year": 2005,
        "title": "Evaluation of antibacterial activity and phytochemical analysis of Delonix regia flower extracts",
        "journal": "International Journal of Green Pharmacy",
        "volume": "1",
        "issue": "2",
        "pages": "79–82"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers",
        "pages": "342"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rivers, M.",
        "year": 2014,
        "title": "Delonix regia",
        "source": "The IUCN Red List of Threatened Species 2014",
        "doi": "https://doi.org/10.2305/IUCN.UK.2014-1.RLTS.T32947A2828337.en"
      },
      {
        "authors": "Saroj, P., Gupta, P. O., & Shah, N.",
        "year": 2022,
        "title": "Delonix regia (Gulmohar): Its ethnobotanical knowledge, phytochemical studies, pharmacological aspects and future prospects",
        "journal": "International Journal of Creative Research Thoughts",
        "volume": "10",
        "issue": "3",
        "pages": "e641–e648"
      },
      {
        "authors": "Shabir, G., Anwar, F., Sultana, B., Khalid, Z. M., Afzal, M., Khan, Q. M., & Ashrafuzzaman, M.",
        "year": 2011,
        "title": "Antioxidant and antimicrobial attributes and phenolics of different solvent extracts from leaves, flowers and bark of Delonix regia",
        "journal": "Molecules",
        "volume": "16",
        "issue": "9",
        "pages": "7302–7319",
        "doi": "https://doi.org/10.3390/molecules16097302"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 2)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 17,
    "id": "Ficus-racemosa",

    "scientific_name": "Ficus racemosa ",

    "aname": "L.",
    "common_name": "Cluster Fig Tree",

    "local_name": "Medi, Atti",

    "image": "/Flora/plant17 (1).jpeg",
    gallery: {

      bark: "/Flora/plant17 (2).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant17 (3).jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Ficus-racemosa",
    'qr_code': '/Flora/qrcodes/Ficus-racemosa.png',

    "botanical_profile": {
      "scientific_name": "Ficus racemosa ",
      "aname": "L.",
      "common_name": "Cluster Fig Tree",
      "local_name": "Medi, Atti",
      
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Monochlamydeae",
      "series": "Unisexuales",
      "family": "Moraceae",
      "genus": "Ficus",
      "species": "racemosa"
    },

    "morphological_characters": "F. racemosa is a large deciduous tree with few or no aerial roots. The trunk is cylindric with smooth, greyish-white bark and white-pilose branchlets. Leaves are elliptic-lanceolate, alternate, with rounded to acute base, entire margins, and acute apex, sub-coriaceous and glabrous on both surfaces. Inflorescence is hypanthodium. Fruits are monoecious figs, cauliflorous, globose, white-pilose, with thick fig walls turning red on ripening. Achenes are lenticular. The species is commonly distributed throughout Andhra Pradesh (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large deciduous tree",
      "bark": "Smooth, greyish white",
      "branchlets": "White-pilose",
      "leaves": "Alternate, elliptic-lanceolate, margin entire",
      "inflorescence": "Hypanthodium",
      "fruit": "Monoecious, cauliflorous, globose figs"
    },

    "phytochemical_constituents": "F. racemosa contains numerous bioactive phytochemicals distributed across different plant parts. Leaves are rich in triterpenoids, tannins, flavonoids such as kaempferol and rutin, saponins, coumarins, phenolic glycosides, bergapten, and psoralen. Fruits contain sterols, triterpenoids, flavonoids, glycosides, tannins, carbohydrates, β-sitosterol, lupeol acetate, gallic acid, and ellagic acid. Stem bark contains alkaloids, steroids, tannins, leucocyanidins, leucopelargonidins, lupeol, stigmasterol, β-sitosterol glucoside, bergenin, and racemosic acid, which contribute to its pharmacological activities (Ahmed & Urooj, 2010; Chaware et al., 2020).",

    "medicinal_importance": "F. racemosa is widely used in Ayurveda and traditional medicine for treating diabetes, diarrhea, dysentery, liver disorders, skin diseases, boils, haemorrhoids, and inflammatory conditions. The plant exhibits antidiabetic, anti-inflammatory, antioxidant, hepatoprotective, antimicrobial, analgesic, antipyretic, antidiarrheal, wound healing, gastroprotective, chemopreventive, antifilarial, and hypotensive activities. Bark, fruits, and latex are therapeutically important and extensively used in herbal formulations (Ahmed & Urooj, 2010; Joseph & Raj, 2011; Chaware et al., 2020).",

    "economic_importance": "F. racemosa possesses considerable economic importance due to its medicinal, nutritional, and commercial applications. The edible fruits are consumed in rural areas and contribute to local food resources. The tree is also used as livestock fodder and serves as a valuable source for herbal and pharmaceutical industries. Latex is used as an adhesive, and the plant supports rural livelihoods through cultivation, trade, and utilization in traditional medicine systems (Ahmed & Urooj, 2010; Joseph & Raj, 2011; Chaware et al., 2020).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2018,
      "details": "Ficus racemosa was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (BGCI & IUCN SSC Global Tree Specialist Group, 2019)."
    },

    "references": [
      {
        "authors": "Ahmed, F., & Urooj, A.",
        "year": 2010,
        "title": "Traditional uses, medicinal properties, and phytopharmacology of Ficus racemosa: A review",
        "journal": "Pharmaceutical Biology",
        "volume": "48",
        "issue": "6",
        "pages": "672–681",
        "doi": "https://doi.org/10.3109/13880200903241861"
      },
      {
        "authors": "Botanic Gardens Conservation International (BGCI) & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Ficus racemosa",
        "source": "The IUCN Red List of Threatened Species 2019",
        "doi": "https://dx.doi.org/10.2305/IUCN.UK.2019-2.RLTS.T145362959A145371147.en"
      },
      {
        "authors": "Chaware, G. K., Kumar, V., Kumar, S., & Kumar, P.",
        "year": 2020,
        "title": "Bioactive compounds, pharmacological activity and food application of Ficus racemosa: A critical review",
        "journal": "International Journal of Fruit Science",
        "volume": "20",
        "issue": "sup2",
        "pages": "S969–S986",
        "doi": "https://doi.org/10.1080/15538362.2020.1774467"
      },
      {
        "authors": "Joseph, B., & Raj, S. J.",
        "year": 2011,
        "title": "Pharmacognostic and phytochemical properties of Ficus racemosa Linn—An overview",
        "journal": "International Journal of PharmTech Research",
        "volume": "3",
        "issue": "3",
        "pages": "1349–1357"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "902"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  },
  {
    plant: 18,
    "id": "Peltophorum-pterocarpum",

    "scientific_name": "Peltophorum pterocarpum ",

    "aname": "(DC.) Backer ex K.Heyne",
    "common_name": "Yellow Flame Tree",

    "local_name": "Pacha Sunkesula, Yellow Flame Tree",

    "image": "/Flora/plant18 (1).jpeg",
    gallery: {

      bark: "/Flora/plant18 (4).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant18 (3).jpeg",
      fruit: "/Flora/plant18 (2).jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Peltophorum-pterocarpum",
    'qr_code': '/Flora/qrcodes/Peltophorum-pterocarpum.png',

    "botanical_profile": {
      "scientific_name": "Peltophorum pterocarpum ",
      "aname": "(DC.) Backer ex K.Heyne",
      "common_name": "Yellow Flame Tree",
      "local_name": "Pacha Sunkesula, Yellow Flame Tree",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "subfamily": "Mimosoideae",
      "genus": "Peltophorum",
      "species": "pterocarpum"
    },

    "morphological_characters": "P. pterocarpum is a medium to large ornamental tree with younger parts covered by rusty-brown or greyish tomentum. Leaves are alternate, bipinnate, about 15 cm long with 6–12 pairs of pinnae and 6–17 pairs of oblong, glabrous leaflets. Flowers are bright yellow and arranged in terminal and axillary reddish-brown panicles measuring 10–35 cm long. Fruits are lanceolate, dark-brown woody pods containing obovate-oblong, compressed, smooth, and glabrous seeds. The species is widely planted as an avenue and ornamental tree (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tree",
      "bark": "Rusty-brown or greyish tomentose",
      "leaves": "Alternate, bipinnate",
      "leaflets": "Oblong and glabrous",
      "flowers": "Bright yellow",
      "inflorescence": "Terminal and axillary reddish-brown panicles",
      "fruit": "Lanceolate, dark-brown woody pods",
      "seed": "Obovate-oblong, compressed and glabrous"
    },

    "phytochemical_constituents": "P. pterocarpum contains a diverse range of bioactive phytochemicals including flavonoids, phenolic compounds, tannins, alkaloids, terpenoids, steroids, saponins, coumarins, amino acids, fatty acids, and aliphatic alcohols. Important sesquiterpenoids such as peltopterins and other secondary metabolites have also been isolated from different plant parts. These phytochemicals contribute significantly to the plant’s pharmacological and therapeutic properties (Jash et al., 2014; Kumar et al., 2019).",

    "medicinal_importance": "P. pterocarpum possesses several medicinal properties and is widely used in traditional systems of medicine. The plant exhibits antimicrobial, antioxidant, anti-inflammatory, antidiabetic, antiulcer, hepatoprotective, cytotoxic, and anticancer activities. Extracts of the bark, leaves, and flowers are traditionally used for the treatment of skin diseases, wounds, dysentery, constipation, ringworm, muscular pain, sores, insomnia, and microbial infections. The antioxidant activity is mainly attributed to its phenolic and flavonoid compounds (Jash et al., 2014; Kumar et al., 2019; Warrier et al., 1996).",

    "economic_importance": "P. pterocarpum is economically important as an ornamental and multipurpose tree species. It is extensively cultivated along roadsides, parks, and gardens because of its attractive bright-yellow flowers. The wood is used for timber, fuelwood, and light construction purposes. The plant is also a source of natural dyes and tannins and has applications in traditional herbal medicine industries. Leaves and flowers are occasionally used as fodder. Due to its rich phytochemical profile and medicinal value, the species has growing importance in pharmaceutical research and drug development (Orwa et al., 2009; Jash et al., 2014).",

    "conservation_status": {
      "iucn_status": "Least Concern",
      "assessment_year": 2023,
      "details": "Peltophorum pterocarpum was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (De Kok, 2024)."
    },

    "references": [
      {
        "authors": "De Kok, R.",
        "year": 2024,
        "title": "Peltophorum pterocarpum",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T176418249A203233433"
      },
      {
        "authors": "Jash, S. K., Singh, R. K., Majhi, S., Sarkar, A., & Gorai, D.",
        "year": 2014,
        "title": "Peltophorum pterocarpum: Chemical and pharmacological aspects",
        "journal": "International Journal of Pharmaceutical Sciences and Research",
        "volume": "5",
        "issue": "1",
        "pages": "26–36"
      },
      {
        "authors": "Kumar, S., Kumar, V., & Prakash, O.",
        "year": 2019,
        "title": "Phytochemical and pharmacological importance of Peltophorum pterocarpum: A review",
        "journal": "Journal of Medicinal Plants Studies",
        "volume": "7",
        "issue": "3",
        "pages": "145–150"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers",
        "pages": "343"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 19,
    "id": "Eucalyptus-globulus",

    "scientific_name": "Eucalyptus globulus ",

    "aname": "Labill.",
    "common_name": "Blue Gum Tree",

    "local_name": "Neelagiri Chettu, Blue Gum Tree, Eucalyptus",

    "image": "/Flora/plant19.jpeg",
    gallery: {

      bark: "/Flora/plant19a.jpeg",
      // leaf: "/Flora/plant19/leaf.jpg",
      flower: "/Flora/plant19c.jpeg",
      fruit: "/Flora/plant19b.jpeg",
      // seed: "/Flora/plant19/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Eucalyptus-globulus",
    'qr_code': '/Flora/qrcodes/Eucalyptus-globulus.png',

    "botanical_profile": {
      "scientific_name": "Eucalyptus globulus ",
      "aname": "Labill.",
      "common_name": "Blue Gum Tree",
      "local_name": "Neelagiri Chettu, Blue Gum Tree, Eucalyptus",
      "family": "Myrtaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Myrtaceae",
      "genus": "Eucalyptus",
      "species": "globulus"
    },

    "morphological_characters": "E. globulus is a tall evergreen tree with bark varying according to age, usually smooth and annually peeling, often showing multi-coloured patches. Leaves are evergreen, aromatic, lanceolate, petiolate, waxy, glossy green, and alternately arranged in mature trees, while young leaves are opposite, sessile, and glaucous. Inflorescence is generally axillary with flowers possessing numerous fluffy stamens that may be cream, yellow, pink, or red. Flower buds are enclosed by a cap-like operculum that detaches during blooming. Fruits are woody capsules commonly called gumnuts containing numerous small seeds. The species is widely cultivated in warm temperate and subtropical regions including the Nilgiris, Annamalai, Palani, and Shimla hills of India (Sharma et al., 2021; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tall evergreen tree",
      "bark": "Smooth with multi-coloured patches",
      "leaves": "Aromatic, lanceolate, petiolate, waxy and glossy green",
      "inflorescence": "Axillary",
      "flowers": "Numerous fluffy stamens, cream, yellow, pink or red",
      "fruit": "Woody capsule (gumnut)",
      "seeds": "Numerous small seeds"
    },

    "phytochemical_constituents": "E. globulus contains numerous bioactive phytochemicals responsible for its medicinal and industrial importance. Its essential oil is rich in 1,8-cineole (eucalyptol) as the major constituent along with α-pinene, β-pinene, limonene, p-cymene, γ-terpinene, and aromadendrene. Non-volatile compounds include flavonoids such as quercetin, rutin, and kaempferol; phenolic acids including gallic, ellagic, and caffeic acids; tannins, triterpenoids, alkaloids, saponins, and glycosides. These phytochemicals contribute significantly to antimicrobial, antioxidant, and anti-inflammatory activities (Sahariah & Goswami, 2021; Bachir & Benali, 2012).",

    "medicinal_importance": "E. globulus is extensively used in traditional and modern medicine because of its broad therapeutic properties. Essential oil rich in 1,8-cineole exhibits strong antibacterial, antifungal, antiviral, expectorant, and antiseptic activities and is widely used in respiratory disorders such as asthma, bronchitis, sinusitis, and cough. The plant also possesses anti-inflammatory, analgesic, antioxidant, antidiabetic, anticancer, immunomodulatory, and wound-healing properties. Extracts are used in inhalants, balms, ointments, disinfectants, and skin preparations. The insecticidal and mosquito repellent activities of eucalyptus oil further enhance its medicinal and public health importance (Sahariah & Goswami, 2021; Sharma et al., 2021; Bachir & Benali, 2012).",

    "economic_importance": "E. globulus has significant economic value due to its extensive industrial applications. It is widely cultivated for timber, pulpwood, fuelwood, and biomass production. The wood is highly valued in the paper and pulp industry because of its fibre quality and fast growth rate. Essential oil extracted from the leaves is commercially important in pharmaceutical, cosmetic, perfumery, and aromatherapy industries. Eucalyptus oil is used in cough syrups, disinfectants, liniments, mouthwashes, and flavouring agents. The species is also planted as windbreaks, for soil conservation, and in plantation forestry, contributing substantially to rural economies and commercial exports (Coppen, 2002; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Eucalyptus globulus was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Fensham et al., 2019)."
    },

    "references": [
      {
        "authors": "Bachir, R. G., & Benali, M.",
        "year": 2012,
        "title": "Antibacterial activity of the essential oils from the leaves of Eucalyptus globulus against Escherichia coli and Staphylococcus aureus",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "2",
        "issue": "9",
        "pages": "739–742",
        "doi": "https://doi.org/10.1016/S2221-1691(12)60220-2"
      },
      {
        "authors": "Coppen, J. J. W.",
        "year": 2002,
        "title": "Eucalyptus: The genus Eucalyptus",
        "publisher": "Taylor & Francis"
      },
      {
        "authors": "Fensham, R., Collingwood, T., & Laffineur, B.",
        "year": 2019,
        "title": "Eucalyptus globulus",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T61912929A61912931"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sahariah, B., & Goswami, J.",
        "year": 2021,
        "title": "Phytochemical properties and diverse beneficial roles of Eucalyptus globulus Labill.: A review",
        "journal": "Horticulturae",
        "volume": "7",
        "issue": "11",
        "pages": "450",
        "doi": "https://doi.org/10.3390/horticulturae7110450"
      },
      {
        "authors": "Sharma, S., Sushma, & Nishtha",
        "year": 2021,
        "title": "A review on Eucalyptus globulus – An authentic herb",
        "journal": "Journal of Pharmaceutical Research International",
        "volume": "33",
        "issue": "53B",
        "pages": "107–114"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Pharmacognosy",
        "edition": "16th",
        "publisher": "Saunders Elsevier"
      }
    ]
  },
  {
    plant: 20,
    "id": "Spathodea-campanulata",

    "scientific_name": "Spathodea campanulata ",

    "aname": "P.Beauv.",
    "common_name": "African Tulip Tree",

    "local_name": "African Tulip Tree, Fountain Tree, Nandi Flame, Flame of the Forest",

    "image": "/Flora/plant20 (3).jpeg",
    gallery: {

      bark: "/Flora/plant20 (2).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant20 (1).jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Spathodea-campanulata",
    'qr_code': '/Flora/qrcodes/Spathodea-campanulata.png',

    "botanical_profile": {
      "scientific_name": "Spathodea campanulata ",
      "aname": "P.Beauv.",
      "common_name": "African Tulip Tree",
      "local_name": "African Tulip Tree, Fountain Tree, Nandi Flame, Flame of the Forest",
      "family": "Bignoniaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Personales",
      "family": "Bignoniaceae",
      "genus": "Spathodea",
      "species": "campanulata"
    },

    "morphological_characters": "S. campanulata is a large evergreen ornamental tree belonging to the family Bignoniaceae. The tree possesses a broad crown with dense foliage and attains a height of about 10–35 m. Bark is greyish-brown and slightly rough, while the stem is stout and branched, producing a spreading canopy. Leaves are opposite, compound, and imparipinnate, usually 30–60 cm long with 7–17 ovate to elliptic leaflets that are dark green and glossy above and lighter beneath. Flowers are large, bell-shaped, bright orange-red or scarlet with yellow margins and arranged in terminal clusters. Flower buds contain watery fluid and are characteristically curved. Fruits are long cylindrical woody capsules that split open on maturity to release numerous winged seeds dispersed by wind. The species is widely cultivated as an avenue and shade tree in tropical and subtropical regions (Padhy, 2021; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large evergreen ornamental tree",
      "bark": "Greyish-brown and slightly rough",
      "stem": "Stout and branched",
      "leaves": "Opposite, compound and imparipinnate",
      "inflorescence": "Terminal clusters",
      "flowers": "Bright orange-red or scarlet",
      "fruit": "Long cylindrical woody capsule",
      "seeds": "Numerous winged seeds"
    },

    "phytochemical_constituents": "S. campanulata contains diverse bioactive phytochemicals including iridoids, triterpenoids, sterols, flavonoids, cinnamic acid derivatives, cerebrosides, carotenoids, monoterpenoids, and sesquiterpenoids. Major compounds reported include verminoside, specioside, spathoside, ursolic acid, tomentosolic acid, kaempferol, quercetin, β-sitosterol, oleanolic acid, caffeic acid, ferulic acid, lutein, and various phenolic compounds. These constituents are mainly distributed in leaves, bark, flowers, and roots and contribute to the plant’s biological and pharmacological activities (Padhy, 2021; Mbosso et al., 2008).",

    "medicinal_importance": "S. campanulata possesses significant ethnomedicinal importance and is widely used in traditional medicine systems. Various plant parts are used in the treatment of malaria, diabetes, gastrointestinal disorders, asthma, wounds, skin infections, microbial diseases, and inflammatory conditions. Pharmacological studies have demonstrated antimalarial, antidiabetic, anti-inflammatory, antioxidant, antimicrobial, wound-healing, analgesic, and anticancer activities. The therapeutic effects are mainly attributed to active compounds such as ursolic acid, verminoside, flavonoids, and phenolic constituents. Preclinical studies support its medicinal potential particularly in malaria management and tissue repair (Padhy, 2021; Ngouela et al., 1991; Mbosso et al., 2008).",

    "economic_importance": "S. campanulata has considerable economic value as an ornamental and multipurpose tree. It is extensively cultivated in gardens, parks, roadsides, and institutions because of its attractive flowers and rapid growth. The wood is used as firewood and in making drums and small wooden articles. Seeds are occasionally utilized as food in some local communities, while leaves may serve as fodder. The tree also contributes to ecological landscaping, shade provision, and urban beautification. However, in certain tropical regions it behaves as an invasive species, affecting native biodiversity and agricultural systems (Orwa et al., 2009; Padhy, 2021).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "details": "S. campanulata has not yet been evaluated for the IUCN Red List of Threatened Species."
    },

    "references": [
      {
        "authors": "Mbosso, E. J. T., Ngouela, S., Nguedia, J. C. A., Beng, V. P., Rohmer, M., & Tsamo, E.",
        "year": 2008,
        "title": "Chemical constituents and antimicrobial activity of the stem bark of Spathodea campanulata",
        "journal": "Natural Product Research",
        "volume": "22",
        "issue": "4",
        "pages": "296–304"
      },
      {
        "authors": "Ngouela, S., Tsamo, E., & Connolly, J. D.",
        "year": 1991,
        "title": "Spathodol, a triterpenoid from Spathodea campanulata",
        "journal": "Phytochemistry",
        "volume": "30",
        "issue": "8",
        "pages": "2646–2648"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Padhy, G. K.",
        "year": 2021,
        "title": "Spathodea campanulata P. Beauv. A review of its ethnomedicinal, phytochemical, and pharmacological profile",
        "journal": "Journal of Applied Pharmaceutical Science",
        "volume": "11",
        "issue": "12",
        "pages": "017–044"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Pharmacognosy",
        "edition": "16th",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 21,
    "id": "Wrightia-tinctoria",

    "scientific_name": "Wrightia tinctoria ",

    "aname": "(Roxb.) R.Br.",
    "common_name": "Sweet Indrajao",

    "local_name": "Palavareni",

    "image": "/Flora/plant21.jpeg",
    gallery: {

      bark: "/Flora/plant21a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant21b.jpeg",
      fruit: "/Flora/plant21c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Wrightia-tinctoria",
    'qr_code': '/Flora/qrcodes/Wrightia-tinctoria.png',

    "botanical_profile": {
      "scientific_name": "Wrightia tinctoria",
      "aname": "(Roxb.) R.Br.",
      "common_name": "Sweet Indrajao",
      "local_name": "Palavareni",
      "family": "Apocynaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Wrightia",
      "species": "tinctoria"
    },

    "morphological_characters": "W. tinctoria is a small to medium-sized deciduous tree commonly found in forests and open hills of many districts. Leaves are ovate-elliptic, sparsely hispid along the nerves below, with attenuate base and petiole. Inflorescence is a lax terminal cyme. Flowers are white, fragrant, and attractive. Fruits are twin, hanging, slender follicles measuring about 20–25 cm long, deep green to black with characteristic white spots. Seeds are numerous and possess silky tufts aiding in wind dispersal (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tree",
      "leaves": "Ovate-elliptic",
      "inflorescence": "Lax terminal cyme",
      "flowers": "White and fragrant",
      "fruit": "Twin hanging slender follicles, deep green to black with white spots",
      "seeds": "Numerous with silky hairs"
    },

    "phytochemical_constituents": "W. tinctoria contains a broad spectrum of phytochemicals distributed in leaves, bark, seeds, roots, and pods. Major constituents include alkaloids, flavonoids, tannins, phenolics, terpenoids, saponins, cardiac glycosides, sterols, and triterpenoids. Important compounds reported are indigotin, indirubin, tryptanthrin, isatin, anthranillate, rutin, β-isatin, indoxyl-yielding O-glycosides, β-sitosterol, stigmasterol, campesterol, β-amyrin, lupeol, cycloartenone, ursolic acid, and oleanolic acid. These phytochemicals are mainly responsible for the plant’s pharmacological and dye-producing properties (Khyade & Vaikos, 2014; Yoganarasimhan, 2000).",

    "medicinal_importance": "W. tinctoria possesses considerable medicinal importance and is extensively used in Ayurveda, Siddha, and folk medicine. The plant is particularly valued in the treatment of psoriasis, eczema, dandruff, and other skin disorders. Leaves and medicated oils prepared from them are externally applied for chronic skin diseases and wound healing. The plant also exhibits antidiabetic, antimicrobial, anti-inflammatory, analgesic, antioxidant, antimalarial, anthelmintic, hepatoprotective, antiulcer, and immunomodulatory activities. Bark and seeds are used as tonic, antidiarrheal, aphrodisiac, and febrifuge agents. Experimental studies support its effectiveness against microbial infections, inflammation, and metabolic disorders (Khyade & Vaikos, 2014; Nadkarni, 2007; Warrier et al., 1996).",

    "economic_importance": "W. tinctoria has important economic applications in traditional dye, timber, and pharmaceutical industries. The plant yields an indigo-producing glucoside used as a natural blue dye for textile applications. Its white wood is lightweight and fine-grained, making it suitable for carving, toy making, matchboxes, turnery, packing cases, and furniture. The plant is also commercially utilized in herbal medicine formulations, especially for dermatological preparations. Due to its medicinal value and phytochemical richness, it is increasingly explored in pharmaceutical and biotechnology sectors (Khyade & Vaikos, 2014; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2024,
      "details": "Wrightia tinctoria was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Amitha Bachan & Devika, 2024)."
    },

    "references": [
      {
        "authors": "Amitha Bachan, K. H., & Devika, M. A.",
        "year": 2024,
        "title": "Wrightia tinctoria",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T200684372A201031358",
        "doi": "https://doi.org/10.2305/IUCN.UK.2024-1.RLTS.T200684372A201031358.en"
      },
      {
        "authors": "Khyade, M. S., & Vaikos, N. P.",
        "year": 2014,
        "title": "Wrightia tinctoria R. Br.—A review on its ethnobotany, pharmacognosy and pharmacological profile",
        "journal": "Journal of Coastal Life Medicine",
        "volume": "2",
        "issue": "10",
        "pages": "826–840"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "2",
        "pages": "578",
        "publisher": "Pawan Kumar Scientific Publishers"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Yoganarasimhan, S. N.",
        "year": 2000,
        "title": "Medicinal plants of India",
        "publisher": "Interline Publishing"
      }
    ]
  },
  {
    plant: 22,
    "id": "Ailanthus-excelsa",

    "scientific_name": "Ailanthus excelsa ",

    "aname": "Roxb.",
    "common_name": "Indian Tree of Heaven",

    "local_name": "Pedda Manu, Indian Tree of Heaven",

    "image": "/Flora/plant22 (1).jpeg",
    gallery: {

      bark: "/Flora/plant22 (2).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant22 (3).jpeg",
      fruit: "/Flora/plant22 (4).jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Ailanthus-excelsa",
    'qr_code': '/Flora/qrcodes/Ailanthus-excelsa.png',

    "botanical_profile": {
      "scientific_name": "Ailanthus excelsa ",
      "aname": "Roxb.",
      "common_name": "Indian Tree of Heaven",
      "local_name": "Pedda Manu, Indian Tree of Heaven",
      "family": "Simaroubaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Simaroubaceae",
      "genus": "Ailanthus",
      "species": "excelsa"
    },

    "morphological_characters": "A. excelsa is a large deciduous tree with rough greyish-brown bark and soft white wood. Branchlets possess persistent leaf scars. Leaves are large, imparipinnate, measuring about 30 × 15 cm, with 8–14 pairs of sub-opposite leaflets. Leaflets are oblong-lanceolate, inequilateral at the base, irregularly toothed to sublobate along the margins, and acuminate at the apex. Flowers are large and polygamous, borne in axillary or terminal panicles. Fruits are oblong samaras, strongly nerved, copper-red in colour, and characteristically twisted once or twice at the base. The species occurs occasionally in forests of Chittoor, Hyderabad, Nizamabad, Mahaboobnagar, Warangal, Adilabad, East Godavari, and Visakhapatnam districts (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large deciduous tree",
      "bark": "Rough, greyish-brown",
      "branchlets": "Soft white wood with persistent leaf scars",
      "leaves": "Imparipinnate",
      "leaflets": "Sub-opposite, oblong-lanceolate",
      "flowers": "Large, polygamous",
      "inflorescence": "Axillary or terminal panicles",
      "fruit": "Copper-red oblong samara",
      "seed": "Solitary, oblong, glabrous"
    },

    "phytochemical_constituents": "More than 80 bioactive compounds have been reported from different parts of A. excelsa including bark, leaves, roots, and fruits. Major phytochemical groups include quassinoids, alkaloids such as canthin derivatives, flavonoids including kaempferol, luteolin, apigenin, and quercetin derivatives, triterpenes like oleanolic acid, phenolic compounds, steroids and phytosterols such as β-sitosterol, glycosides, saponins, fatty acids, and proteins. Important compounds like ailanthone and excelsin are associated with significant biological activities (Kirtikar & Basu, 1999; Ray et al., 2025; Nadkarni, 2007).",

    "medicinal_importance": "A. excelsa possesses considerable medicinal importance in traditional and modern systems of medicine. Different plant parts are traditionally used in the treatment of fever, asthma, bronchitis, diarrhea, dysentery, skin diseases, wounds, and gastrointestinal disorders. Pharmacological studies have demonstrated anticancer, antidiabetic, antimicrobial, antifungal, antiviral, anti-inflammatory, hepatoprotective, antioxidant, analgesic, antiasthmatic, and antidepressant activities. These therapeutic properties are mainly attributed to the presence of quassinoids, alkaloids, flavonoids, and terpenoids (Nadkarni, 2007; Warrier et al., 1993; Ray et al., 2025).",

    "economic_importance": "A. excelsa is an economically important multipurpose tree species widely cultivated in dry and semi-arid regions of India. Its soft and lightweight timber is used for plywood, packing cases, match splints, construction work, and paper pulp. Leaves are nutritious and serve as fodder for livestock. Seed oil has potential for biodiesel production, while the tree is also planted as a roadside, avenue, and shelterbelt species in agroforestry systems. Due to its rapid growth and adaptability to arid conditions, it plays an important role in afforestation and rural economy (Orwa et al., 2009; Warrier et al., 1993; Ray et al., 2025).",

    "conservation_status": {
      "IUCN_status": "Data Deficient",
      "assessment_year": 2024,
      "details": "Ailanthus excelsa was assessed in The IUCN Red List of Threatened Species and categorized as Data Deficient (IUCN SSC Global Tree Specialist Group & BGCI, 2024)."
    },

    "references": [
      {
        "authors": "IUCN SSC Global Tree Specialist Group & Botanic Gardens Conservation International (BGCI)",
        "year": 2024,
        "title": "Ailanthus excelsa",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T158177189A235467199"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 1)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers",
        "pages": "180–181"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Ray, K., Sahoo, R. K., Samantaray, B., & Kar, B.",
        "year": 2025,
        "title": "A systematic review on phytochemical constituents, pharmacological properties and ethnic uses of Ailanthus excelsa Roxb.",
        "journal": "Phytochemistry Reviews",
        "volume": "25",
        "issue": "3",
        "pages": "2583–2621"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1993,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 1)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 23,
    "id": "Acacia-nilotica",

    "scientific_name": "Acacia nilotica  ",

    "aname": "(L.) Delile",
    "common_name": "Indian Gum Arabic Tree",

    "local_name": "Nalla Tumma, Babul, Indian Gum Arabic Tree",

    "image": "/Flora/plant23 (1).jpeg",
    gallery: {

      bark: "/Flora/plant23 (4).jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant23 (2).jpeg",
      fruit: "/Flora/plant23 (3).jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Acacia-nilotica",
    'qr_code': '/Flora/qrcodes/Acacia-nilotica.png',

    "botanical_profile": {
      "scientific_name": "Acacia nilotica  ",
      "aname": "(L.) Delile",
      "common_name": "Indian Gum Arabic Tree",
      "local_name": "Nalla Tumma, Babul and Indian Gum Arabic Tree",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "subfamily": "Mimosoideae",
      "genus": "Acacia",
      "species": "nilotica"
    },

    "morphological_characters": "A. nilotica is a medium to large tree with sparsely puberulous young branches. Bark is dark brown and deeply fissured. Leaves are alternate with straight stipular spines up to 5 cm long. Rachis is grey-pubescent with glands generally present between the first and terminal pairs of pinnae. Pinnae are 5–10 pairs with numerous subsessile elliptic leaflets having oblique base, entire margin, and rounded apex. Flower heads are globose and yellow, arranged in axillary fascicles. Pods are stipitate, glaucous, moniliform, and constricted between seeds. Seeds are elliptical, compressed, and dark brown to black. The species is common in dry localities across most districts (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tree",
      "bark": "Dark brown, fissured",
      "branches": "Sparsely puberulous",
      "leaves": "Alternate, stipular spines, rachis grey-pubescent and glandular",
      "leaflets": "Subsessile, elliptic, oblique base, rotund apex",
      "flowers": "Globose yellow heads",
      "inflorescence": "Axillary fascicles",
      "fruit": "Stipitate, glaucous, moniliform pods constricted at apex",
      "seed": "6–16 dark brown to black seeds per pod"
    },

    "phytochemical_constituents": "A. nilotica contains a rich diversity of phytochemicals distributed throughout its bark, leaves, pods, seeds, flowers, and gum. Major constituents include tannins, flavonoids, alkaloids, saponins, glycosides, terpenoids, phenolic compounds, gallic acid, catechin, epicatechin, kaempferol, rutin, and ellagic acid. The gum exudate is rich in arabic acid polysaccharides and minerals, while seeds contain proteins, fatty acids, and amino acids. Bioactive compounds such as methyl gallate and pyrogallol contribute significantly to its antioxidant, antimicrobial, and anti-inflammatory properties (Saeedi et al., 2020; Kalaivani et al., 2011; Ali et al., 2012).",

    "medicinal_importance": "A. nilotica possesses wide medicinal importance in traditional Ayurvedic, Siddha, and Unani systems of medicine. Different plant parts exhibit antimicrobial, antioxidant, anti-inflammatory, antidiarrheal, antidiabetic, antihypertensive, analgesic, anthelmintic, hepatoprotective, and wound-healing activities. Bark and pods are traditionally used for treating diarrhea, dysentery, bleeding disorders, and gastrointestinal ailments because of their strong astringent properties. Leaf and bark extracts show antibacterial and antifungal activity against several pathogenic microorganisms. Gum is used as a soothing agent for inflamed tissues and in wound management. The plant is also employed in the treatment of cough, bronchitis, skin diseases, dental infections, and ulcers. Its rich phenolic and flavonoid content contributes to free radical scavenging and protection against oxidative stress (Kalaivani et al., 2011; Saeedi et al., 2020; Ali et al., 2012; Warrier et al., 1993).",

    "economic_importance": "A. nilotica is economically important due to its multipurpose uses in forestry, agriculture, medicine, and industry. The bark is rich in tannins and extensively used in leather tanning industries. The tree produces gum arabic, widely utilized as an emulsifier and stabilizer in food, pharmaceutical, textile, and cosmetic industries. Wood is highly valued as fuelwood, charcoal, and timber because of its durability and calorific value. Leaves and pods are nutritious fodder for livestock, especially in arid and semi-arid regions. The species is also planted in agroforestry systems for soil conservation, nitrogen fixation, and fencing. Its medicinal applications and phytochemical-rich extracts further enhance its commercial significance in herbal drug industries (Orwa et al., 2009; Saeedi et al., 2020; Warrier et al., 1993).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2017,
      "details": "Vachellia nilotica was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Rivers, 2017)."
    },

    "references": [
      {
        "authors": "Ali, A., Akhtar, N., Khan, B. A., Khan, M. S., Rasul, A., Khalid, N., Waseem, K., Mahmood, T., Ali, L., & Qasim, M.",
        "year": 2012,
        "title": "Acacia nilotica: A plant of multipurpose medicinal uses",
        "journal": "Journal of Medicinal Plants Research",
        "volume": "6",
        "issue": "9",
        "pages": "1492–1496"
      },
      {
        "authors": "Kalaivani, T., Mathew, L., & Free-Radical Biology Research Group",
        "year": 2011,
        "title": "Free radical scavenging activity from leaves of Acacia nilotica (L.) Delile, an Indian medicinal tree",
        "journal": "Food and Chemical Toxicology",
        "volume": "48",
        "issue": "1",
        "pages": "298–305"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers",
        "pages": "350–351"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rivers, M. C.",
        "year": 2017,
        "title": "Vachellia nilotica (errata version published in 2020)",
        "source": "The IUCN Red List of Threatened Species 2017",
        "pages": "e.T158379A187765963"
      },
      {
        "authors": "Saeedi, R., Sultana, A., & Rahman, K.",
        "year": 2020,
        "title": "Medicinal properties of different parts of Acacia nilotica Linn (Babul), its phytoconstituents and diverse pharmacological activities",
        "journal": "International Journal of Pharmacy and Pharmaceutical Sciences",
        "volume": "12",
        "issue": "2",
        "pages": "8–14"
      },
      {
        "authors": "Singh, B. N., Singh, B. R., Singh, R. L., Prakash, D., Sarma, B. K., Singh, H. B., & Upadhyay, G.",
        "year": 2009,
        "title": "Polyphenolics from various extracts/fractions of red onion peel with potent antioxidant and antimutagenic activities",
        "journal": "Food and Chemical Toxicology",
        "volume": "47",
        "issue": "6",
        "pages": "1161–1167"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1993,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 1)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 24,
    "id": "Balanites-aegyptiaca",

    "scientific_name": "Balanites aegyptiaca ",

    "aname": "(L.) Delile",
    "common_name": "Desert Date",

    "local_name": "Gara Chettu, Desert Date",

    "image": "/Flora/plant24.jpeg",
    gallery: {

      bark: "/Flora/plant24a.jpeg",
      // leaf: "/Flora/plant24/leaf.jpg",
      flower: "/Flora/plant24b.jpeg",
      fruit: "/Flora/plant24c.jpeg",
      // seed: "/Flora/plant24/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Balanites-aegyptiaca",
    'qr_code': '/Flora/qrcodes/Balanites-aegyptiaca.png',

    "botanical_profile": {
      "scientific_name": "Balanites aegyptiaca ",
      "aname": "(L.) Delile",
      "common_name": "Desert Date",
      "local_name": "Gara Chettu, Desert Date",
      "family": "Zygophyllaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Zygophyllaceae",
      "genus": "Balanites",
      "species": "aegyptiaca"
    },

    "morphological_characters": "B. aegyptiaca is a small thorny tree with terete, striate branchlets that are puberulous or glabrous. Thorns are sharp and up to 2 cm long. Bark is grey in colour. Leaves are bifoliolate with elliptic-ovate or oblong coriaceous leaflets measuring up to 4 × 2 cm, having acute bases, finely nerved surfaces, and emarginate apices. Flowers are whitish and arranged in axillary fascicles or supra-axillary pseudo-umbels. Fruits are ashy-green drupes, elliptic-oblong or ovoid, slightly five-grooved, containing a solitary seed embedded in pulp. The species is commonly found in dry forests of moist districts (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small thorny tree",
      "branches": "Terete, glabrous or puberulous, thorny",
      "bark": "Grey",
      "leaves": "2-foliolate, coriaceous, acute base, emarginate apex",
      "flowers": "Whitish, arranged in pseudo-umbels",
      "inflorescence": "Axillary fascicles or supra-axillary pseudo-umbels",
      "fruit": "Ashy-green drupes",
      "seed": "Solitary seed embedded in pulp"
    },

    "phytochemical_constituents": "B. aegyptiaca contains a wide range of bioactive phytochemicals distributed in fruits, seeds, leaves, bark, roots, and galls. Major constituents include steroidal saponins such as diosgenin, yamogenin, and balanitins, along with flavonoids, alkaloids, phenolic acids, coumarins, tannins, pregnane glycosides, sterols, and triterpenoids. Polyphenolic compounds including quercetin, kaempferol, and rutin contribute significantly to antioxidant activity. Seeds are rich in fixed oils and fatty acids, while fruits contain sugars, proteins, and medicinally important steroidal sapogenins (Murthy et al., 2020; Chothani & Vaghasiya, 2011; Yadav et al., 2016).",

    "medicinal_importance": "B. aegyptiaca possesses diverse medicinal properties and has long been used in traditional medicine systems. Various plant parts exhibit hepatoprotective, antioxidant, antimicrobial, antifungal, antidiabetic, anticancer, anti-inflammatory, antiparasitic, wound-healing, anthelmintic, and diuretic activities. Fruits and bark are used in treating jaundice, constipation, intestinal worms, fever, and skin diseases, while seed oil is applied for rheumatism and inflammatory conditions. Steroidal saponins and flavonoids contribute to its therapeutic effects against microbial infections and metabolic disorders. Scientific studies also support its use in managing liver disorders, diabetes, and oxidative stress-related diseases (Murthy et al., 2020; Sharma & Sharma, 2026; Chothani & Vaghasiya, 2011).",

    "economic_importance": "B. aegyptiaca is an economically important multipurpose tree species widely utilized in arid and semi-arid regions. The fruits are edible and rich in fatty acids, making them useful for edible oil production and livestock feed. Seed oil is commercially valuable in soap, cosmetic, pharmaceutical, and biodiesel industries. Steroidal compounds such as diosgenin serve as raw materials for manufacturing steroidal drugs, contraceptive pills, and hormones. Wood is used as fuelwood and charcoal, while leaves and pods serve as fodder. The species is also important in agroforestry and desert reclamation because of its drought tolerance and soil conservation ability. Excessive exploitation and poor natural regeneration may threaten local populations in some regions (Fadl, 2015; Orwa et al., 2009; Hall & Walker, 1991).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Balanites aegyptiaca was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (BGCI & IUCN SSC Global Tree Specialist Group, 2019)."
    },

    "references": [
      {
        "authors": "Botanic Gardens Conservation International (BGCI), & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Balanites aegyptiaca (amended version of 2019 assessment)",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T19182478A155800536"
      },
      {
        "authors": "Chothani, D. L., & Vaghasiya, H. U.",
        "year": 2011,
        "title": "A review on Balanites aegyptiaca Del (desert date): Phytochemical constituents, traditional uses, and pharmacological activity",
        "journal": "Pharmacognosy Reviews",
        "volume": "5",
        "issue": "9",
        "pages": "55–62"
      },
      {
        "authors": "Fadl, K. E. M.",
        "year": 2015,
        "title": "Balanites aegyptiaca (L.): A multipurpose fruit tree in savanna zone of Western Sudan",
        "journal": "International Journal of Environment",
        "volume": "4",
        "issue": "1",
        "pages": "197–203"
      },
      {
        "authors": "Hall, J. B., & Walker, D. H.",
        "year": 1991,
        "title": "Balanites aegyptiaca: A monograph",
        "publisher": "School of Agricultural and Forest Sciences, University of Wales"
      },
      {
        "authors": "Murthy, H. N., Yadav, G. G., Dewir, Y. H., & Ibrahim, A.",
        "year": 2020,
        "title": "Phytochemicals and biological activity of desert date (Balanites aegyptiaca (L.) Delile)",
        "journal": "Plants",
        "volume": "10",
        "issue": "1",
        "pages": "32"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers",
        "pages": "181"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sharma, V., & Sharma, R.",
        "year": 2026,
        "title": "Systematic review of Balanites aegyptiaca (Ingudi): Phytochemistry, pharmacology, and therapeutic potentials",
        "journal": "Journal of Ayurveda and Integrative Medical Sciences",
        "volume": "11",
        "issue": "1",
        "pages": "428–435"
      },
      {
        "authors": "Yadav, J. P., Panghal, M., & Beniwal, V.",
        "year": 2016,
        "title": "Phytochemical and pharmacological potential of Balanites aegyptiaca: A review",
        "journal": "International Journal of Green Pharmacy",
        "volume": "10",
        "issue": "2",
        "pages": "55–63"
      }
    ]
  },
  {
    plant: 25,
    "id": "Annona-squamosa",

    "scientific_name": "Annona squamosa .",

    "aname": "L",
    "common_name": "Custard Apple",

    "local_name": "Sitaphalamu, Custard Apple",

    "family": "Annonaceae",

    "image": "/Flora/plant25.jpeg",
    gallery: {

      bark: "/Flora/plant25a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant25b.jpeg",
      fruit: "/Flora/plant25c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Annona-squamosa",
    'qr_code': '/Flora/qrcodes/Annona-squamosa.png',

    "botanical_profile": {
      "scientific_name": "Annona squamosa ",
      "aname": "L.",
      "common_name": "Custard Apple",
      "local_name": "Sitaphalamu, Custard Apple",
      "family": "Annonaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledones",
      "sub_class": "Polypetalae",
      "series": "Thalamiflorae",
      "order": "Ranales",
      "family": "Annonaceae",
      "genus": "Annona",
      "species": "squamosa"
    },

    "morphological_characters": "A. squamosa is a small tree with grey bark. Leaves are simple, oblong-lanceolate, glabrous, acute, and possess entire margins. Flowers are greenish-yellow, occurring solitary or in small clusters on leaf-opposed peduncles. Fruits are globose syncarps with green grooved surface and sweet pulp. Seeds are numerous, angular, oblong, black, and shining. The species is commonly cultivated for its edible fruits and occurs occasionally in forests. It is native to tropical America (Venkata Raju & Pullaiah, 1995).",

    "digital_identification": {
      "habit": "Small tree",
      "bark": "Grey",
      "leaves": "Simple, oblong-lanceolate, glabrous, acute, entire margin",
      "inflorescence": "Solitary or clustered on leaf-opposed peduncles",
      "flowers": "Greenish-yellow",
      "fruit": "Globose syncarp with sweet pulp",
      "seeds": "Many, angular, oblong, black"
    },

    "phytochemical_constituents": "A. squamosa contains numerous phytochemicals including flavonoids, alkaloids, tannins, glycosides, saponins, terpenoids, polyphenols, and annonaceous acetogenins. Important compounds reported include squamocin, bullatacin, cyclosquamosin, annotemoyin, murisolin, quercetin, anonaine, xylopine, caryophyllene oxide, and ent-kaurene derivatives. These compounds are distributed in the seeds, leaves, bark, roots, stems, and fruits and are associated with diverse biological activities (Singh et al., 2025; Ragasa et al., 2012).",

    "medicinal_importance": "A. squamosa possesses significant medicinal value due to its antioxidant, antimicrobial, anticancer, anti-inflammatory, antidiabetic, hepatoprotective, antiulcer, antimalarial, wound-healing, and immune-enhancing properties. The plant has traditionally been used to treat dysentery, ulcers, diabetes, skin disorders, and parasitic infections. Leaf and seed extracts exhibit strong antibacterial and cytotoxic activities, while fruit and bark extracts are used in traditional herbal medicine (Singh et al., 2025; Bhalke et al., 2010; Wang et al., 2014).",

    "economic_importance": "A. squamosa is economically important because of its edible and nutritious fruits, which are widely marketed and consumed fresh or processed into desserts, beverages, and food products. Various plant parts are used in traditional medicine and pharmaceutical industries. Seeds possess insecticidal properties useful in pest management. Due to its phytochemical richness and therapeutic potential, the plant has growing importance in nutraceutical, pharmaceutical, and herbal product industries (Morton, 1987; Singh et al., 2025).",

    "conservation_status": {
      "iucn_status": "Least Concern",
      "assessment_year": 2019
    },

    "references": [
      {
        "authors": "Annapurna, A., Reddy, C. S., Akondi, R. B., & Rao, S. R.",
        "year": 2010,
        "title": "Cardioprotective actions of two bioflavonoids, quercetin and rutin, in experimental myocardial infarction in both normal and streptozotocin induced type I diabetic rats",
        "journal": "Journal of Pharmacy and Pharmacology",
        "volume": "61",
        "issue": "10",
        "pages": "1365–1374"
      },
      {
        "authors": "Bhalke, R. D., Chavan, M. J., & Biyani, K. R.",
        "year": 2010,
        "title": "Cytotoxic and antimicrobial activity of Annona squamosa Linn. leaves",
        "journal": "Pharmacognosy Research",
        "volume": "2",
        "issue": "6",
        "pages": "373–375"
      },
      {
        "authors": "Botanic Gardens Conservation International (BGCI) & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Annona squamosa",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T146787183A146787185"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2005,
        "title": "Indian medicinal plants",
        "publisher": "International Book Distributors",
        "volume": "1"
      },
      {
        "authors": "Morton, J. F.",
        "year": 1987,
        "title": "Sugar apple",
        "book": "Fruits of Warm Climates",
        "pages": "69–72",
        "publisher": "Florida Flair Books"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Ragasa, C. Y., Soriano, G., Torres, O. B., Don, M. J., & Shen, C. C.",
        "year": 2012,
        "title": "Acetogenins from Annona squamosa Linn. and their cytotoxic activity",
        "journal": "Pharmacognosy Magazine",
        "volume": "8",
        "issue": "32",
        "pages": "328–331"
      },
      {
        "authors": "Singh, R. P., Pattnaik, A. K., Rudrapal, M., & Bhattacharya, S.",
        "year": 2025,
        "title": "Annona squamosa Linn.: A review of its ethnobotany, pharmacology, phytochemistry, toxicity, and conservation needs",
        "journal": "Pharmacognosy Magazine",
        "volume": "21",
        "issue": "2",
        "pages": "403–412"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool (Andhra Pradesh)",
        "publisher": "Bishen Singh Mahendra Pal Singh"
      },
      {
        "authors": "Vijayameena, C., Subhashini, G., Loganayagi, M., & Ramesh, B.",
        "year": 2013,
        "title": "Phytochemical screening and assessment of antibacterial activity for the bioactive compounds in Annona squamosa",
        "journal": "International Journal of Current Microbiology and Applied Sciences",
        "volume": "2",
        "issue": "1",
        "pages": "1–8"
      },
      {
        "authors": "Wang, D. S., Rizwani, G. H., Guo, H., Ahmed, M., Ahmed, M., Hassan, S. Z., Li, J., & Guo, D. A.",
        "year": 2014,
        "title": "Annona squamosa Linn.: Cytotoxic activity found in leaf extract against human tumor cell lines",
        "journal": "Pakistan Journal of Pharmaceutical Sciences",
        "volume": "27",
        "issue": "5",
        "pages": "1559–1563"
      }
    ]
  },
  {
    plant: 26,
    "id": "Lawsonia-inermis",

    "scientific_name": "Lawsonia inermis ",

    "aname": "L.",
    "common_name": "Henna",

    "local_name": "Henna, Mehndi",

    "family": "Lythraceae",

    "image": "/Flora/plant26.jpeg",
    gallery: {

      bark: "/Flora/plant26a.jpeg",
      // leaf: "/Flora/plant26/leaf.jpg",
      flower: "/Flora/plant26b.jpeg",
      fruit: "/Flora/plant26c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Lawsonia-inermis",
    'qr_code': '/Flora/qrcodes/Lawsonia-inermis.png',

    "botanical_profile": {
      "scientific_name": "Lawsonia inermis ",
      "aname": "L.",
      "common_name": "Henna",
      "local_name": "Henna, Mehndi",
      "family": "Lythraceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledons",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Lythraceae",
      "genus": "Lawsonia",
      "species": "inermis"
    },

    "morphological_characters": "L. inermis is a bushy shrub or small tree with spine-tipped branchlets and smooth greenish-white bark. Leaves are opposite, decussate, obovate-elliptic, subsessile, with attenuate base, entire margin, and acute apex. Inflorescence occurs as terminal panicles bearing white or creamy-white fragrant flowers. Fruits are globose capsules, smooth and glabrous, containing numerous minute brown seeds. The species is commonly cultivated as a hedge plant and occasionally occurs as an escape in plains districts (Pullaiah & Chennaiah, 1997).",

    "digital_identification": {
      "habit": "Bushy shrub or small tree",
      "branchlets": "Spine tipped",
      "bark": "Greenish-white and smooth",
      "leaves": "Opposite decussate, obovate-elliptic, entire margin",
      "inflorescence": "Terminal panicles",
      "flowers": "White or creamy-white",
      "fruit": "Globose capsule",
      "seeds": "Minute, brown, smooth and glabrous"
    },

    "phytochemical_constituents": "L. inermis contains a rich diversity of phytochemicals including lawsone (2-hydroxy-1,4-naphthoquinone), flavonoids, tannins, phenolic compounds, alkaloids, terpenoids, coumarins, xanthones, sterols, and essential oils. Important constituents such as gallic acid, luteolin, apigenin, quercetin, and β-sitosterol have also been reported. These compounds contribute significantly to its antimicrobial, antioxidant, anti-inflammatory, and dyeing properties (Salma et al., 2024; Chaudhary et al., 2010).",

    "medicinal_importance": "L. inermis possesses diverse medicinal properties and has been extensively used in Ayurveda, Siddha, and Unani systems of medicine. The plant exhibits antimicrobial, antifungal, antiviral, antioxidant, anti-inflammatory, analgesic, hepatoprotective, antidiabetic, wound-healing, and anticancer activities. Leaf paste is traditionally applied for burns, wounds, ulcers, skin diseases, and fungal infections. Decoctions and extracts are used for treating fever, diarrhea, jaundice, and inflammatory disorders. The pharmacological properties are mainly attributed to lawsone, flavonoids, and phenolic compounds present in the plant (Salma et al., 2024; Mikhaeil et al., 2004).",

    "economic_importance": "L. inermis is economically important because its leaves are commercially processed into henna powder, widely used as a natural dye for hair, skin, nails, and textiles. It plays a major role in cosmetic, herbal, and pharmaceutical industries. Henna is extensively used in traditional ceremonies and cultural practices, particularly in India, the Middle East, and North Africa. The plant also contributes to rural livelihoods through cultivation, processing, and export of henna products. In addition, extracts of the plant are utilized in herbal formulations, perfumes, and natural cosmetic preparations (Semwal et al., 2014).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2024
    },

    "references": [
      {
        "authors": "Chaudhary, G., Goyal, S., & Poonia, P.",
        "year": 2010,
        "title": "Lawsonia inermis Linnaeus: A phytopharmacological review",
        "journal": "International Journal of Pharmaceutical Sciences and Drug Research",
        "volume": "2",
        "issue": "2",
        "pages": "91–98"
      },
      {
        "authors": "Habbal, O., Al-Jabri, A., & El-Hag, A.",
        "year": 2005,
        "title": "Antimicrobial properties of Lawsonia inermis (henna)",
        "journal": "Sultan Qaboos University Medical Journal",
        "volume": "5",
        "issue": "2",
        "pages": "33–39"
      },
      {
        "authors": "Mikhaeil, B. R., Badria, F. A., Maatooq, G. T., & Amer, M. M.",
        "year": 2004,
        "title": "Antioxidant and immunomodulatory constituents of henna leaves",
        "journal": "Zeitschrift für Naturforschung C",
        "volume": "59",
        "issue": "7-8",
        "pages": "468–476"
      },
      {
        "authors": "Plummer, J.",
        "year": 2024,
        "title": "Lawsonia inermis (amended version of 2020 assessment)",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T138450837A265977337"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "393"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Salma, R., Vijay, V., Muthuswamy, S., Vijayakumar, A. R., & Deepa, N.",
        "year": 2024,
        "title": "A review on phytochemical, pharmacological, and toxicological properties of Lawsonia inermis L.",
        "journal": "Journal of Pharma Insights and Research",
        "volume": "2",
        "issue": "3",
        "pages": "155–166"
      },
      {
        "authors": "Semwal, R. B., Semwal, D. K., Combrinck, S., & Viljoen, A.",
        "year": 2014,
        "title": "Lawsonia inermis L. (henna): Ethnobotanical, phytochemical and pharmacological aspects",
        "journal": "Journal of Ethnopharmacology",
        "volume": "155",
        "issue": "1",
        "pages": "80–103"
      },
      {
        "authors": "Singh, D. K., Luqman, S., & Mathur, A. K.",
        "year": 2015,
        "title": "Lawsonia inermis L. – A commercially important primaeval dying and medicinal plant with diverse pharmacological activity",
        "journal": "Industrial Crops and Products",
        "volume": "65",
        "pages": "269–286"
      }
    ]
  },
  {
    plant: 27,
    "id": "Pithecellobium-dulce",

    "scientific_name": "Pithecellobium dulce ",

    "aname": "(Roxb.) Benth.",
    "common_name": "Manila Tamarind",

    "local_name": "Seema Chintakaya",

    "image": "/Flora/plant27.jpeg",
    gallery: {

      bark: "/Flora/plant27a.jpeg",
      // leaf: "/Flora/plant27/leaf.jpg",
      flower: "/Flora/plant27b.jpeg",
      fruit: "/Flora/plant27c.jpeg",
      // seed: "/Flora/plant27/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Pithecellobium-dulce",
    'qr_code': '/Flora/qrcodes/Pithecellobium-dulce.png',

    "botanical_profile": {
      "scientific_name": "Pithecellobium dulce ",
      "aname": "(Roxb.) Benth.",
      "common_name": "Manila Tamarind",
      "local_name": "Seema Chintakaya",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Pithecellobium",
      "species": "dulce"
    },

    "morphological_characters": "P. dulce is an armed, medium to large evergreen tree growing up to 15 m tall. The trunk is irregular with spreading branches bearing stipular spines. Leaves are bipinnate with one pair of pinnae and glabrous oblong-oblanceolate to elliptic-oblong leaflets measuring about 2–4 cm long and 0.5–1 cm broad. Flowers are creamish-white and arranged in axillary globose heads. Fruits are spirally twisted reddish-brown pods measuring about 10–15 cm long, circinate and dehiscent. Seeds are orbicular, usually 4–8 in number, surrounded by a white edible aril. The species is commonly cultivated in gardens, hedges, and roadsides and is native to tropical America (Pullaiah & Venkata Raju, 1995; Kumar et al., 2022).",

    "digital_identification": {
      "habit": "Tree",
      "leaves": "Bipinnate with one pair of pinnae",
      "leaflets": "Oblong-oblanceolate, glabrous",
      "flowers": "Creamish-white",
      "inflorescence": "Axillary globose heads",
      "fruit": "Spirally twisted reddish-brown pods",
      "seeds": "Orbicular with white edible aril"
    },

    "phytochemical_constituents": "P. dulce contains diverse phytochemicals distributed in leaves, fruits, seeds, and peel. Leaves contain cyclitol, dulcitol, octacosanol, α-spinasterol, kaempferol-3-rhamnoside, quercetin, and afzelin. Fruits possess D-pinitol, stigmasterol, gallic acid, mandelic acid, vanillic acid, coumaric acid, rutin, naringin, daidzein, tetracosanol, and heptacosanoic acid. Seeds contain pithedulosides, dulcin, hederagenin, oleanolic acid, and echinocystic acid, while peel extracts contain stigmasterol, sitosterol, quercetin, and pinitol. These phytochemicals contribute to the medicinal and antioxidant properties of the species (Kumar et al., 2022; Patil & Gaikwad, 2011).",

    "medicinal_importance": "P. dulce possesses significant medicinal value and is widely used in traditional systems of medicine. The plant exhibits antimicrobial activity against pathogenic bacteria such as Klebsiella pneumoniae and Acinetobacter baumannii. Methanolic extracts show analgesic, anti-inflammatory, antioxidant, anticonvulsant, cardioprotective, antidiabetic, antidiarrhoeal, antiulcer, nephroprotective, antiparasitic, antitubercular, and larvicidal activities. Traditionally, different plant parts are used for treating dysentery, diabetes, fever, skin diseases, ulcers, earache, inflammation, and convulsions. High phenolic and flavonoid contents are mainly responsible for its pharmacological potential (Kumar et al., 2022; Megala et al., 2014).",

    "economic_importance": "P. dulce has considerable economic importance because of its nutritional, medicinal, and environmental value. The sweet edible aril surrounding the seeds is consumed locally as food. Various plant parts are utilized in traditional medicine and pharmaceutical research. Due to its antimicrobial, antioxidant, and antidiabetic activities, the species has promising applications in herbal medicine and nutraceutical industries. The tree is also cultivated as an ornamental avenue and hedge plant in tropical regions, contributing to environmental beautification and local livelihoods (Kumar et al., 2022; The Wealth of India, 2003).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": " P. dulce was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern due to its wide distribution and stable population trend (BGCI & IUCN SSC Global Tree Specialist Group, 2019)."
    },

    "references": [
      {
        "authors": "BGCI & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Pithecellobium dulce",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T130519803A149057978",
        "doi": "https://doi.org/10.2305/IUCN.UK.2019-2.RLTS.T130519803A149057978.en"
      },
      {
        "authors": "Kumar, R., Usmani, S., Singh, B., Prakash, O., Verma, P., Wahab, S., & Khatoon, S.",
        "year": 2022,
        "title": "A comprehensive review on phytopharmacological perspectives of Pithecellobium dulce (Roxb.) Benth.",
        "journal": "Annals of Phytomedicine",
        "volume": "11",
        "issue": "1",
        "pages": "115–120",
        "doi": "https://doi.org/10.54085/ap.2022.11.1.12"
      },
      {
        "authors": "Megala, J., Geetha, A., & Ravikumar, S.",
        "year": 2014,
        "title": "Biological and pharmacological activities of Pithecellobium dulce: A review",
        "journal": "International Journal of Pharmacy and Pharmaceutical Sciences",
        "volume": "6",
        "issue": "6",
        "pages": "22–26"
      },
      {
        "authors": "Patil, U. H., & Gaikwad, D. K.",
        "year": 2011,
        "title": "Pharmacological activities of Pithecellobium dulce and its phytochemical constituents: A review",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "10",
        "issue": "2",
        "pages": "13–18"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., & Venkata Raju, R. R.",
        "year": 1995,
        "title": "Flora of Kurnool",
        "pages": "43",
        "publisher": "Bishen Singh Mahendra Pal Singh Publishers"
      },
      {
        "authors": "CSIR",
        "year": 2003,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "publisher": "Council of Scientific and Industrial Research"
      }
    ]
  },
  {
    plant: 28,
    "id": "Callistemon-lanceolatus",
    "scientific_name": "Callistemon lanceolatus ",
    "aname": "(Sm.) Sweet",
    "common_name": "Bottlebrush Tree",
    "local_name": "Seesa Brush, Lemon Bottlebrush",
    "image": "/Flora/plant28.jpeg",
    gallery: {

      bark: "/Flora/plant28a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant28b.jpeg",
      fruit: "/Flora/plant28c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },
    "qr_url": "https://rukap.edu.in/digital-flora/Callistemon-lanceolatus",
    'qr_code': '/Flora/qrcodes/Callistemon-lanceolatus.png',

    "botanical_profile": {
      "scientific_name": "Callistemon lanceolatus ",
      "aname": "(Sm.) Sweet",
      "common_name": "Bottlebrush Tree",
      "local_name": "Seesa Brush, Lemon Bottlebrush",
      "family": "Myrtaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Myrtaceae",
      "genus": "Callistemon",
      "species": "lanceolatus"
    },

    "morphological_characters": "Callistemon lanceolatus is a small evergreen ornamental tree with dark brown to greenish-grey rough fibrous bark. Young branchlets are silky-hairy in appearance. Leaves are elliptic-lanceolate, thick-coriaceous, entire, acute, and contain prominent lateral glands. Flowers are showy, scarlet red to crimson in color and arranged in dense intercalary or terminal spikes resembling a bottlebrush. Fruits are woody depressed-globose capsules containing numerous extremely minute brown to dark brown seeds measuring less than 1 mm in length. The species is widely cultivated in gardens, parks, and landscapes for its attractive floral display during blooming season.",

    "digital_identification": {
      "habit": "Evergreen tree",
      "bark": "Dark brown to greenish-grey, rough and fibrous",
      "branchlets": "Silky-hairy when young",
      "leaves": "Elliptic-lanceolate, thick-coriaceous with prominent lateral glands",
      "flowers": "Showy scarlet red to crimson",
      "inflorescence": "Dense intercalary or terminal spikes",
      "fruit": "Woody depressed-globose capsules",
      "seed": "Extremely minute brown seeds, less than 1 mm long"
    },

    "phytochemical_constituents": "Callistemon lanceolatus contains a diverse range of phytochemicals including flavonoids, triterpenoids, phenolic compounds, tannins, fatty acids, and volatile essential oils. Major compounds identified from different plant parts include quercetin, kaempferol glycosides, betulinic acid, ursolic acid, erythrodiol, alphitolic acid, eucalyptin, sideroxylin, callistenones, and various acylphloroglucinols. The essential oil is rich in 1,8-cineole, alpha-pinene, beta-pinene, limonene, and alpha-terpineol. These phytochemical constituents are mainly responsible for the plant's antioxidant, antimicrobial, and anti-inflammatory properties.",

    "medicinal_importance": "Callistemon lanceolatus possesses several medicinal and pharmacological properties because of its rich phytochemical composition. The plant exhibits antimicrobial, antioxidant, anti-inflammatory, antidiabetic, antifungal, insecticidal, and antiproliferative activities. Leaf and aerial part extracts are effective against bacterial pathogens such as Staphylococcus aureus and fungal organisms including Candida albicans. Essential oils derived from the plant are traditionally used in the treatment of cough, bronchitis, respiratory disorders, and minor infections. Flavonoids and triterpenoids isolated from the plant have also shown potential anticancer and anti-inflammatory effects. Antioxidant compounds present in the species help scavenge free radicals and may protect against oxidative stress-related disorders.",

    "economic_importance": "Callistemon lanceolatus has considerable economic importance as an ornamental, medicinal, and aromatic plant. It is widely cultivated in gardens, parks, road dividers, and landscapes because of its attractive crimson bottlebrush flowers. The plant is also valued for essential oil production used in aromatic preparations, herbal medicines, and pharmaceutical products. Leaves are occasionally used as a tea substitute because of their pleasant flavor and aroma. Essential oils possess antimicrobial and insecticidal properties useful in agricultural and medicinal applications. The species additionally contributes to horticulture, landscaping, urban beautification, and environmental management programs.",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2024,
      "details": "Callistemon lanceolatus has not yet been evaluated in the IUCN Red List of Threatened Species."
    },

    "references": [
      {
        "authors": "Madhava Chetty, K., Sivaji, K., & Tulasi Rao, K.",
        "year": 2008,
        "title": "Flowering Plants of Chittoor District, Andhra Pradesh, India",
        "publisher": "Students Offset Printers"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Oyedeji, O. O., Lawal, O. A., Shode, F. O., & Oyedeji, A. O.",
        "year": 2009,
        "title": "Chemical Composition and Antibacterial Activity of the Essential Oils of Callistemon citrinus and Callistemon viminalis from South Africa",
        "journal": "Molecules",
        "volume": "14",
        "issue": "6",
        "pages": "1990-1998",
        "doi": "https://doi.org/10.3390/molecules14061990"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sowndhararajan, K., Deepa, P., & Kim, S.",
        "year": 2021,
        "title": "A Review of the Chemical Composition and Biological Activities of Callistemon lanceolatus (Sm.) Sweet",
        "journal": "Journal of Applied Pharmaceutical Science",
        "volume": "11",
        "issue": "12",
        "pages": "065-073"
      }
    ]
  }
  ,
  {
    plant: 29,
    "id": "Moringa-oleifera",

    "scientific_name": "Moringa oleifera ",

    "aname": "Lam.",
    "common_name": "Drumstick Tree",

    "local_name": "Munaga Chettu, Horseradish Tree",

    "image": "/Flora/plant29.jpeg",
    gallery: {

      bark: "/Flora/plant29a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant29b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Moringa-oleifera",
    'qr_code': '/Flora/qrcodes/Moringa-oleifera.png',

    "botanical_profile": {
      "scientific_name": "Moringa oleifera ",
      "aname": "Lam.",
      "common_name": "Drumstick Tree",
      "local_name": "Munaga Chettu, Horseradish Tree",
      "family": "Moringaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Sapindales",
      "family": "Moringaceae",
      "genus": "Moringa",
      "species": "oleifera"
    },

    "morphological_characters": "M. oleifera is a medium-sized deciduous tree growing up to 8 m tall with grey-white bark marked by longitudinal wrinkles. Leaves are usually tripinnate and measure up to 40 cm long. Leaflets are obovate or elliptic, glabrous, obtuse, and measure about 1.5–2.5 × 1–1.5 cm. Flowers are white, sweet-scented, and borne in terminal panicles. Fruits are long, linear, woody capsules that dehisce loculicidally. Seeds are short-winged and adapted for dispersal. The species is widely cultivated in gardens, agricultural lands, and house compounds for its nutritional and medicinal importance (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Medium-sized tree",
      "bark": "Grey-white with longitudinal wrinkles",
      "leaves": "Tripinnate",
      "leaflets": "Obovate or elliptic, glabrous",
      "flowers": "White and sweet-scented",
      "inflorescence": "Terminal panicles",
      "fruit": "Long linear woody capsules",
      "seed": "Short-winged"
    },

    "phytochemical_constituents": "M. oleifera contains a broad spectrum of phytochemicals distributed in leaves, seeds, bark, roots, flowers, and pods. Major constituents include flavonoids such as quercetin, kaempferol, and apigenin; phenolic acids including chlorogenic acid, caffeic acid, and gallic acid; alkaloids, glucosinolates, isothiocyanates, tannins, saponins, terpenoids, steroids, carotenoids, phytosterols, vitamins, minerals, proteins, and essential amino acids. Important compounds reported include β-carotene, lutein, stigmasterol, sitosterol, vitamin C, vitamin A, calcium, potassium, and iron. These phytochemicals are mainly responsible for the antioxidant, nutritional, and therapeutic properties of the plant (Rathore & Das, 2022; Anwar et al., 2007; Saini et al., 2016).",

    "medicinal_importance": "M. oleifera possesses extensive medicinal value and is widely utilized in traditional and modern medicine. The plant exhibits antioxidant, anti-inflammatory, antidiabetic, antimicrobial, anticancer, hepatoprotective, cardioprotective, antiulcer, analgesic, and antipyretic activities. Leaves, seeds, roots, flowers, and bark are used in herbal remedies and pharmaceutical formulations for the treatment of malnutrition, anemia, diabetes, hypertension, infections, gastric disorders, and inflammatory conditions. Experimental studies support its therapeutic potential against oxidative stress, microbial infections, metabolic disorders, and liver dysfunctions (Rathore & Das, 2022; Fahey, 2005; Leone et al., 2015).",

    "economic_importance": "M. oleifera has remarkable economic importance because almost every part of the plant has commercial utility. Seeds yield high-quality oil used in perfumes, cosmetics, lubricants, and hair-care products. Seed cake remaining after oil extraction serves as organic fertilizer and natural coagulant for water purification. Leaves are used as nutritious food supplements, cattle fodder, and raw material for nutraceutical industries. Wood is useful in paper and textile industries, while bark is employed in tanning. The plant also contributes to renewable energy production through biogas generation. India is one of the largest producers of moringa, with Andhra Pradesh, Karnataka, and Tamil Nadu serving as major cultivation regions contributing substantially to rural economy and agricultural income (Anwar et al., 2007; Rathore & Das, 2022).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2020,
      "details": "Moringa oleifera was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern due to its wide cultivation and stable population trend (Roland, 2020)."
    },

    "references": [
      {
        "authors": "Anwar, F., Latif, S., Ashraf, M., & Gilani, A. H.",
        "year": 2007,
        "title": "Moringa oleifera: A food plant with multiple medicinal uses",
        "journal": "Phytotherapy Research",
        "volume": "21",
        "issue": "1",
        "pages": "17–25",
        "doi": "https://doi.org/10.1002/ptr.2023"
      },
      {
        "authors": "Fahey, J. W.",
        "year": 2005,
        "title": "Moringa oleifera: A review of the medical evidence for its nutritional, therapeutic, and prophylactic properties",
        "journal": "Trees for Life Journal",
        "volume": "1",
        "issue": "5",
        "pages": "1–15"
      },
      {
        "authors": "Leone, A., Spada, A., Battezzati, A., Schiraldi, A., Aristil, J., & Bertoli, S.",
        "year": 2015,
        "title": "Cultivation, genetic, ethnopharmacology, phytochemistry and pharmacology of Moringa oleifera leaves: An overview",
        "journal": "International Journal of Molecular Sciences",
        "volume": "16",
        "issue": "6",
        "pages": "12791–12835",
        "doi": "https://doi.org/10.3390/ijms160612791"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers",
        "pages": "232"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rathore, J., & Das, C. R.",
        "year": 2022,
        "title": "Moringa oleifera: A review of phytochemical constituents and medicinal properties as a future source of new drugs",
        "journal": "International Journal of Health Sciences",
        "volume": "6",
        "issue": "S1",
        "pages": "6952–6976"
      },
      {
        "authors": "Roland, C.",
        "year": 2020,
        "title": "Moringa oleifera",
        "source": "The IUCN Red List of Threatened Species 2020",
        "pages": "e.T61890232A61890241",
        "doi": "https://doi.org/10.2305/IUCN.UK.2020-3.RLTS.T61890232A61890241.en"
      },
      {
        "authors": "Saini, R. K., Sivanesan, I., & Keum, Y. S.",
        "year": 2016,
        "title": "Phytochemicals of Moringa oleifera: A review of their nutritional, therapeutic and industrial significance",
        "journal": "3 Biotech",
        "volume": "6",
        "pages": "203",
        "doi": "https://doi.org/10.1007/s13205-016-0526-3"
      }
    ]
  },
  {
    plant: 30,
    "id": "Chloroxylon-swietenia",

    "scientific_name": "Chloroxylon swietenia ",

    "aname": "(Roxb.) DC.",
    "common_name": "East Indian Satinwood",

    "local_name": "Billudu, Satinwood",

    "image": "/Flora/plant30.jpeg",
    gallery: {

      bark: "/Flora/plant30a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant30b.jpeg",
      fruit: "/Flora/plant30c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Chloroxylon-swietenia",
    'qr_code': '/Flora/qrcodes/Chloroxylon-swietenia.png',

    "botanical_profile": {
      "scientific_name": "Chloroxylon swietenia ",
      "aname": "(Roxb.) DC.",
      "common_name": "East Indian Satinwood",
      "local_name": "Billudu, Satinwood",
      "family": "Rutaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledones",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Rutaceae",
      "genus": "Chloroxylon",
      "species": "swietenia"
    },

    "morphological_characters": "C. swietenia is a medium-sized deciduous tree growing up to 8 m tall. Bark is externally pale yellowish-brown and rough in texture, while the wood is yellowish with a characteristic fibrous texture and satin-like lustre. Leaves are pinnate with oblong-lanceolate leaflets measuring about 2–3.5 × 0.5–1.5 cm. Leaflets are gland-dotted, obtuse, entire, and possess an oblique base. Flowers are white and borne in terminal racemes. Fruits are ovoid-oblong capsules containing compressed winged seeds adapted for dispersal. The species commonly occurs in dry deciduous forests and rocky regions of India (Pullaiah & Venkata Raju, 1995; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tree",
      "bark": "Pale yellowish-brown",
      "wood": "Yellowish with fibrous texture",
      "leaves": "Pinnate",
      "leaflets": "Oblong-lanceolate, gland-dotted",
      "flowers": "White",
      "inflorescence": "Terminal racemes",
      "fruit": "Ovoid-oblong capsule",
      "seed": "Compressed and winged"
    },

    "phytochemical_constituents": "C. swietenia contains several important phytochemical constituents in different solvent extracts, particularly methanol and ethanol extracts. Major phytochemicals reported include alkaloids, anthraquinones, catechins, coumarins, flavonoids, glycosides, phenols, quinones, saponins, steroids, sugars, tannins, and xanthoproteins. Flavonoids, phenolic compounds, and tannins occur in significant quantities and are associated with strong antioxidant properties. These phytochemicals contribute to the biological and therapeutic importance of the species (Devi & Mohan, 2018; Kirtikar & Basu, 2006).",

    "medicinal_importance": "C. swietenia possesses several medicinal properties because of its rich phytochemical composition. Flavonoids exhibit anti-inflammatory, anti-allergic, antiviral, anti-ageing, and anticarcinogenic activities, while phenolic compounds function as antioxidants by scavenging free radicals and reducing oxidative stress. Tannins are traditionally used as astringents for the treatment of wounds and burns. Plant extracts have also shown potential therapeutic applications against hyperglycemia, hyperlipidemia, diabetes mellitus, cardiovascular diseases, osteoporosis, neurodegenerative disorders, and certain skin diseases. Traditional medicinal systems additionally employ different parts of the plant for treating inflammation and microbial infections (Devi & Mohan, 2018; Nadkarni, 2007).",

    "economic_importance": "C. swietenia possesses significant economic value because of its medicinally important phytochemicals and highly valued timber. The yellow satin-like wood is durable, attractive, and extensively used in high-quality furniture, cabinetry, decorative veneers, agricultural implements, and handicrafts. Ethanol and methanol extracts rich in bioactive compounds are useful in the development of herbal medicines and phytopharmaceutical products. The plant therefore contributes to timber industries, healthcare applications, and nutraceutical research, increasing its commercial significance in forestry and pharmaceutical sectors (Devi & Mohan, 2018; Troup, 1921).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2024,
      "details": "Chloroxylon swietenia has not yet been evaluated in The IUCN Red List of Threatened Species."
    },

    "references": [
      {
        "authors": "Devi, A. N., & Mohan, G. K.",
        "year": 2018,
        "title": "A review on Chloroxylon swietenia",
        "journal": "International Journal of Pharmacy and Biological Sciences",
        "volume": "8",
        "issue": "4",
        "pages": "502–506"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., & Venkata Raju, R. R.",
        "year": 1995,
        "title": "Flora of Kurnool",
        "publisher": "Bishen Singh Mahendra Pal Singh Publishers",
        "pages": "110–111"
      },
      {
        "authors": "Troup, R. S.",
        "year": 1921,
        "title": "The Silviculture of Indian Trees (Vol. 2)",
        "publisher": "Clarendon Press"
      }
    ]
  },
  {
    plant: 31,
    "id": "Morinda-pubescens",

    "scientific_name": "Morinda pubescens Sm.",

    "aname": "Sm.",
    "common_name": "Indian Mulberry",

    "local_name": "Maddi, Bandamaddi, Molagha, Togara",

    "image": "/Flora/plant31.jpeg",
    gallery: {

      bark: "/Flora/plant31a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant31b.jpeg",
      fruit: "/Flora/plant31c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Morinda-pubescens",
    'qr_code': '/Flora/qrcodes/Morinda-pubescens.png',

    "botanical_profile": {
      "scientific_name": "Morinda pubescens Sm.",
      "aname": "Sm.",
      "common_name": "Indian Mulberry",
      "local_name": "Maddi, Bandamaddi, Molagha, Togara",
      "family": "Rubiaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Inferae",
      "order": "Rubiales",
      "family": "Rubiaceae",
      "genus": "Morinda",
      "species": "pubescens"
    },

    "morphological_characters": "M. pubescens is a small tree commonly distributed in forest regions of many districts in India. Leaves are obovate-elliptic with attenuate to rounded bases, undulate margins, acuminate apices, and tomentose surfaces. Petioles are short and stipules are connate forming a bifid sheath. Inflorescences are usually solitary, axillary, or rarely terminal globose heads. Flowers are small, white, and arranged compactly in globose heads. Fruits form a syncarpium due to the fusion of multiple fruits. The species commonly occurs in dry deciduous forests and scrub vegetation (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small tree",
      "leaves": "Obovate-elliptic with undulate margin",
      "stipules": "Connate into bifid sheath",
      "inflorescence": "Axillary globose heads",
      "flowers": "White",
      "fruit": "Syncarpium"
    },

    "phytochemical_constituents": "M. pubescens is rich in diverse bioactive phytochemicals. The plant contains major secondary metabolites such as alkaloids, flavonoids, phenols, tannins, terpenoids, steroids, saponins, coumarins, anthraquinones, cardiac glycosides, lignin, and catechin. Important compounds identified include morindone, damnacanthal, rubiadin, ursolic acid, taraxerol, β-sitosterol, stigmasterol, hyoscyamine, phytol, linoleic acid, caproic acid, caprylic acid, and anthragallol derivatives. Fatty acids such as palmitic, oleic, stearic, and arachidic acids are present in the seed oil. The plant also contains essential minerals including calcium, potassium, magnesium, zinc, iron, and manganese, contributing to its biological activities (Dhivya & Santhy, 2018; Warrier et al., 1996).",

    "medicinal_importance": "M. pubescens possesses significant ethnomedicinal and pharmacological importance. Traditionally, the plant is used for treating diabetes, fever, malaria, rheumatism, jaundice, ulcers, eczema, digestive disorders, wounds, piles, and microbial infections. Leaves are applied externally for wound healing and skin disorders, while roots are valued as anti-inflammatory and tonic agents. Bark preparations are used for fever and dermatological conditions. Pharmacological investigations have demonstrated antimicrobial, antioxidant, anticancer, antidiabetic, hepatoprotective, nephroprotective, anti-inflammatory, and wound healing activities. Studies also indicate its ability to induce apoptosis in cancer cells, reduce blood glucose levels, and protect liver and kidney tissues from oxidative damage (Dhivya & Santhy, 2018; Nadkarni, 2007).",

    "economic_importance": "M. pubescens has several economic and industrial applications. The plant is traditionally utilized as a natural green dye and dye adsorbent in textile industries. It serves as a low-cost biosorbent for removing industrial dyes such as malachite green and crystal violet from wastewater. The species is also used as green manure and plant growth stimulant, improving seed germination and crop growth. Additionally, the plant is explored in green synthesis of silver and zinc oxide nanoparticles because of its phytochemical richness. These properties make the species valuable in textile, environmental biotechnology, agriculture, and pharmaceutical sectors (Dhivya & Santhy, 2018).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2024,
      "details": "Morinda pubescens has not yet been evaluated in The IUCN Red List of Threatened Species."
    },

    "references": [
      {
        "authors": "Dhivya, J. V., & Santhy, K. S.",
        "year": 2018,
        "title": "Demystifying the ethnomedicinal plant Morinda pubescens with ethnopharmacological, phytochemical, and pharmacotoxicological evidence",
        "journal": "Journal of Critical Reviews",
        "volume": "5",
        "issue": "5",
        "pages": "1–6",
        "doi": "https://doi.org/10.22159/jcr.2018v5i5.28484"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "489"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      }
    ]
  }
  ,
  {
    plant: 32,
    "id": "Madhuca-indica",

    "scientific_name": "Madhuca indica ",

    "aname": "J.F.Gmel.",
    "common_name": "Indian Butter Tree",

    "local_name": "Ippa, Madhukamu, Mahua, Indian Butter Tree",

    "image": "/Flora/plant32.jpeg",
    gallery: {

      bark: "/Flora/plant32a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant32b.jpeg",
      fruit: "/Flora/plant32c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Madhuca-indica",
    'qr_code': '/Flora/qrcodes/Madhuca-indica.png',

    "botanical_profile": {
      "scientific_name": "Madhuca indica ",
      "aname": "J.F.Gmel.",
      "common_name": "Indian Butter Tree",
      "local_name": "Ippa, Madhukamu, Mahua",
      "family": "Sapotaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Heteromerae",
      "order": "Ebenales",
      "family": "Sapotaceae",
      "genus": "Madhuca",
      "species": "indica"
    },

    "morphological_characters": "M. indica is a medium to large deciduous tree belonging to the family Sapotaceae and grows up to 20 m tall. The trunk is stout with thick dark-colored bark that is vertically cracked externally and reddish internally, exuding milky latex upon injury. Young branchlets are densely tomentose. Leaves are simple, alternate, elliptic-ovate, 4–8.5 × 2–4.5 cm, glabrous on both surfaces, entire margined, apiculate at the apex, cuneate at the base, and borne on distinct petioles. Flowers are creamish-white, fleshy, sweet-scented, and arranged in dense axillary fascicles. Fruits are fleshy berries, tawny tomentose, containing 1–4 seeds. Seeds are ovoid, smooth, shiny, and dark brown to black in colour (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Medium to large deciduous tree",
      "branches": "Tomentose young branchlets",
      "bark": "Thick, dark coloured, cracked, milky latex present",
      "leaves": "Glabrous on both sides, petiolate, elliptic-ovate",
      "flowers": "Creamish-white and fleshy",
      "inflorescence": "Axillary dense fascicles",
      "fruit": "Tawny tomentose berries",
      "seed": "Ovoid, smooth, shiny, dark brown to black"
    },

    "phytochemical_constituents": "M. indica contains numerous biologically active phytochemicals distributed in different plant parts. Important compounds include triterpenoids such as madhucic acid, erythrodiol, lupeol, betulinic acid, ursolic acid, oleanolic acid, β-amyrin, and α-amyrin acetate. Flavonoids and isoflavones including quercetin, taxifolin, myricetin, flavanones, and madhucosides have also been reported. Seeds contain fatty acids such as oleic acid, linoleic acid, palmitic acid, stearic acid, arachidic acid, and myristic acid. Saponins such as saponin A and saponin B, carbohydrates including glucose, fructose, sucrose, galactose, arabinose, and xylose, along with phenolic compounds like ferulic acid, hydroquinone, and p-hydroxyacetophenone are also present. Steroids, glycosides, tannins, and polysaccharides contribute to its medicinal importance (Roat et al., 2023; Warrier et al., 1995).",

    "medicinal_importance": "Different parts of M. indica possess remarkable ethnomedicinal and pharmacological importance. Bark is traditionally used in the treatment of wounds, fractures, swelling, ulcers, gum diseases, itching, and snake bite. Leaves are applied for burns, eczema, migraine, hemorrhoids, and vomiting. Flowers act as cooling tonics, expectorants, diuretics, antihelmintics, and are useful in cough and bronchitis. Seed oil is extensively used for rheumatism, skin diseases, headache, constipation, and wound healing. Scientific investigations have demonstrated antioxidant, anti-inflammatory, antimicrobial, antifungal, hepatoprotective, antidiabetic, anticancer, antiulcer, antihyperglycemic, analgesic, and wound-healing activities owing to the presence of flavonoids, saponins, triterpenoids, and phenolic constituents (Roat et al., 2023; Kritikar & Basu, 2005; Warrier et al., 1995).",

    "economic_importance": "M. indica is an economically valuable multipurpose tree widely utilized in rural and tribal communities. Flowers are used in the preparation of traditional fermented beverages, sweets, syrups, jams, jellies, and natural sweeteners. Seeds yield edible and industrial oil used in soap making, detergents, cosmetics, candles, biodiesel, lubricants, and aromatic oils. Leaves serve as fodder while wood is used as fuel and timber. The tree contributes significantly to tribal livelihoods through food, medicine, and income generation. Due to its high calorific value and multipurpose utility, the species is considered an important energy-efficient and commercially valuable tree in India (Roat et al., 2023; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "details": "Madhuca indica has not yet been evaluated under the IUCN Red List categories."
    },

    "references": [
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2005,
        "title": "Indian medicinal plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "pages": "549",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Roat, P., Hada, S., Chechani, B., Yadav, D. K., Kumar, S., & Kumari, N.",
        "year": 2023,
        "title": "Madhuca indica: A review on the phytochemical and pharmacological aspects",
        "journal": "Pharmaceutical Chemistry Journal",
        "volume": "57",
        "issue": "2",
        "pages": "284–295"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Pharmacognosy",
        "edition": "16th",
        "publisher": "Saunders Elsevier"
      }
    ]
  }
  ,
  {
    plant: 33,
    "id": "Tecoma-stans",

    "scientific_name": "Tecoma stans ",

    "aname": "(L.) Juss. ex Kunth",
    "common_name": "Yellow Bells",

    "local_name": "Pachagotla, Yellow Bells",

    "image": "/Flora/plant33.jpeg",
    gallery: {

      bark: "/Flora/plant33a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant33b.jpeg",
      fruit: "/Flora/plant33c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Tecoma-stans",
    'qr_code': '/Flora/qrcodes/Tecoma-stans.png',

    "botanical_profile": {
      "scientific_name": "Tecoma stans ",
      "aname": "(L.) Juss. ex Kunth",
      "common_name": "Yellow Bells",
      "local_name": "Pachagotla, Yellow Bells",
      "family": "Bignoniaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Personales",
      "family": "Bignoniaceae",
      "genus": "Tecoma",
      "species": "stans"
    },

    "morphological_characters": "T. stans is a small evergreen ornamental tree or shrub belonging to the family Bignoniaceae. The bark is light brown to grey and smooth with lenticels in young branches. Leaves are opposite, pinnately compound with lanceolate leaflets having serrated or dentate margins. Flowers are large, showy, golden yellow, trumpet-shaped, and arranged in terminal racemes. Fruits are linear, flattened, elongated dehiscent capsules containing numerous flattened winged seeds. The species is widely cultivated as an ornamental avenue and garden plant because of its attractive flowering habit (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Evergreen tree or shrub",
      "bark": "Light brown to grey, smooth with lenticels",
      "leaves": "Opposite and pinnately compound",
      "leaflets": "Lanceolate with dentate margins",
      "flowers": "Golden yellow, trumpet-shaped",
      "inflorescence": "Terminal racemes",
      "fruit": "Linear, flattened dehiscent capsule",
      "seeds": "Numerous, flattened and winged"
    },

    "phytochemical_constituents": "T. stans contains a wide range of bioactive phytochemicals including monoterpenoid alkaloids, flavonoids, phenolics, triterpenoids, sterols, and glycosides. Important compounds reported from different plant parts include tecomine, tecostanine, 5-hydroxy-skytanthine hydrochloride, lapachol, ursolic acid, oleanolic acid, α-amyrin, β-sitosterol, chlorogenic acid, caffeic acid, vanillic acid, coumaric acid, sinapic acid, and various flavonoids and tannins. Sugars such as glucose, fructose, sucrose, and xylose are also present. A novel phenylethanoid glycoside and several secondary metabolites have been isolated from fruits and flowers, contributing to the medicinal and pharmacological significance of the species (Verma, 2016; Anand & Basavaraju, 2021).",

    "medicinal_importance": "T. stans possesses several important pharmacological activities due to the presence of flavonoids, alkaloids, tannins, phenolics, saponins, and triterpenoids. Extracts of the plant exhibit antioxidant, antimicrobial, antifungal, anti-inflammatory, wound-healing, antidiabetic, and anticancer properties. Alcoholic and aqueous extracts have demonstrated antibacterial activity against Escherichia coli and Bacillus subtilis. Methanolic leaf extracts have shown significant wound-healing activity. Flavonoids and phenolic compounds act as free radical scavengers, while tannins and saponins contribute to antioxidant and antimicrobial actions. Tecomine and chlorogenic acid have also been reported to possess glucose-lowering activity, supporting the traditional use of the plant in diabetes management (Verma, 2016; Anand & Basavaraju, 2021).",

    "economic_importance": "T. stans is widely cultivated as an ornamental plant in gardens, parks, roadsides, and institutional landscapes because of its bright yellow attractive flowers and prolonged blooming season. The flowers are an important nectar source in apiculture and support pollinator populations. Certain phytochemicals isolated from the plant have industrial and pharmaceutical importance. Plant extracts and isolated compounds are utilized in cosmetic formulations, perfumery, and flavoring components. Recently, leaf and flower extracts have been employed in the green synthesis of silver nanoparticles with applications in biomedicine, wound healing, antimicrobial coatings, and food packaging industries. The species also contributes to ecological beautification and urban landscaping (Anand & Basavaraju, 2021).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Tecoma stans was assessed by the IUCN Red List and categorized as Least Concern due to its wide distribution and extensive cultivation."
    },

    "references": [
      {
        "authors": "Anand, M., & Basavaraju, R.",
        "year": 2021,
        "title": "A review on phytochemistry and pharmacological uses of Tecoma stans (L.) Juss. Ex Kunth",
        "journal": "Journal of Ethnopharmacology",
        "volume": "265",
        "pages": "113270"
      },
      {
        "authors": "Botanic Gardens Conservation International (BGCI) & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Tecoma stans",
        "journal": "The IUCN Red List of Threatened Species",
        "pages": "e.T82858855A149060597"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "pages": "686",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Verma, S.",
        "year": 2016,
        "title": "Phytochemical and pharmacological review study on Tecoma stans Linn.",
        "journal": "Journal of Medicinal Plants Studies",
        "volume": "4",
        "issue": "5",
        "pages": "162–164"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2005,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      }
    ]
  }


  ,
  {
    plant: 34,
    "id": "Holoptelea-integrifolia",

    "scientific_name": "Holoptelea integrifolia ",

    "aname": "(Roxb.) Planch.",
    "common_name": "Indian Elm",

    "local_name": "Nemali Nara, Thapasi, Jungle Cork Tree",

    "image": "/Flora/plant34.jpeg",
    gallery: {

      bark: "/Flora/plant34a.jpeg",
      // leaf: "/Flora/plant34_leaf.jpg",
      //flower: "/Flora/plant34_flower.jpeg",
      fruit: "/Flora/plant34b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Holoptelea-integrifolia",
    'qr_code': '/Flora/qrcodes/Holoptelea-integrifolia.png',

    "botanical_profile": {
      "scientific_name": "Holoptelea integrifolia ",
      "aname": "(Roxb.) Planch.",
      "common_name": "Indian Elm",
      "local_name": "Nemali Nara, Thapasi, Jungle Cork Tree",
      "family": "Ulmaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Monochlamydeae",
      "series": "Unisexuales",
      "order": "Urticales",
      "family": "Ulmaceae",
      "genus": "Holoptelea",
      "species": "integrifolia"
    },

    "morphological_characters": "H. integrifolia is a medium to large deciduous tree reaching up to 12 m in height with pubescent young parts and grey bark. Leaves are elliptic-ovate, measuring about 6–12 × 3–8 cm, pubescent, acute at the apex, entire, and rounded or truncate at the base. Flowers are greenish-yellow and borne in axillary fascicles. Fruits are dry, winged samaras containing solitary, flat, kidney-shaped light-brown seeds. The species is commonly distributed in dry deciduous forests and plains throughout India (Venkata Raju & Pullaiah, 1995; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Medium-sized deciduous tree",
      "bark": "Grey",
      "leaves": "Elliptic-ovate, pubescent, acute",
      "flowers": "Greenish-yellow",
      "inflorescence": "Axillary fascicles",
      "fruit": "Dry, winged samara",
      "seed": "Solitary, flat, kidney-shaped, light brown"
    },

    "phytochemical_constituents": "H. integrifolia contains numerous bioactive compounds including terpenoids, sterols, saponins, tannins, proteins, carbohydrates, alkaloids, phenols, flavonoids, glycosides, coumarins, and quinones. Important isolated compounds reported from the bark and leaves include Holoptelin-A, Holoptelin-B, friedelin, epifriedelin, β-amyrin, α-amyrin, β-sitosterol, stigmasterol, hederagenin, hexacosanol, octacosanol, betulin, betulinic acid, and 1,4-naphthalenedione. These phytochemicals contribute significantly to the medicinal potential of the plant (Ganie & Yadav, 2014; Benjamin & Christopher, 2009).",

    "medicinal_importance": "H. integrifolia possesses significant medicinal importance in traditional systems of medicine. Various plant parts are used in the treatment of skin diseases, rheumatism, inflammation, intestinal worms, diabetes, obesity, fever, digestive disorders, and wounds. Pharmacological investigations have demonstrated antibacterial, antifungal, anti-inflammatory, analgesic, antioxidant, anthelmintic, antidiabetic, antidiarrhoeal, adaptogenic, anticancer, wound-healing, hepatoprotective, larvicidal, antiemetic, CNS depressant, and hypolipidemic activities. These biological activities are mainly attributed to the presence of flavonoids, terpenoids, sterols, and quinones (Ganie & Yadav, 2014; Harsha et al., 2003; Kumar et al., 2012).",

    "economic_importance": "H. integrifolia is economically valuable as a medicinal and multipurpose tree species. The wood is used for light construction, furniture, packing cases, agricultural implements, and fuelwood. Leaves and bark are traded in traditional herbal medicine markets. The tree is also planted for shade, avenue planting, and environmental conservation purposes. Due to its antimicrobial and pesticidal properties, the species has potential applications in pharmaceutical and natural pesticide industries (Warrier et al., 1995; Prajapati et al., 2003).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2022,
      "details": "Holoptelea integrifolia was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern."
    },

    "references": [
      {
        "authors": "Benjamin, J. K. P., & Christopher, P. K. S.",
        "year": 2009,
        "title": "Preliminary phytochemical and pharmacognostic studies of Holoptelea integrifolia Roxb.",
        "journal": "Ethnobotanical Leaflets",
        "volume": "13",
        "pages": "1222–1231"
      },
      {
        "authors": "De Kok, R.",
        "year": 2024,
        "title": "Holoptelea integrifolia",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T213369224A213399836"
      },
      {
        "authors": "Ganie, S. A., & Yadav, S. S.",
        "year": 2014,
        "title": "Holoptelea integrifolia (Roxb.) Planch: A review of its ethnobotany, pharmacology, and phytochemistry",
        "journal": "BioMed Research International",
        "volume": "2014",
        "article_id": "401213",
        "doi": "10.1155/2014/401213"
      },
      {
        "authors": "Harsha, V. H., Hebbar, S. S., Shripathi, V., & Hegde, G. R.",
        "year": 2003,
        "title": "Ethnomedicobotany of Uttara Kannada district in Karnataka, India: Plants in treatment of skin diseases",
        "journal": "Journal of Ethnopharmacology",
        "volume": "84",
        "issue": "1",
        "pages": "37–40",
        "doi": "10.1016/S0378-8741(02)00261-1"
      },
      {
        "authors": "Kumar, D., Kumar, K., Kumar, S., & Kumar, T.",
        "year": 2012,
        "title": "Pharmacognostic evaluation of leaf and root bark of Holoptelea integrifolia Roxb.",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "2",
        "issue": "3",
        "pages": "169–175",
        "doi": "10.1016/S2221-1691(12)60036-7"
      },
      {
        "authors": "Mahishi, P., Srinivasa, B. H., & Shivanna, M. B.",
        "year": 2005,
        "title": "Medicinal plant wealth of local communities in some villages in Shimoga district of Karnataka, India",
        "journal": "Journal of Ethnopharmacology",
        "volume": "98",
        "issue": "3",
        "pages": "307–312",
        "doi": "10.1016/j.jep.2005.01.035"
      },
      {
        "authors": "Parinitham, M., Harish, G. U., Vivek, N. C., Mahesh, T., & Shivanna, M. B.",
        "year": 2004,
        "title": "Ethnobotanical wealth of Bhadra wildlife sanctuary in Karnataka",
        "journal": "Indian Journal of Traditional Knowledge",
        "volume": "3",
        "pages": "37–50"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A Handbook of Medicinal Plants: A Complete Source Book",
        "publisher": "Agrobios Publications"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Ramzan, M. M., Gul, H., Ali, I., et al.",
        "year": 2025,
        "title": "Phytochemical, antioxidant and physicochemical evaluation of Holoptelea integrifolia (Roxb.) seed oil",
        "journal": "South Eastern European Journal of Public Health",
        "doi": "10.70135/seejph.vi.6788"
      },
      {
        "authors": "Singh, V. K., & Ali, Z. A.",
        "year": 1994,
        "title": "Folk medicines in primary health care: Common plants used for the treatment of fevers in India",
        "journal": "Fitoterapia",
        "volume": "65",
        "issue": "1",
        "pages": "68–74"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool, Andhra Pradesh",
        "publisher": "Bishen Singh Mahendra Pal Singh",
        "page": 433
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 35,
    "id": "Caryota-urens",

    "scientific_name": "Caryota urens ",

    "aname": "L.",
    "common_name": "Fishtail Palm",

    "local_name": "Jeelugu, Fishtail Palm, Toddy Palm",

    "image": "/Flora/plant35.jpeg",
    gallery: {

      bark: "/Flora/plant35a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant35b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Caryota-urens",
    'qr_code': '/Flora/qrcodes/Caryota-urens.png',

    "botanical_profile": {
      "scientific_name": "Caryota urens ",
      "aname": "L.",
      "common_name": "Fishtail Palm",
      "local_name": "Jeelugu, Fishtail Palm, Toddy Palm",
      "family": "Arecaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Monocotyledones",
      "series": "Calycineae",
      "order": "Arecales",
      "family": "Arecaceae",
      "genus": "Caryota",
      "species": "urens"
    },

    "morphological_characters": "C. urens is a medium to tall palm tree with smooth, shining stems and light grey bark marked by prominent annular leaf scars. Leaves are large and bipinnate with irregularly serrate leaflets resembling a fishtail. Flowers are light green and arranged in interfoliar spadices. Fruits are globose yellow berries containing small, round, slightly flattened seeds. The species occurs occasionally in the Nallamalai forests and is also widely cultivated as an ornamental and economic palm in tropical regions of South Asia (Venkata Raju & Pullaiah, 1995; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Palm tree",
      "bark": "Smooth, light grey with annular leaf scars",
      "leaves": "2-pinnate",
      "leaflets": "Irregularly serrate, fishtail-shaped",
      "flowers": "Light green",
      "inflorescence": "Interfoliar spadices",
      "fruit": "Globose yellow berries",
      "seed": "Small, round, plano-convex"
    },

    "phytochemical_constituents": "C. urens contains numerous phytochemical compounds distributed in roots, bark, leaves, flowers, sap, and seeds. Major constituents include polyphenols such as caffeoylquinic acids and caffeoylshikimic acids, flavonoids including quercetin, kaempferol, and eriocitrin, amino acids, fatty acids, phytosterols, sugars, and starch-rich compounds in the pith. Antioxidant compounds present in the sap and seeds contribute significantly to its medicinal properties. Phytochemical screening studies have also reported the occurrence of phenolics, tannins, glycosides, and bioactive antioxidant metabolites responsible for antimicrobial and free radical scavenging activities (Dulmini & Perera, 2024; Arunachalam et al., 2012; Krishnaraj & Ramasamy, 2016).",

    "medicinal_importance": "C. urens possesses important medicinal properties in traditional and Ayurvedic systems of medicine. Different plant parts are used for the treatment of rheumatic swelling, snakebite poisoning, tooth ailments, anemia, jaundice, and gastrointestinal disorders. Scientific studies have demonstrated antidiabetic, anticancer, antioxidant, antimicrobial, anti-inflammatory, and libido-enhancing activities. Traditional tribal communities in South India also use the plant for wound healing and general health improvement. These therapeutic effects are mainly attributed to the presence of flavonoids, polyphenols, phenolic acids, and antioxidant phytochemicals (Dulmini & Perera, 2024; Joseph & Raj, 2010; Warrier et al., 1994).",

    "economic_importance": "C. urens is an economically valuable multipurpose palm species. The tapped inflorescence sap is used for preparing sweet toddy, fermented alcoholic beverages, treacle syrup, and jaggery. Starch extracted from the pith is processed into edible flour and traditional food products. The species provides livelihood opportunities for rural communities through tapping, processing, handicrafts, and local trade activities. It also has ornamental, cultural, agroforestry, and biodiversity conservation significance, particularly in Sri Lanka and South India. The tree is additionally valued for soil conservation, avenue planting, and sustainable utilization in rural economies (Orwa et al., 2009; Sivaraj et al., 2014; Nadkarni, 2007).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2009,
      "details": "Caryota urens was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern."
    },

    "references": [
      {
        "authors": "Anonymous",
        "year": 1992,
        "title": "The Wealth of India: Raw Materials (Vol. 3)",
        "publisher": "Council of Scientific and Industrial Research (CSIR)"
      },
      {
        "authors": "Arunachalam, K., Parimelazhagan, T., & Nallamuthu, T.",
        "year": 2012,
        "title": "Studies on phytochemical constituents and antioxidant potential of Caryota urens L.",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "2",
        "issue": "3",
        "pages": "S1553–S1558"
      },
      {
        "authors": "Dulmini, A. D. T., & Perera, S. D.",
        "year": 2024,
        "title": "Phytochemical constituents in Kithul (Caryota urens) and its medical significance: A mini review",
        "journal": "OUSL Journal",
        "volume": "19",
        "issue": "1",
        "pages": "7–26"
      },
      {
        "authors": "Joseph, J., & Raj, S. J.",
        "year": 2010,
        "title": "Traditional uses of Caryota urens among tribal communities of South India",
        "journal": "Indian Journal of Traditional Knowledge",
        "volume": "9",
        "issue": "1",
        "pages": "102–104"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants (Vol. 4)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Krishnaraj, M., & Ramasamy, V.",
        "year": 2016,
        "title": "Phytochemical screening and antimicrobial activity of Caryota urens Linn.",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "37",
        "issue": "2",
        "pages": "98–102"
      },
      {
        "authors": "Loftus, C.",
        "year": 2014,
        "title": "Caryota urens",
        "source": "The IUCN Red List of Threatened Species 2014",
        "pages": "e.T44393459A44452629"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sivaraj, N., Pandravada, S. R., & Sunil, N.",
        "year": 2014,
        "title": "Traditional knowledge and biodiversity conservation of Caryota urens in South India",
        "journal": "Indian Journal of Plant Genetic Resources",
        "volume": "27",
        "issue": "2",
        "pages": "145–150"
      },
      {
        "authors": "Sundriyal, M., & Sundriyal, R. C.",
        "year": 2001,
        "title": "Wild edible plants of the Sikkim Himalaya: Nutritive values of selected species",
        "journal": "Economic Botany",
        "volume": "55",
        "issue": "3",
        "pages": "377–390"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool, Andhra Pradesh",
        "publisher": "Bishen Singh Mahendra Pal Singh",
        "page": 459
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1994,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species (Vol. 2)",
        "publisher": "Orient Longman"
      }
    ]
  }


  ,
  {
    plant: 36,
    "id": "Cassia-auriculata",

    "scientific_name": "Cassia auriculata ",

    "aname": "L.",
    "common_name": "Tanner's Cassia",

    "local_name": "Tangedu",

    "image": "/Flora/plant36.jpeg",
    gallery: {

      bark: "/Flora/plant36a.jpeg",
      // leaf: "/Flora/plant36/leaf.jpg",
      flower: "/Flora/plant36b.jpeg",
      fruit: "/Flora/plant36c.jpeg",
      // seed: "/Flora/plant36/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Cassia-auriculata",
    'qr_code': '/Flora/qrcodes/Cassia-auriculata.png',

    "botanical_profile": {
      "scientific_name": "Cassia auriculata ",
      "aname": "L.",
      "common_name": "Tanner's Cassia",
      "local_name": "Tangedu",
      "family": " Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledons",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Leguminosae / Fabaceae",
      "sub_family": "Caesalpinioideae",
      "genus": "Cassia",
      "species": "auriculata"
    },

    "morphological_characters": "C. auriculata is a much-branched shrub commonly found in wastelands and occasionally in forests. Leaves are pinnate with oblong-obovate leaflets and characteristic glands. Flowers are bright yellow and arranged in terminal corymbose racemes. Pods are long, stipitate, flat, and hairy at the apex, while seeds are ovoid in shape. The species is widely distributed in dry regions of India and commonly cultivated for medicinal and ornamental purposes (Venkata Raju & Pullaiah, 1995).",

    "digital_identification": {
      "habit": "Much-branched shrub",
      "leaves": "Pinnate with oblong-obovate leaflets",
      "flowers": "Yellow",
      "inflorescence": "Terminal corymbose racemes",
      "pods": "Long, stipitate, flat, hairy apex",
      "seeds": "Ovoid"
    },

    "phytochemical_constituents": "C. auriculata is rich in phytochemical constituents distributed throughout the flowers, leaves, roots, bark, seeds, and fruits. Flowers contain alkaloids, glycosides, saponins, phenols, terpenoids, flavonoids, tannins, steroids, aloe-emodin, anthraquinones, and sitosterols. Leaves possess O-methyl-D-glucose, resorcinol, alpha-tocopherol-beta-mannosidase, and carboxylic acids. Seeds contain palmitic acid, linoleic acid, benzoic acid derivatives, and resorcinol, while roots are rich in anthraquinone glycosides and flavone glycosides. Major phytochemical groups such as flavonoids, phenolics, terpenoids, and anthraquinones are mainly responsible for the antioxidant, antidiabetic, and anti-inflammatory activities of the species. Recent pharmacological studies also emphasize the role of bioactive compounds in glucose metabolism regulation and free radical scavenging activity (Jeevitha & Anandan, 2023; Rani & Sharma, 2013; Guruprasad et al., 2021; Tietel et al., 2024).",

    "medicinal_importance": "C. auriculata holds an important place in Ayurvedic and Siddha systems of medicine due to its extensive therapeutic applications. The plant exhibits antidiabetic, antioxidant, antibacterial, anti-inflammatory, analgesic, antimicrobial, antifungal, antihyperlipidemic, hepatoprotective, nephroprotective, anticancer, antiarthritic, antiulcer, anthelmintic, antiparasitic, antipyretic, and immunomodulatory activities. Traditionally, it is used for treating diabetes, rheumatism, conjunctivitis, leprosy, ulcers, skin diseases, eye irritation, leucorrhoea, tuberculosis, fractures, hair loss, stomachache, scorpion stings, constipation, dysentery, diarrhea, urinary disorders, spermatorrhea, and purulent ophthalmia. Various formulations such as 'Avarai Panchaga Choornam' and 'Kalpa Herbal Tea' are prepared using different plant parts for medicinal use. Modern studies have particularly highlighted its antidiabetic mechanisms, safety pharmacology, and therapeutic efficacy in metabolic disorders, supporting its widespread traditional use (Jeevitha & Anandan, 2023; Balamurugan et al., 2011; Guruprasad et al., 2021; Puranik et al., 2011; Shafeeq et al., 2018).",

    "economic_importance": "C. auriculata possesses significant economic value because of its medicinal, pharmaceutical, and industrial applications. Commonly called Tanner's Cassia, it has been traditionally used in the leather tanning industry. The plant is commercially utilized for preparing herbal formulations and health beverages such as Kalpa Herbal Tea used in managing diabetes and urinary disorders. Seeds contain approximately 40.8% fatty acids useful for oil extraction, while roots rich in saponins are utilized in pharmaceutical industries. The species is cultivated in several Indian states including Punjab, Uttar Pradesh, Haryana, and West Bengal, contributing to local economies and traditional medicine markets. Recent commercial interest in herbal nutraceuticals and phytopharmaceutical products has further increased the economic importance of the species. Sustainable cultivation is essential due to increasing commercial demand and overharvesting from natural habitats (Jeevitha & Anandan, 2023; Khare, 2007; Ariyarathna, 2024).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2023,
      "details": "Cassia auriculata was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern."
    },

    "references": [
      {
        "authors": "Ariyarathna, H. A. C. K.",
        "year": 2024,
        "title": "Medicinal and economic importance of Cassia auriculata: A review",
        "journal": "International Journal of Herbal Medicine",
        "volume": "12",
        "issue": "1",
        "pages": "45–53"
      },
      {
        "authors": "Balamurugan, R., Ignacimuthu, S., & Balachandran, B.",
        "year": 2011,
        "title": "Evaluation of anti-diabetic and hypolipidemic activity of Cassia auriculata Linn.",
        "journal": "Indian Journal of Experimental Biology",
        "volume": "49",
        "issue": "10",
        "pages": "804–809"
      },
      {
        "authors": "Guruprasad, B., Sreelakshmi, K. S., & Rajesh, N.",
        "year": 2021,
        "title": "Phytochemical and pharmacological importance of Cassia auriculata Linn.: A review",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "10",
        "issue": "2",
        "pages": "1450–1456"
      },
      {
        "authors": "Jeevitha, G., & Anandan, R.",
        "year": 2023,
        "title": "Therapeutic applications and phytochemical profile of Cassia auriculata",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "81",
        "issue": "1",
        "pages": "112–120"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian medicinal plants: An illustrated dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 2)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A handbook of medicinal plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Puranik, G., Kammar, K. F., & Devi, R. S.",
        "year": 2011,
        "title": "Evaluation of antidiabetic and antioxidant activity of Cassia auriculata",
        "journal": "Pharmacologyonline",
        "volume": "2",
        "pages": "447–455"
      },
      {
        "authors": "Rani, P., & Sharma, A.",
        "year": 2013,
        "title": "Phytochemical and pharmacological profile of Cassia auriculata Linn.",
        "journal": "International Research Journal of Pharmacy",
        "volume": "4",
        "issue": "4",
        "pages": "29–34"
      },
      {
        "authors": "Shafeeq, P., Rameshkumar, K. B., & George, V.",
        "year": 2018,
        "title": "Medicinal uses and pharmacological activities of Cassia auriculata",
        "journal": "Asian Journal of Pharmaceutical and Clinical Research",
        "volume": "11",
        "issue": "5",
        "pages": "15–21"
      },
      {
        "authors": "Tietel, Z., Sharma, R., & Meena, P.",
        "year": 2024,
        "title": "Bioactive compounds and therapeutic potential of Cassia auriculata",
        "journal": "Journal of Herbal Medicine",
        "volume": "42",
        "pages": "100690"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool",
        "publisher": "Bishen Singh Mahendra Pal Singh"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 2)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 37,
    "id": "Euphorbia-tirucalli",

    "scientific_name": "Euphorbia tirucalli ",

    "aname": "L.",
    "common_name": "Pencil Cactus",

    "local_name": "Jemudu Kadalu, Pencil Cactus & Milk Bush",

    "image": "/Flora/plant37.jpeg",
    gallery: {

      bark: "/Flora/plant37a.jpeg",
      // leaf: "/Flora/plant37/leaf.jpg",
      //flower: "/Flora/plant37c.jpeg",
      //fruit: "/Flora/plant37b.jpeg",
      // seed: "/Flora/plant37/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Euphorbia-tirucalli",
    'qr_code': '/Flora/qrcodes/Euphorbia-tirucalli.png',

    "botanical_profile": {
      "scientific_name": "Euphorbia tirucalli ",
      "aname": "L.",
      "common_name": "Pencil Cactus",
      "local_name": "Jemudu Kadalu, Pencil Cactus & Milk Bush",
      "family": "Euphorbiaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Monochlamydeae",
      "series": "Unisexuales",
      "order": "Euphorbiales",
      "family": "Euphorbiaceae",
      "genus": "Euphorbia",
      "species": "tirucalli"
    },

    "morphological_characters": "E. tirucalli is a succulent shrub or small tree with terete, glabrous and articulate branchlets. Leaves are linear, cuneate at the base, entire, obtuse-acute at the apex, caducous and subsessile. Inflorescence consists of few terminal cyathia. Flowers are enclosed within a cupular and coriaceous involucre with triangular, fringed and ciliate lobes. Glands are 4–5, orbicular and thick, while appendages are absent. Male florets are 6–8 and female florets are erect. Capsules are globose, pubescent and about 0.7 mm in diameter. Seeds are globose and smooth. The species is commonly found in field hedges near villages in Rayalaseema districts and occurs occasionally in Telangana and Circar districts (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Succulent shrub or small tree",
      "root_system": "Tap root system",
      "leaves": "Linear, cuneate at base, entire and obtuse-acute at apex",
      "inflorescence": "Cyathia",
      "flowers": "Small, yellow and clustered at branch tips",
      "latex": "Milky white and caustic",
      "fruit": "Globose and pubescent capsule",
      "seed": "Globose and smooth"
    },

    "phytochemical_constituents": "E. tirucalli contains numerous bioactive phytochemicals including euphol, β-sitosterol, euphorbol hexacosonate, cycloeuphordenol, cyclotirucanenol, tirucalicine, tri-methyl ellagic acid, gallic acid, terpenic alcohol, isoeuphorol, taraxasterol, tirucallol, euphorone, euphorcinol, euphorbins, cycloartenol, 24-methylenecycloartenol, ingenol triacetate, taraxerone, euphorginol, taraxerol, campesterol, stigmasterol, palmitic acid, linoleic acid and β-amyrin. Polyphenols, tannins and phorbol esters are also reported from the plant. Several pharmacologically active diterpenes, triterpenes and sterols have also been isolated from the latex and aerial parts of the species (Mali & Panchal, 2017; Mwine & Van Damme, 2011; Khare, 2007).",

    "medicinal_importance": "E. tirucalli possesses several medicinal properties and is widely used in traditional medicine. The latex is vesicant and rubefacient and is used in the treatment of rheumatism, warts, cough, asthma, earache, toothache and neuralgia. In small doses, the latex acts as a purgative, whereas in larger doses it acts as an irritant and emetic. The milky juice is alexiteric, carminative and purgative and is traditionally used in whooping cough, gonorrhea, leprosy, dropsy, dyspepsia, enlargement of spleen, jaundice and bladder stones. Fresh latex is applied externally for neuralgia and syphilis. Decoctions of branches are used in gastralgia and colic. Bark and stem poultices are traditionally employed in the treatment of fractures and bone repair. Root extracts are used as emetics in snakebite cases and also for infertility treatment in women. Extracts of the plant have additionally shown analgesic, anti-inflammatory, antimicrobial and antioxidant activities in experimental studies (Mali & Panchal, 2017; Gaur et al., 2009; Duke, 2002; Nadkarni, 2009).",

    "economic_importance": "E. tirucalli is economically important as a hedge plant, ornamental species and bioresource plant in arid and semi-arid regions. The plant is widely used for sand dune stabilization and fencing purposes. The milky latex is employed as an insecticide and gum source in East Africa. Wood is close-grained, fairly hard and useful for rafters, toys and veneer production. Latex-derived oil has industrial applications in linoleum, oilskin and leather cloth manufacturing. In traditional Asian medicine, the species is used for treating broken bones, haemorrhoids, ulceration and swellings. Root scrapings mixed with coconut oil are administered against stomach ache, while plant extracts also exhibit antibiotic activity. The species is also considered a potential hydrocarbon and biofuel-producing plant because of its latex composition and adaptability to dryland ecosystems (Khorwal et al., 2023; The Wealth of India, 2003; Prajapati et al., 2003).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2017,
      "details": "Euphorbia tirucalli was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Haevermans, 2017)."
    },

    "references": [
      {
        "authors": "Duke, J. A.",
        "year": 2002,
        "title": "Handbook of medicinal herbs",
        "edition": "2nd Edition",
        "publisher": "CRC Press"
      },
      {
        "authors": "Gaur, K., Kori, M. L., Nema, R. K., & Sharma, C. S.",
        "year": 2009,
        "title": "Anti-inflammatory and analgesic activity of Euphorbia tirucalli",
        "journal": "Research Journal of Pharmacology and Pharmacodynamics",
        "volume": "1",
        "issue": "1",
        "pages": "8–10"
      },
      {
        "authors": "Haevermans, T.",
        "year": 2017,
        "title": "Euphorbia tirucalli (amended version of 2004 assessment)",
        "source": "The IUCN Red List of Threatened Species 2017",
        "doi": "https://doi.org/10.2305/IUCN.UK.2017-3.RLTS.T44452A117034216.en"
      },
      {
        "authors": "Jain, S. K.",
        "year": 1991,
        "title": "Dictionary of Indian folk medicine and ethnobotany",
        "publisher": "Deep Publications"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian medicinal plants: An illustrated dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Khorwal, R. N., Khorwal, A., & Shekhawat, C.",
        "year": 2023,
        "title": "Propagation, ecology and economic importance of Euphorbia tirucalli L.",
        "journal": "Shrinkhla Ek Shodhparak Vaicharik Patrika",
        "volume": "10",
        "issue": "11"
      },
      {
        "authors": "Mali, P. Y., & Panchal, S. S.",
        "year": 2017,
        "title": "Euphorbia tirucalli L.: Review on morphology, medicinal uses, phytochemistry and pharmacological activities",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "7",
        "issue": "7",
        "pages": "603–613"
      },
      {
        "authors": "Mwine, J. T., & Van Damme, P.",
        "year": 2011,
        "title": "Why do Euphorbiaceae tick as medicinal plants? A review of Euphorbiaceae family and its medicinal features",
        "journal": "Journal of Medicinal Plants Research",
        "volume": "5",
        "issue": "5",
        "pages": "652–662"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A handbook of medicinal plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "publisher": "Scientific Publishers, Jodhpur",
        "pages": "867–868"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "The Wealth of India",
        "year": 2003,
        "title": "A dictionary of Indian raw materials and industrial products: Raw materials (Vol. 3)",
        "publisher": "National Institute of Science Communication and Information Resources (NISCAIR), CSIR"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 2)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 38,
    "id": "Mangifera-indica",

    "scientific_name": "Mangifera indica ",

    "aname": "L.",
    "common_name": "Mango",

    "local_name": "Mamidi, Mango",

    "image": "/Flora/plant38.jpeg",
    gallery: {

      bark: "/Flora/plant38a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant38b.jpeg",
      fruit: "/Flora/plant38c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Mangifera-indica",
    'qr_code': '/Flora/qrcodes/Mangifera-indica.png',

    "botanical_profile": {
      "scientific_name": "Mangifera indica L.",
      "aname": "L.",
      "common_name": "Mango",
      "local_name": "Mamidi, Mango",
      "family": "Anacardiaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Sapindales",
      "family": "Anacardiaceae",
      "genus": "Mangifera",
      "species": "indica"
    },

    "morphological_characters": "M. indica is a large evergreen tree with brown bark and glabrous, terete branches. Leaves are oblong or elliptic-lanceolate, dark green, coriaceous and shining, measuring about 10–20 × 3–6 cm. Leaves are alternate with 25 pairs of lateral nerves, base cuneate-subacute, margins slightly wavy and apex acuminate. Flowers are yellowish-white and arranged in terminal tomentose panicles. Fruits are fleshy drupes, globose and obliquely gibbous on one side with compressed fibrous stones. Seeds are oblong. The species commonly occurs in hill forests of many districts and is universally cultivated in gardens, avenues and orchards, often becoming naturalized (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tree",
      "bark": "Brown",
      "branches": "Glabrous and terete",
      "leaves": "Oblong or elliptic-lanceolate, dark green, alternate, base cuneate-subacute and apex acuminate",
      "flowers": "Yellowish-white",
      "inflorescence": "Terminal tomentose panicles",
      "fruit": "Globose drupe with fibrous stone",
      "seed": "Oblong"
    },

    "phytochemical_constituents": "M. indica is rich in several bioactive phytochemical constituents including mangiferin, gallic acid, gallotannins, quercetin, isoquercetin, ellagic acid, catechin, epicatechin, chlorogenic acid, quercitrin and β-sitosterol. Mango pulp contains abundant polyphenols and flavonoids, while mesocarp tissue is rich in carotenoids responsible for the characteristic yellow colour of ripe fruits. Mangiferin is considered one of the major pharmacologically active xanthones present in mango. Peel and seed kernels also contain significant antioxidant compounds including phenolic acids and tannins. These phytochemicals contribute to antioxidant, antimicrobial, anti-inflammatory and anticancer properties of the plant (Kabir et al., 2017; Jahurul et al., 2015; Rastogi & Mehrotra, 1991).",

    "medicinal_importance": "M. indica possesses several medicinal properties and has long been used in Ayurveda and traditional medicine. Polyphenols and antioxidants present in mango fruits help scavenge harmful free radicals and reduce oxidative stress. Mangiferin exhibits antiviral activity against Herpes simplex virus type 2 and also demonstrates antidiabetic, anti-inflammatory and immunomodulatory effects. Peel extracts show antibacterial and antifungal activity against pathogens such as Escherichia coli and Staphylococcus aureus. Methanolic extracts exhibit antidiarrhoeal activity, while mango exocarp extracts induce apoptosis in human cervical adenocarcinoma HeLa cells. Seed kernel extracts exhibit inhibitory effects against fibrinogenolytic and caseinolytic activities of cobra and viper venom. Traditionally, different parts of the plant are used for treating diarrhea, dysentery, asthma, bronchitis, toothache and skin disorders (Anitha Rajasekaran & Sharmila Soundarapandian, 2023; Nadkarni, 2009; Kirtikar & Basu, 1999).",

    "economic_importance": "M. indica is one of the most economically important fruit crops cultivated throughout tropical and subtropical regions. Mango fruits are consumed fresh and processed into juices, jams, jellies, pickles, chutneys, beverages, ice creams, candies and mango leather. The fruit contributes significantly to food industries, export markets and rural livelihoods. Unripe mangoes are valued for their acidity, vitamin C and culinary applications, while ripe fruits are important for pulp processing industries. Mango wood is lightweight and used for furniture, packing cases and plywood industries. Mango seed kernels are utilized in cosmetic and pharmaceutical preparations, while peel and by-products are increasingly explored for nutraceutical and antioxidant applications. The species plays a major role in horticultural economies and agroforestry systems in India and many tropical countries (Bhusari et al., 2025; Litz, 2009; Bally, 2006).",

    "conservation_status": {
      "IUCN_status": "Data Deficient",
      "assessment_year": 2021,
      "details": "Mangifera indica was assessed in The IUCN Red List of Threatened Species and categorized as Data Deficient (Ganesan, 2021)."
    },

    "references": [
      {
        "authors": "Anitha Rajasekaran, & Sharmila Soundarapandian",
        "year": 2023,
        "title": "Nutritional and medicinal values of Mangifera indica L. fruit",
        "journal": "Trends in Horticulture",
        "volume": "6",
        "issue": "2"
      },
      {
        "authors": "Bally, I. S. E.",
        "year": 2006,
        "title": "Mangifera indica (mango)",
        "journal": "Species Profiles for Pacific Island Agroforestry",
        "publisher": "Permanent Agriculture Resources (PAR)"
      },
      {
        "authors": "Bhusari, R. M., Patil, S. D., Gethe, A. S., & Patil, S. R.",
        "year": 2025,
        "title": "A comprehensive review on processing technologies and value-added products of mango",
        "journal": "European Journal of Nutrition & Food Safety",
        "volume": "17",
        "issue": "9",
        "pages": "19–28"
      },
      {
        "authors": "Chadha, K. L.",
        "year": 2008,
        "title": "Handbook of horticulture",
        "publisher": "Indian Council of Agricultural Research"
      },
      {
        "authors": "Chopra, R. N., Nayar, S. L., & Chopra, I. C.",
        "year": 1956,
        "title": "Glossary of Indian medicinal plants",
        "publisher": "Council of Scientific and Industrial Research"
      },
      {
        "authors": "Duke, J. A.",
        "year": 2002,
        "title": "Handbook of medicinal herbs",
        "edition": "2nd Edition",
        "publisher": "CRC Press"
      },
      {
        "authors": "Ganesan, S. K.",
        "year": 2021,
        "title": "Mangifera indica",
        "source": "The IUCN Red List of Threatened Species 2021",
        "identifier": "e.T31389A67735735"
      },
      {
        "authors": "Jahurul, M. H. A., Zaidul, I. S. M., Ghafoor, K., Al-Juhaimi, F. Y., Nyam, K. L., Norulaini, N. A. N., & Omar, A. K. M.",
        "year": 2015,
        "title": "Mango (Mangifera indica L.) by-products and their valuable components: A review",
        "journal": "Food Chemistry",
        "volume": "183",
        "pages": "173–180",
        "doi": "https://doi.org/10.1016/j.foodchem.2015.03.046"
      },
      {
        "authors": "Jain, S. K.",
        "year": 1991,
        "title": "Dictionary of Indian folk medicine and ethnobotany",
        "publisher": "Deep Publications"
      },
      {
        "authors": "Kabir, Y., Shekhar, H. U., & Sidhu, J. S.",
        "year": 2017,
        "title": "Phytochemical compounds in functional properties of mangoes",
        "book": "Handbook of Mango Fruit"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 1)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Krishna, K. R.",
        "year": 2012,
        "title": "Agroecosystems, soil management and climate change",
        "publisher": "Apple Academic Press"
      },
      {
        "authors": "Litz, R. E.",
        "year": 2009,
        "title": "The mango: Botany, production and uses",
        "edition": "2nd Edition",
        "publisher": "CAB International"
      },
      {
        "authors": "Mabberley, D. J.",
        "year": 2017,
        "title": "Mabberley’s plant-book: A portable dictionary of plants, their classification and uses",
        "edition": "4th Edition",
        "publisher": "Cambridge University Press"
      },
      {
        "authors": "Morton, J.",
        "year": 1987,
        "title": "Mango",
        "book": "Fruits of Warm Climates",
        "pages": "221–239",
        "publisher": "Florida Flair Books"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pandey, S. N., & Chadha, A.",
        "year": 1993,
        "title": "Economic botany",
        "publisher": "Vikas Publishing House"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A handbook of medicinal plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers, Jodhpur",
        "pages": "229"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 1991,
        "title": "Compendium of Indian medicinal plants (Vol. 2)",
        "publisher": "Central Drug Research Institute & Publications and Information Directorate"
      },
      {
        "authors": "Sivakumar, D., Jiang, Y., & Yahia, E. M.",
        "year": 2011,
        "title": "Maintaining mango fruit quality during the export chain",
        "journal": "Food Research International",
        "volume": "44",
        "issue": "5",
        "pages": "1254–1263"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 4)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 39,
    "id": "Sapindus-emarginatus",

    "scientific_name": "Sapindus emarginatus ",

    "aname": "Vahl",
    "common_name": "South Indian Soapnut",

    "local_name": "Kunkudu, Kookudu",

    "image": "/Flora/plant39.jpeg",
    gallery: {

      bark: "/Flora/plant39a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant39b.jpeg",
      fruit: "/Flora/plant39c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Sapindus-emarginatus",
    'qr_code': '/Flora/qrcodes/Sapindus-emarginatus.png',

    "botanical_profile": {
      "scientific_name": "Sapindus emarginatus ",
      "aname": "Vahl",
      "common_name": "South Indian Soapnut",
      "local_name": "Kunkudu, Kookudu",
      "family": "Sapindaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Sapindales",
      "family": "Sapindaceae",
      "genus": "Sapindus",
      "species": "emarginatus"
    },

    "morphological_characters": "S. emarginatus is a medium-sized tree with grey to dark brown bark. Branches are terete, striate and tomentose when young. Leaves are even pinnate with 3–4 pairs of sub-opposite, elliptic-oblong leaflets that are thick, coriaceous, glabrous above and pubescent below. Leaflet base is cuneate or attenuate with entire margins and emarginate-retuse apex. Flowers are brownish yellow and arranged in terminal panicles. Fruits are ovoid, tomentose drupes, distinctly 3-lobed and wrinkled when ripe. Seeds are black and one occurs in each locule. The species is commonly distributed in forests and occasionally cultivated in many districts of South India (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Tree",
      "bark": "Grey to dark brown",
      "branches": "Terete, striate and tomentose when young",
      "leaves": "Even pinnate",
      "leaflets": "Opposite, thick, glabrous above, pubescent below, base cuneate and apex emarginate-retuse",
      "flowers": "Brownish yellow",
      "inflorescence": "Terminal panicles",
      "fruit": "Ovoid-tomentose drupe, 3-lobed and wrinkled when ripe",
      "seed": "One seed in each locule, black"
    },

    "phytochemical_constituents": "S. emarginatus contains several important secondary metabolites including flavonoids, triterpenoids, glycosides, carbohydrates, fatty acids, phenols, fixed oils and saponins. The fruit pericarp is particularly rich in saponins containing the sapogenin hederagenin. Important compounds isolated from the species include kaempferol, quercetin, β-sitosterol, mukurozioside IIb, cyclitols and flavonoids. Pericarps contain piscicidal triterpenoid saponins such as 3-O-[β-D-xylopyranosyl-(1→3)-α-L-rhamnopyranosyl-(1→2)-α-L-arabinopyranosyl] derivatives. Fruits also contain hederagenin glycosides including hederagenin-3-O-β-D-galactopyranosyl-(1→2)-β-D-glucopyranosyl and glucuronopyranosyl derivatives. These phytochemicals contribute significantly to the antioxidant, antimicrobial, insecticidal and medicinal activities of the species (Arora et al., 2012; Mandal & Das, 2010; Khare, 2007).",

    "medicinal_importance": "S. emarginatus possesses diverse medicinal properties and is widely used in traditional systems of medicine. Fruit extracts exhibit antifertility and antiandrogenic activities, while saponins demonstrate significant antihyperlipidemic properties. Methanolic extracts of the plant show central nervous system depressant activity. Fruit extracts possess larvicidal activity against Aedes aegypti mosquito larvae, which are vectors for dengue and chikungunya. Leaf extracts exhibit antihyperglycemic activity in glucose-overloaded hyperglycemic rats and demonstrate antimicrobial activity against bacteria such as Pseudomonas testosteroni and Staphylococcus epidermidis. Phenols and flavonoids present in leaves contribute to antioxidant activity. Traditionally, the plant is also used for skin disorders, epilepsy, excessive salivation and dental problems. Herbal formulations prepared from the fruits are commonly employed in Ayurveda and Siddha medicine for scalp cleansing, dandruff control and skin care applications (Arora et al., 2012; Warrier et al., 1996; Nadkarni, 2009; Kirtikar & Basu, 1999).",

    "economic_importance": "S. emarginatus is an economically important multipurpose tree widely valued for its medicinal, cosmetic and industrial applications. The fruit pericarp, commonly known as soapnut or reetha, is extensively used as a natural cleansing agent because of its high saponin content. It is utilized in herbal shampoos, detergents, soaps, face washes and textile cleaning formulations as an eco-friendly alternative to synthetic chemicals. The species is also important in Ayurveda and folk medicine industries for preparing herbal remedies. Increased demand for herbal cosmetics and green products has enhanced its commercial significance. The wood is occasionally used as fuel, while fruits are traded in local markets for domestic and industrial purposes. Saponin-rich extracts are also used in biopesticides, emulsifiers and pharmaceutical formulations. Sustainable cultivation and conservation of this species are important due to increasing commercial exploitation (Das et al., 2025; Orwa et al., 2009; Anonymous, 1972).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2016,
      "details": "Sapindus emarginatus is currently categorized as Not Evaluated (NE) in the IUCN Red List. The species is commonly distributed in tropical dry forests of South India, Sri Lanka and the Andaman Islands and is not presently considered globally threatened (Sankara Rao et al., 2016)."
    },

    "references": [
      {
        "authors": "Anonymous",
        "year": 1972,
        "title": "The Wealth of India: Raw materials (Vol. 9)",
        "publisher": "CSIR, New Delhi"
      },
      {
        "authors": "Arora, B., Bhadauria, P., Tripathi, D., & Sharma, A.",
        "year": 2012,
        "title": "Sapindus emarginatus: Phytochemistry and various biological activities",
        "journal": "Indo Global Journal of Pharmaceutical Sciences",
        "volume": "2",
        "issue": "3",
        "pages": "250–257"
      },
      {
        "authors": "Chopra, R. N., Nayar, S. L., & Chopra, I. C.",
        "year": 1956,
        "title": "Glossary of Indian medicinal plants",
        "publisher": "Council of Scientific and Industrial Research"
      },
      {
        "authors": "Das, A., Alam, S. K. S., Basole, S., Kumar, S., & Mishra, S.",
        "year": 2025,
        "title": "Medicinal and cosmetic uses of Sapindus emarginatus",
        "book": "Medicinal Trees of India",
        "volume": "II",
        "chapter": "7"
      },
      {
        "authors": "Duke, J. A.",
        "year": 2002,
        "title": "Handbook of medicinal herbs",
        "edition": "2nd Edition",
        "publisher": "CRC Press"
      },
      {
        "authors": "Jain, S. K.",
        "year": 1991,
        "title": "Dictionary of Indian folk medicine and ethnobotany",
        "publisher": "Deep Publications"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian medicinal plants: An illustrated dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 1)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Mabberley, D. J.",
        "year": 2017,
        "title": "Mabberley’s plant-book: A portable dictionary of plants, their classification and uses",
        "edition": "4th Edition",
        "publisher": "Cambridge University Press"
      },
      {
        "authors": "Mandal, S. C., & Das, A. K.",
        "year": 2010,
        "title": "Pharmacognostic and phytochemical evaluation of Sapindus species",
        "journal": "Pharmacognosy Journal",
        "volume": "2",
        "issue": "12",
        "pages": "403–408"
      },
      {
        "authors": "Moghimipour, E., & Handali, S.",
        "year": 2015,
        "title": "Saponin: Properties, methods of evaluation and applications",
        "journal": "Annual Research & Review in Biology",
        "volume": "5",
        "issue": "3",
        "pages": "207–220"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A handbook of medicinal plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers, Jodhpur",
        "pages": "224"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 1993,
        "title": "Compendium of Indian medicinal plants (Vol. 2)",
        "publisher": "Central Drug Research Institute & Publications and Information Directorate"
      },
      {
        "authors": "Sankara Rao, K., Arun Singh, R., Deepak Kumar, Raja K. Swamy, & Navendu Page",
        "year": 2016,
        "title": "Digital Flora of Eastern Ghats",
        "note": "Reference used for conservation status of Sapindus emarginatus"
      },
      {
        "authors": "Singh, M. P., & Panda, H.",
        "year": 2005,
        "title": "Medicinal herbs with their formulations",
        "publisher": "Daya Publishing House"
      },
      {
        "authors": "Sivarajan, V. V., & Balachandran, I.",
        "year": 1994,
        "title": "Ayurvedic drugs and their plant sources",
        "publisher": "Oxford and IBH Publishing"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 5)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 40,
    "id": "Plumeria-rubra",

    "scientific_name": "Plumeria rubra  ",

    "aname": "L.",
    "common_name": "Red Frangipani",

    "local_name": "Devaganneru, Frangipani, Red Frangipani",

    "image": "/Flora/plant40.jpeg",
    gallery: {

      bark: "/Flora/plant40a.jpeg",
      // leaf: "/Flora/plant40/leaf.jpg",
      flower: "/Flora/plant40b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Plumeria-rubra",
    'qr_code': '/Flora/qrcodes/Plumeria-rubra.png',

    "botanical_profile": {
      "scientific_name": "Plumeria rubra  ",
      "aname": "L.",
      "common_name": "Red Frangipani",
      "local_name": "Devaganneru, Frangipani, Red Frangipani",
      "family": "Apocynaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Plumeria",
      "species": "rubra"
    },

    "morphological_characters": "P. rubra is a small ornamental tree with fleshy branches containing milky latex. Leaves are spiral, oblong-lanceolate to obovate, glabrous or sparsely pubescent beneath, with acute base and acuminate apex. Inflorescence is terminal and cymose. Flowers are large, fragrant, whitish-yellow with a yellow centre and externally tinged pink, arranged in terminal many-flowered thyrsi. Fruits are paired follicles that are elongated and fistulate. Seeds are flat and winged. The species is widely cultivated in gardens, temples and avenues throughout tropical regions as an ornamental plant (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small tree",
      "branches": "Fleshy with milky sap",
      "leaves": "Spiral, oblong-lanceolate to obovate",
      "inflorescence": "Terminal cyme",
      "flowers": "Whitish yellow with yellow centre and pink tinge",
      "fruit": "Paired follicles, fistulate",
      "seed": "Flat and winged"
    },

    "phytochemical_constituents": "P. rubra contains several important bioactive phytochemicals distributed throughout the flowers, bark, leaves and latex. Major constituents include flavonoids such as quercetin and kaempferol, cyanidin diglycosides, terpenoids, tannins, saponins, steroids, cardiac glycosides and reducing sugars. Important iridoids and triterpenoids such as plumericin, isoplumericin, rubranonoside, rubranin, fulvoplumerin and ursolic acid have also been reported. Essential oils extracted from flowers and leaves contain limonene, phytol, benzyl salicylate, farnesene and phenyl acetaldehyde. These compounds contribute significantly to antioxidant, antimicrobial, anti-inflammatory and therapeutic properties of the species (Sambale et al., 2023; Gupta et al., 2006; Verma et al., 2018).",

    "medicinal_importance": "P. rubra possesses diverse medicinal properties and has been traditionally used in Ayurveda and folk medicine for the treatment of various ailments. Different plant parts exhibit cardioprotective, anticoagulant, antioxidant, antimicrobial, antiviral, anti-inflammatory, hepatoprotective and hypolipidemic activities. Extracts are used in treating diabetes, asthma, ulcers, wounds, skin infections, rheumatism, leprosy and digestive disorders. The latex is traditionally applied for treating inflammation and skin diseases, while flowers are used in remedies for fever and cough. Presence of flavonoids, phenolic compounds and iridoids contributes to free radical scavenging and anti-inflammatory activities. Modern pharmacological studies support its therapeutic potential against microbial infections and oxidative stress-related disorders (Sambale et al., 2023; Kirtikar & Basu, 1999; Nadkarni, 2009).",

    "economic_importance": "P. rubra is an economically important ornamental and medicinal plant widely cultivated in tropical and subtropical regions. Its attractive and fragrant flowers make it highly valuable in landscaping, avenue planting, gardens, parks and temple premises. Flowers are commercially utilized in perfume and essential oil industries because of their pleasant fragrance. The plant is also important in traditional medicine and herbal pharmaceutical preparations. In several cultures, flowers are used for garlands, decorations and religious rituals, contributing to socio-economic activities associated with floriculture and horticulture industries. Increasing demand for ornamental plants and herbal products has further enhanced the commercial value of the species (Sambale et al., 2023; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Plumeria rubra was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (BGCI & IUCN SSC Global Tree Specialist Group, 2019)."
    },

    "references": [
      {
        "authors": "Botanic Gardens Conservation International (BGCI) & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Plumeria rubra",
        "source": "The IUCN Red List of Threatened Species 2019",
        "identifier": "e.T144270910A149056540"
      },
      {
        "authors": "Chopra, R. N., Nayar, S. L., & Chopra, I. C.",
        "year": 1956,
        "title": "Glossary of Indian medicinal plants",
        "publisher": "Council of Scientific and Industrial Research"
      },
      {
        "authors": "Gupta, M., Mazumder, U. K., Gomathi, P., & Selvan, V. T.",
        "year": 2006,
        "title": "Antiinflammatory evaluation of leaves of Plumeria acuminata",
        "journal": "BMC Complementary and Alternative Medicine",
        "volume": "6",
        "pages": "36"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian medicinal plants (Vol. 2)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Mabberley, D. J.",
        "year": 2017,
        "title": "Mabberley’s plant-book: A portable dictionary of plants, their classification and uses",
        "edition": "4th Edition",
        "publisher": "Cambridge University Press"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree database: A tree reference and selection guide version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A handbook of medicinal plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "575"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sambale, P., Shrikhande, M., Bafana, Y., Rohokale, A., & Kapre, M.",
        "year": 2023,
        "title": "Phytochemical and pharmacological profile of Plumeria rubra",
        "journal": "International Journal of Research and Analytical Reviews",
        "volume": "10",
        "issue": "4",
        "pages": "113–125"
      },
      {
        "authors": "Verma, N., Amresh, G., Sahu, P. K., Rao, C. V., Singh, A. P., & Rao, C. V.",
        "year": 2018,
        "title": "Pharmacological evaluation of Plumeria rubra Linn.",
        "journal": "International Journal of Green Pharmacy",
        "volume": "12",
        "issue": "2",
        "pages": "95–101"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1993,
        "title": "Indian medicinal plants: A compendium of 500 species (Vol. 4)",
        "publisher": "Orient Longman"
      }
    ]
  },
  // {
  //   plant: 41,
  //   "id": "Ficus-religiosa",

  //   "scientific_name": "Ficus religiosa ",

  //   "aname": "L.",
  //   "common_name": "Peepal",

  //   "local_name": "Ravi, Ragi, Peepal",

  //   "family": "Moraceae",

  //   "image": "/Flora/plant41.jpeg",
  //   gallery: {

  //     bark: "/Flora/plant41a.jpeg",
  //     // leaf: "/Flora/plant5/leaf.jpg",
  //     //flower: "/Flora/plant5c.jpeg",
  //     fruit: "/Flora/plant41b.jpeg",
  //     // seed: "/Flora/plant5/seed.jpg"
  //   },

  //   "qr_url": "https://rukap.edu.in/digital-flora/ficus-religiosa",
  //   'qr_code': '/Flora/qrcodes/Ficus-religiosa.png',

  //   "botanical_profile": {
  //     "scientific_name": "Ficus religiosa   ",
  //     "local_name": "Ravi, Ragi, Peepal",
  //     "family": "Moraceae"
  //   },

  //   "taxonomic_classification": {
  //     "kingdom": "Plantae",
  //     "division": "Angiosperms",
  //     "class": "Dicotyledonae",
  //     "sub_class": "Monochlamydeae",
  //     "series": "Unisexuales",
  //     "order": "Urticales",
  //     "family": "Moraceae",
  //     "genus": "Ficus",
  //     "species": "religiosa"
  //   },

  //   "morphological_characters": "Habit large glabrous trees, trunk cylindric; bark greenish. Leaves broadly ovate, narrowed upwards, alternate, base broad rounded or truncate, rarely cordate in young leaves, margin entire, apex produced into a linear lanceolate tail, sub-coriaceous, glabrous on both sides, shining. Fruit figs monoecious, axillary, sessile, paired, obovoid or depressed globose, ripening dark purple or black; fig wall thick. Achenes smooth. It is commonly and widely planted on village sites and in avenues (Pullaiah et al., 1997).",

  //   "digital_identification": {
  //     "habit": "Large glabrous tree",
  //     "bark": "Greenish",
  //     "leaves": "Ovate, alternate",
  //     "inflorescence": "Axillary",
  //     "fruit": "Figs, monoecious and sessile"
  //   },

  //   "phytochemical_constituents": "F. religiosa contains a wide variety of bioactive phytochemicals including flavonoids, tannins, phenolic compounds, alkaloids, saponins, glycosides, terpenoids, and steroids. Specific compounds reported include β-sitosterol, β-sitosteryl-D-glucoside, stigmasterol, lanosterol, lupen-3-one, methyl oleanolate, n-octacosanol, and furanocoumarins such as bergapten. Flavonols including quercetin, kaempferol, and myricetin have also been identified, along with proteins, amino acids, carbohydrates, vitamins, and minerals (Joseph & Raj, 2011; Singh et al., 2012; Sonawane et al., 2015; Verma & Gupta, 2015).",

  //   "medicinal_importance": "F. religiosa is an important medicinal tree widely used in Ayurveda, Siddha, and Unani systems of medicine. Various parts such as bark, leaves, fruits, seeds, roots, and latex are used to treat gastrointestinal disorders, respiratory diseases, skin ailments, fever, ulcers, wounds, heart diseases, and infections. The plant exhibits antioxidant, antimicrobial, anti-inflammatory, antidiabetic, anticonvulsant, wound-healing, immunomodulatory, and neuroprotective activities (Joseph & Raj, 2011; Singh et al., 2012; Sonawane et al., 2015; Verma & Gupta, 2015).",

  //   "economic_importance": "F. religiosa possesses significant religious, cultural, and economic importance. It is commonly planted near temples, roadsides, parks, and village sites as an ornamental and avenue tree. The species contributes to air purification, shade provision, carbon sequestration, and biodiversity conservation. Plant products are also used in cosmetic preparations, dyes, fodder, and food-related applications (Joseph & Raj, 2011; Singh et al., 2012; Sonawane et al., 2015).",

  //   "conservation_status": {
  //     "IUCN_status": "Least Concern",
  //     "assessment_year": 2021,
  //     "reference": "(Lakhey et al., 2022)"
  //   },

  //   "references": [
  //     {
  //       "authors": "Joseph, B., & Raj, S. J.",
  //       "year": 2011,
  //       "title": "Pharmacognostic and phytochemical properties of Ficus religiosa: An overview",
  //       "journal": "International Journal of Pharmaceutical Sciences Review and Research",
  //       "volume_issue": "6(1)",
  //       "pages": "49–52"
  //     },
  //     {
  //       "authors": "Lakhey et al.",
  //       "year": 2022,
  //       "title": "Ficus religiosa",
  //       "source": "The IUCN Red List of Threatened Species"
  //     },
  //     {
  //       "authors": "Pullaiah, T., Chennaiah, E., & Rao, D. M.",
  //       "year": 1997,
  //       "title": "Flora of Andhra Pradesh (Vols. 1–3)",
  //       "source": "Scientific Publishers"
  //     },
  //     {
  //       "authors": "Singh, D., Chaudhuri, P. K., & Upadhyay, G.",
  //       "year": 2012,
  //       "title": "Phytochemical and pharmacological studies of Ficus religiosa",
  //       "journal": "Journal of Medicinal Plants Research",
  //       "volume_issue": "6(33)",
  //       "pages": "4923–4930"
  //     },
  //     {
  //       "authors": "Sonawane, V. C., et al.",
  //       "year": 2015,
  //       "title": "Phytochemical and pharmacological profile of Ficus religiosa: A review",
  //       "journal": "Research Journal of Pharmacognosy and Phytochemistry",
  //       "volume_issue": "7(4)",
  //       "pages": "239–245"
  //     },
  //     {
  //       "authors": "Verma, R. S., & Gupta, R. K.",
  //       "year": 2015,
  //       "title": "Phytochemical and therapeutic studies on Ficus religiosa",
  //       "journal": "International Journal of Pharmaceutical Sciences Review and Research",
  //       "volume_issue": "32(1)",
  //       "pages": "118–127"

  //     }
  //   ]
  // },
  {
    plant: 42,
    "id": "Soymida-febrifuga",

    "scientific_name": "Soymida febrifuga ",

    "aname": "(Roxb.) A. Juss.",
    "common_name": "Indian Redwood, Bastard Cedar",

    "local_name": "Somida Chettu, Chevamanu",

    "image": "/Flora/plant42.jpeg",
    gallery: {

      bark: "/Flora/plant42a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant42b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Soymida-febrifuga",
    'qr_code': '/Flora/qrcodes/Soymida-febrifuga.png',

    "botanical_profile": {
      "scientific_name": "Soymida febrifuga ",
      "aname": "(Roxb.) A. Juss.",
      "common_name": "Indian Redwood, Bastard Cedar",
      "local_name": "Somida Chettu, Chevamanu",
      "family": "Meliaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Meliaceae",
      "genus": "Soymida",
      "species": "febrifuga"
    },

    "morphological_characters": "S. febrifuga is a lofty deciduous glabrous tree attaining heights of 18–30 m. The bark is rough, dark brown to blackish with conspicuous scales and fissures. Branchlets bear persistent leaf scars. Leaves are alternate, paripinnate and clustered towards the ends of branches; leaflets usually 6–12, opposite, ovate-oblong, thick-coriaceous, glabrous, with an oblique base, entire margin and obtuse apex. Flowers are small, white to creamy white and arranged in axillary or terminal panicles. Fruits are woody, brown capsules, 5-celled and septifragally dehiscent into five valves. Seeds are numerous, oblong, compressed and winged at both ends. The species commonly occurs in tropical dry deciduous forests throughout peninsular India and the Eastern Ghats (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Lofty glabrous deciduous tree",
      "bark": "Rough, dark brownish to blackish with visible scales",
      "branchlets": "With persistent leaf scars",
      "leaves": "Alternate, paripinnate",
      "leaflets": "Opposite, ovate-oblong, coriaceous, glabrous, apex obtuse",
      "flowers": "White to creamy white",
      "inflorescence": "Axillary or terminal panicles",
      "fruit": "Woody, 5-celled capsule",
      "seed": "Oblong, compressed and winged at both ends"
    },

    "phytochemical_constituents": "S. febrifuga contains numerous biologically active compounds including limonoids, triterpenoids, flavonoids, phenolics, steroids and tannins. Major constituents reported from various plant parts include β-sitosterol, lupeol, stigmasterol, methyl angolensate, febrifugin A, febrifugin B, febrifugin C, kaempferol, luteolin-7-O-glucoside, gallic acid, ellagitannins, saponins and essential oils. Limonoids and flavonoids are considered the principal bioactive compounds responsible for antioxidant, antimicrobial, anti-inflammatory and anticancer activities. The bark is particularly rich in tannins and phenolic compounds that contribute to its medicinal and industrial significance (Pareek et al., 2025; Khare, 2007; Rastogi & Mehrotra, 1993).",

    "medicinal_importance": "S. febrifuga is an important medicinal tree in Ayurveda and folk medicine. The bark is traditionally used as a febrifuge and tonic and has been employed in the treatment of fever, diarrhea, dysentery and gastrointestinal disorders. Pharmacological studies have demonstrated antimicrobial, antifungal, antidiabetic, anti-inflammatory, antioxidant, hepatoprotective, cardiotonic and anticancer activities. Bark extracts have shown effectiveness against various bacterial and fungal pathogens, while antioxidant constituents help neutralize free radicals. The species has also been investigated for its glucose-lowering effects and potential role in protecting liver tissues from oxidative damage (Pareek et al., 2025; Nadkarni, 2009; Sivarajan & Balachandran, 1994; Kirtikar & Basu, 1999).",

    "economic_importance": "S. febrifuga is one of the valuable timber trees of India. The heartwood is dark brown, hard, durable and resistant to decay, making it suitable for construction work, posts, beams, rafters, agricultural implements, furniture, flooring, turnery and carving. The bark contains tannins used in leather tanning, producing high-quality leather with good colour and texture. A clear gum exuded from the bark serves as an adhesive mucilage, while strong fibres extracted from the bark are utilized in rope making. The timber is commercially important in several forest divisions and contributes significantly to forest-based livelihoods and wood industries. The species is also valued for furniture framing, cabinet work and decorative woodcraft applications (Pareek et al., 2025; Troup, 1921; Anonymous, 1972; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2024,
      "details": "S. febrifuga has been assessed as Least Concern (LC) in the IUCN Red List due to its relatively wide distribution across India and neighboring regions. Although the species remains common in several dry deciduous forests, local populations may be affected by overharvesting for timber and bark extraction (De Kok, 2024)."
    },

    "references": [
      {
        "authors": "Anonymous",
        "year": 1972,
        "title": "The Wealth of India: Raw Materials (Vol. 10)",
        "publisher": "CSIR, New Delhi"
      },
      {
        "authors": "Chopra, R. N., Nayar, S. L., & Chopra, I. C.",
        "year": 1956,
        "title": "Glossary of Indian Medicinal Plants",
        "publisher": "CSIR, New Delhi"
      },
      {
        "authors": "De Kok, R.",
        "year": 2024,
        "title": "Soymida febrifuga",
        "journal": "The IUCN Red List of Threatened Species",
        "identifier": "e.T211764039A211814236"
      },
      {
        "authors": "Duke, J. A.",
        "year": 2002,
        "title": "Handbook of Medicinal Herbs",
        "edition": "2nd Edition",
        "publisher": "CRC Press"
      },
      {
        "authors": "Jain, S. K.",
        "year": 1991,
        "title": "Dictionary of Indian Folk Medicine and Ethnobotany",
        "publisher": "Deep Publications"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants (Vol. 1)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Mabberley, D. J.",
        "year": 2017,
        "title": "Mabberley's Plant-book: A Portable Dictionary of Plants, Their Classification and Uses",
        "edition": "4th Edition",
        "publisher": "Cambridge University Press"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pareek, D., Aggarwal, S., Sharma, S., Sahu, S., & Monika",
        "year": 2025,
        "title": "Exploring the Therapeutic and Traditional Applications of Mamsarohini (Soymida febrifuga): A Review",
        "journal": "International Journal of Research in Ayurveda and Pharmacy",
        "volume": "16",
        "issue": "4",
        "pages": "172-175"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2003,
        "title": "A Handbook of Medicinal Plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers, Jodhpur",
        "pages": "190"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 1993,
        "title": "Compendium of Indian Medicinal Plants (Vol. 2)",
        "publisher": "CDRI, Lucknow"
      },
      {
        "authors": "Sivarajan, V. V., & Balachandran, I.",
        "year": 1994,
        "title": "Ayurvedic Drugs and Their Plant Sources",
        "publisher": "Oxford & IBH Publishing"
      },
      {
        "authors": "Troup, R. S.",
        "year": 1921,
        "title": "The Silviculture of Indian Trees (Vol. 1)",
        "publisher": "Oxford University Press"
      }
    ]
  },
  {
    plant: 43,
    "id": "Tamarindus-indica",

    "scientific_name": "Tamarindus indica ",

    "aname": "L.f",
    "common_name": "Tamarind",

    "local_name": "Chintachettu, Tamarind",

    "image": "/Flora/plant43.jpeg",
    gallery: {

      bark: "/Flora/plant43a.jpeg",
      // leaf: "/Flora/plant43/leaf.jpg",
      flower: "/Flora/plant43b.jpeg",
      fruit: "/Flora/plant43c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Tamarindus-indica",
    'qr_code': '/Flora/qrcodes/Tamarindus-indica.png',

    "botanical_profile": {
      "scientific_name": "Tamarindus indica ",
      "aname": "L.",
      "common_name": "Tamarind",
      "local_name": "Chintachettu, Tamarind",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Tamarindus",
      "species": "indica"
    },

    "morphological_characters": "T. indica is a large evergreen to semi-evergreen tree attaining heights of 12–25 m with a dense spreading crown. The bark is rough, greyish-brown and deeply fissured. Branches are glabrous and widely spreading. Leaves are alternate, evenly pinnate with 12–16 pairs of oblong leaflets that are chartaceous, glabrous or slightly puberulous, with obtuse base and apex and entire margins. Flowers are yellow with pink or red striations and are borne in terminal or axillary few-flowered racemes. Fruits are linear-oblong, slightly curved (falcate) pods with a brittle epicarp, fleshy acidic mesocarp and leathery septate endocarp. Seeds are 1–12, quadrangular, compressed, hard, brown and shining. The species is widely cultivated and naturalized throughout tropical India and is commonly planted as an avenue and shade tree (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large evergreen tree",
      "bark": "Greyish-brown, rough and fissured",
      "branches": "Glabrous",
      "leaves": "Even pinnate",
      "leaflets": "12–16 pairs, oblong, chartaceous, obtuse at both ends",
      "flowers": "Yellow with pink or red striations",
      "inflorescence": "Terminal or axillary few-flowered racemes",
      "fruit": "Linear-oblong pod with brittle epicarp and pulpy mesocarp",
      "seed": "Quadrangular, brown, hard and shining"
    },

    "phytochemical_constituents": "T. indica contains a rich diversity of phytochemicals including flavonoids, tannins, saponins, alkaloids, triterpenoids, steroids, phenolic compounds, cardiac glycosides and pectin. The fruit pulp is particularly rich in tartaric acid, citric acid, malic acid and succinic acid. Other important constituents include β-sitosterol, epicatechin, catechin, orientin, isoorientin, vitexin, isovitexin, procyanidins, limonene, geraniol and cinnamic acid derivatives. The seeds contain polysaccharides, proteins and fatty acids, while leaves and bark are rich in phenolics and tannins. These compounds are responsible for the plant's antioxidant, antimicrobial, anti-inflammatory and therapeutic properties (Mukherjee et al., 2024; Khare, 2007; Rastogi & Mehrotra, 1993).",

    "medicinal_importance": "T. indica is widely used in Ayurveda, Siddha and folk medicine. The fruit pulp acts as a mild laxative, digestive aid and refrigerant. Various parts of the plant are employed in the treatment of fever, jaundice, constipation, diabetes, dysentery, parasitic infections, respiratory ailments and cardiovascular disorders. Scientific studies have demonstrated antimicrobial, antifungal, antiviral, antioxidant, anti-inflammatory, analgesic, antidiabetic, hepatoprotective and hypolipidemic activities. Tamarind extracts have shown potential in reducing oxidative stress, regulating blood glucose levels and protecting liver tissues from damage. The seeds and leaves are also used in traditional formulations for wound healing and skin disorders (Mukherjee et al., 2024; Nadkarni, 2009; Warrier et al., 1996).",

    "economic_importance": "T. indica is one of the most economically important multipurpose tree species of tropical regions. The fruit pulp is extensively utilized in culinary preparations including curries, chutneys, beverages, sauces, pickles and confectionery products. It serves as a rich source of vitamins, minerals and organic acids and is widely traded in domestic and international markets. Tamarind seed polysaccharide is used in textile sizing, paper industries, adhesives and pharmaceutical formulations. The timber is hard and durable and is used for agricultural implements, furniture and construction purposes. Leaves, flowers and immature fruits are consumed as vegetables in several regions. The species supports rural livelihoods and contributes significantly to food, pharmaceutical and nutraceutical industries (Mukherjee et al., 2024; Orwa et al., 2009; Anonymous, 1976).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2017,
      "details": "Tamarindus indica was assessed for the IUCN Red List of Threatened Species and categorized as Least Concern (LC) because of its extensive cultivation, broad geographical distribution and stable global population. The species is widely naturalized throughout tropical regions and is not currently considered threatened (Rivers & Mark, 2017)."
    },

    "references": [
      {
        "authors": "Anonymous",
        "year": 1976,
        "title": "The Wealth of India: Raw Materials (Vol. 10)",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Chopra, R. N., Nayar, S. L., & Chopra, I. C.",
        "year": 1956,
        "title": "Glossary of Indian Medicinal Plants",
        "publisher": "CSIR, New Delhi"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Mukherjee, D., Deb, J., Deb, N. K., Saha, S., & Chakraborty, S.",
        "year": 2024,
        "title": "Ethnopharmacological, Phytochemical and Pharmacological Review on Tamarindus indica L.",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "13",
        "issue": "1",
        "pages": "120-126"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. 1)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers, Jodhpur",
        "pages": "344-345"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 1993,
        "title": "Compendium of Indian Medicinal Plants (Vol. 2)",
        "publisher": "Central Drug Research Institute, Lucknow"
      },
      {
        "authors": "Rivers, M. C., & Mark, J.",
        "year": 2017,
        "title": "Tamarindus indica",
        "journal": "The IUCN Red List of Threatened Species",
        "identifier": "e.T62020997A62020999"
      },
      {
        "authors": "Sivarajan, V. V., & Balachandran, I.",
        "year": 1994,
        "title": "Ayurvedic Drugs and Their Plant Sources",
        "publisher": "Oxford & IBH Publishing"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species (Vol. 5)",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 44,
    "id": "Tabernaemontana-divaricata",

    "scientific_name": "Tabernaemontana divaricata ",

    "aname": "(L.) R.Br. ",
    "common_name": "Crape Jasmine, Pinwheel Flower",

    "local_name": "Nandivardhanam",

    "image": "/Flora/plant44.jpeg",
    gallery: {

      bark: "/Flora/plant44a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant44b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Tabernaemontana-divaricata",
    'qr_code': '/Flora/qrcodes/Tabernaemontana-divaricata.png',

    "botanical_profile": {
      "scientific_name": "Tabernaemontana divaricata ",
      "aname": "(L.) R.Br. ",
      "common_name": "Crape Jasmine, Pinwheel Flower",
      "local_name": "Nandivardhanam",
      "family": "Apocynaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Tabernaemontana",
      "species": "divaricata"
    },

    "morphological_characters": "T. divaricata is a dichotomously branched large shrub or small tree containing abundant milky latex. The bark is silvery-grey and smooth. Leaves are simple, opposite, oblanceolate to oblong, sub-coriaceous, with cuneate to attenuate base, entire margins, acuminate apex, and about 8 pairs of lateral veins. Flowers are creamish-white to white, fragrant, with a characteristic pinwheel-shaped corolla and yellow-centered spot. Inflorescence occurs in terminal divaricate cymes. Fruits are paired follicles (mericarps), lanceolate, curved and beaked. Seeds are dull brown, lacking coma, enclosed within orange-red follicles. The species is commonly cultivated as an ornamental plant and occurs in parts of Andhra Pradesh including Visakhapatnam, Srikakulam, and East Godavari districts (Pullaiah & Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large shrub or small tree",
      "bark": "Silvery-grey, exuding milky latex",
      "leaves": "Oblanceolate to oblong, opposite",
      "flower": "Creamish-white, fragrant, pinwheel-shaped",
      "inflorescence": "Terminal divaricate cymes",
      "fruit": "Paired lanceolate follicles, curved and beaked",
      "seed": "Dull brown, without coma"
    },

    "phytochemical_constituents": "T. divaricata is rich in diverse phytochemicals distributed throughout the leaves, flowers, roots, stem bark, and latex. The plant is particularly known for its monoterpenoid indole alkaloids including coronaridine, voacangine, ibogamine, apparicine, tabernaemontanine, catharanthine, and conophylline. Other constituents include flavonoids, phenolic compounds, tannins, saponins, triterpenoids, steroids, glycosides, and essential oils. These bioactive compounds are responsible for the plant's antioxidant, antimicrobial, anti-inflammatory, anticancer, antidiabetic, and neuroprotective properties (Choudhury et al., 2025; Prajapati et al., 2011; Van Beek et al., 1984).",

    "medicinal_importance": "The species possesses significant therapeutic value in traditional and modern medicine. Various extracts exhibit antioxidant, anti-inflammatory, antimicrobial, analgesic, antidiabetic, anticancer, wound-healing, hepatoprotective, and neuropharmacological activities. In Ayurveda and folk medicine, the roots, flowers, leaves, and latex are used for the treatment of skin disorders, ulcers, inflammation, eye diseases, hypertension, fever, diabetes, microbial infections, and cancer-related conditions. The presence of pharmacologically active indole alkaloids contributes substantially to its medicinal applications (Choudhury et al., 2025; Prajapati et al., 2011; Kirtikar & Basu, 2006).",

    "economic_importance": "T. divaricata is widely cultivated as an ornamental garden and landscape plant because of its attractive evergreen foliage and fragrant white flowers. The plant is commercially important in the herbal medicine and pharmaceutical industries owing to its rich alkaloid content. Extracts and isolated compounds are being investigated for the development of novel drugs with anticancer, antimicrobial, and anti-inflammatory activities. It also contributes to the horticultural trade as a popular ornamental species in tropical and subtropical regions (Choudhury et al., 2025; Prajapati et al., 2011).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2020,
      "details": "T. divaricata was assessed in the IUCN Red List of Threatened Species and categorized as Least Concern because of its wide distribution, extensive cultivation, and stable populations across its native and introduced range (Lakhey & Pathak, 2020)."
    },

    "references": [
      {
        "authors": "Choudhury, S., Das, R., Sharma, P., Mohanty, J. P., Ghosh, A., Banik, B., & Tiwari, K.",
        "year": 2025,
        "title": "Comprehensive disquisition on the phytochemical spectrum and pharmacodynamic nuances of Tabernaemontana divaricata",
        "journal": "International Journal of Pharmacognosy and Life Sciences",
        "volume": "6",
        "issue": "2",
        "pages": "8-15"
      },
      {
        "authors": "Lakhey, P. & Pathak, J.",
        "year": 2020,
        "title": "Tabernaemontana divaricata",
        "source": "The IUCN Red List of Threatened Species",
        "pages": "e.T149853146A149853842"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T. & Moulali, D. A.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "2",
        "pages": "576-577",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Prajapati, N. D., Purohit, S. S., Sharma, A. K., & Kumar, T.",
        "year": 2011,
        "title": "A Handbook of Medicinal Plants",
        "publisher": "Agrobios (India)"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "3",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Van Beek, T. A., Verpoorte, R., Baerheim Svendsen, A., Leeuwenberg, A. J. M., & Bisset, N. G.",
        "year": 1984,
        "title": "Tabernaemontana L. (Apocynaceae): A review of its taxonomy, phytochemistry, ethnobotany and pharmacology",
        "journal": "Journal of Ethnopharmacology",
        "volume": "10",
        "issue": "1",
        "pages": "1-156"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      }
    ]
  },
  {
    plant: 45,
    "id": "Psidium-guajava",

    "scientific_name": "Psidium guajava ",

    "aname": "L.",
    "common_name": "Guava",

    "local_name": "Jama, Guava",

    "image": "/Flora/plant45.jpeg",
    gallery: {

      bark: "/Flora/plant45a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant45b.jpeg",
      fruit: "/Flora/plant45c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Psidium-guajava",
    'qr_code': '/Flora/qrcodes/Psidium-guajava.png',

    "botanical_profile": {
      "scientific_name": "Psidium guajava ",
      "aname": "L.",
      "common_name": "Guava",
      "local_name": "Jama, Guava",
      "family": "Myrtaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Myrtaceae",
      "genus": "Psidium",
      "species": "guajava"
    },

    "morphological_characters": "P. guajava is a small to medium-sized evergreen tree with appressed tomentose branchlets. Leaves are opposite and decussate, oblong to ovate-lanceolate, coriaceous, with prominent veins beneath, sparsely tomentose above and densely tomentose below. The leaves possess pellucid oil glands, an obtuse to cuneate base, entire margins, and an acute apex. Inflorescence is solitary axillary or a 1–3 flowered cyme. Flowers are white, bisexual, and fragrant with numerous stamens. Fruits are edible globose or pear-shaped berries with a sweet aromatic pulp. Seeds are numerous, small, hard, and embedded within the fruit pulp. The species is extensively cultivated and frequently naturalized in most districts of Andhra Pradesh and throughout tropical and subtropical regions (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small to medium-sized tree",
      "leaves": "Decussate, oblong to ovate-lanceolate, coriaceous",
      "inflorescence": "Solitary axillary or 1–3 flowered cyme",
      "flower": "White, fragrant",
      "fruit": "Edible globose berry",
      "seed": "Numerous, small, hard"
    },

    "phytochemical_constituents": "P. guajava contains a rich diversity of phytochemicals including flavonoids, tannins, alkaloids, saponins, terpenoids, glycosides, polyphenols, and essential oils. Important phenolic compounds identified from leaves include catechin, epicatechin, gallic acid, ellagic acid, quercetin, rutin, kaempferol, and guaijaverin. Ellagitannins such as corilagin and pedunculagin, as well as terpenoids including β-caryophyllene, limonene, and α-pinene, have also been reported. These bioactive compounds contribute significantly to the antioxidant, antimicrobial, antidiabetic, anti-inflammatory, and anticancer properties of the plant (Bulugahapitiya et al., 2021; Gutiérrez et al., 2008).",

    "medicinal_importance": "P. guajava is widely recognized as a medicinal plant with extensive pharmacological activities. Leaf, fruit, bark, and root extracts exhibit antioxidant, antimicrobial, antidiabetic, antitumor, anticancer, antidiarrheal, wound-healing, hepatoprotective, anti-inflammatory, antimalarial, antiglycative, and cytotoxic properties. Traditionally, guava leaves are used to treat diarrhea, dysentery, stomach disorders, cough, cold, wounds, skin diseases, dental plaque, and hypertension. Bioactive compounds such as quercetin, catechin, gallic acid, and ellagic acid play crucial roles in reducing oxidative stress, regulating blood glucose levels, inhibiting microbial growth, and preventing cellular damage associated with chronic diseases and cancer (Bulugahapitiya et al., 2021; Gutiérrez et al., 2008; Begum et al., 2004).",

    "economic_importance": "P. guajava is an economically important fruit crop cultivated throughout tropical and subtropical regions. The fruits are consumed fresh and processed into juices, jams, jellies, beverages, candies, and nutritional supplements. Leaves are utilized in herbal medicines, nutraceuticals, and cosmetic formulations. Guava processing industries generate by-products that are increasingly utilized in animal feed, biofuel production, enzyme technology, food additives, and biodegradable materials. Due to its high nutritional value, medicinal properties, and industrial applications, guava contributes significantly to agriculture, food processing, pharmaceutical industries, and rural livelihoods (Takeda et al., 2022; Morton, 1987).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Psidium guajava was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern owing to its widespread cultivation, naturalization, and stable populations across tropical and subtropical regions worldwide (Canteiro & Lucas, 2019)."
    },

    "references": [
      {
        "authors": "Begum, S., Hassan, S. I., Ali, S. N., & Siddiqui, B. S.",
        "year": 2004,
        "title": "Chemical constituents from the leaves of Psidium guajava",
        "journal": "Natural Product Research",
        "volume": "18",
        "issue": "2",
        "pages": "135-140"
      },
      {
        "authors": "Bulugahapitiya, V. P., Kokilananthan, S., Manawadu, H., & Gangabadage, C. S.",
        "year": 2021,
        "title": "Phytochemistry and medicinal properties of Psidium guajava L. leaves: A review",
        "journal": "Plant Science Today",
        "volume": "8",
        "issue": "4",
        "pages": "953-971"
      },
      {
        "authors": "Canteiro, C. & Lucas, E.",
        "year": 2019,
        "title": "Psidium guajava",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T49485755A49485759"
      },
      {
        "authors": "Gutiérrez, R. M. P., Mitchell, S., & Solis, R. V.",
        "year": 2008,
        "title": "Psidium guajava: A review of its traditional uses, phytochemistry and pharmacology",
        "journal": "Journal of Ethnopharmacology",
        "volume": "117",
        "issue": "1",
        "pages": "1-27"
      },
      {
        "authors": "Morton, J. F.",
        "year": 1987,
        "title": "Guava",
        "book": "Fruits of Warm Climates",
        "pages": "356-363",
        "publisher": "Creative Resource Systems"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "1",
        "pages": "381",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Takeda, L. N., Laurindo, L. F., Guiguer, E. L., Bishayee, A., Araújo, A. C., & Ubeda, L. C. C.",
        "year": 2022,
        "title": "Psidium guajava L.: A systematic review of the multifaceted health benefits and economic importance",
        "journal": "Food Reviews International",
        "volume": "39",
        "issue": "7",
        "pages": "4333-4363"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      }
    ]
  },
  {
    plant: 46,
    "id": "Nyctanthes-arbor-tristis",

    "scientific_name": "Nyctanthes arbor-tristis ",

    "aname": "L.",
    "common_name": "Night-flowering Jasmine, Coral Jasmine",

    "local_name": "Parijatham",

    "image": "/Flora/plant46.jpeg",
    gallery: {

      bark: "/Flora/plant46a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant46c.jpeg",
      fruit: "/Flora/plant46b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Nyctanthes-arbor-tristis",
    'qr_code': '/Flora/qrcodes/Nyctanthes-arbor-tristis.png',

    "botanical_profile": {
      "scientific_name": "Nyctanthes arbor-tristis ",
      "aname": "L.",
      "common_name": "Night-flowering Jasmine, Coral Jasmine",
      "local_name": "Parijatham",
      "family": "Oleaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Oleaceae",
      "genus": "Nyctanthes",
      "species": "arbor-tristis"
    },

    "morphological_characters": "N. arbor-tristis is a small deciduous tree or large shrub, rough all over with stiff white hairs. Young branches are sharply quadrangular and densely hairy. Leaves are opposite, ovate to obovate, coriaceous, rough and scabrous above due to short bulbous hairs, with a rounded base and acute apex. The leaves are distinctly 7-nerved and conspicuously veined beneath. Inflorescence consists of terminal or axillary cymose panicles. Flowers are highly fragrant, white with an orange-yellow tubular center, arranged in 3-chotomous pedunculate capitate heads. Peduncles are four-angled and hairy with broadly ovate bracts. Fruits are compressed capsules separating into two flat, one-seeded carpels with prominent reticulation. Seeds are small, flattened, and brownish. The species commonly occurs in deciduous forests and is cultivated throughout Telangana and Coastal Andhra Pradesh (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small tree or large shrub",
      "bark": "Rough with stiff white hairs",
      "branches": "Quadrangular and hairy",
      "leaves": "Ovate-obovate, coriaceous, rough and scabrous above",
      "flowers": "White with orange-yellow center, fragrant, arranged in capitate heads",
      "inflorescence": "Terminal or axillary cymose panicle",
      "fruit": "Compressed capsule separating into two flat one-seeded carpels",
      "seed": "Small, flattened, brownish"
    },

    "phytochemical_constituents": "N. arbor-tristis contains numerous bioactive compounds distributed in leaves, flowers, seeds, bark, and fruits. Major phytochemicals include iridoid glycosides such as arbortristoside A, B and C, nyctanthoside, flavonoids, tannins, phenolic compounds, carotenoids, essential oils, oleanolic acid, lupeol, friedelin, benzoic acid, mannitol, glucose, and other sugars. Flowers contain crocin-like carotenoid pigments responsible for their characteristic orange coloration. These compounds contribute significantly to the plant's antioxidant, anti-inflammatory, antimicrobial, hepatoprotective, antimalarial, and immunomodulatory properties (Sharma et al., 2023; Puri et al., 1994; Khare, 2007).",

    "medicinal_importance": "N. arbor-tristis is an important medicinal plant in Ayurveda, Siddha, and folk medicine. Different plant parts possess anti-inflammatory, antipyretic, analgesic, hepatoprotective, antiviral, antifungal, antibacterial, antimalarial, antihistaminic, anti-leishmanial, antioxidant, immunomodulatory, and antiarthritic activities. Traditionally, leaves are used to treat fever, malaria, arthritis, sciatica, and chronic rheumatism. Flowers are employed in the management of skin diseases and digestive disorders, while seeds are used as anthelmintic agents. Scientific studies have demonstrated its efficacy against inflammatory disorders, liver diseases, parasitic infections, and microbial pathogens, supporting many traditional uses (Sharma et al., 2023; Saxena et al., 1984; Puri et al., 1994; Verma et al., 2012).",

    "economic_importance": "The species possesses considerable economic value as a medicinal, ornamental, and aromatic plant. Its flowers are widely used in religious ceremonies and for the extraction of natural dyes. Various plant parts serve as raw materials in herbal pharmaceutical industries for the production of Ayurvedic formulations. The fragrant flowers contribute to ornamental horticulture, while bioactive compounds isolated from the plant are being explored for drug development. Due to its therapeutic importance, It is commercially cultivated in several regions of India and other tropical countries (Sharma et al., 2023; CSIR, 2008).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2022,
      "details": "N. arbor-tristis was assessed by the IUCN Red List and categorized as Least Concern because of its wide distribution, extensive cultivation, and stable populations throughout its native range (IUCN SSC Global Tree Specialist Group et al., 2022)."
    },

    "references": [
      {
        "authors": "IUCN SSC Global Tree Specialist Group, Botanic Gardens Conservation International (BGCI), Lakhey, P. & Pathak, J.",
        "year": 2022,
        "title": "Nyctanthes arbor-tristis",
        "source": "The IUCN Red List of Threatened Species 2022",
        "pages": "e.T150224828A152201552"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T. & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "2",
        "pages": "565",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Sharma, A., Goel, A., Gupta, N., & Sharma, B.",
        "year": 2023,
        "title": "Phytochemicals from Nyctanthes arbor-tristis and their biomedical implications",
        "journal": "Journal of Medical Pharmaceutical and Allied Sciences",
        "volume": "12",
        "issue": "4",
        "pages": "6012-6020"
      },
      {
        "authors": "Saxena, R. S., Gupta, B., Saxena, K. K., Singh, R. C., & Prasad, D. N.",
        "year": 1984,
        "title": "Study of anti-inflammatory, analgesic and antipyretic activity of Nyctanthes arbor-tristis",
        "journal": "Journal of Ethnopharmacology",
        "volume": "11",
        "issue": "3",
        "pages": "319-330"
      },
      {
        "authors": "Puri, A., Saxena, R., Saxena, K. C., Tandon, J. S., & Chandra, S.",
        "year": 1994,
        "title": "Immunostimulant activity of Nyctanthes arbor-tristis",
        "journal": "Journal of Ethnopharmacology",
        "volume": "42",
        "issue": "1",
        "pages": "31-37"
      },
      {
        "authors": "Verma, N., Amresh, G., Sahu, P. K., Rao, C. V., & Singh, A. P.",
        "year": 2012,
        "title": "Pharmacological evaluation of Nyctanthes arbor-tristis: A review",
        "journal": "Research Journal of Pharmaceutical, Biological and Chemical Sciences",
        "volume": "3",
        "issue": "1",
        "pages": "420-432"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "7",
        "publisher": "International Book Distributors"
      },
      {
        "authorss": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "volume": "4",
        "publisher": "Orient Longman"
      },
      {
        "authors": "CSIR",
        "year": 2008,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      }
    ]
  },
  {
    plant: 47,
    "id": "Limonia-acidissima",

    "scientific_name": "Limonia acidissima ",

    "aname": "L.",
    "common_name": "Wood Apple, Elephant Apple",

    "local_name": "Velagapandu",

    "image": "/Flora/plant47.jpeg",
    gallery: {

      bark: "/Flora/plant47a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant47b.jpeg",
      fruit: "/Flora/plant47c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Limonia-acidissima",
    'qr_code': '/Flora/qrcodes/Limonia-acidissima.png',

    "botanical_profile": {
      "scientific_name": "Limonia acidissima ",
      "aname": "L.",
      "common_name": "Wood Apple, Elephant Apple",
      "local_name": "Velagapandu",
      "family": "Rutaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Sapindales",
      "family": "Rutaceae",
      "genus": "Limonia",
      "species": "acidissima"
    },

    "morphological_characters": "L. acidissima is an armed deciduous tree reaching up to 20 m in height. The bark is dark blackish-grey, rough, and deeply fissured. Branches are often spiny. Leaves are alternate, imparipinnate (odd-pinnate), aromatic when crushed, with 5–9 glabrous obovate to elliptic leaflets having entire margins and obtuse apices. Inflorescences are axillary and terminal panicles bearing numerous small creamish to greenish-white flowers. Fruits are hard-shelled woody berries, globose in shape, containing aromatic brown pulp. Seeds are numerous, compressed, and embedded within the sweet mucilaginous pulp. The species occurs in dry deciduous forests and plains and is commonly found in Peccheruvu forest and other regions of Andhra Pradesh (Venkata Raju & Pullaiah, 1995; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Armed deciduous tree",
      "bark": "Deeply fissured, blackish-grey",
      "leaves": "Odd-pinnate, aromatic",
      "leaflets": "Glabrous, obovate, entire",
      "flowers": "Creamish to greenish-white",
      "inflorescence": "Axillary and terminal panicles",
      "fruit": "Woody, globose berry",
      "seed": "Numerous, embedded in sweet pulp"
    },

    "phytochemical_constituents": "L. acidissima contains a diverse range of bioactive compounds distributed in fruits, leaves, bark, roots, and seeds. Major phytochemicals include alkaloids, flavonoids, coumarins, tannins, saponins, lignans, triterpenoids, sterols, phenolic acids, chromeno-flavanones, tyramine derivatives, and essential oils. Important compounds reported include limonene, psoralen, xanthotoxin, bergapten, umbelliferone, stigmasterol, β-sitosterol, and various phenolic antioxidants. The bark and leaves possess antimicrobial flavanones and coumarins, while the fruit pulp is rich in polyphenols and vitamins that contribute to its medicinal value (Sharma & Tenguria, 2021; Rahman et al., 2018).",

    "medicinal_importance": "L. acidissima is widely used in Ayurveda, Siddha, and traditional medicine systems. Various plant parts exhibit antioxidant, antibacterial, antiviral, antifungal, antidiabetic, hepatoprotective, gastroprotective, anti-ulcer, anti-inflammatory, cardioprotective, wound-healing, antidiarrheal, antidysenteric, and anticancer activities. Traditionally, the fruit pulp is used for treating chronic diarrhea, dysentery, digestive disorders, peptic ulcers, and liver ailments. Leaves and bark are employed in the management of asthma, tumors, hepatitis, urinary disorders, and inflammatory conditions. Scientific studies support its therapeutic potential due to its rich phytochemical composition and antioxidant properties (Sharma & Tenguria, 2021; Ilango & Chitra, 2009; Rahman et al., 2018).",

    "economic_importance": "Wood apple is an economically valuable multipurpose tree. The fruits are consumed fresh or processed into beverages, jams, jellies, chutneys, squashes, desserts, and nutraceutical products. The pulp is rich in nutrients and serves as a raw material for food processing industries. The tree contributes to the herbal medicine sector due to its pharmacological properties. Gum obtained from the trunk is used in traditional medicinal preparations and as an adhesive. The hard shell of the fruit is utilized in handicrafts and decorative items. Cultivation and marketing of wood apple fruits provide supplementary income to rural communities and support local agro-based industries (Sharma & Tenguria, 2021; Morton, 1987).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": null,
      "details": "Limonia acidissima has not yet been formally evaluated under the IUCN Red List Categories and Criteria."
    },

    "references": [
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Venkata Raju, R. R. & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool, Andhra Pradesh",
        "pages": "104",
        "publisher": "Bishen Singh Mahendra Pal Singh Publishers"
      },
      {
        "authors": "Sharma, P. & Tenguria, R. K.",
        "year": 2021,
        "title": "Phytochemical properties and health benefits of Limonia acidissima: A review",
        "journal": "International Research Journal of Plant Science",
        "volume": "12",
        "issue": "2",
        "pages": "1-6"
      },
      {
        "authors": "Rahman, M. S., Hossain, M. A., Islam, M. T., & Rahman, M. M.",
        "year": 2018,
        "title": "Phytochemical and pharmacological activities of Limonia acidissima: A review",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "7",
        "issue": "5",
        "pages": "1220-1226"
      },
      {
        "authors": "Ilango, K. & Chitra, V.",
        "year": 2009,
        "title": "Wound healing and antioxidant activities of the fruit pulp of Limonia acidissima Linn.",
        "journal": "International Journal of Health Research",
        "volume": "2",
        "issue": "3",
        "pages": "233-240"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "1",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "volume": "3",
        "publisher": "Orient Longman"
      },
      {
        "authors": "CSIR",
        "year": 2003,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "6",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Morton, J. F.",
        "year": 1987,
        "title": "Wood Apple",
        "book": "Fruits of Warm Climates",
        "pages": "190-191",
        "publisher": "Creative Resource Systems, Miami"
      }
    ]
  },
  {
    plant: 48,
    "id": "Cassia-siamea",

    "scientific_name": "Cassia siamea ",

    "aname": "Lam. (Syn. Senna siamea (Lam.) H.S. Irwin )",
    "common_name": "Yellow Cassia, Kassod Tree, Ironwood Tree",

    "local_name": "Sima Tangedu, Yellow Cassia, Ironwood Tree",

    "image": "/Flora/plant48.jpeg",
    gallery: {

      bark: "/Flora/plant48a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant48b.jpeg",
      fruit: "/Flora/plant48c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Cassia-siamea",
    'qr_code': '/Flora/qrcodes/Cassia-siamea.png',

    "botanical_profile": {
      "scientific_name": "Cassia siamea ",
      "aname": "Lam. (Syn. Senna siamea (Lam.) H.S. Irwin )",
      "common_name": "Yellow Cassia, Kassod Tree, Ironwood Tree",
      "local_name": "Sima Tangedu",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "sub_family": "Caesalpinioideae",
      "genus": "Cassia",
      "species": "siamea"
    },

    "morphological_characters": "C. siamea is a moderate-sized evergreen tree characterized by light blackish-brown, rough, longitudinally fissured bark. Leaves are alternate and paripinnately compound with 7–14 pairs of elliptic-oblong, coriaceous leaflets. Leaflets are minutely petiolulate, glabrous above, pilose beneath, with prominent venation, obtuse bases and apices, and entire margins. Flowers are pale yellow and borne in axillary and terminal corymbose racemes. Fruits are long-stipitate, strap-shaped, flat, compressed woody pods measuring about 20–25 cm in length with thick sutures. Each pod contains 20–30 flat, oval, dark-brown, shiny seeds. The species is widely planted as an avenue, ornamental, and shade tree and has become naturalized in many tropical regions (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Moderate-sized tree",
      "bark": "Light blackish-brown, rough, longitudinally fissured",
      "leaves": "Alternate, paripinnately compound",
      "leaflets": "Elliptic-oblong, coriaceous, glabrous above, pilose beneath",
      "flowers": "Pale yellow",
      "inflorescence": "Axillary and terminal corymbose racemes",
      "fruit": "Long-stipitate, strap-shaped, flat compressed pod",
      "seed": "20–30 per pod, flat, oval, dark brown and shiny"
    },

    "phytochemical_constituents": "C. siamea contains a rich diversity of secondary metabolites distributed throughout its leaves, flowers, bark, roots, and seeds. Major phytochemicals include anthraquinones such as chrysophanol, emodin, physcion, cassiamin, and barakol; flavonoids including luteolin, apigenin, kaempferol, and quercetin; coumarins; alkaloids; glycosides; tannins; phenolic compounds; triterpenoids such as lupeol and betulin; and phytosterols including β-sitosterol and stigmasterol. These compounds are responsible for the plant's broad spectrum of biological activities and medicinal applications (Kumar et al., 2017; Orwa et al., 2009).",

    "medicinal_importance": "C. siamea is an important medicinal plant widely used in traditional and modern herbal medicine. Traditionally, various plant parts are used to treat fever, malaria, diabetes, hypertension, constipation, jaundice, asthma, abdominal pain, and menstrual disorders. Scientific studies have demonstrated antioxidant, anti-inflammatory, analgesic, antimalarial, antimicrobial, antidiabetic, anti-HIV, antitumor, antiarrhythmic, anxiolytic, hepatoprotective, and vasorelaxant activities. The bioactivities are primarily attributed to anthraquinones, flavonoids, and other phenolic compounds. In several Southeast Asian countries, decoctions of leaves and flowers are employed as herbal remedies for infectious and metabolic diseases (Kumar et al., 2017; Kirtikar & Basu, 2006).",

    "economic_importance": "C. siamea has considerable economic value due to its timber, ornamental, nutritional, and environmental applications. The hard, durable wood is extensively used in furniture making, agricultural implements, construction, poles, fuelwood, and charcoal production. The tree is widely planted as an avenue and shade tree in tea, coffee, cocoa, and rubber plantations. Young leaves and flowers are consumed as vegetables in several Asian countries after appropriate processing. The species also contributes to agroforestry systems, soil conservation, and urban landscaping. Because of its rapid growth and adaptability, it is an important multipurpose tree in tropical forestry and rural economies (Orwa et al., 2009; Kumar et al., 2017).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2018,
      "details": "Senna siamea (syn. Cassia siamea) was assessed for the IUCN Red List and categorized as Least Concern due to its wide distribution, extensive cultivation, and stable populations across tropical regions (Barstow, 2018)."
    },

    "references": [
      {
        "authors": "Barstow, M.",
        "year": 2018,
        "title": "Senna siamea",
        "source": "The IUCN Red List of Threatened Species 2018",
        "pages": "e.T62027907A62027910"
      },
      {
        "authors": "Kumar, D., Jain, A., & Verma, A.",
        "year": 2017,
        "title": "Phytochemical and Pharmacological Investigation of Cassia siamea Lamk: An Insight",
        "journal": "The Natural Products Journal",
        "volume": "7",
        "issue": "4",
        "pages": "255-266"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "1",
        "pages": "340",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "2",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "CSIR",
        "year": 1992,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "3",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1994,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "volume": "2",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 49,
    "id": "Prosopis-juliflora",

    "scientific_name": "Prosopis juliflora ",

    "aname": "(Sw.) DC.",
    "common_name": "Mesquite, Algaroba",

    "local_name": "Mulla Tumma, Sarkar Tumma",

    "image": "/Flora/plant49.jpeg",
    gallery: {

      bark: "/Flora/plant49a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant49b.jpeg",
      fruit: "/Flora/plant49c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Prosopis-juliflora",
    'qr_code': '/Flora/qrcodes/Prosopis-juliflora.png',

    "botanical_profile": {
      "scientific_name": "Prosopis juliflora ",
      "synonym": "Neltuma juliflora (Sw.) Raf.",
      "aname": "(Sw.) DC.",
      "common_name": "Mesquite, Algaroba",
      "local_name": "Mulla Tumma, Sarkar Tumma",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "sub_family": "Mimosoideae",
      "genus": "Prosopis",
      "species": "juliflora"
    },

    "morphological_characters": "P. juliflora is a moderate-sized, drought-resistant tree with a spreading crown and drooping branches, usually reaching up to 7 m in height. The bark is rough, thick, gray-brown to dull-red, deeply fissured, and often scaly. Leaves are alternate or clustered, bipinnate, with 1–2 pairs of pinnae. Leaflets occur in 15–20 pairs, are obliquely oblong, glabrous, and measure about 0.8–1.3 × 0.1–0.2 cm. Straight spines, about 1.5 cm long, are present on the branches. Flowers are creamish-yellow and borne in axillary hanging spikes. Fruits are drupaceous, indehiscent pods, slightly curved, compressed, and measure about 15–20 × 0.8–1.2 cm. Seeds are brown, ovoid, and numerous. The species commonly grows along rivers, streams, roadsides, village surroundings, and wastelands, and is rare in forest habitats (Venkata Raju & Pullaiah, 1995; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Moderate-sized drought-resistant tree",
      "bark": "Rough, thick, gray-brown to dull-red, fissured and scaly",
      "leaves": "Alternate or clustered, bipinnate",
      "leaflets": "Obliquely oblong, glabrous",
      "spines": "Straight, about 1.5 cm long",
      "flowers": "Creamish-yellow",
      "inflorescence": "Axillary hanging spikes",
      "fruit": "Drupaceous, slightly curved indehiscent pods",
      "seeds": "Brown, ovoid"
    },

    "phytochemical_constituents": "P. juliflora contains numerous bioactive compounds distributed throughout its leaves, bark, pods, seeds, and flowers. Major phytochemicals include alkaloids, flavonoids, phenolic compounds, tannins, terpenoids, steroids, glycosides, saponins, quinones, coumarins, proteins, and amino acids. Important alkaloids reported from the species include juliflorine, julifloricine, juliprosopine, prosopine, and prosopinine. Flavonoids such as apigenin, luteolin, quercetin derivatives, kaempferol derivatives, and isorhamnetin glycosides have also been identified. These compounds contribute significantly to the plant's antioxidant, antimicrobial, anti-inflammatory, and pharmacological activities (Patil et al., 2016; Pasiecznik et al., 2001).",

    "medicinal_importance": "P. juliflora has long been utilized in traditional medicine and exhibits a broad spectrum of pharmacological activities. Scientific studies have demonstrated antioxidant, antimicrobial, anti-inflammatory, antidiabetic, antiulcer, anthelmintic, antipyretic, wound-healing, amoebicidal, antigiardial, and cytotoxic properties. Extracts of various plant parts have shown activity against bacterial and fungal pathogens. Traditional uses include the treatment of colds, sore throat, diarrhea, dysentery, skin infections, inflammation, measles, flu, digestive disorders, and wounds. Several alkaloids isolated from the plant have also shown promising anticancer and antimicrobial potential (Patil et al., 2016; Ahmed et al., 2018).",

    "economic_importance": "P. juliflora is economically important in arid and semi-arid regions due to its multiple uses. The wood is widely used as fuelwood, charcoal, fencing material, and for small-scale furniture production. The pods serve as nutritious livestock fodder and can be processed into animal feed products. The species contributes to soil improvement through nitrogen fixation, stabilizes sand dunes, and helps combat desertification. It is also utilized in the production of bioethanol, activated carbon, biomass energy, and biochar. Furthermore, Prosopis juliflora has gained attention for phytoremediation, carbon sequestration, and environmental restoration projects. Despite these benefits, it is considered one of the world's most invasive tree species because of its rapid spread and ecological impacts on native vegetation (Prasad & Tewari, 2024; Pasiecznik et al., 2001).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2023,
      "details": "Prosopis juliflora (currently accepted as Neltuma juliflora in some taxonomic treatments) was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern owing to its wide distribution, adaptability, and abundant populations worldwide (Rivers, 2023)."
    },

    "references": [
      {
        "authors": "Ahmed, S., Abbas, Q., & Khan, M. A.",
        "year": 2018,
        "title": "Phytochemical Composition and Pharmacological Potential of Prosopis juliflora",
        "journal": "Journal of Medicinal Plants Research",
        "volume": "12",
        "issue": "6",
        "pages": "79-88"
      },
      {
        "authors": "CSIR",
        "year": 1969,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "8",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pasiecznik, N. M., Felker, P., Harris, P. J. C., Harsh, L. N., Cruz, G., Tewari, J. C., Cadoret, K., & Maldonado, L. J.",
        "year": 2001,
        "title": "The Prosopis juliflora–Prosopis pallida Complex: A Monograph",
        "publisher": "HDRA, Coventry, UK"
      },
      {
        "authors": "Patil, J., Kuppast, I. J., Kishan Kumar, M. A., & Kishan, K. G.",
        "year": 2016,
        "title": "Prosopis juliflora",
        "journal": "Research Journal of Pharmacology and Pharmacodynamics",
        "volume": "8",
        "issue": "4",
        "pages": "175-180"
      },
      {
        "authors": "Prasad, M. N. V., & Tewari, J. C.",
        "year": 2024,
        "title": "Prosopis juliflora (Sw.) DC.: Potential for Bioremediation and Bio-based Economy",
        "book": "Bioremediation and Bioeconomy",
        "edition": "2nd",
        "pages": "99-118",
        "publisher": "Elsevier"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rivers, M. C.",
        "year": 2023,
        "title": "Prosopis juliflora",
        "source": "The IUCN Red List of Threatened Species 2023",
        "pages": "e.T49485886A49485889"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool, Andhra Pradesh",
        "pages": "153",
        "publisher": "Bishen Singh Mahendra Pal Singh"
      }
    ]
  },
  {
    plant: 50,
    "id": "Gmelina-arborea",

    "scientific_name": "Gmelina arborea ",

    "aname": "Roxb. ex Sm.",
    "common_name": "White Teak, Gamhar",

    "local_name": "Gummer Tek, Pedda Gumudu Teku",

    "image": "/Flora/plant50.jpeg",
    gallery: {

      bark: "/Flora/plant50a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant50b.jpeg",
      fruit: "/Flora/plant50c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Gmelina-arborea",
    'qr_code': '/Flora/qrcodes/Gmelina-arborea.png',

    "botanical_profile": {
      "scientific_name": "Gmelina arborea ",
      "aname": "Roxb. ex Sm.",
      "common_name": "White Teak, Gamhar",
      "local_name": "Gummer Tek, Pedda Gumudu Teku",
      "family": "Lamiaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledones",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Polemoniales",
      "family": "Lamiaceae",
      "genus": "Gmelina",
      "species": "arborea"
    },

    "morphological_characters": "G. arborea is an unarmed, medium-sized deciduous tree with terete branches and a straight bole. Leaves are broadly ovate, cordate-truncate at the base, entire along the margins, acuminate at the apex, and puberulous above. The inflorescence is a terminal dichasial cyme, with older flowers situated at the base of the panicle and younger flowers towards the apex. Flowers are arranged in clusters of three, with a cupular calyx having five lobes and a yellow to yellowish-brown corolla. Stamens are four and inserted at the throat of the corolla tube. Fruits are fleshy drupes, ovoid to pyriform, turning orange-yellow when ripe. The species becomes leafless just before flowering and is found occasionally in deciduous forests across many districts of Andhra Pradesh (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Medium-sized deciduous tree",
      "branches": "Terete",
      "leaves": "Broadly ovate, cordate-truncate base, entire margin, acuminate apex",
      "inflorescence": "Terminal dichasial cyme",
      "flowers": "Yellow or yellowish-brown, arranged in threes",
      "calyx": "Cupular with five lobes",
      "stamens": "Four, inserted on corolla throat",
      "fruit": "Ovoid or pyriform drupe, orange-yellow when ripe"
    },

    "phytochemical_constituents": "G. arborea contains a diverse range of phytochemicals distributed throughout its leaves, roots, bark, fruits, flowers, and heartwood. Major constituents include lignans such as arboreol, gmelinol, paulownin, epieudesmin, and balanophonin; iridoid glycosides including gmelinosides and verbascoside; flavonoids such as luteolin, quercetin, rutin, kaempferol, apigenin, and isoquercetin; sterols including β-sitosterol, stigmasterol, and campesterol; terpenoids, alkaloids, tannins, phenolic compounds, and fatty acids such as oleic, linoleic, palmitic, and stearic acids. These bioactive compounds contribute significantly to the plant's pharmacological properties (Bhattacharyya et al., 2024; Kumar et al., 2012).",

    "medicinal_importance": "G. arborea is one of the important medicinal plants of Ayurveda and is a constituent of the classical formulation Dashamoola. The plant exhibits anti-inflammatory, antioxidant, hepatoprotective, nephroprotective, cardioprotective, antidiabetic, antiulcer, antimicrobial, anthelmintic, anticonvulsant, analgesic, anticancer, and immunomodulatory activities. Extracts from roots, bark, leaves, and fruits have been traditionally used to treat fever, dyspepsia, wounds, urinary disorders, diabetes, liver diseases, inflammatory conditions, and gastrointestinal ailments. Recent studies have also demonstrated promising anticancer and nanoparticle-mediated therapeutic applications (Bhattacharyya et al., 2024; Kumar et al., 2012; Kirtikar & Basu, 2006).",

    "economic_importance": "G. arborea is a highly valued fast-growing timber species extensively cultivated in plantation forestry across South and Southeast Asia. Its wood is lightweight, durable, and widely used for furniture, plywood, construction materials, agricultural implements, paper pulp, packing cases, and musical instruments. The species is also utilized in agroforestry systems because of its rapid growth and adaptability. Seed oil extracted from the fruits has industrial applications, while various plant parts are used in Ayurvedic pharmaceutical preparations. Owing to its medicinal potential, phytochemicals from G. arborea are being explored for development of modern therapeutic products, nutraceuticals, and nanotechnology-based drug delivery systems (Bhattacharyya et al., 2024; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Gmelina arborea was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern because of its wide distribution, extensive cultivation, and stable populations across its native and introduced range (De Kok, 2019)."
    },

    "references": [
      {
        "authors": "Bhattacharyya, S., Datta, K., Choudhury, P., & Sarkar, D.",
        "year": 2024,
        "title": "Chemical Constituents and Pharmacological Potential of Gmelina arborea Roxb. (Lamiaceae): A Review",
        "journal": "Plant Science Today"
      },
      {
        "authors": "De Kok, R.",
        "year": 2019,
        "title": "Gmelina arborea",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T32354A67741197"
      },
      {
        "authors": "Pullaiah, T. & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "2",
        "pages": "744",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Kumar, G. H., Vidya, S. M., & Krishna, V.",
        "year": 2012,
        "title": "Pharmacological Review on Gmelina arborea Roxb.",
        "journal": "International Journal of Research in Pharmaceutical Sciences",
        "volume": "3",
        "issue": "2",
        "pages": "173-181"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "3",
        "publisher": "International Book Distributors, Dehradun"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "CSIR",
        "year": 1959,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "4",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "volume": "1",
        "publisher": "Popular Prakashan"
      }
    ]
  }
  ,
  {
    plant: 51,
    "id": "Punica-granatum",

    "scientific_name": "Punica granatum ",

    "aname": "L.f",
    "common_name": "Pomegranate",

    "local_name": "Danimma, Pomegranate",

    "image": "/Flora/plant51.jpeg",
    gallery: {

      // bark: "/Flora/plant51a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant51a.jpeg",
      fruit: "/Flora/plant51b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Punica-granatum",
    'qr_code': '/Flora/qrcodes/Punica-granatum.png',

    "botanical_profile": {
      "scientific_name": "Punica granatum ",
      "aname": "L.",
      "common_name": "Pomegranate",
      "local_name": "Danimma, Pomegranate",
      "family": "Lythraceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Lythraceae",
      "genus": "Punica",
      "species": "granatum"
    },

    "morphological_characters": "P. granatum is a deciduous or evergreen shrub or small tree growing up to 6–10 m tall with numerous thorny branches. The bark is hard and woody. Leaves are simple, evergreen, short-stalked, and commonly arranged in clusters on branches. Inflorescences are terminal dichasial cymes bearing 2–7 flowers. Flowers are bright red with pointed sepals and numerous stamens. Fruits are globose to hexagonal berries with a hard leathery red rind crowned by a persistent tubular calyx. The interior contains numerous juicy edible arils separated by membranous partitions and white spongy tissue. Seeds are enclosed within the fleshy arils. The species is native to Iran and the north-western Himalayas and is extensively cultivated throughout tropical and subtropical regions for its edible fruits (Hussain et al., 2021; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Shrub or small tree",
      "bark": "Hard and woody",
      "leaves": "Simple, evergreen, short-stalked, clustered on branches",
      "inflorescence": "Terminal dichasial cyme",
      "flowers": "Bright red with numerous stamens",
      "fruit": "Globose berry with leathery red rind and persistent calyx",
      "seeds": "Numerous, enclosed in fleshy edible arils"
    },

    "phytochemical_constituents": "P. granatum contains a rich diversity of bioactive phytochemicals distributed throughout the fruit, peel, seeds, bark, flowers, and leaves. Major constituents include polyphenols such as ellagic acid, gallic acid, punicalagin, punicalin, and ellagitannins. Important flavonoids include quercetin, kaempferol, luteolin, catechin, epicatechin, and naringenin. Anthocyanins such as cyanidin, delphinidin, and pelargonidin contribute to the characteristic red coloration of the fruit. Seeds are rich in punicic acid, a conjugated fatty acid, along with phytosterols including β-sitosterol, campesterol, and stigmasterol. Other constituents include phenolic acids, tannins, alkaloids, terpenoids, tocopherols, vitamins, and minerals. These compounds are largely responsible for the antioxidant, antimicrobial, anti-inflammatory, and therapeutic properties of the plant (Arul, 2017; Viuda-Martos et al., 2010; Jurenka, 2008).",

    "medicinal_importance": "P. granatum possesses extensive medicinal value and has been used in traditional medicine systems such as Ayurveda, Unani, and Traditional Persian Medicine. Scientific studies have demonstrated strong antioxidant, antimicrobial, anti-inflammatory, antidiabetic, antihypertensive, cardioprotective, hepatoprotective, gastroprotective, and anticancer activities. Pomegranate extracts help reduce oxidative stress, improve cardiovascular health, regulate blood glucose levels, and inhibit the growth of various pathogenic microorganisms. The fruit peel and seeds exhibit significant chemo-preventive and anticancer properties due to their high polyphenol content. Pomegranate preparations are also used to support digestive health, boost immunity, and aid wound healing (Jurenka, 2008; Arul, 2017; Hussain et al., 2021).",

    "economic_importance": "P. granatum is one of the most economically important fruit crops worldwide. Fresh fruits are consumed directly and processed into juices, concentrates, syrups, jams, wines, and nutraceutical products. The peel and seeds serve as valuable raw materials for pharmaceutical, cosmetic, and food industries due to their high antioxidant content. Pomegranate extracts are incorporated into dietary supplements, herbal medicines, skincare products, and functional foods. The crop contributes significantly to agricultural income, export earnings, and rural livelihoods in many countries owing to its high market demand and adaptability to semi-arid conditions (Hussain et al., 2021; Viuda-Martos et al., 2010).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2020,
      "details": "Punica granatum was assessed in the IUCN Red List of Threatened Species and categorized as Least Concern due to its extensive cultivation, wide distribution, and stable global population (FFI/IUCN SSC Central Asian Regional Tree Red Listing Workshop, 2020)."
    },

    "references": [
      {
        "authors": "Arul, J.",
        "year": 2017,
        "title": "Punica granatum: A review on phytochemicals, antioxidant and antimicrobial properties",
        "journal": "Journal of Academia and Industrial Research",
        "volume": "5",
        "issue": "9",
        "pages": "132-135"
      },
      {
        "authors": "Hussain, S. Z., Wani, I. A., & Dar, B. N.",
        "year": 2021,
        "title": "Pomegranate (Punica granatum): Morphology, taxonomy, composition and health benefits",
        "book": "Fruits Grown in Highland Regions of the Himalayas",
        "pages": "131-144",
        "publisher": "Springer"
      },
      {
        "authors": "Jurenka, J. S.",
        "year": 2008,
        "title": "Therapeutic applications of pomegranate (Punica granatum L.): A review",
        "journal": "Alternative Medicine Review",
        "volume": "13",
        "issue": "2",
        "pages": "128-144"
      },
      {
        "authors": "Participants of the FFI/IUCN SSC Central Asian Regional Tree Red Listing Workshop, Bishkek, Kyrgyzstan (11–13 July 2006)",
        "year": 2020,
        "title": "Punica granatum (amended version of 2007 assessment)",
        "source": "The IUCN Red List of Threatened Species 2020",
        "pages": "e.T63531A173543609"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "1",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Viuda-Martos, M., Fernández-López, J., & Pérez-Álvarez, J. A.",
        "year": 2010,
        "title": "Pomegranate and its many functional components as related to human health: A review",
        "journal": "Comprehensive Reviews in Food Science and Food Safety",
        "volume": "9",
        "issue": "6",
        "pages": "635-654"
      }
    ]
  }
  ,
  {
    plant: 52,
    "id": "Citrus-medica",

    "scientific_name": "Citrus medica L.",

    "aname": "L.",
    "common_name": "Citron, Wild Lemon",

    "local_name": "Nimmakaya, Citron, Wild Lemon",

    "image": "/Flora/plant52.jpeg",
    gallery: {

      bark: "/Flora/plant52a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant52b.jpeg",
      fruit: "/Flora/plant52c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Citrus-medica",
    'qr_code': '/Flora/qrcodes/Citrus-medica.png',

    "botanical_profile": {
      "scientific_name": "Citrus medica ",
      "aname": "L.",
      "common_name": "Citron, Wild Lemon",
      "local_name": "Nimmakaya",
      "family": "Rutaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledones",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Rutaceae",
      "genus": "Citrus",
      "species": "medica"
    },

    "morphological_characters": "C. medica is a small evergreen tree or shrub with smooth yellowish-brown to light-grey bark. Young shoots are glabrous and characteristically purple in color. Branches are armed with stout spines. Leaves are simple, unifoliolate with winged petioles; leaf blades are oblong, up to 15 cm long, usually obtuse, crenate-serrate along the margins, and acute at the base. Flowers are white, often tinged with reddish-purple externally, fragrant, and borne in small racemes or clusters. Fruits are large hesperidia, oblong to obovoid, with a thick, aromatic, often warted rind and scanty acidic pulp. Seeds are numerous, ovoid, rough, and pale in color. In Andhra Pradesh, the species is reported from Visakhapatnam and Prakasam districts, usually occurring in thickets along streams up to 1000 m elevation (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small tree or shrub; young shoots purple and glabrous",
      "bark": "Smooth, yellowish-brown to light grey",
      "branches": "Armed with stout spines",
      "leaves": "Simple, unifoliolate with winged petiole",
      "flowers": "White, often tinged with red or purple",
      "inflorescence": "Small racemes or clusters",
      "fruit": "Large aromatic yellow hesperidium with thick rind",
      "seeds": "Numerous, ovoid and rough"
    },

    "phytochemical_constituents": "C. medica contains numerous bioactive compounds distributed in the peel, pulp, leaves, flowers, and essential oils. Major phytochemicals include flavonoids such as hesperidin, naringin, rutin, quercetin, diosmin, and eriocitrin; coumarins including bergapten, citropten, and scoparone; terpenoids such as limonene, γ-terpinene, β-myrcene, citral, limonin, nomilin, linalool, neryl acetate, and neryl alcohol. The fruit is also rich in phenolic acids including chlorogenic, ferulic, caffeic, and p-coumaric acids. Additionally, the peel contains abundant pectin, vitamin C, volatile oils, and antioxidant compounds that contribute to the plant's nutritional and medicinal value (Patil et al., 2023; Menichini et al., 2011).",

    "medicinal_importance": "C. medica possesses significant medicinal properties and has been used extensively in traditional medicine systems including Ayurveda, Siddha, and Unani. Scientific studies have demonstrated antioxidant, anti-inflammatory, antimicrobial, antidiabetic, antihyperlipidemic, cardioprotective, hepatoprotective, neuroprotective, and anticancer activities. The fruit and peel are used as digestive stimulants, carminatives, antiemetics, and remedies for gastrointestinal disorders. Flower extracts are traditionally employed as antidepressants, appetite stimulants, and treatments for asthma, cough, vomiting, and bowel disorders. The essential oils exhibit antimicrobial activity against various bacterial and fungal pathogens. High concentrations of flavonoids and vitamin C contribute to its therapeutic effects against oxidative stress and chronic diseases (Patil et al., 2023; Menichini et al., 2011).",

    "economic_importance": "C. medica has considerable economic importance in food, pharmaceutical, cosmetic, and perfumery industries. The thick aromatic rind is processed into candied citron, marmalades, jams, pickles, beverages, and confectionery products. The peel serves as a major source of pectin and essential oils used in perfumes, cosmetics, soaps, and flavoring agents. Citron extracts are incorporated into herbal medicines, nutraceuticals, and dietary supplements because of their medicinal properties. The species also holds religious and cultural significance in several countries, increasing its horticultural value. Commercial cultivation and processing generate income for farmers and support small-scale food and herbal industries (Patil et al., 2023; Calabrese et al., 2020).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2021,
      "details": "C. medica was assessed for The IUCN Red List of Threatened Species and categorized as Least Concern due to its wide cultivation, broad distribution, and stable populations in cultivated and semi-natural habitats (Plummer, 2021)."
    },

    "references": [
      {
        "authors": "Calabrese, F., De Pasquale, F., & Siracusa, L.",
        "year": 2020,
        "title": "The Citron (Citrus medica L.): Historical, Botanical and Economic Perspectives",
        "journal": "Plants",
        "volume": "9",
        "issue": "10",
        "pages": "1289"
      },
      {
        "authors": "CSIR",
        "year": 1992,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "2",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "1",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Menichini, F., Loizzo, M. R., Bonesi, M., Sicari, V., Pellicanò, T. M., Tundis, R., & Statti, G.",
        "year": 2011,
        "title": "Phytochemical Profile, Antioxidant, Anti-inflammatory and Antimicrobial Activities of Citrus medica L.",
        "journal": "Food Chemistry",
        "volume": "124",
        "issue": "2",
        "pages": "409-414"
      },
      {
        "authors": "Patil, A., Patil, K., Vikhankar, Y., & Gabhale, V.",
        "year": 2023,
        "title": "Citrus medica L.: A Comprehensive Review of Botany, Phytochemistry, and Medicinal Properties",
        "journal": "International Journal of Pharmacy Practice and Research",
        "volume": "28",
        "issue": "1",
        "pages": "414-431"
      },
      {
        "authors": "Plummer, J.",
        "year": 2021,
        "title": "Citrus medica",
        "source": "The IUCN Red List of Threatened Species 2021",
        "pages": "e.T62041221A62041228"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "1",
        "pages": "172",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  },
  {
    plant: 53,
    "id": "Wodyetia-bifurcata",

    "scientific_name": "Wodyetia bifurcata ",

    "aname": "A.K. Irvine",
    "common_name": "Foxtail Palm",

    "local_name": "Foxtail Palm, Wodyetia Palm",

    "image": "/Flora/plant53.jpeg",
    gallery: {

      bark: "/Flora/plant53a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Wodyetia-bifurcata",
    'qr_code': '/Flora/qrcodes/Citrus-medica.png',

    "botanical_profile": {
      "scientific_name": "Wodyetia bifurcata ",
      "aname": "A.K. Irvine",
      "common_name": "Foxtail Palm",
      "local_name": "Foxtail Palm, Wodyetia Palm",
      "family": "Arecaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Monocotyledonae",
      "series": "Calycinae",
      "order": "Arecales",
      "family": "Arecaceae",
      "genus": "Wodyetia",
      "species": "bifurcata"
    },

    "morphological_characters": "W. bifurcata is a solitary-trunked ornamental palm native to northeastern Queensland, Australia. It generally grows 10–15 m tall and may attain 18 m under favorable conditions. The trunk is smooth, slender, light grey, and marked with prominent ring-like leaf scars. The crown consists of 8–10 large pinnate fronds arching gracefully. Leaves are 2.5–3.5 m long and bear hundreds of narrow leaflets irregularly arranged around the rachis, creating the characteristic fluffy 'foxtail' appearance. Leaflets are bright to dark green, slightly twisted, and approximately 60–90 cm long. Interfoliar inflorescences bear creamy-white male and female flowers. Fruits are ovoid drupes that change from green to orange and reddish-orange when mature. Each fruit contains a single hard seed. The root system is fibrous and adventitious, providing good anchorage and drought tolerance (Sobana et al., 2025; Dowe, 1998).",

    "digital_identification": {
      "habit": "Solitary-trunked ornamental palm",
      "trunk": "Smooth, slender, light grey with ring-like scars",
      "crown": "8–10 large pinnate fronds",
      "leaves": "Long pinnate leaves with fluffy foxtail appearance",
      "leaflets": "Bright green to dark green, narrow and slightly twisted",
      "inflorescence": "Interfoliar",
      "flowers": "Creamy white",
      "fruit": "Ovoid drupe, orange to reddish-orange at maturity",
      "seed": "Single hard seed",
      "root": "Fibrous adventitious root system"
    },

    "phytochemical_constituents": "Phytochemical investigations of W. bifurcata have revealed the presence of several biologically active compounds in leaves, fruits, and seeds. Reported constituents include carbohydrates, proteins, phenolic compounds, flavonoids, alkaloids, saponins, terpenoids, phytosterols, glycosides, tannins, and antioxidant metabolites. Phenolic and flavonoid compounds contribute significantly to the antioxidant and antimicrobial activities of the plant. Recent studies have also demonstrated the utility of plant extracts in green synthesis of metallic nanoparticles with biomedical applications (Sobana et al., 2025).",

    "medicinal_importance": "W. bifurcata possesses promising medicinal properties attributed to its phytochemical constituents. Leaf extracts exhibit significant antioxidant activity by neutralizing free radicals and reducing oxidative stress. Antibacterial activity has been reported against Staphylococcus aureus, Bacillus subtilis, Escherichia coli, and Pseudomonas aeruginosa, while antifungal activity has been demonstrated against Candida albicans and Aspergillus niger. Cytotoxic studies using HeLa and MCF-7 cancer cell lines indicate potential anticancer properties. Traditional indigenous practices have utilized leaf preparations for minor skin ailments and wound healing. Furthermore, extracts are increasingly employed in green nanotechnology for the synthesis of silver, gold, and zinc nanoparticles possessing antimicrobial and antioxidant properties (Sobana et al., 2025).",

    "economic_importance": "W. bifurcata is one of the most commercially valuable ornamental palms worldwide. Its attractive foliage, rapid growth, drought tolerance, and low maintenance requirements make it highly desirable for landscaping in gardens, parks, resorts, institutional campuses, and urban environments. The species supports nursery and horticultural industries through large-scale propagation and international trade of seedlings. In addition, its extracts are increasingly utilized in biotechnology and nanotechnology sectors for eco-friendly nanoparticle production with applications in pharmaceuticals, cosmetics, agriculture, and environmental remediation. The palm is also used in ecological restoration and landscape greening projects, while its fruits provide food resources for birds and wildlife, enhancing urban biodiversity (Sobana et al., 2025; Dowe, 1998).",

    "conservation_status": {
      "IUCN_status": "Lower Risk/Conservation Dependent",
      "assessment_year": 1998,
      "details": "Wodyetia bifurcata was assessed for the IUCN Red List in 1998 and categorized as Lower Risk/Conservation Dependent. Although naturally restricted to a limited area in Queensland, Australia, the species is extensively cultivated worldwide as an ornamental palm (Dowe, 1998)."
    },
    "references": [
      {
        "authors": "Broschat, T. K. & Meerow, A. W.",
        "year": 2000,
        "title": "Ornamental Palm Horticulture",
        "publisher": "University Press of Florida"
      },
      {
        "authors": "Dransfield, J., Uhl, N. W., Asmussen, C. B., Baker, W. J., Harley, M. M., & Lewis, C. E.",
        "year": 2008,
        "title": "Genera Palmarum: The Evolution and Classification of Palms",
        "publisher": "Kew Publishing"
      },
      {
        "authors": "Dowe, J. L.",
        "year": 1998,
        "title": "Wodyetia bifurcata",
        "source": "The IUCN Red List of Threatened Species 1998",
        "pages": "e.T38733A10146773"
      },
      {
        "authors": "Dowe, J. L.",
        "year": 2009,
        "title": "Australian Palms: Biogeography, Ecology and Systematics",
        "publisher": "CSIRO Publishing"
      },
      {
        "authors": "Jones, D. L.",
        "year": 1995,
        "title": "Palms Throughout the World",
        "publisher": "Smithsonian Institution Press"
      },
      {
        "authors": "Meerow, A. W. & Broschat, T. K.",
        "year": 2015,
        "title": "Ornamental Palm Horticulture",
        "publisher": "University Press of Florida"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sobana, M., Gayathri Devi, S., Ezhilarrasi, M. V., Madhunika, S., & Ragavan, M.",
        "year": 2025,
        "title": "A Brief Review on Plant Wodyetia bifurcata",
        "journal": "Journal of Emerging Technologies and Innovative Research",
        "volume": "12",
        "issue": "7",
        "pages": "e357-e365"
      }
    ]
  },
  {
    plant: 54,
    "id": "Thuja-occidentalis",

    "scientific_name": "Thuja occidentalis ",

    "aname": "L.",
    "common_name": "Northern White Cedar, Arborvitae, Tree of Life",

    "local_name": "Mayurpamkhi, Tree of Life",

    "image": "/Flora/plant54.jpeg",
    gallery: {

      bark: "/Flora/plant54a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Thuja-occidentalis",
    'qr_code': '/Flora/qrcodes/Thuja-occidentalis.png',

    "botanical_profile": {
      "scientific_name": "Thuja occidentalis ",
      "aname": "L.",
      "common_name": "Northern White Cedar, Arborvitae",
      "local_name": "Mayurpamkhi, Tree of Life",
      "family": "Cupressaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Gymnosperms",
      "class": "Gymnospermae",
      "order": "Coniferales",
      "family": "Cupressaceae",
      "genus": "Thuja",
      "species": "occidentalis"
    },

    "morphological_characters": "T. occidentalis is an evergreen, bushy, slow-growing coniferous tree commonly cultivated as a hedge and ornamental plant. It usually grows 8–12 m tall, occasionally reaching 15 m. The crown is dense and conical with flattened, compact branches. Young leaves are needle-like but later become scale-like and are arranged in opposite decussate pairs along the branchlets. The bark is thin, fibrous, reddish-brown to grayish-brown, and exfoliates in narrow strips. The species is monoecious, producing male and female cones on the same plant. Male cones are small, reddish-yellow, while female cones are green to purplish when young and become brown at maturity. Mature seed cones are solitary, oblong, 8–16 mm long, consisting of thin woody scales enclosing flattened wingless seeds. The species thrives in cool, moist climates and is widely cultivated in gardens, parks, and landscapes (Bharti et al., 2022).",

    "digital_identification": {
      "habit": "Evergreen coniferous tree",
      "branches": "Flattened and compact",
      "leaves": "Needle-like in juvenile stage, later scale-like",
      "bark": "Thin, fibrous, brownish",
      "male_flowers": "Small, rounded, reddish-yellow cones",
      "female_flowers": "Green or purple-tinged cones",
      "cones": "Solitary, oblong, woody",
      "seeds": "Flattened, wingless"
    },

    "phytochemical_constituents": "T. occidentalis contains a variety of bioactive compounds including α-thujone, β-thujone, isothujone, fenchone, sabinene, camphene, borneol, pinene, flavonoids, tannins, coumarins, glycosides, alkaloids, terpenoids, saponins, and polysaccharides. The essential oil is rich in monoterpenes and phenolic compounds that contribute to its antimicrobial, antioxidant, and medicinal properties. Thujone is considered the principal active constituent and is responsible for many of the plant’s biological activities (Bharti et al., 2022; Naser et al., 2005).",

    "medicinal_importance": "T. occidentalis has long been used in traditional herbal and homeopathic medicine. It exhibits antimicrobial, antiviral, antifungal, antioxidant, anti-inflammatory, analgesic, immunostimulatory, hepatoprotective, radioprotective, and anticancer activities. The plant is commonly used for the treatment of respiratory tract infections, warts, skin disorders, arthritis, rheumatism, urinary tract disorders, and inflammatory conditions. Extracts of the plant have shown potential in enhancing immune responses and supporting wound healing. Its essential oil is widely used in herbal formulations and complementary medicine (Bharti et al., 2022; Naser et al., 2005).",

    "economic_importance": "T. occidentalis is economically important as an ornamental landscape and hedge plant due to its dense evergreen foliage and adaptability. The species is extensively cultivated in gardens, parks, cemeteries, and urban landscapes. Its essential oil is utilized in herbal medicine, perfumery, cosmetics, disinfectants, insect repellents, and preservation products. The wood is lightweight, durable, aromatic, and naturally resistant to decay, making it useful for fencing, poles, shingles, outdoor structures, and handicrafts. The plant also contributes significantly to the nursery and horticultural industries (Bharti et al., 2022; Farjon, 2013).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2013,
      "details": "Thuja occidentalis was assessed by the IUCN Red List and categorized as Least Concern due to its wide distribution, stable populations, and extensive cultivation throughout its native and introduced range (Farjon, 2013)."
    },

    "references": [
      {
        "authors": "Bharti, K., Sharma, M., Vyas, G. K., & Sharma, S.",
        "year": 2022,
        "title": "A review on phytochemical, pharmacological and biological activities of Thuja occidentalis",
        "journal": "Asian Journal of Pharmaceutical Research and Development",
        "volume": "10",
        "issue": "2",
        "pages": "111-115"
      },
      {
        "authors": "Farjon, A.",
        "year": 2013,
        "title": "Thuja occidentalis",
        "source": "The IUCN Red List of Threatened Species 2013",
        "pages": "e.T42262A2967995"
      },
      {
        "authors": "Naser, B., Bodinet, C., Tegtmeier, M., & Lindequist, U.",
        "year": 2005,
        "title": "Thuja occidentalis (Arbor vitae): A review of its pharmaceutical, pharmacological and clinical properties",
        "journal": "Evidence-Based Complementary and Alternative Medicine",
        "volume": "2",
        "issue": "1",
        "pages": "69-78"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  },
  {
    plant: 55,
    "id": "Prosopis-cineraria",

    "scientific_name": "Prosopis cineraria ",

    "aname": "(L.) Druce",
    "common_name": "Ghaf Tree, Khejri Tree",

    "local_name": "Jammi, Jammi Chettu",

    "image": "/Flora/plant55.jpeg",
    gallery: {

      bark: "/Flora/plant55a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant55b.jpeg",
      fruit: "/Flora/plant55c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Prosopis-cineraria",
    'qr_code': '/Flora/qrcodes/Prosopis-cineraria.png',

    "botanical_profile": {
      "scientific_name": "Prosopis cineraria ",
      "aname": "(L.) Druce",
      "common_name": "Ghaf Tree, Khejri Tree",
      "local_name": "Jammi, Jammi Chettu",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "sub_family": "Mimosoideae",
      "genus": "Prosopis",
      "species": "cineraria"
    },

    "morphological_characters": "P. cineraria is a medium-sized armed tree reaching up to 10 m in height. Branches bear scattered spines and form a spreading crown. Leaves are bipinnate, 3–5 cm long, with two pairs of pinnae. Each pinna bears 8–12 pairs of sessile oblong leaflets that are appressed-hairy, with oblique bases, entire margins, and rounded apices. Inflorescences occur as axillary spikes or slender spike-like racemes, often clustered or arranged in terminal panicles. Flowers are small, yellowish-green to yellow, borne on long slender spikes. Fruits are straight or curved glabrous pods, moniliform and pendent. Seeds are dull brown, oblong, and compressed. The species commonly occurs in dry stony lands, open forests, wastelands, and arid regions throughout India (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Armed tree",
      "leaves": "Bipinnate with two pairs of pinnae",
      "leaflets": "Oblong, sessile, appressed-hairy",
      "inflorescence": "Axillary spike or spike-like raceme",
      "flowers": "Yellow to yellowish-green",
      "pods": "Straight or curved, glabrous, pendent",
      "seeds": "Dull brown, oblong"
    },

    "phytochemical_constituents": "P. cineraria contains numerous biologically active compounds including flavonoids, alkaloids, phenolic compounds, tannins, steroids, glycosides, lipids, amino acids, vitamins, and minerals. Important constituents reported include patulatin, spicigerin, prosogerins A, B, C and D, luteolin, quercetin, apigenin, and various phenolic antioxidants. Leaves, bark, flowers, pods, and seeds contain bioactive compounds that contribute to the plant's medicinal properties and nutritional value (Sipani & Sharma, 2020; Pareek et al., 2015).",

    "medicinal_importance": "P. cineraria is a valuable medicinal tree extensively used in Ayurveda and traditional medicine. The plant exhibits antihyperglycemic, antihyperlipidemic, antioxidant, anti-inflammatory, analgesic, antipyretic, anticonvulsant, hepatoprotective, antimicrobial, antidepressant, antitumor, and anthelmintic activities. Traditionally, different parts of the plant are used to treat asthma, dysentery, leprosy, leucoderma, skin diseases, digestive disorders, piles, wounds, muscle pain, and infections. Leaves and pods are used for wound healing and indigestion, while bark preparations are employed as tonics and remedies for parasitic infections. The plant is also traditionally used for snake bites, scorpion stings, earache, toothache, and fractured bones (Sipani & Sharma, 2020; Pareek et al., 2015).",

    "economic_importance": "P. cineraria is regarded as the 'King of the Desert' because of its immense economic and ecological value in arid and semi-arid regions. The tree provides nutritious fodder, fuelwood, timber, food, gum, and medicine. Immature pods are consumed as vegetables and are key ingredients in traditional dishes such as Panchkuta and Sangri preparations. Leaves serve as valuable livestock fodder during drought periods. Wood is highly valued for fuel, charcoal production, agricultural implements, and rural construction. The bark is utilized in tanning and dyeing industries. As a nitrogen-fixing species, the tree improves soil fertility, supports agroforestry systems, prevents desertification, and contributes significantly to rural livelihoods and sustainable agriculture (Pareek et al., 2015; Tewari et al., 1998).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2012,
      "details": "Prosopis cineraria is generally regarded as a species of Least Concern due to its wide distribution across arid regions of South Asia and the Arabian Peninsula, stable populations, and extensive cultivation in agroforestry systems."
    },
    "references": [
      {
        "authors": "Aarti Sipani & Daisy Sharma",
        "year": 2020,
        "title": "A Review Study on Pharmacological Properties and Health Benefits",
        "book": "Research Trends in Medicinal Plant Sciences",
        "volume": "8",
        "chapter": "3",
        "pages": "27-39",
        "publisher": "AkiNik Publications"
      },
      {
        "authors": "CSIR",
        "year": 2003,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "8",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "IUCN",
        "year": 2012,
        "title": "IUCN Red List Categories and Criteria: Version 3.1",
        "publisher": "International Union for Conservation of Nature"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "2",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Pareek, A., Yadav, N., Vyas, N., Sharma, S., & Pareek, A.",
        "year": 2015,
        "title": "Prosopis cineraria: A Gift of Nature for Pharmacy",
        "journal": "International Journal of Pharma Sciences and Research",
        "volume": "6",
        "issue": "6",
        "pages": "958-964"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "1",
        "pages": "362",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Tewari, J. C., Pasiecznik, N. M., Harsh, L. N., & Harris, P. J. C.",
        "year": 1998,
        "title": "Prosopis Species in the Arid and Semi-Arid Zones of India",
        "publisher": "HDRA Publishing"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "volume": "4",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 56,
    "id": "Murraya-koenigii",

    "scientific_name": "Murraya koenigii ",

    "aname": "(L.) Spreng.",
    "common_name": "Curry Leaf Tree",

    "local_name": "Karivepaku, Curry Leaf Tree",

    "image": "/Flora/plant56.jpeg",
    gallery: {

      // bark: "/Flora/plant5a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant56a.jpeg",
      fruit: "/Flora/plant56b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Murraya-koenigii",
    'qr_code': '/Flora/qrcodes/Murraya-koenigii.png',

    "botanical_profile": {
      "scientific_name": "Murraya koenigii ",
      "aname": "(L.) Spreng.",
      "common_name": "Curry Leaf Tree",
      "local_name": "Karivepaku, Curry Leaf Tree",
      "family": "Rutaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Sapindales",
      "family": "Rutaceae",
      "genus": "Murraya",
      "species": "koenigii"
    },

    "morphological_characters": "M. koenigii is an aromatic shrub or small tree reaching up to 6 m in height. Leaves are alternate, imparipinnate, bearing 10–25 leaflets. Leaflets are oblong-lanceolate, somewhat asymmetrical, glabrous, aromatic, with oblique bases and acute apices; margins are entire to slightly serrate. Flowers are small, white, fragrant, and borne in terminal corymbose panicles. Fruits are subglobose berries that become purplish-black when ripe and contain whitish pulp. Seeds are usually one or two, green and globose. The species commonly occurs on hill slopes, in dense forests, and is widely cultivated in home gardens throughout India for culinary and medicinal purposes (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Shrub or small tree",
      "leaves": "Pinnate, aromatic",
      "leaflets": "Alternate, glabrous, oblong-lanceolate, acute apex",
      "flowers": "White and fragrant",
      "inflorescence": "Terminal corymbose panicles",
      "fruit": "Purplish-black berry when ripe",
      "seed": "Green, globose"
    },

    "phytochemical_constituents": "M. koenigii contains a rich diversity of bioactive phytochemicals. Important constituents include carbazole alkaloids such as mahanimbine, girinimbine, koenigine, koenidine, koenioline, mukonicine, murrayacine, murrayazolidine, cyclomahanimbine, bicyclomahanimbicine, pyrayafoline-carbazole, and murrayastine. The leaves also contain flavonoids, coumarins, terpenoids, glycosides, tannins, phenolic compounds, oxalic acid, resin, and volatile oils rich in caryophyllene, α-pinene, β-pinene, sabinene, and limonene. Fruits contain reducing sugars, tannins, organic acids, carotenoids, minerals, and vitamin C. These compounds are responsible for the plant's diverse pharmacological activities (Harshita Sisodia & Rathore, 2023; Balakrishnan et al., 2020).",

    "medicinal_importance": "M. koenigii possesses numerous medicinal properties and has long been used in Ayurveda and traditional medicine. Various plant parts exhibit antioxidant, antidiabetic, antimicrobial, anti-inflammatory, hepatoprotective, anticancer, antiulcer, antihyperlipidemic, neuroprotective, and wound-healing activities. Leaves, roots, and bark are traditionally used as digestive stimulants, antiemetics, anthelmintics, analgesics, and remedies for fever, dysentery, piles, blood disorders, inflammation, itching, leucoderma, and renal pain. Fresh leaves are consumed for managing digestive disorders, while leaf paste and decoctions are applied to treat poisonous bites, skin eruptions, and wounds. Scientific studies have validated many of these traditional uses through pharmacological investigations (Balakrishnan et al., 2020; Harshita Sisodia & Rathore, 2023).",

    "economic_importance": "M. koenigii is one of the most economically important spice and medicinal plants in South Asia. Fresh and dried leaves are extensively used as flavoring agents in households, restaurants, food processing industries, and ready-to-cook food products. Curry leaf powder, dried leaf flakes, extracts, and pastes contribute significantly to the spice market. The plant is widely utilized in Ayurvedic, herbal, and nutraceutical industries because of its antioxidant, hypoglycemic, hepatoprotective, and antimicrobial properties. Essential oils extracted from leaves are used in cosmetics, hair oils, shampoos, soaps, perfumes, and skincare products. Curry leaf extracts also serve as natural biopesticides due to their insecticidal and antifungal properties, supporting sustainable and organic agriculture. The growing demand for medicinal plants and natural products has enhanced its commercial value globally (Patil et al., 2026; Balakrishnan et al., 2020).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2021,
      "details": "M. koenigii was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern because of its wide distribution, extensive cultivation, and stable populations across its native range (Plummer, 2021)."
    },

    "references": [
      {
        "authors": "Balakrishnan, R., Vijayraja, D., Jo, S. H., Ganesan, P., Kim, I. S., & Choi, D. K.",
        "year": 2020,
        "title": "Medicinal Profile, Phytochemistry, and Pharmacological Activities of Murraya koenigii and its Primary Bioactive Compounds",
        "journal": "Antioxidants",
        "volume": "9",
        "issue": "2",
        "pages": "101"
      },
      {
        "authors": "CSIR",
        "year": 2003,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "6",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Kirtikar, K. R. & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "1",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Ningappa, M. B., Dinesha, R., & Srinivas, L.",
        "year": 2008,
        "title": "Antioxidant and Free Radical Scavenging Activities of Polyphenol-Enriched Curry Leaf Extract",
        "journal": "Food Chemistry",
        "volume": "106",
        "issue": "2",
        "pages": "720-728"
      },
      {
        "authors": "Patil, M. J., Patil, A. R., Yevle, S. L., & Palve, S. A.",
        "year": 2026,
        "title": "Review Article on Murraya koenigii",
        "journal": "International Journal of Research Publication and Reviews",
        "volume": "7",
        "issue": "1",
        "pages": "826-832"
      },
      {
        "authors": "Plummer, J.",
        "year": 2021,
        "title": "Murraya koenigii",
        "source": "The IUCN Red List of Threatened Species 2021",
        "pages": "e.T156236806A166564522"
      },
      {
        "authors": "Pullaiah, T. & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "1",
        "pages": "175",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T. & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sisodia, H. & Rathore, P.",
        "year": 2023,
        "title": "Phytochemicals and Pharmacological Studies of Murraya koenigii Spreng (Rutaceae): A Comprehensive Review of its Therapeutic Potential",
        "journal": "Biological Forum – An International Journal",
        "volume": "15",
        "issue": "6",
        "pages": "521-528"
      }
    ]
  },
  {
    plant: 57,
    "id": "Nerium-indicum",

    "scientific_name": "Nerium indicum",

    "aname": " Mill.",
    "common_name": "Indian Oleander",

    "local_name": "Ganneru",

    "image": "/Flora/plant57.jpeg",
    gallery: {

      bark: "/Flora/plant57a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant57b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Nerium-indicum",
    'qr_code': '/Flora/qrcodes/Nerium-indicum.png',

    "botanical_profile": {
      "scientific_name": "Nerium indicum",
      "aname": " Mill.",
      "common_name": "Indian Oleander",
      "local_name": "Ganneru",
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledones",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Nerium",
      "species": "indicum"
    },

    "morphological_characters": "N. indicum is a large, erect, profusely branched evergreen xerophytic shrub, usually branching from the base. Leaves are linear-lanceolate, sparsely pubescent when young and becoming glabrous with age, thickly coriaceous, arranged in whorls, with a very stout midrib, acute base, entire margins, and acute apex. Inflorescence consists of terminal polychasial cymes. Flowers are showy, fragrant, and occur in shades of rose, red, pink, or white. Fruits are paired follicles, cylindrical, straight, ribbed, and dehiscent at maturity. The plant is widely cultivated as an ornamental in gardens, parks, roadsides, and temple premises throughout Andhra Pradesh and other parts of India (Pullaiah & Ali Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large evergreen xerophytic shrub",
      "branches": "Profusely branched from the base",
      "leaves": "Linear-lanceolate, coriaceous, arranged in whorls, stout midrib",
      "inflorescence": "Terminal polychasial cymes",
      "flowers": "Rose, pink, red or white, fragrant",
      "fruit": "Paired cylindrical ribbed follicles",
      "seed": "Numerous seeds with silky hairs"
    },

    "phytochemical_constituents": "N. indicum contains numerous biologically active compounds distributed throughout the leaves, flowers, bark, roots, latex, and seeds. Major phytochemicals include cardiac glycosides such as oleandrin, neriin, neritaloside, digitoxigenin, neriodorin, neriodorein, karabin, and anhydro-oleandrin. Other constituents include flavonoids such as rutin and quercetin, triterpenoids, phenolic acids, tannins, saponins, polysaccharides, aromatic oils, coumarins including scopoletin and scopolin, sterols, and potassium salts. The cardiac glycosides are primarily responsible for the plant's potent biological and toxic activities (Nagargoje & Phad, 2013; Langford & Boor, 1996).",

    "medicinal_importance": "N. indicum has long been used in traditional systems of medicine for treating skin diseases, ulcers, leprosy, eczema, wounds, and inflammatory disorders. Scientific studies have demonstrated antimicrobial, antifungal, antiviral, antioxidant, anti-inflammatory, analgesic, antiulcer, hepatoprotective, antidiabetic, cardiotonic, and anticancer activities. Extracts of the plant have shown cytotoxic effects against several cancer cell lines. Despite these medicinal properties, all parts of the plant are highly toxic because of their cardiac glycoside content, and improper use may cause severe poisoning. Therefore, medicinal applications require careful processing and professional supervision (Nagargoje & Phad, 2013; Bandara et al., 2010).",

    "economic_importance": "N. indicum is widely cultivated as an ornamental shrub because of its attractive flowers, drought tolerance, and adaptability to urban environments. It is extensively used in landscaping, avenue planting, hedges, and garden decoration. The flowers are occasionally used as a source of natural dyes, while extracts have been employed traditionally as insecticidal and pesticidal agents. Its extensive root system contributes to soil stabilization and erosion control. The species also has significance in pharmaceutical research due to its bioactive cardiac glycosides and potential anticancer compounds (Nagargoje & Phad, 2013; Kirtikar & Basu, 2006).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": null,
      "details": "Nerium indicum has not been independently evaluated by the IUCN Red List. However, the species is widely cultivated and naturalized in tropical and subtropical regions around the world and does not currently face significant conservation threats."
    },

    "references": [
      {
        "authors": "Bandara, V., Weinstein, S. A., White, J., Eddleston, M., & Fernando, R.",
        "year": 2010,
        "title": "A Review of the Natural History, Toxicology, Diagnosis and Clinical Management of Nerium oleander Poisoning",
        "journal": "Toxicon",
        "volume": "56",
        "issue": "3",
        "pages": "273-281"
      },
      {
        "authors": "CSIR",
        "year": 1966,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "volume": "7",
        "publisher": "Council of Scientific and Industrial Research, New Delhi"
      },
      {
        "authors": "Dey, P., Chaudhuri, T. K., & Chaudhuri, S.",
        "year": 2015,
        "title": "Pharmacological and Toxicological Profile of Nerium indicum: A Review",
        "journal": "International Journal of Pharmaceutical Sciences and Research",
        "volume": "6",
        "issue": "5",
        "pages": "1878-1885"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "volume": "3",
        "publisher": "International Book Distributors, Dehradun"
      },
      {
        "authors": "Langford, S. D., & Boor, P. J.",
        "year": 1996,
        "title": "Oleander Toxicity: An Examination of Human and Animal Toxic Exposures",
        "journal": "Toxicology",
        "volume": "109",
        "issue": "1",
        "pages": "1-13"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "volume": "1",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Nagargoje, A. N., & Phad, S. S.",
        "year": 2013,
        "title": "A Review on Phytochemistry and Pharmacology of Nerium indicum Mill.",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "21",
        "issue": "2",
        "pages": "148-151"
      },
      {
        "authors": "Pullaiah, T., & Ali Moulali, D.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh",
        "volume": "2",
        "pages": "574",
        "publisher": "Scientific Publishers, Jodhpur"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  },
  {
    plant: 58,
    "id": "Azadirachta-indica",

    "scientific_name": "Azadirachta indica ",

    "aname": "A. Juss.",
    "common_name": "Neem Tree",

    "local_name": "Neem, Vepaku",

    "image": "/Flora/plant58.jpeg",
    gallery: {

      bark: "/Flora/plant58a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant58b.jpeg",
      fruit: "/Flora/plant58c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Azadirachta-indica",
    'qr_code': '/Flora/qrcodes/Azadirachta-indica.png',

    "botanical_profile": {
      "scientific_name": "Azadirachta indica ",
      "aname": "A. Juss.",
      "common_name": "Neem Tree",
      "local_name": "Neem, Vepaku",
      "family": "Meliaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Meliaceae",
      "genus": "Azadirachta",
      "species": "indica"
    },

    "morphological_characters": "A. indica A. Juss. is a medium to large evergreen tree reaching up to 15–20 m in height. The bark is rough, fissured, and brown to dark grey in colour. Leaves are alternate, imparipinnate, and compound with 5–6 pairs of ovate-lanceolate leaflets having oblique bases, crenate-serrate margins, and acute apices (Pullaiah & Chennaiah, 1997). Flowers are small, white, fragrant, and arranged in axillary panicles. Fruits are smooth oblong drupes that turn yellow upon ripening, while seeds are solitary and ellipsoid (Kirtikar & Basu, 2006). The species commonly occurs in plains, roadsides, cultivated lands, and dry deciduous forests throughout India (Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Medium-sized evergreen tree",
      "bark": "Brown to dark grey, fissured",
      "leaves": "Alternate, imparipinnate",
      "leaflets": "Ovate-lanceolate, crenate-serrate margin",
      "leaf_surface": "Glabrous and green",
      "inflorescence": "Axillary panicle",
      "flowers": "White and fragrant",
      "fruit": "Oblong drupe, yellow when ripe",
      "seed": "Solitary and ellipsoid"
    },

    "phytochemical_constituents": "A. indica contains diverse phytochemicals including limonoids, flavonoids, tannins, glycosides, steroids, alkaloids, terpenoids, and phenolic compounds (Alzohairy, 2016). Major bioactive constituents include azadirachtin, nimbin, nimbidin, nimbolide, salannin, gedunin, quercetin, sodium nimbinate, and nimbidol (Biswas et al., 2002). These phytochemicals contribute to antioxidant, antimicrobial, anti-inflammatory, antidiabetic, anticancer, antiviral, and insecticidal activities (Subapriya & Nagini, 2005).",

    "medicinal_importance": "A. indica is widely used in Ayurveda, Siddha, and Unani medicine for treating skin diseases, ulcers, diabetes, fever, wounds, dental infections, and gastrointestinal disorders (Kirtikar & Basu, 2006). Neem extracts exhibit antimicrobial, antioxidant, anti-inflammatory, hepatoprotective, antiparasitic, antiviral, and immunomodulatory activities (Alzohairy, 2016). Neem oil and leaf extracts possess wound-healing properties and are effective against several bacterial and fungal pathogens (Biswas et al., 2002). Limonoids such as azadirachtin are also effective against agricultural pests and malaria vectors.",

    "economic_importance": "A. indica is economically important in agriculture, medicine, cosmetics, and environmental management. Neem cake is widely used as an organic manure and soil conditioner, while neem-based biopesticides are extensively utilized in sustainable farming systems (National Research Council, 1992). Neem oil is used in soap, pharmaceutical, cosmetic, and biodiesel industries. Wood is durable and termite-resistant, making it useful in furniture and rural construction. Plant extracts are also used in eco-friendly pesticides and herbal medicinal formulations (Umar Muhammad Faisal et al., 2023).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2018,
      "details": " Azadirachta indica was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Barstow & Deepu, 2018)."
    },

    "references": [
      {
        "authors": "Alzohairy, M. A.",
        "year": 2016,
        "title": "Therapeutics role of Azadirachta indica (Neem) and their active constituents in diseases prevention and treatment",
        "journal": "Evidence-Based Complementary and Alternative Medicine",
        "volume": "2016",
        "pages": "7382506",
        "doi": "https://doi.org/10.1155/2016/7382506"
      },
      {
        "authors": "Barstow, M., & Deepu, S.",
        "year": 2018,
        "title": "Azadirachta indica",
        "source": "The IUCN Red List of Threatened Species 2018",
        "doi": "https://doi.org/10.2305/IUCN.UK.2018-1.RLTS.T61793521A61793525.en"
      },
      {
        "authors": "Biswas, K., Chattopadhyay, I., Banerjee, R. K., & Bandyopadhyay, U.",
        "year": 2002,
        "title": "Biological activities and medicinal properties of neem (Azadirachta indica)",
        "journal": "Current Science",
        "volume": "82",
        "issue": "11",
        "pages": "1336–1345"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian medicinal plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "National Research Council",
        "year": 1992,
        "title": "Neem: A tree for solving global problems",
        "publisher": "National Academy Press",
        "doi": "https://doi.org/10.17226/1924"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 1)",
        "publisher": "Scientific Publishers"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Subapriya, R., & Nagini, S.",
        "year": 2005,
        "title": "Medicinal properties of neem leaves: A review",
        "journal": "Current Medicinal Chemistry – Anti-Cancer Agents",
        "volume": "5",
        "issue": "2",
        "pages": "149–156",
        "doi": "https://doi.org/10.2174/1568011053174828"
      },
      {
        "authors": "Umar Muhammad Faisal, U. M., Muhammad Sahil Saifi, M. S., Md. Kaish, M. K., Maryamu Ibrahim, M. I., Shiwani, S., Said Suleiman Kwakuri, S. S., & Muhammad Arif, M. A.",
        "year": 2023,
        "title": "Azadirachta indica (Neem): An important medicinal plant: A literature review of its chemistry, biological activities, role in COVID-19 management and economic importance",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "12",
        "issue": "6",
        "pages": "59–65"
      }
    ]
  },
  {
    plant: 59,
    "id": "Erythrina-variegata",

    "scientific_name": "Erythrina variegata ",

    "aname": "L.",
    "common_name": "Indian Coral Tree",

    "local_name": "Badida Chettu, Tiger's Claw",

    "image": "/Flora/plant59.jpeg",
    gallery: {

      bark: "/Flora/plant59a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant59b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Erythrina-variegata",
    'qr_code': '/Flora/qrcodes/Erythrina-variegata.png',

    "botanical_profile": {
      "scientific_name": "Erythrina variegata ",
      "aname": "L.",
      "common_name": "Indian Coral Tree",
      "local_name": "Badida Chettu, Tiger's Claw",
      "family": "Fabaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Rosales",
      "family": "Fabaceae",
      "genus": "Erythrina",
      "species": "variegata"
    },

    "morphological_characters": "E. variegata is a medium to large deciduous tree commonly known as the Indian Coral Tree. The bark is grayish-brown and rough. Leaves are alternate, trifoliate, with broad ovate to rhomboid leaflets. Young leaves are often slightly pubescent. Flowers are large, bright scarlet, crimson-red, or orange-red, papilionaceous, and borne in terminal or axillary racemes. Fruits are elongated cylindrical pods that turn dark brown to black upon maturity. Seeds are kidney-shaped, smooth, glossy, and dark red, brown, or purplish in color (Pullaiah & Karuppusamy, 2018; Keerthana et al., 2024).",

    "digital_identification": {
      "habit": "Medium to large deciduous tree",
      "bark": "Grayish-brown and rough",
      "leaves": "Alternate and trifoliate",
      "leaflets": "Broad ovate to rhomboid",
      "flowers": "Bright scarlet, crimson-red or orange-red, papilionaceous",
      "inflorescence": "Terminal or axillary racemes",
      "fruit": "Long cylindrical pod",
      "seeds": "Kidney-shaped, smooth, dark red to purplish"
    },

    "phytochemical_constituents": "E. variegata contains diverse bioactive compounds including alkaloids, flavonoids, isoflavonoids, phenolics, terpenoids, steroids, lectins, proteins, and amino acids. Major alkaloids reported include erythraline, erysodine, erysotrine, erysovine, erythratidine, and erythramine. Important flavonoids and isoflavonoids include erycristagallin, erythrinin, alpinumisoflavone, phaseollin, and orientanol. Other constituents such as β-sitosterol, stigmasterol, octacosyl ferulate, and dihydrofolinin have also been identified. These phytochemicals contribute significantly to the medicinal properties of the plant (Keerthana et al., 2024; Kumar et al., 2010).",

    "medicinal_importance": "E. variegata is widely used in Ayurveda and traditional medicine. The leaves, bark, roots, and seeds possess antioxidant, anti-inflammatory, analgesic, antimicrobial, anticonvulsant, antiasthmatic, antiulcer, anthelmintic, and wound-healing properties. Extracts are traditionally employed in the treatment of fever, dysentery, rheumatism, toothache, wounds, insomnia, and parasitic infections. Scientific studies have demonstrated anticancer, antitumor, CNS depressant, smooth muscle relaxant, and antibacterial activities. The species has also shown potential in phytoremediation by removing heavy metals such as zinc and cadmium from polluted environments (Keerthana et al., 2024; Warrier et al., 1996; Kumar et al., 2010).",

    "economic_importance": "E. variegata has considerable economic value as an ornamental, medicinal, agroforestry, and environmental management tree. It is extensively cultivated as an avenue tree and as shade support in tea, coffee, cocoa, black pepper, and betel vine plantations. Being a nitrogen-fixing species, it improves soil fertility and supports sustainable agriculture. The lightweight wood is used for packing cases, handicrafts, small implements, toys, and low-cost construction. The brilliant flowers enhance landscape aesthetics, while the plant's phytoremediation capability makes it useful in wastewater treatment and environmental restoration projects (Orwa et al., 2009; Kumar et al., 2010).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2025,
      "details": "Erythrina variegata has not yet been formally assessed under the IUCN Red List categories."
    },
    "references": [
      {
        "authors": "Anonymous",
        "year": 2023,
        "title": "The Wealth of India: Raw Materials, Erythrina Species",
        "publisher": "CSIR-NIScPR"
      },
      {
        "authors": "Keerthana, V., Amudha, P., & Vijayalakshmi, V.",
        "year": 2024,
        "title": "A concise review on Erythrina variegata and its pharmacological properties",
        "journal": "International Journal for Research Trends and Innovation",
        "volume": "9",
        "issue": "2",
        "pages": "347-351"
      },
      {
        "authors": "Kumar, A., Lingadurai, S., Jain, A., & Barman, N.",
        "year": 2010,
        "title": "Erythrina variegata Linn: A review on morphology, phytochemistry and pharmacological aspects",
        "journal": "Pharmacologyonline",
        "volume": "1",
        "pages": "147-152"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Yoganarasimhan, S. N.",
        "year": 2000,
        "title": "Medicinal Plants of India",
        "publisher": "Interline Publishing Pvt. Ltd."
      }
    ]
  },
  {
    plant: 60,
    "id": "Bougainvillea-spectabilis",

    "scientific_name": "Bougainvillea spectabilis ",

    "aname": "Willd.",
    "common_name": "Paper Flower",

    "local_name": "Kagithala Puvvu",

    "image": "/Flora/plant60.jpeg",
    gallery: {

      bark: "/Flora/plant60a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant60b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Bougainvillea-spectabilis",
    'qr_code': '/Flora/qrcodes/Bougainvillea-spectabilis.png',

    "botanical_profile": {
      "scientific_name": "Bougainvillea spectabilis Willd.",
      "aname": "Willd.",
      "common_name": "Paper Flower",
      "local_name": "Kagithala Puvvu",
      "family": "Nyctaginaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Monochlamydeae",
      "series": "Curvembryae",
      "family": "Nyctaginaceae",
      "genus": "Bougainvillea",
      "species": "spectabilis"
    },

    "morphological_characters": "B. spectabilis is a large ornamental woody climber or shrub widely cultivated in tropical and subtropical regions. The bark is rough and brownish. Stems are hard, woody, branched, and often armed with curved thorns. Young branches are green and flexible, becoming brown and woody with age. Leaves are simple, alternate, ovate to elliptical, soft-textured, and green with prominent venation. Flowers are small, tubular, bisexual, and usually cream or white in color. The inflorescence consists of clusters of flowers enclosed by three large, brightly colored papery bracts that may be purple, pink, red, orange, or white. Fruits are small, narrow, elongated achenes containing a single seed. Seeds are hard and enclosed within the dry fruit (Kumari & Kumar, 2017; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Woody climber or shrub",
      "bark": "Rough and brownish",
      "stem": "Woody, branched, often thorny",
      "leaves": "Simple, broad, alternate, ovate to elliptical",
      "flowers": "Small, tubular, cream to white",
      "inflorescence": "Dichasial cyme",
      "bracts": "Large, papery, brightly coloured",
      "fruit": "Small, narrow, elongated achene",
      "seeds": "Small and hard"
    },

    "phytochemical_constituents": "B. spectabilis contains numerous bioactive phytochemicals including alkaloids, flavonoids, phenols, glycosides, tannins, saponins, steroids, quinones, furanoids, triterpenoids, proteins, carbohydrates, and reducing sugars. The leaves and flowers are particularly rich in flavonoids and phenolic compounds responsible for antioxidant activity. Important compounds reported from the plant include pinitol, bougainvinones, betalains, terpenoids, and various phenolic acids. These constituents contribute significantly to its medicinal and pharmacological properties (Kumari & Kumar, 2017; Abarca-Vargas & Petricevich, 2018).",

    "medicinal_importance": "B. spectabilis possesses diverse medicinal properties and is extensively used in traditional medicine systems. The plant exhibits antidiabetic, antihyperglycemic, antioxidant, antimicrobial, anti-inflammatory, antiulcer, hepatoprotective, hypolipidemic, thrombolytic, antifertility, and wound-healing activities. The presence of pinitol contributes significantly to blood glucose regulation. Leaf and flower extracts have demonstrated antibacterial and antifungal activities against various pathogenic microorganisms. Traditionally, decoctions of leaves and stems are used to treat cough, sore throat, diarrhea, gastric disorders, acidity, ulcers, and respiratory ailments. Scientific studies have further supported its therapeutic potential in pharmaceutical and herbal medicine applications (Kumari & Kumar, 2017; Edwin et al., 2007; Abarca-Vargas & Petricevich, 2018).",

    "economic_importance": "B. spectabilis is one of the most important ornamental plants used in gardens, parks, hedges, avenues, and landscape beautification projects worldwide. Its attractive colorful bracts and adaptability to drought and poor soils make it highly valuable in the horticultural industry. The species is extensively propagated and marketed as an ornamental flowering plant. In addition, its medicinal properties contribute to its value in herbal medicine and pharmaceutical research. The antioxidant, antimicrobial, and antidiabetic constituents have attracted considerable interest for developing natural therapeutic products. The plant also plays a role in urban greening and environmental beautification programs (Abarca-Vargas & Petricevich, 2018; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2025,
      "details": "Bougainvillea spectabilis has not been formally evaluated under the IUCN Red List categories and criteria."
    },
    "references": [
      {
        "authors": "Abarca-Vargas, R., & Petricevich, V. L.",
        "year": 2018,
        "title": "Bougainvillea genus: A review on phytochemistry, pharmacology, and toxicology",
        "journal": "Evidence-Based Complementary and Alternative Medicine",
        "volume": "2018",
        "pages": "1-17"
      },
      {
        "authors": "Anonymous",
        "year": 2023,
        "title": "The Wealth of India: Raw Materials",
        "publisher": "CSIR-NIScPR"
      },
      {
        "authors": "Edwin, E., Sheeja, E., Toppo, E., & Tiwari, V.",
        "year": 2007,
        "title": "Antidiabetic, antioxidant and antimicrobial activities of Bougainvillea spectabilis leaves",
        "journal": "International Journal of Green Pharmacy",
        "volume": "1",
        "issue": "2",
        "pages": "75-79"
      },
      {
        "authors": "Kumari, A., & Kumar, A. S.",
        "year": 2017,
        "title": "A phytopharmacological review on Bougainvillea spectabilis",
        "journal": "International Journal of Pharmacology Research",
        "volume": "7",
        "issue": "1",
        "pages": "36-39"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 61,
    "id": "Dypsis-lutescens",

    "scientific_name": "Dypsis lutescens (H.Wendl.) Beentje & J.Dransf.",

    "aname": "(H.Wendl.) Beentje & J.Dransf.",
    "common_name": "Areca Palm, Butterfly Palm, Golden Cane Palm",

    "local_name": "Areca Palm",

    "image": "/Flora/plant61.jpeg",
    gallery: {

      bark: "/Flora/plant61a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Dypsis-lutescens",
    'qr_code': '/Flora/qrcodes/Dypsis-lutescens.png',

    "botanical_profile": {
      "scientific_name": "Dypsis lutescens ",
      "aname": "(H.Wendl.) Beentje & J.Dransf.",
      "common_name": "Areca Palm, Butterfly Palm, Golden Cane Palm",
      "local_name": "Areca Palm",
      "family": "Arecaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Monocotyledones",
      "series": "Calycineae",
      "family": "Arecaceae",
      "genus": "Dypsis",
      "species": "lutescens"
    },

    "morphological_characters": "D. lutescens is an evergreen, clustering ornamental palm that grows in dense tufts and typically attains a height of 3–10 m. The plant produces multiple slender, cane-like stems arising from the base. Stems are smooth, yellowish-green, ringed with conspicuous leaf scars, and become greyish with age. Leaves are pinnately compound, gracefully arching, feather-like, and measure up to 2–3 m long. Numerous narrow, lanceolate leaflets are arranged regularly along the rachis, giving the palm a soft and elegant appearance. The inflorescence emerges below the crownshaft as a branched panicle bearing numerous small flowers. Flowers are creamy-white to yellowish and develop into oval fruits that change from green to yellow, orange, and finally dark purple or black upon maturity. Each fruit generally contains a single seed (Dransfield et al., 2008; El-Ghonemy et al., 2019; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Evergreen clustered palm",
      "stems": "Multiple, slender, cane-like, yellowish-green with prominent leaf scars",
      "leaves": "Pinnately compound, arching, feather-like",
      "leaflets": "Numerous narrow lanceolate leaflets arranged along the rachis",
      "inflorescence": "Branched panicle arising below leaves",
      "flowers": "Creamy-white to yellowish",
      "fruits": "Oval, yellow to orange turning dark at maturity",
      "seeds": "Single seed per fruit"
    },

    "phytochemical_constituents": "Leaves of D. lutescens contain a wide range of bioactive phytochemicals including flavonoids, phenolic compounds, tannins, triterpenes, steroids, lignans, polyphenols, phenolic glycosides, and other antioxidant constituents. These secondary metabolites exhibit free radical scavenging activity and contribute to the plant's biological and therapeutic properties. Phytochemical investigations have identified several phenolic derivatives responsible for antioxidant, hepatoprotective, and anti-inflammatory activities (El-Ghonemy et al., 2019; Khare, 2007; Nair & Mohanan, 2017).",

    "medicinal_importance": "D. lutescens possesses noteworthy medicinal potential. Experimental studies have demonstrated significant antioxidant activity, helping to neutralize reactive oxygen species and reduce oxidative stress. Leaf extracts exhibit hepatoprotective properties by protecting liver tissues from chemically induced damage and restoring normal liver functions. The presence of flavonoids, phenolics, and polyphenolic compounds contributes to anti-inflammatory activity by suppressing inflammatory mediators. Preliminary studies have also indicated cytotoxic and anticancer potential against certain cell lines. Additionally, the antioxidant-rich phytochemical profile suggests possible applications in preventing oxidative stress-related disorders (El-Ghonemy et al., 2019; Khare, 2007; Nair & Mohanan, 2017).",

    "economic_importance": "D. lutescens is one of the most commercially important ornamental palms worldwide. It is extensively cultivated for landscaping, avenue planting, indoor decoration, urban greening, and beautification projects. The plant is highly valued in homes, offices, hotels, shopping complexes, parks, and gardens because of its elegant foliage, adaptability, and low maintenance requirements. It is also recognized as an air-purifying plant capable of improving indoor environmental quality by removing airborne pollutants. The species contributes significantly to the ornamental horticulture and nursery industries and is increasingly explored as a source of bioactive compounds for pharmaceutical, nutraceutical, and cosmetic applications (Dransfield et al., 2008; El-Ghonemy et al., 2019; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Near Threatened",
      "assessment_year": 2012,
      "details": "Dypsis lutescens was assessed by the IUCN Red List and categorized as Near Threatened (NT) due to habitat loss and population decline in its native range of Madagascar (Rakotoarinivo & Dransfield, 2012)."
    },

    "references": [
      {
        "authors": "Dransfield, J., Uhl, N. W., Asmussen, C. B., Baker, W. J., Harley, M. M., & Lewis, C. E.",
        "year": 2008,
        "title": "Genera Palmarum: The Evolution and Classification of Palms",
        "publisher": "Kew Publishing"
      },
      {
        "authors": "El-Ghonemy, M. M., El-Kashak, W. A., Mohamed, T. K., Omara, E. A., Hussein, J., Farrag, A. R. H., Nassar, M. I., & El-Kady, M. Y.",
        "year": 2019,
        "title": "Hepatoprotective Activity of Dypsis lutescens Against D-Galactosamine-Induced Hepatotoxicity in Rats and Its Phytoconstituents",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "9",
        "issue": "11",
        "pages": "467-473"
      },
      {
        "authors": "Khare, C. P.",
        "year": 2007,
        "title": "Indian Medicinal Plants: An Illustrated Dictionary",
        "publisher": "Springer"
      },
      {
        "authors": "Nair, R., & Mohanan, N.",
        "year": 2017,
        "title": "Phytochemical and Pharmacological Potential of Ornamental Palms: A Review",
        "journal": "International Journal of Pharmaceutical Sciences and Research",
        "volume": "8",
        "issue": "9",
        "pages": "3701-3709"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rakotoarinivo, M., & Dransfield, J.",
        "year": 2012,
        "title": "Dypsis lutescens",
        "source": "The IUCN Red List of Threatened Species 2012",
        "pages": "e.T195960A2436709",
        "doi": "10.2305/IUCN.UK.2012.RLTS.T195960A2436709.en"
      }
    ]
  },
  {
    plant: 62,
    "id": "Couroupita-guianensis",

    "scientific_name": "Couroupita guianensis ",

    "aname": "Aubl.",
    "common_name": "Cannonball Tree",

    "local_name": "Nagalinga, Shivalingapushpam, Cannonball Tree",

    "image": "/Flora/plant62.jpeg",
    gallery: {

      bark: "/Flora/plant62a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant62b.jpeg",
      fruit: "/Flora/plant62c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Couroupita-guianensis",
    'qr_code': '/Flora/qrcodes/Courouptia-guianensis.png',

    "botanical_profile": {
      "scientific_name": "Couroupita guianensis ",
      "aname": "Aubl.",
      "common_name": "Cannonball Tree",
      "local_name": "Nagalinga, Shivalingapushpam",
      "family": "Lecythidaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Lecythidaceae",
      "genus": "Couroupita",
      "species": "guianensis"
    },

    "morphological_characters": "C. guianensis is a large evergreen tropical tree attaining a height of about 20–35 m. Leaves are alternate, oblong-obovate to lanceolate, clustered towards branch tips, entire to slightly serrate, and hairy beneath along the veins. The inflorescence is a long raceme arising directly from the trunk and major branches (cauliflory). Flowers are large, fragrant, reddish-pink to crimson with yellow tinges and possess a distinctive hood-like androphore. Fruits are large, globose, woody capsules measuring 15–24 cm in diameter, brown to reddish-brown when mature. Each fruit contains 200–300 seeds embedded in a whitish pulp with a characteristic odor. Pollination is mainly carried out by bees and bats. The hanging cannonball-like fruits are a distinctive diagnostic feature of the species (Pullaiah & Karuppusamy, 2018; Orwa et al., 2009; Sumathi & Anuradha, 2017; Prance & Mori, 1979).",

    "digital_identification": {
      "habit": "Large evergreen tree",
      "leaves": "Alternate, oblong-obovate, clustered at branch ends",
      "inflorescence": "Cauliflorous raceme",
      "flowers": "Large, fragrant, reddish-pink with yellow tinge",
      "fruit": "Large globose woody capsule resembling cannonballs",
      "seeds": "Numerous seeds embedded in whitish pulp"
    },

    "phytochemical_constituents": "C. guianensis contains numerous bioactive phytochemicals including alkaloids, flavonoids, tannins, phenolics, glycosides, saponins, terpenoids, steroids, triterpenoids, anthraquinones, proteins, carbohydrates, anthocyanins, eugenol, stigmasterol, campesterol, β-sitosterol, α-amyrin, β-amyrin, linoleic acid, nerol, isatin, indirubin, and tryptanthrin. These compounds contribute to the plant’s antioxidant, antimicrobial, anti-inflammatory, and therapeutic activities (Sumathi & Anuradha, 2017; Nadkarni, 2007; Warrier et al., 1996; Kirtikar & Basu, 1999).",

    "medicinal_importance": "C. guianensis is widely used in Ayurveda, Siddha, and folk medicine. Different parts of the plant are employed in the treatment of skin diseases, wounds, inflammation, dysentery, stomach disorders, common cold, scabies, hypertension, and pain. Scientific studies have demonstrated antimicrobial, antioxidant, anti-inflammatory, antiulcer, antidiarrheal, hepatoprotective, anticancer, antipyretic, antiarthritic, immunomodulatory, wound-healing, antidepressant, anxiolytic, and insecticidal properties. Extracts from leaves, flowers, fruits, and bark have shown activity against various pathogenic bacteria and fungi and possess significant free radical scavenging potential (Sumathi & Anuradha, 2017; Kirtikar & Basu, 1999; Warrier et al., 1996; Nadkarni, 2007; Nascimento et al., 2011).",

    "economic_importance": "C. guianensis has considerable ornamental, medicinal, ecological, and economic value. The species is extensively planted in temples, botanical gardens, parks, and avenues because of its attractive flowers and unique cannonball-like fruits. Various plant parts are utilized in traditional medicine and pharmaceutical research. The plant exhibits potential as a source of natural antimicrobial and antioxidant compounds for drug development. Its leaves and fruits are also investigated for vermicomposting and organic manure production. Due to its insecticidal and ovicidal properties, the species may contribute to environmentally friendly pest management practices (Orwa et al., 2009; Sumathi & Anuradha, 2017; Anonymous, 2023).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2023,
      "details": "C. guianensis was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Oldfield, 2023)."
    },

    "references": [
      {
        "authors": "Anonymous",
        "year": 2023,
        "title": "The Wealth of India: Raw Materials",
        "publisher": "CSIR-NIScPR"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Nascimento, M. V., Silva, G. C., & Silva, M. S.",
        "year": 2011,
        "title": "Phytochemical Screening and Biological Activities of Couroupita guianensis",
        "journal": "Revista Brasileira de Farmacognosia",
        "volume": "21",
        "issue": "5",
        "pages": "915-922"
      },
      {
        "authors": "Oldfield, S.",
        "year": 2023,
        "title": "Couroupita guianensis",
        "source": "The IUCN Red List of Threatened Species 2023",
        "pages": "e.T33969A212029048"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Philippine Medicinal Plants",
        "year": 2024,
        "title": "Couroupita guianensis (Cannonball Tree)",
        "source": "Philippine Medicinal Plants Database"
      },
      {
        "authors": "Prance, G. T., & Mori, S. A.",
        "year": 1979,
        "title": "The Lecythidaceae: A Monograph of the Neotropical Family",
        "publisher": "New York Botanical Garden"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Sumathi, S., & Anuradha, R.",
        "year": 2017,
        "title": "Couroupita guianensis Aubl: An Updated Review of its Phytochemistry and Pharmacology",
        "journal": "Asian Journal of Pharmacy and Pharmacology",
        "volume": "3",
        "issue": "1",
        "pages": "1-8"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      }
    ]
  },
  {
    plant: 63,
    "id": "Commiphora-caudata",

    "scientific_name": "Commiphora caudata ",

    "aname": "(Wight & Arn.) Engl.",
    "common_name": "Hill Mango, Green Commiphora",

    "local_name": "Konda Mamidi",

    "image": "/Flora/plant63.jpeg",
    gallery: {

      bark: "/Flora/plant63a.jpeg",
      // leaf: "/Flora/plant63/leaf.jpg",
      flower: "/Flora/plant63b.jpeg",
      fruit: "/Flora/plant63c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Commiphora-caudata",
    'qr_code': '/Flora/qrcodes/Commiphora-caudata.png',

    "botanical_profile": {
      "scientific_name": "Commiphora caudata ",
      "aname": "(Wight & Arn.) Engl.",
      "common_name": "Hill Mango, Green Commiphora",
      "local_name": "Konda Mamidi",
      "family": "Burseraceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Geraniales",
      "family": "Burseraceae",
      "genus": "Commiphora",
      "species": "caudata"
    },

    "morphological_characters": "C. caudata is a deciduous, unarmed tree reaching up to 18 m in height. The bark is smooth, greenish, aromatic and exfoliating in thin flakes. Leaves are alternate and 3–7-foliolate; leaflets are elliptic-ovate, glabrescent, acute at the apex and unequal at the base. Flowers are red and arranged in axillary cymes. Fruits are globose drupes containing a solitary seed. The species occurs occasionally in the Nallamala forests and other dry deciduous regions of Andhra Pradesh (Venkata Raju & Pullaiah, 1995; Pullaiah & Karuppusamy, 2018; Gamble, 1915–1936; Hooker, 1875).",

    "digital_identification": {
      "habit": "Deciduous tree",
      "bark": "Smooth, greenish, aromatic and exfoliating",
      "leaves": "3–7 foliolate",
      "leaflets": "Elliptic-ovate, glabrescent",
      "flowers": "Red",
      "inflorescence": "Axillary cymes",
      "fruit": "Globose drupe",
      "seed": "Solitary"
    },

    "phytochemical_constituents": "C. caudata contains a diverse array of bioactive phytochemicals including alkaloids, flavonoids, glycosides, tannins, terpenoids, steroids, phenolic compounds, proteins, amino acids, reducing sugars and starch. Essential oil analysis has revealed the presence of cyclofenchene, β-pinene, dihydrocarveol and other volatile terpenoid constituents. The plant is particularly rich in phenolics and flavonoids which contribute significantly to antioxidant activity through free radical scavenging mechanisms. Resinous exudates contain sesquiterpenes, monoterpenes, aromatic compounds and resin acids responsible for antimicrobial and anti-inflammatory properties. The phytochemical profile of Commiphora species indicates the presence of biologically active compounds with therapeutic potential against oxidative stress, inflammation and microbial infections (Mounika et al., 2020; Hanuš et al., 2005; Shen et al., 2012; Harborne, 1998; Evans, 2009; Nadkarni, 2007).",

    "medicinal_importance": "C. caudata possesses significant ethnomedicinal and pharmacological importance. Traditionally, the plant is used for treating diabetes, fever, urinary disorders, oral ulcers, wounds, inflammatory conditions and digestive ailments. The gum-resin is employed as a mouthwash for oral ulcers and wound healing owing to its antiseptic properties, while leaves are used as an aphrodisiac and vitality enhancer. Roots are valued in folk medicine for managing diabetes, fever and urinary disorders. Pharmacological studies have demonstrated anti-inflammatory, antioxidant, antimicrobial, antidiabetic, anti-ulcer, anti-arthritic, analgesic and hepatoprotective activities. The plant is also reported to improve memory and learning ability. Bioactive terpenoids and phenolic compounds present in the plant contribute to tissue protection, reduction of oxidative stress and enhancement of healing processes. Extracts of Commiphora species have shown promising efficacy in inflammatory disorders, microbial infections and metabolic diseases (Mounika et al., 2020; Nadkarni, 2007; Shen et al., 2012; Hanuš et al., 2005; Dolara et al., 2000; CSIR, 2003; Reddy et al., 2008; Warrier et al., 1996).",

    "economic_importance": "C. caudata is an important source of aromatic resin and essential oils utilized in pharmaceutical preparations, traditional medicines and herbal formulations. Due to its antioxidant and antimicrobial properties, the plant has potential applications in food preservation, cosmetics and natural health products. The species is widely explored for herbal drug development and possesses significant commercial value in pharmaceutical, nutraceutical and natural medicine industries. Resinous products are used in traditional therapeutic preparations, aromatic formulations and value-added herbal products. The increasing global demand for plant-based medicines and natural antioxidants further enhances the economic significance of this species (Mounika et al., 2020; CSIR, 2003; Nadkarni, 2007).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2025,
      "details": "Commiphora caudata has not yet been evaluated in The IUCN Red List of Threatened Species. Sustainable utilization and habitat conservation are recommended because of its medicinal and economic importance (POWO, 2025)."
    },

    "references": [
      {
        "authors": "Mounika, G., Anitha, K., & Balaji, A.",
        "year": 2020,
        "title": "A Comprehensive Review on Aromatic Medicinal Plant – Commiphora caudata",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "64",
        "issue": "1",
        "pages": "60–63"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Venkata Raju, R. R., & Pullaiah, T.",
        "year": 1995,
        "title": "Flora of Kurnool, Andhra Pradesh",
        "publisher": "Bishen Singh Mahendra Pal Singh",
        "pages": "107–108"
      },
      {
        "authors": "Gamble, J. S.",
        "year": 1915,
        "title": "Flora of the Presidency of Madras",
        "publisher": "Adlard & Son Ltd., London"
      },
      {
        "authors": "Hooker, J. D.",
        "year": 1875,
        "title": "The Flora of British India, Vol. I",
        "publisher": "L. Reeve & Co., London"
      },
      {
        "authors": "Hanuš, L. O., Řezanka, T., Dembitsky, V. M., & Moussaieff, A.",
        "year": 2005,
        "title": "Myrrh—Commiphora Chemistry",
        "journal": "Biomedical Papers",
        "volume": "149",
        "issue": "1",
        "pages": "3–28"
      },
      {
        "authors": "Shen, T., Li, G. H., Wang, X. N., & Lou, H. X.",
        "year": 2012,
        "title": "The Genus Commiphora: A Review of its Traditional Uses, Phytochemistry and Pharmacology",
        "journal": "Journal of Ethnopharmacology",
        "volume": "142",
        "issue": "2",
        "pages": "319–330"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods: A Guide to Modern Techniques of Plant Analysis",
        "publisher": "Chapman & Hall, London"
      },
      {
        "authors": "Evans, W. C.",
        "year": 2009,
        "title": "Trease and Evans Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Council of Scientific and Industrial Research (CSIR)",
        "year": 2003,
        "title": "The Wealth of India: A Dictionary of Indian Raw Materials and Industrial Products",
        "publisher": "CSIR Publications"
      },
      {
        "authors": "Reddy, K. N., Pattanaik, C., Reddy, C. S., & Raju, V. S.",
        "year": 2008,
        "title": "Medicinal Plants of Andhra Pradesh",
        "publisher": "Botanical Survey of India"
      },
      {
        "authors": "Dolara, P., Luceri, C., Ghelardini, C., Monserrat, C., Aiolli, S., Luceri, F., & Lodovici, M.",
        "year": 2000,
        "title": "Analgesic and Anti-inflammatory Properties of Compounds Isolated from Commiphora Species",
        "journal": "Planta Medica",
        "volume": "66",
        "pages": "356–358"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Royal Botanic Gardens, Kew",
        "year": 2025,
        "title": "Plants of the World Online (POWO): Commiphora caudata",
        "publisher": "Kew Science"
      }
    ]
  },
  {
    plant: 64,
    "id": "Polyalthia-longifolia",

    "scientific_name": "Polyalthia longifolia ",

    "aname": "(Sonn.) Thwaites  ",
    "common_name": "False Ashoka, Buddha Tree, Mast Tree",

    "local_name": "Asokamu",

    "image": "/Flora/plant64.jpeg",
    gallery: {

      bark: "/Flora/plant64a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant64b.jpeg",
      fruit: "/Flora/plant64c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Polyalthia-longifolia",
    'qr_code': '/Flora/qrcodes/Polyalthia-longifolia.png',

    "botanical_profile": {
      "scientific_name": "Polyalthia longifolia ",
      "aname": "(Sonn.) Thwaites  ",
      "common_name": "False Ashoka, Buddha Tree, Mast Tree",
      "local_name": "Asokamu",
      "family": "Annonaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledons",
      "sub_class": "Polypetalae",
      "series": "Thalamiflorae",
      "order": "Ranales",
      "family": "Annonaceae",
      "genus": "Polyalthia",
      "species": "longifolia"
    },

    "morphological characters": "P. longifolia is a tall evergreen tree with a characteristic narrow pyramidal crown. The bark is dark to grayish-brown and smooth. Leaves are narrowly lanceolate, 15–20 cm long, shining, glabrous, with undulate margins, cuneate base and acuminate apex. Flowers are yellowish-green and borne in axillary or terminal fascicles or umbels. Fruits occur in clusters of one-seeded berries. Seeds are ovoid, hard and pale brown. The species is widely cultivated throughout India as an ornamental avenue tree and is commonly found in gardens, educational institutions, temples and urban landscapes (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018; Gamble, 1915–1936; Hooker, 1872).",

    "digital_identification": {
      "habit": "Tall evergreen tree",
      "bark": "Dark to grayish-brown and smooth",
      "leaves": "Narrowly lanceolate, shining and glabrous",
      "flowers": "Yellowish-green",
      "inflorescence": "Axillary or terminal fascicles/umbels",
      "fruit": "Clustered berries",
      "seeds": "Ovoid, hard and pale brown"
    },

    "phytochemical_constituents": "P. longifolia contains a rich diversity of bioactive phytochemicals including alkaloids, flavonoids, terpenoids, phenolic compounds, diterpenoids, tannins, mucilage, saponins and glycosides. Important compounds isolated from different plant parts include clerodane diterpenes such as polyalthialdoic acid, polyalthic acid, kolavenic acid, kolavenol, 16-oxo-cleroda-3,13(14)-dien-15-oic acid and 3α-hydroxy-cleroda-4(18),13-dien-15-oic acid. Other phytochemicals reported include liriodenine, noroliveroline, annonaceous acetogenins, β-sitosterol, stigmasterol, quercetin, kaempferol, rutin, catechin and various phenolic antioxidants. The plant also contains bioactive alkaloids and lignan derivatives that contribute to its pharmacological potential. These compounds exhibit antioxidant, antimicrobial, anti-inflammatory, anticancer, antimalarial, antiviral, cytotoxic, hepatoprotective and immunomodulatory activities. The abundance of clerodane diterpenoids and aporphine alkaloids makes the species an important source of pharmacologically active natural products and a promising candidate for pharmaceutical research and drug development (Preethi et al., 2025; Katkar et al., 2010; Faizi et al., 2008; Chang et al., 2006; Wu et al., 1994; Dhanasekaran et al., 2009; Sashidhara et al., 2010; Tanna et al., 2011; Harborne, 1998; Evans, 2009).",

    "medicinal_importance": "P. longifolia is an important medicinal plant in traditional and modern systems of medicine. Different plant parts including leaves, bark, roots and seeds exhibit anti-inflammatory, antioxidant, antimicrobial, antidiabetic, anticancer, antiulcer, antimalarial, antiviral, wound-healing, hypotensive and immunomodulatory properties. Traditionally, the plant is used to treat fever, skin diseases, hypertension, helminthiasis, digestive disorders and diabetes. Pharmacological studies have demonstrated significant antimicrobial activity against pathogenic bacteria and fungi, cytotoxic effects against prostate and other cancer cell lines, and protective effects against oxidative stress. The presence of clerodane diterpenoids, alkaloids and flavonoids supports many of these biological activities. Studies have also reported cardioprotective, hepatoprotective and chemoprotective effects (Preethi et al., 2025; Faizi et al., 2008; Katkar et al., 2010; Dhanasekaran et al., 2009; Nadkarni, 2007; Warrier et al., 1996; Kirtikar & Basu, 1999).",

    "economic_importance": "The species is extensively cultivated as an ornamental avenue and landscape tree because of its elegant appearance, evergreen foliage and pollution-tolerant nature. It is commonly planted along roadsides, educational institutions, parks and residential areas for beautification, noise reduction and windbreak purposes. P. longifolia also serves as a source of medicinal raw materials for herbal drug manufacturing. Due to its rich phytochemical profile, it has considerable potential in pharmaceutical and nutraceutical industries. The wood is occasionally utilized for light construction, packing cases, pencils, match splints and household articles. The species contributes significantly to urban greening, carbon sequestration, environmental management and biodiversity conservation programmes (CSIR, 2003; Anonymous, 1988; Preethi et al., 2025).",

    "conservation_status": {
      "IUCN_status": "Least Concern (LC)",
      "assessment_year": 2024,
      "details": "Monoon longifolium (formerly Polyalthia longifolia) was assessed for the IUCN Red List of Threatened Species and categorized as Least Concern owing to its wide distribution, extensive cultivation and stable population trend (Verspagen et al., 2024)."
    },

    "references": [
      {
        "authors": "Preethi, B. H., Balasubramanian, T., Suresh, B. S., & Ahalya Devi, K. H.",
        "year": 2025,
        "title": "Phytochemistry, Traditional Uses, and Pharmacological Properties of Polyalthia longifolia: Review Article",
        "journal": "Journal of Pharma Insights and Research",
        "volume": "3",
        "issue": "4",
        "pages": "23–31"
      },
      {
        "authors": "Katkar, K. V., Suthar, A. C., & Chauhan, V. S.",
        "year": 2010,
        "title": "The Chemistry, Pharmacologic and Therapeutic Applications of Polyalthia longifolia",
        "journal": "Pharmacognosy Reviews",
        "volume": "4",
        "issue": "7",
        "pages": "62–68"
      },
      {
        "authors": "Faizi, S., Mughal, N. R., Khan, R. A., Khan, S. A., Ahmad, A., Bibi, N., & Ahmed, S. A.",
        "year": 2008,
        "title": "Evaluation of the Antimicrobial Property of Polyalthia longifolia",
        "journal": "Phytotherapy Research",
        "volume": "22",
        "pages": "907–912"
      },
      {
        "authors": "Chang, F. R. et al.",
        "year": 2006,
        "title": "Anti-inflammatory and Cytotoxic Diterpenes from Polyalthia longifolia",
        "journal": "Planta Medica",
        "volume": "72",
        "pages": "1344–1347"
      },
      {
        "authors": "Wu, Y. C. et al.",
        "year": 1994,
        "title": "Two New Clerodane Diterpenes from Polyalthia longifolia",
        "journal": "Journal of Natural Products",
        "volume": "57",
        "issue": "2",
        "pages": "201–206"
      },
      {
        "authors": "Dhanasekaran, M. et al.",
        "year": 2009,
        "title": "Chemoprotective Potential of Polyalthia longifolia Against Oxidative Stress",
        "journal": "Evidence-Based Complementary and Alternative Medicine",
        "volume": "6",
        "issue": "2",
        "pages": "265–272"
      },
      {
        "authors": "Sashidhara, K. V. et al.",
        "year": 2010,
        "title": "Clerodane Diterpenoids from Polyalthia longifolia and Their Biological Activities",
        "journal": "Bioorganic and Medicinal Chemistry Letters",
        "volume": "20",
        "pages": "5767–5770"
      },
      {
        "authors": "Tanna, A., Nair, R., & Chanda, S.",
        "year": 2011,
        "title": "Assessment of Polyalthia longifolia for Phytochemical Constituents and Antioxidant Activity",
        "journal": "Pharmacognosy Journal",
        "volume": "3",
        "issue": "24",
        "pages": "45–51"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh, Vol. I",
        "publisher": "Scientific Publishers",
        "pages": "71"
      },
      {
        "authors": "Verspagen, N., Erkens, R.H.J., & Hills, R.",
        "year": 2024,
        "title": "Monoon longifolium",
        "journal": "The IUCN Red List of Threatened Species"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods",
        "publisher": "Chapman & Hall"
      },
      {
        "authors": "Evans, W. C.",
        "year": 2009,
        "title": "Trease and Evans Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Council of Scientific and Industrial Research (CSIR)",
        "year": 2003,
        "title": "The Wealth of India",
        "publisher": "CSIR Publications"
      },
      {
        "authors": "Anonymous",
        "year": 1988,
        "title": "The Useful Plants of India",
        "publisher": "CSIR Publications"
      }
    ]
  }
  ,
  {
    plant: 65,
    "id": "Terminalia-catappa",

    "scientific_name": "Terminalia catappa ",

    "aname": "L.",
    "common_name": "Indian Almond, Tropical Almond",

    "local_name": "Badam",

    "image": "/Flora/plant65.jpeg",
    gallery: {

      bark: "/Flora/plant65a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant65b.jpeg",
      fruit: "/Flora/plant65c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Terminalia-catappa",
    'qr_code': '/Flora/qrcodes/Terminalia-catappa.png',

    "botanical_profile": {
      "scientific_name": "Terminalia catappa ",
      "aname": "L.",
      "common_name": "Indian Almond, Tropical Almond",
      "local_name": "Badam",
      "family": "Combretaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Combretaceae",
      "genus": "Terminalia",
      "species": "catappa"
    },

    "morphological_characters": "T. catappa is a medium to large deciduous tree characterized by a distinctive pagoda-like branching pattern. Branchlets possess persistent leaf scars. Leaves are alternate and densely clustered at the ends of branchlets, obovate, thin coriaceous, glabrous above and tomentose beneath, with a cuneate base, entire margin and obtuse to retuse apex. Two glands are present near the base of the leaf blade. Inflorescences are axillary spikes bearing small whitish-yellow flowers. Fruits are ellipsoid drupes, distinctly two-ridged, glabrous when dry and lacking wings. The species is commonly cultivated in gardens, parks, coastal regions and as an avenue tree throughout tropical areas (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018; Gamble, 1919).",

    "digital_identification": {
      "habit": "Tree",
      "branchlets": "Persistent leaf scars",
      "leaves": "Alternate, densely clustered at branch ends",
      "leaf_shape": "Obovate",
      "leaf_surface": "Glabrous above, tomentose beneath",
      "flowers": "Whitish-yellow",
      "inflorescence": "Axillary spikes",
      "fruit": "Ellipsoid drupe, two-ridged"
    },

    "phytochemical_constituents": "T. catappa contains diverse phytochemicals including tannins, flavonoids, phenolic compounds, alkaloids, terpenoids, steroids, cardiac glycosides, saponins, coumarins and phytosterols. Major compounds identified include gallic acid, ellagic acid, punicalagin, punicalin, corilagin, tercatain, chebulagic acid, chebulinic acid, sgentisic acid, chlorogenic acid, quercetin, kaempferol, rutin, luteolin, vitexin, isovitexin, ?-sitosterol and stigmasterol. Seeds are rich in proteins, unsaturated fatty acids, vitamins and minerals. These bioactive constituents contribute to antioxidant, antimicrobial, anti-inflammatory, hepatoprotective and antidiabetic activities (Bhat et al., 2025; Fan et al., 2004; Lin et al., 2001; Cock, 2015; Harborne, 1998; Evans, 2009).",

    "medicinal_importance": "T. catappa is widely recognized for its medicinal importance in traditional and modern healthcare systems. The plant exhibits antioxidant, anti-inflammatory, antimicrobial, antiviral, antidiabetic, antihyperlipidemic, hepatoprotective, nephroprotective, cardioprotective, wound-healing and anticancer properties. Leaf and bark extracts have demonstrated activity against several bacterial and fungal pathogens. Traditionally, the species is used in the treatment of diarrhea, dysentery, asthma, bronchitis, fever, skin diseases, liver disorders, intestinal parasitic infections and rheumatism. Scientific studies have reported blood glucose-lowering, cholesterol-reducing and liver-protective effects. Certain phytochemicals isolated from the plant have shown cytotoxic activity against cancer cell lines and anti-HIV potential (Bhat et al., 2025; Lin et al., 2001; Fan et al., 2004; Cock, 2015; Nadkarni, 2007; Warrier et al., 1996).",

    "economic_importance": "T. catappa possesses considerable economic value. The edible kernels are nutritious and consumed similarly to almonds. Leaves, bark and fruits are utilized in herbal medicine and pharmaceutical formulations. The tree is extensively cultivated as an ornamental, avenue and shade tree. Leaves are commercially used in aquaculture to improve water quality and reduce microbial infections in ornamental fish culture. The wood is used for fuel, packing cases, furniture and light construction. Seed oil has potential applications in food, cosmetic and biodiesel industries. The species contributes significantly to horticulture, agroforestry, traditional medicine and local economies (CSIR, 2003; Anonymous, 1988; Bhat et al., 2025).",

    "conservation_status": {
      "IUCN_status": "Least Concern (LC)",
      "assessment_year": 2019,
      "details": "Terminalia catappa was assessed by the IUCN Red List and categorized as Least Concern owing to its wide distribution, extensive cultivation and stable populations throughout tropical regions (Thomson & Evans, 2019)."
    },

    "references": [
      {
        "authors": "Bhat, R., Sneha, D., & Bhat, S. S.",
        "year": 2025,
        "title": "Terminalia catappa: A Review of its Botanical Identity, Phytochemistry and Clinical Potential",
        "journal": "International Journal of Pharmaceutical Sciences",
        "pages": "2892-2900"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh, Vol. I",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "378"
      },
      {
        "authors": "Thomson, L., & Evans, B.",
        "year": 2019,
        "title": "Terminalia catappa",
        "journal": "The IUCN Red List of Threatened Species",
        "identifier": "e.T61989853A61989855"
      },
      {
        "authors": "Fan, Y. M., Xu, L. Z., Gao, J., Wang, Y., Tang, X. H., Zhao, X. N., & Zhang, Z. X.",
        "year": 2004,
        "title": "Phytochemical and Anti-inflammatory Studies on Terminalia catappa",
        "journal": "Fitoterapia",
        "volume": "75",
        "pages": "253-260"
      },
      {
        "authors": "Lin, C. C., Hsu, Y. F., & Lin, T. C.",
        "year": 2001,
        "title": "Antioxidant and Hepatoprotective Activity of Terminalia catappa",
        "journal": "American Journal of Chinese Medicine",
        "volume": "29",
        "pages": "153-165"
      },
      {
        "authors": "Cock, I. E.",
        "year": 2015,
        "title": "The Medicinal Properties and Phytochemistry of Terminalia catappa",
        "journal": "Pharmacognosy Communications",
        "volume": "5",
        "issue": "4",
        "pages": "244-265"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods",
        "publisher": "Chapman and Hall"
      },
      {
        "authors": "Evans, W. C.",
        "year": 2009,
        "title": "Trease and Evans Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Gamble, J. S.",
        "year": 1919,
        "title": "Flora of the Presidency of Madras",
        "publisher": "Adlard and Son Ltd."
      },
      {
        "authors": "Hooker, J. D.",
        "year": 1878,
        "title": "The Flora of British India",
        "publisher": "L. Reeve and Co."
      },
      {
        "authors": "Council of Scientific and Industrial Research",
        "year": 2003,
        "title": "The Wealth of India",
        "publisher": "CSIR Publications"
      },
      {
        "authors": "Anonymous",
        "year": 1988,
        "title": "The Useful Plants of India",
        "publisher": "CSIR Publications"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      }
    ]
  },
  {
    plant: 66,
    "id": "Terminalia-bellirica",

    "scientific_name": "Terminalia bellirica ",

    "aname": "(Gaertn.) Roxb.",
    "common_name": "Baheda, Beleric Myrobalan",

    "local_name": "Tadi, Tandra, Bhutavasami",

    "image": "/Flora/plant66.jpeg",
    gallery: {

      bark: "/Flora/plant66a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant66b.jpeg",
      fruit: "/Flora/plant66c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Terminalia-bellirica",
    'qr_code': '/Flora/qrcodes/Terminalia-bellirica.png',

    "botanical_profile": {
      "scientific_name": "Terminalia bellirica ",
      "aname": "(Gaertn.) Roxb.",
      "common_name": "Baheda, Beleric Myrobalan",
      "local_name": "Tadi, Tandra, Bhutavasami",
      "family": "Combretaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Combretaceae",
      "genus": "Terminalia",
      "species": "bellirica"
    },

    "morphological_characters": "T. bellirica is a large deciduous tree commonly occurring in deciduous forests throughout India. Branchlets are warty and bear persistent leaf scars. Leaves are alternate and densely clustered at the tips of branchlets, broadly elliptic, coriaceous, glabrous, finely pellucid-dotted above, with cuneate and slightly oblique bases, entire to subcrenulate margins, and rounded to emarginate apices. Inflorescences are axillary spikes bearing pale-white flowers. Fruits are ovoid drupes, softly tomentose, obscurely five-ridged and wingless. The species is widely distributed in tropical and subtropical forests and forms an important component of dry deciduous vegetation (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018; Gamble, 1919).",

    "digital_identification": {
      "habit": "Large deciduous tree",
      "branchlets": "Warty with persistent leaf scars",
      "leaves": "Broadly elliptic, glabrous, clustered at branch tips",
      "leaf_margin": "Entire to subcrenulate",
      "flowers": "Pale-white",
      "inflorescence": "Axillary spikes",
      "fruit": "Ovoid drupe, softly tomentose, obscurely 5-ridged"
    },

    "phytochemical_constituents": "T. bellirica contains a wide spectrum of phytochemicals including tannins, flavonoids, alkaloids, glycosides, terpenoids, lignans, steroids, phenolic compounds and saponins. Major bioactive constituents include gallic acid, ellagic acid, chebulagic acid, ethyl gallate, belleric acid, β-sitosterol, termilignan, thannilignan, bellericoside and bellericanin. Other compounds reported include glucose, fructose, galactose, mannose, sucrose, rutin, quercetin, kaempferol, luteolin and various hydrolysable tannins. The fruits are particularly rich in polyphenols and tannins responsible for potent antioxidant activity. These phytochemicals contribute significantly to the plant's medicinal and pharmacological properties (Kadian et al., 2014; Bahera et al., 2020; Warrier et al., 1996; Harborne, 1998; Evans, 2009).",

    "medicinal_importance": "T. bellirica is an important medicinal tree in Ayurveda and is one of the three ingredients of the renowned formulation Triphala. The plant exhibits antioxidant, anti-inflammatory, analgesic, antimicrobial, antifungal, antiviral, antidiabetic, antihypertensive, hepatoprotective, bronchodilatory, immunomodulatory, antidepressant and anticancer activities. Fruits are traditionally used to treat cough, asthma, hoarseness, digestive disorders, diarrhea, dysentery, ulcers, fever and diabetes. Scientific studies have demonstrated free radical scavenging activity, liver protective effects, cholesterol-lowering action, antimicrobial effects against pathogenic microorganisms and cytotoxic effects against cancer cell lines. The plant is also used to promote wound healing, improve bowel movements and support respiratory health (Kadian et al., 2014; Nadkarni, 2007; Warrier et al., 1996; Kirtikar & Basu, 1999; Bahera et al., 2020).",

    "economic_importance": "T. bellirica has considerable economic importance in herbal medicine, pharmaceutical and forest-based industries. The fruits are one of the principal constituents of Triphala, a widely marketed Ayurvedic formulation. Fruit pericarps rich in tannins are used in dyeing, tanning and ink manufacturing. The plant serves as a source of herbal drugs, nutraceuticals, antioxidants and antimicrobial products. Timber is moderately durable and used in furniture, packing cases and construction. The species contributes significantly to the herbal pharmaceutical industry and provides livelihood opportunities for rural communities through collection and trade of fruits and medicinal products (Kadian et al., 2014; CSIR, 2003; Anonymous, 1988).",

    "conservation_status": {
      "IUCN_status": "Least Concern (LC)",
      "assessment_year": 2021,
      "details": "T. bellirica was assessed for the IUCN Red List and categorized as Least Concern due to its wide distribution, large natural populations and extensive occurrence throughout South and Southeast Asia (Plummer, 2021)."
    },

    "references": [
      {
        "authors": "Kadian, R., Parle, M., & Yadav, M.",
        "year": 2014,
        "title": "Therapeutic Potential and Phytopharmacology of Terminalia bellirica",
        "journal": "World Journal of Pharmacy and Pharmaceutical Sciences",
        "volume": "3",
        "issue": "10",
        "pages": "804-819"
      },
      {
        "authors": "Plummer, J.",
        "year": 2021,
        "title": "Terminalia bellirica",
        "journal": "The IUCN Red List of Threatened Species",
        "identifier": "e.T61989645A61989649"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh, Vol. I",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "378"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods",
        "publisher": "Chapman and Hall"
      },
      {
        "authors": "Evans, W. C.",
        "year": 2009,
        "title": "Trease and Evans Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Bahera, S. K., Mohapatra, S., & Rout, P. K.",
        "year": 2020,
        "title": "Phytochemistry and Pharmacological Potential of Terminalia bellirica: A Review",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "9",
        "issue": "4",
        "pages": "1450-1458"
      },
      {
        "authors": "Gamble, J. S.",
        "year": 1919,
        "title": "Flora of the Presidency of Madras",
        "publisher": "Adlard and Son Ltd."
      },
      {
        "authors": "Hooker, J. D.",
        "year": 1878,
        "title": "The Flora of British India",
        "publisher": "L. Reeve and Co."
      },
      {
        "authors": "Council of Scientific and Industrial Research",
        "year": 2003,
        "title": "The Wealth of India",
        "publisher": "CSIR Publications"
      },
      {
        "authors": "Anonymous",
        "year": 1988,
        "title": "The Useful Plants of India",
        "publisher": "CSIR Publications"
      }
    ]
  },
  {
    plant: 67,
    "id": "Syzygium-cumini",

    "scientific_name": "Syzygium cumini ",

    "aname": "(Wight & Arn.) Engl.",
    "common_name": "Jamun, Java Plum, Black Plum, Malabar Plum",

    "local_name": "Neredu",

    "image": "/Flora/plant67.jpeg",
    gallery: {

      bark: "/Flora/plant67a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant67b.jpeg",
      fruit: "/Flora/plant67c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Syzygium-cumini",
    'qr_code': '/Flora/qrcodes/Syzygium-cumini.png',

    "botanical_profile": {
      "scientific_name": "Syzygium cumini ",
      "aname": "(Wight & Arn.) Engl.",
      "common_name": "Jamun, Java Plum, Black Plum, Malabar Plum",
      "local_name": "Neredu",
      "family": "Myrtaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Myrtaceae",
      "genus": "Syzygium",
      "species": "cumini"
    },

    "morphological_characters": "S. cumini is a large evergreen tree with smooth ashy-brown bark and a dense spreading crown. Leaves are opposite, decussate, elliptic-oblong to lanceolate, coriaceous, glabrous and glossy above, with cuneate to obtuse bases, entire margins and acuminate apices. Inflorescences are axillary or terminal trichotomous panicles bearing pale greenish-white sessile flowers. Fruits are fleshy berries, ovate to oblong, glabrous and shining, turning from bright purple to dark purple upon maturity. Seeds are usually solitary. The species is commonly found in plains and hill forests up to 2000 m elevation and is frequently planted along roadsides, parks and gardens (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018; Gamble, 1919).",

    "digital_identification": {
      "habit": "Evergreen tree",
      "bark": "Smooth ashy-brown",
      "leaves": "Opposite decussate, glossy, coriaceous",
      "inflorescence": "Axillary or terminal trichotomous panicles",
      "flowers": "Pale greenish-white",
      "fruit": "Dark purple berry",
      "seed": "Solitary"
    },

    "phytochemical_constituents": "S. cumini is rich in diverse bioactive phytochemicals distributed throughout its fruits, seeds, leaves, bark and roots. Major constituents include alkaloids, flavonoids, tannins, glycosides, saponins, terpenoids, steroids and phenolic compounds. Important anthocyanins identified in fruits include delphinidin, cyanidin, malvidin, peonidin and petunidin derivatives. Other major compounds include ellagic acid, gallic acid, chlorogenic acid, ferulic acid, caffeic acid, quercetin, myricetin, kaempferol, rutin and catechin. Seeds contain jamboline, jambosine, ellagitannins and glycosides associated with antidiabetic activity. Essential oils, triterpenoids such as oleanolic acid and ursolic acid, phytosterols including β-sitosterol, and various minerals are also present. These compounds are responsible for the plant's potent antioxidant, antidiabetic and pharmacological activities (Jagetia, 2017; Ayyanar & Subash-Babu, 2012; Baliga et al., 2011; Warrier et al., 1996; Evans, 2009).",

    "medicinal_importance": "S. cumini possesses extensive medicinal value and is widely used in Ayurveda, Siddha, Unani and folk medicine. The plant exhibits antidiabetic, antioxidant, anti-inflammatory, antimicrobial, antiviral, antifungal, anticancer, cardioprotective, hepatoprotective, gastroprotective, nephroprotective and immunomodulatory activities. Seed extracts are particularly valued for regulating blood glucose levels and improving insulin sensitivity. Fruits and leaves possess strong free-radical scavenging properties that protect against oxidative stress and chronic diseases. Traditionally, the plant is used for treating diabetes, diarrhea, dysentery, ulcers, digestive disorders, respiratory ailments, sore throat and skin diseases. Experimental studies have demonstrated hypoglycemic, antihyperlipidemic, anti-obesity and chemoprotective effects. The high anthocyanin and polyphenol content contributes significantly to cardiovascular protection and disease prevention (Jagetia, 2017; Ayyanar & Subash-Babu, 2012; Baliga et al., 2011; Nadkarni, 2007; Kirtikar & Basu, 1999).",

    "economic_importance": "S. cumini has considerable economic significance in food, pharmaceutical, nutraceutical and timber industries. The fruits are consumed fresh and processed into juices, squashes, jams, jellies, candies, wines, vinegar and fermented beverages. Seed powder is widely used in herbal formulations for diabetes management. Bark rich in tannins is utilized in leather tanning and dyeing industries. The tree produces kino gum used in traditional medicine and industrial applications. Its durable and water-resistant wood is employed in construction, furniture making, railway sleepers, agricultural implements and fuelwood. Due to its rich antioxidant profile and medicinal value, the species has growing importance in nutraceutical, pharmaceutical and functional food industries. The tree is also planted as an avenue, shade and ornamental species in urban landscapes (Jagetia, 2017; CSIR, 2003; Anonymous, 1988).",

    "conservation_status": {
      "IUCN_status": "Least Concern (LC)",
      "assessment_year": 2019,
      "details": "Syzygium cumini was assessed by the IUCN Red List and categorized as Least Concern because of its wide distribution, large natural populations and extensive cultivation throughout tropical regions (BGCI & IUCN SSC Global Tree Specialist Group, 2019)."
    },

    "references": [
      {
        "authors": "Botanic Gardens Conservation International (BGCI) & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Syzygium cumini",
        "journal": "The IUCN Red List of Threatened Species",
        "identifier": "e.T49487196A145821979"
      },
      {
        "authors": "Jagetia, G. C.",
        "year": 2017,
        "title": "Phytochemical Composition and Pleiotropic Pharmacological Properties of Jamun (Syzygium cumini Skeels)",
        "journal": "Journal of Exploratory Research in Pharmacology",
        "volume": "2",
        "issue": "2",
        "pages": "54-66"
      },
      {
        "authors": "Ayyanar, M., & Subash-Babu, P.",
        "year": 2012,
        "title": "Syzygium cumini (L.) Skeels: A Review of its Phytochemical Constituents and Traditional Uses",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "2",
        "issue": "3",
        "pages": "240-246"
      },
      {
        "authors": "Baliga, M. S., Bhat, H. P., Baliga, B. R. V., Wilson, R., & Palatty, P. L.",
        "year": 2011,
        "title": "Phytochemistry, Traditional Uses and Pharmacology of Eugenia jambolana Lam. (Black Plum)",
        "journal": "Food Research International",
        "volume": "44",
        "pages": "1776-1789"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh, Vol. I",
        "publisher": "Pawan Kumar Scientific Publishers",
        "pages": "383"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 1999,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods",
        "publisher": "Chapman and Hall"
      },
      {
        "authors": "Evans, W. C.",
        "year": 2009,
        "title": "Trease and Evans Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Gamble, J. S.",
        "year": 1919,
        "title": "Flora of the Presidency of Madras",
        "publisher": "Adlard and Son Ltd."
      },
      {
        "authors": "Hooker, J. D.",
        "year": 1879,
        "title": "The Flora of British India",
        "publisher": "L. Reeve and Co."
      },
      {
        "authors": "Council of Scientific and Industrial Research",
        "year": 2003,
        "title": "The Wealth of India",
        "publisher": "CSIR Publications"
      },
      {
        "authors": "Anonymous",
        "year": 1988,
        "title": "The Useful Plants of India",
        "publisher": "CSIR Publications"
      }
    ]
  },
  {
    plant: 68,
    "id": "Moringa-concanensis",

    "scientific_name": "Moringa concanensis ",

    "aname": "Nimmo ex Dalzell ",
    "common_name": "Konkan Moringa, Wild Moringa",

    "local_name": "Konda Munaga",

    "image": "/Flora/plant68.jpeg",
    gallery: {

      bark: "/Flora/plant68a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant68b.jpeg",
      fruit: "/Flora/plant68c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Moringa-concanensis",
    'qr_code': '/Flora/qrcodes/Moringa-concanensis.png',

    "botanical_profile": {
      "scientific_name": "Moringa concanensis ",
      "aname": "Nimmo ex Dalzell ",
      "common_name": "Konkan Moringa, Wild Moringa",
      "local_name": "Konda Munaga",
      "family": "Moringaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledones",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "family": "Moringaceae",
      "genus": "Moringa",
      "species": "concanensis"
    },

    "morphological_characters": "M. concanensis is a small to medium-sized evergreen tree with a broad and much-branched crown. Bark is greyish-brown, rough externally and fissured with age. Leaves are alternate, bipinnate to tripinnate, bearing small obovate to elliptic leaflets that are smooth, somewhat leathery and deciduous. Leaflets are oppositely arranged on secondary rachises. Inflorescences are large irregular panicles borne in axillary or terminal positions. Flowers are large, bisexual, white to cream-colored with yellowish petals marked by reddish veins. The fruit is a long, straight, three-angled capsule (pod), slightly constricted between seeds and turning brown upon maturity. Seeds are pale white to yellowish, rounded to triangular and enclosed within the pod (Metri et al., 2025; Gamble, 1918; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small to medium-sized evergreen tree",
      "bark": "Greyish-brown, rough externally",
      "leaves": "Alternate, bipinnate to tripinnate",
      "leaflets": "Small, obovate to elliptic, smooth, opposite",
      "inflorescence": "Large irregular axillary or terminal panicles",
      "flowers": "White to cream-colored, bisexual",
      "fruit": "Long, straight, three-angled capsule",
      "seeds": "Pale white to yellowish, rounded to triangular"
    },

    "phytochemical_constituents": "Phytochemical investigations have revealed the presence of numerous bioactive compounds in M. concanensis. Major constituents include alkaloids, flavonoids, phenolic compounds, tannins, saponins, steroids, triterpenoids, cardiac glycosides, carbohydrates, amino acids, reducing sugars, flavonols and proanthocyanidins. Important compounds reported include quercetin, isoquercetin, astragalin, rutin, caffeic acid, chlorogenic acid, α-tocopherol (Vitamin E), oleic acid, campesterol, β-sitosterol, digoxin, pyranone derivatives and various antioxidant polyphenols. Leaves and seeds are particularly rich in flavonoids and phenolic acids that contribute to significant antioxidant activity. The plant also contains nutritionally important fatty acids and phytosterols with therapeutic potential (Metri et al., 2025; Fahey, 2005; Anwar et al., 2007; Leone et al., 2015; Saini et al., 2016).",

    "medicinal_importance": "M. concanensis possesses diverse medicinal and pharmacological properties. Extracts from leaves, bark, roots, flowers and seeds have demonstrated significant antidiabetic activity by reducing hyperglycemia and improving glucose metabolism. The plant exhibits strong antioxidant activity owing to its high content of flavonoids, phenolic acids, proanthocyanidins and tocopherols. Studies have reported significant anti-inflammatory, analgesic and antipyretic effects, supporting its traditional use in inflammatory disorders. Extracts also possess antimicrobial and antifungal activities against several pathogenic microorganisms. Cytotoxic studies indicate potential anticancer activity through inhibition of cancer cell proliferation and induction of apoptosis. Additional pharmacological activities include anticonvulsant, antiarthritic, hepatoprotective, immunomodulatory and wound-healing properties. Traditionally, the plant is used in the treatment of rheumatism, ulcers, skin diseases, dysentery, hypertension, diabetes, thyroid disorders, fatigue, eye ailments and poisonous bites. The therapeutic effects are mainly attributed to flavonoids, phenolic acids, sterols, tocopherols and other antioxidant compounds (Metri et al., 2025; Fahey, 2005; Anwar et al., 2007; Leone et al., 2015; Saini et al., 2016; Gupta et al., 2012; Mbikay, 2012; Tiloke et al., 2013; Stohs & Hartman, 2015; Gopalakrishnan et al., 2016).",

    "economic_importance": "M. concanensis has considerable economic value as a medicinal and nutraceutical resource. Leaves, bark, flowers, roots, fruits and seeds are used as raw materials in traditional Ayurvedic and Unani formulations. The species serves as a potential source of natural antioxidants, phytopharmaceutical compounds and herbal health products. Its drought tolerance makes it suitable for cultivation in arid and semi-arid regions for sustainable agroforestry systems. The plant has potential applications in functional foods, dietary supplements, herbal cosmetics and pharmaceutical industries. Due to its rich phytochemical profile and therapeutic significance, It is increasingly recognized as an important medicinal tree with commercial prospects in the herbal medicine sector (Metri et al., 2025; Leone et al., 2015; CSIR, 2003).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2025,
      "details": "Moringa concanensis has not yet been evaluated by the IUCN Red List of Threatened Species."
    },

    "references": [
      {
        "authors": "Metri, S., Bhavana, B., Geethasree, M. S., Sirisha, E., Prabhas, K. G., & Mathew, C.",
        "year": 2025,
        "title": "Exploring Moringa concanensis: A Hidden Plant with Medicinal and Pharmacological Properties",
        "journal": "International Journal of Pharmaceutical and Bio-Medical Science",
        "volume": "5",
        "issue": "6",
        "pages": "407-413"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Fahey, J. W.",
        "year": 2005,
        "title": "Moringa oleifera: A Review of the Medical Evidence for Its Nutritional, Therapeutic and Prophylactic Properties",
        "journal": "Trees for Life Journal",
        "volume": "1",
        "pages": "1-15"
      },
      {
        "authors": "Anwar, F., Latif, S., Ashraf, M., & Gilani, A. H.",
        "year": 2007,
        "title": "Moringa oleifera: A Food Plant with Multiple Medicinal Uses",
        "journal": "Phytotherapy Research",
        "volume": "21",
        "issue": "1",
        "pages": "17-25"
      },
      {
        "authors": "Leone, A., Spada, A., Battezzati, A., Schiraldi, A., Aristil, J., & Bertoli, S.",
        "year": 2015,
        "title": "Cultivation, Genetic, Ethnopharmacology, Phytochemistry and Pharmacology of Moringa oleifera Leaves: An Overview",
        "journal": "International Journal of Molecular Sciences",
        "volume": "16",
        "issue": "6",
        "pages": "12791-12835"
      },
      {
        "authors": "Saini, R. K., Sivanesan, I., & Keum, Y. S.",
        "year": 2016,
        "title": "Phytochemicals of Moringa oleifera: A Review of Their Nutritional, Therapeutic and Industrial Significance",
        "journal": "3 Biotech",
        "volume": "6",
        "pages": "203"
      },
      {
        "authors": "Gupta, R., Mathur, M., Bajaj, V. K., Katariya, P., Yadav, S., Kamal, R., & Gupta, R. S.",
        "year": 2012,
        "title": "Evaluation of Antidiabetic and Antioxidant Activity of Moringa oleifera in Experimental Diabetes",
        "journal": "Journal of Diabetes",
        "volume": "4",
        "issue": "2",
        "pages": "164-171"
      },
      {
        "authors": "Mbikay, M.",
        "year": 2012,
        "title": "Therapeutic Potential of Moringa oleifera Leaves in Chronic Hyperglycemia and Dyslipidemia",
        "journal": "Frontiers in Pharmacology",
        "volume": "3",
        "pages": "24"
      },
      {
        "authors": "Tiloke, C., Phulukdaree, A., & Chuturgoon, A. A.",
        "year": 2013,
        "title": "The Antiproliferative Effect of Moringa oleifera Crude Aqueous Leaf Extract on Cancerous Human Alveolar Epithelial Cells",
        "journal": "BMC Complementary and Alternative Medicine",
        "volume": "13",
        "pages": "226"
      },
      {
        "authors": "Stohs, S. J., & Hartman, M. J.",
        "year": 2015,
        "title": "Review of the Safety and Efficacy of Moringa oleifera",
        "journal": "Phytotherapy Research",
        "volume": "29",
        "issue": "6",
        "pages": "796-804"
      },
      {
        "authors": "Gopalakrishnan, L., Doriya, K., & Kumar, D. S.",
        "year": 2016,
        "title": "Moringa oleifera: A Review on Nutritive Importance and Its Medicinal Application",
        "journal": "Food Science and Human Wellness",
        "volume": "5",
        "issue": "2",
        "pages": "49-56"
      }
    ]
  },
  {
    plant: 69,
    "id": "Tabebuia-aurea",

    "scientific_name": "Tabebuia aurea ",

    "aname": "(Silva Manso) Benth. ",
    "common_name": "Silver Trumpet Tree, Caribbean Trumpet Tree",

    "local_name": "Silver Trumpet Tree",

    "image": "/Flora/plant69.jpeg",
    gallery: {

      bark: "/Flora/plant69a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant69b.jpeg",
      fruit: "/Flora/plant69c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Tabebuia-aurea",
    'qr_code': '/Flora/qrcodes/Tabebuia-aurea.png',

    "botanical_profile": {
      "scientific_name": "Tabebuia aurea ",
      "aname": "(Silva Manso) Benth.",
      "common_name": "Silver Trumpet Tree, Caribbean Trumpet Tree",
      "local_name": "Silver Trumpet Tree",
      "family": "Bignoniaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "order": "Lamiales",
      "family": "Bignoniaceae",
      "genus": "Tabebuia",
      "species": "aurea"
    },

    "morphological_characters": "T. aurea is a medium-sized deciduous tree usually 5–20 m tall. Crown broad, rounded and spreading. Bark grey to light brown, rough, fissured and corky with age. Inner bark fibrous and pale yellow. Leaves opposite and palmately compound, usually composed of five leaflets. Petiole long and slender. Leaflets obovate to elliptic, 5–15 cm long, upper surface green and lower surface silvery-grey due to dense hairs. Margins entire and apex rounded to acute. Flowers large, bright golden-yellow, trumpet-shaped, bisexual and fragrant, arranged in terminal panicles or racemes. Flowering often occurs before new leaves emerge. Fruit a long cylindrical dehiscent capsule containing numerous flat, thin and winged seeds (Barbosa-Filho et al., 2004; Gentry, 1992; Lorenzi, 2008).",

    "digital_identification": {
      "habit": "Medium-sized deciduous tree",
      "bark": "Grey to light brown, rough, fissured and corky",
      "leaves": "Opposite, palmately compound",
      "petiole": "Long and slender",
      "leaflets": "Obovate to elliptic, lower surface silvery-grey",
      "inflorescence": "Terminal panicles or racemes",
      "flowers": "Large, bright golden-yellow, trumpet-shaped",
      "fruit": "Long cylindrical dehiscent capsule",
      "seeds": "Numerous, flat, thin and winged"
    },

    "phytochemical_constituents": "Phytochemical investigations of T. aurea have revealed the presence of numerous bioactive compounds including lapachol, β-lapachone, dehydro-α-lapachone, β-sitosterol, stigmasterol, campesterol, betulinic acid, p-hydroxybenzoic acid, p-coumaric acid, p-anisic acid, veratric acid, methyl cinnamate, ethyl p-hydroxycinnamate, flavonoids, phenolic compounds, quinones, tannins, triterpenoids and steroids. Naphthoquinones such as lapachol and β-lapachone are considered the major bioactive constituents. Flowers, bark and leaves are rich in phenolic compounds and antioxidant metabolites responsible for several pharmacological activities (Barbosa-Filho et al., 2004; Oliveira et al., 1990; da Silva et al., 2003; Gómez Castellanos et al., 2009).",

    "medicinal_importance": "T. aurea possesses significant medicinal value owing to its rich phytochemical composition. Extracts of the bark, leaves, flowers and stem exhibit antimicrobial activity against several bacterial and fungal pathogens. Phenolic compounds and flavonoids contribute to strong antioxidant activity by scavenging free radicals and reducing oxidative stress. Traditional medicinal uses include treatment of wounds, skin infections, inflammatory disorders and microbial diseases. Naphthoquinones such as lapachol and β-lapachone exhibit anti-inflammatory, analgesic, antimicrobial, antiparasitic, trypanocidal, cytoprotective, wound-healing and potential anticancer activities. Experimental studies have demonstrated cytotoxic effects against various cancer cell lines and promotion of tissue regeneration during wound healing. These pharmacological properties indicate considerable potential for pharmaceutical and nutraceutical applications (Barbosa-Filho et al., 2004; Gómez Castellanos et al., 2009; Pereira et al., 2006; Li et al., 1999; Kung et al., 2014; Pinto & de Castro, 2009; da Silva et al., 2003; Oliveira et al., 1990).",

    "economic_importance": "T. aurea is widely cultivated as an ornamental avenue and landscape tree because of its spectacular display of bright yellow flowers. It is extensively planted in parks, gardens, educational institutions and urban landscapes for beautification purposes. The tree contributes to urban greening and provides nectar resources for bees, butterflies and other pollinators. Wood is moderately durable and used locally for light construction, agricultural implements, fencing and fuelwood. Due to the presence of valuable secondary metabolites such as lapachol and β-lapachone, the species has potential economic importance in pharmaceutical, herbal medicine and nutraceutical industries. It is also useful in ecological restoration and afforestation programmes in tropical and subtropical regions (Lorenzi, 2008; Barbosa-Filho et al., 2004).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2024,
      "details": "Tabebuia aurea was assessed by the IUCN Red List in 2024 and categorized as Least Concern (LC) due to its wide distribution and stable population."
    },

    "references": [
      {
        "authors": "Barbosa-Filho, J. M., Lima, C. S. A., Camorim, E. L., & Sena, K. X. F. R.",
        "year": 2004,
        "title": "Botanical Study, Phytochemistry and Antimicrobial Activity of Tabebuia aurea",
        "journal": "Phyton-International Journal of Experimental Botany",
        "volume": "73",
        "pages": "221-228"
      },
      {
        "authors": "Gómez Castellanos, J. R., Prieto, J. M., & Heinrich, M.",
        "year": 2009,
        "title": "Red Lapacho (Tabebuia impetiginosa): A Global Ethnopharmacological Commodity?",
        "journal": "Journal of Ethnopharmacology",
        "volume": "121",
        "issue": "1",
        "pages": "1-13"
      },
      {
        "authors": "Pereira, E. M., Machado, T. B., Leal, I. C. R., Jesus, D. M., Damaso, C. R., Pinto, A. V., & Kuster, R. M.",
        "year": 2006,
        "title": "Tabebuia avellanedae Naphthoquinones: Antimicrobial Activity and Cytotoxicity",
        "journal": "Fitoterapia",
        "volume": "77",
        "issue": "7-8",
        "pages": "549-551"
      },
      {
        "authors": "Li, C. J., Li, Y. Z., Pinto, A. V., & Pardee, A. B.",
        "year": 1999,
        "title": "Potent Antitumor Activity of β-Lapachone",
        "journal": "Proceedings of the National Academy of Sciences",
        "volume": "96",
        "issue": "23",
        "pages": "13369-13374"
      },
      {
        "authors": "Kung, H. N., Yang, M. J., Chang, C. F., Chau, Y. P., Lu, K. S., & Huang, C. Y.",
        "year": 2014,
        "title": "In Vitro and In Vivo Wound Healing-Promoting Activities of β-Lapachone",
        "journal": "American Journal of Translational Research",
        "volume": "6",
        "issue": "4",
        "pages": "303-311"
      },
      {
        "authors": "Pinto, A. V., & de Castro, S. L.",
        "year": 2009,
        "title": "The Trypanocidal Activity of Naphthoquinones: A Review",
        "journal": "Molecules",
        "volume": "14",
        "issue": "11",
        "pages": "4570-4590"
      },
      {
        "authors": "da Silva, M. N., Ferreira, V. F., & Souza, M. C. B. V.",
        "year": 2003,
        "title": "An Overview of the Biological Activities of Lapachol and Related Naphthoquinones",
        "journal": "Current Medicinal Chemistry",
        "volume": "10",
        "issue": "9",
        "pages": "857-876"
      },
      {
        "authors": "Oliveira, B. H., Sant'Ana, A. E. G., & Bastos, D. Z. L.",
        "year": 1990,
        "title": "Phenolic Constituents and Antioxidant Activity in Bignoniaceae Species",
        "journal": "Phytochemistry",
        "volume": "29",
        "issue": "5",
        "pages": "1651-1655"
      },
      {
        "authors": "Gentry, A. H.",
        "year": 1992,
        "title": "Bignoniaceae: Part II (Tribe Tecomeae)",
        "publisher": "Flora Neotropica Monograph"
      },
      {
        "authors": "Lorenzi, H.",
        "year": 2008,
        "title": "Brazilian Trees: A Guide to the Identification and Cultivation of Brazilian Native Trees",
        "publisher": "Instituto Plantarum"
      },
      {
        "authors": "Svensson, M. S.",
        "year": 2024,
        "title": "Tabebuia aurea",
        "journal": "The IUCN Red List of Threatened Species",
        "pages": "e.T153628997A153655672"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  },
  {
    plant: 70,
    "id": "Phoenix-dactylifera",

    "scientific_name": "Phoenix dactylifera ",

    "aname": "L.",
    "common_name": "Date Palm",

    "local_name": "Khajurapu Chettu",

    "image": "/Flora/plant70.jpeg",
    gallery: {

      bark: "/Flora/plant70a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant70b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      seed: "/Flora/plant70c.jpeg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Phoenix-dactylifera",
    'qr_code': '/Flora/qrcodes/Phoneix-dactylifera.png',

    "botanical_profile": {
      "scientific_name": "Phoenix dactylifera ",
      "aname": "L.",
      "common_name": "Date Palm",
      "local_name": "Khajurapu Chettu",
      "family": "Arecaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Phanerogams",
      "class": "Monocotyledones",
      "series": "Calyciflorae",
      "order": "Calycinae",
      "family": "Arecaceae",
      "genus": "Phoenix",
      "species": "dactylifera"
    },

    "morphological_characters": "P. dactylifera is a tall, evergreen, dioecious palm belonging to the family Arecaceae. It usually grows 15–30 m in height with a single unbranched trunk. The trunk is cylindrical, rough, and covered with persistent leaf-base scars. Older trunks become fibrous and rugged due to the remains of fallen leaves. Leaves are pinnately compound, arranged in a terminal crown, bluish-green to greyish-green, and may reach 3–6 m in length. Numerous narrow, linear-lanceolate leaflets are arranged along both sides of the rachis and are rigid, pointed, and waxy. Flowers are small, creamy-white to yellowish and borne on separate male and female trees. Inflorescences are large branched spadices enclosed within a tough spathe before opening. Fruits are one-seeded berries known as dates, oblong to oval in shape, varying from yellow and orange to reddish-brown and dark brown when mature. Seeds are elongated, hard, brown, and possess a characteristic longitudinal groove (Mehdi Shah et al., 2023; Zaid & de Wet, 2002).",

    "digital_identification": {
      "habit": "Tall, evergreen, dioecious palm",
      "trunk": "Cylindrical, rough, covered with persistent leaf-base scars",
      "leaves": "Pinnately compound, terminal crown, bluish-green to greyish-green",
      "leaflets": "Numerous, narrow, linear-lanceolate, rigid and waxy",
      "inflorescence": "Large branched spadix enclosed in a spathe",
      "flowers": "Dioecious, small, creamy-white to yellowish",
      "fruit": "Berry (date), oblong to oval, yellow to dark brown at maturity",
      "seed": "Elongated, hard, brown with longitudinal groove"
    },

    "phytochemical_constituents": "P. dactylifera contains a wide range of bioactive compounds including polyphenols, flavonoids, carotenoids, anthocyanins, tocopherols, phytosterols, triterpenoids, tannins, phenolic acids, alkaloids, glycosides, saponins, dietary fiber, vitamins, minerals, amino acids, and essential fatty acids. Important phenolic compounds include gallic acid, ferulic acid, caffeic acid, p-coumaric acid, protocatechuic acid, quercetin, luteolin, apigenin, and rutin. Carotenoids such as β-carotene and lutein, along with tocopherols and selenium, contribute to strong antioxidant activity. The fruits are rich in glucose, fructose, sucrose, potassium, calcium, magnesium, iron, and zinc (Mehdi Shah et al., 2023; Baliga et al., 2011; Al-Farsi & Lee, 2008; Vayalil, 2012).",

    "medicinal_importance": "P. dactylifera exhibits numerous pharmacological activities owing to its rich phytochemical profile. Scientific studies have reported antioxidant, anti-inflammatory, antidiabetic, antihyperlipidemic, hepatoprotective, nephroprotective, cardioprotective, neuroprotective, antimicrobial, anticancer, antiulcer, immunomodulatory, and gastroprotective activities. Polyphenols and flavonoids help reduce oxidative stress and inflammation, while dietary fiber improves gastrointestinal health and acts as a prebiotic. Date fruit consumption has been associated with improved cardiovascular health, regulation of blood glucose, enhanced immune response, and protection against neurodegenerative disorders. Traditional medicine systems use different parts of the plant for treating fever, digestive disorders, respiratory ailments, wounds, and reproductive health problems (Mehdi Shah et al., 2023; Baliga et al., 2011; Vayalil, 2012; Rahmani et al., 2014; El-Far et al., 2016).",

    "economic_importance": "P. dactylifera is one of the most economically important fruit crops of arid and semi-arid regions. Fruits are consumed fresh, dried, or processed into syrups, jams, juices, beverages, confectionery products, and health foods. Seeds are utilized for animal feed, coffee substitutes, and extraction of seed oil. Leaves are used in making baskets, mats, ropes, brooms, handicrafts, and thatching materials. Trunks provide timber for construction and rural housing. The species contributes significantly to food security, employment generation, agro-industries, and export earnings in many countries of the Middle East, North Africa, and South Asia. Increasing demand for nutraceutical products and functional foods has further enhanced its commercial value (Zaid & de Wet, 2002; Baliga et al., 2011).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "assessment_year": 2025,
      "details": "Phoenix dactylifera has not been formally evaluated under the IUCN Red List categories and criteria."
    },

    "references": [
      {
        "authors": "Mehdi Shah, S. M., Abbas Naqvi, S., Jafar Jaskani, M., & Mehdi Shah, I.",
        "year": 2023,
        "title": "A Review on Phytochemicals and Pharmacological Chemicals of Date Palm (Phoenix dactylifera)",
        "journal": "Journal of Advance Research in Food, Agriculture and Environmental Science",
        "volume": "9",
        "issue": "8",
        "pages": "8-25"
      },
      {
        "authors": "Baliga, M. S., Baliga, B. R. V., Kandathil, S. M., Bhat, H. P., & Vayalil, P. K.",
        "year": 2011,
        "title": "A Review of the Chemistry and Pharmacology of the Date Fruits (Phoenix dactylifera L.)",
        "journal": "Food Research International",
        "volume": "44",
        "issue": "7",
        "pages": "1812-1822"
      },
      {
        "authors": "Vayalil, P. K.",
        "year": 2012,
        "title": "Date Fruits (Phoenix dactylifera Linn): An Emerging Medicinal Food",
        "journal": "Critical Reviews in Food Science and Nutrition",
        "volume": "52",
        "issue": "3",
        "pages": "249-271"
      },
      {
        "authors": "Al-Farsi, M., & Lee, C. Y.",
        "year": 2008,
        "title": "Nutritional and Functional Properties of Dates",
        "journal": "Critical Reviews in Food Science and Nutrition",
        "volume": "48",
        "issue": "10",
        "pages": "877-887"
      },
      {
        "authors": "Rahmani, A. H., Aly, S. M., Ali, H., Babiker, A. Y., Srikar, S., & Khan, A. A.",
        "year": 2014,
        "title": "Therapeutic Effects of Date Fruits (Phoenix dactylifera) in the Prevention of Diseases",
        "journal": "International Journal of Clinical and Experimental Medicine",
        "volume": "7",
        "issue": "3",
        "pages": "483-491"
      },
      {
        "authors": "El-Far, A. H., Shaheen, H. M., Alsenosy, A. A., & El-Sayed, Y. S.",
        "year": 2016,
        "title": "Date Palm Fruits and Seeds in Health and Disease Prevention",
        "journal": "Asian Pacific Journal of Tropical Biomedicine",
        "volume": "6",
        "issue": "9",
        "pages": "745-753"
      },
      {
        "authors": "Zaid, A., & de Wet, P. F.",
        "year": 2002,
        "title": "Date Palm Cultivation",
        "publisher": "Food and Agriculture Organization (FAO), Rome"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      }
    ]
  }
  ,
  {
    plant: 71,
    "id": "Cocos-nucifera",

    "scientific_name": "Cocos nucifera ",

    "aname": "L.",
    "common_name": "Coconut Palm",

    "local_name": "Kobbari Chettu",

    "image": "/Flora/plant71.jpeg",
    gallery: {

      bark: "/Flora/plant71a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant71b.jpeg",
      fruit: "/Flora/plant71c.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Cocos-nucifera",
    'qr_code': '/Flora/qrcodes/Cocos-nucifera.png',

    "botanical_profile": {
      "scientific_name": "Cocos nucifera ",
      "aname": "L.",
      "common_name": "Coconut Palm",
      "local_name": "Kobbari Chettu",
      "family": "Arecaceae (Palmae)"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Phanerogamia",
      "class": "Monocotyledonae",
      "series": "Calycinae",
      "order": "Palmales",
      "family": "Arecaceae (Palmae)",
      "genus": "Cocos",
      "species": "nucifera"
    },

    "morphological_characters": "C. nucifera is a tall, evergreen, unbranched palm tree reaching 20–30 m in height. It is an arborescent monocotyledon with a dense crown of leaves at the apex. The stem is cylindrical, unbranched, and marked with prominent leaf-scar rings. The trunk is smooth to slightly rough and lacks secondary growth. Leaves are large, pinnately compound, feather-shaped fronds arranged in a terminal crown around the apical bud. Each leaf consists of a petiole, rachis, and numerous linear-lanceolate leaflets with parallel venation. The inflorescence is an axillary spadix enclosed by a woody spathe. Flowers are monoecious, bearing both male and female flowers on the same inflorescence. Female flowers are larger and occur at the base of the inflorescence, while male flowers are numerous and located towards the apex. The fruit is a fibrous drupe consisting of a smooth epicarp, thick fibrous mesocarp, and hard woody endocarp enclosing coconut water and white edible endosperm (Pullaiah & Karuppusamy, 2018; Yong et al., 2009).",

    "digital_identification": {
      "habit": "Tall evergreen unbranched palm tree",
      "stem": "Cylindrical, unbranched with prominent leaf-scar rings",
      "trunk": "Smooth to slightly rough",
      "leaves": "Large, pinnately compound, feather-shaped fronds",
      "leaflets": "Numerous, linear-lanceolate, parallel venation",
      "inflorescence": "Axillary spadix enclosed by a woody spathe",
      "flowers": "Monoecious; male and female flowers on the same inflorescence",
      "fruit": "Fibrous drupe with epicarp, mesocarp and endocarp",
      "seed": "Single seed containing coconut water and white edible endosperm"
    },

    "phytochemical_constituents": "Different parts of C. nucifera contain numerous bioactive compounds including phenolics, flavonoids, tannins, catechin, epicatechins, leucoanthocyanidins, triterpenes, steroids, alkaloids, saponins, polyphenols, lauric acid, capric acid, caprylic acid, α-tocopherol (Vitamin E), amino acids, vitamins B1, B2, B3, B5, B6, C, folic acid, biotin, cytokinins, auxins, and minerals. Coconut water is particularly rich in sugars, amino acids, electrolytes, antioxidants, and growth-promoting phytohormones. Virgin coconut oil contains medium-chain fatty acids, especially lauric acid, which contribute significantly to its biological activities (Yong et al., 2009; Marina et al., 2009; Lima et al., 2015).",

    "medicinal_importance": "C. nucifera possesses a wide range of pharmacological activities including antioxidant, anti-inflammatory, antimicrobial, antibacterial, antifungal, antiviral, antihelminthic, antidiarrheal, antipyretic, analgesic, antiarthritic, antihypertensive, cardioprotective, hepatoprotective, nephroprotective, hypoglycemic, antiulcer, wound-healing, immunomodulatory, anticonvulsant, vasodilatory, anti-osteoporotic, antitumor, and cytotoxic activities. Coconut water has cytoprotective and rehydrating properties, while virgin coconut oil exhibits significant antioxidant and wound-healing effects. Root extracts have demonstrated anticonvulsant and central nervous system depressant activities. These medicinal properties make the plant valuable in traditional and modern medicine (DebMandal & Mandal, 2011; Nevin & Rajamohan, 2010; Lima et al., 2015; Warrier et al., 1996).",

    "economic_importance": "C. nucifera is one of the most economically important plantation crops in tropical regions. Coconut water is consumed as a nutritious beverage, while the kernel is used for food, coconut milk, and coconut oil production. Coir obtained from the husk is utilized in the manufacture of ropes, mats, carpets, brushes, and horticultural substrates. Coconut shells are used in handicrafts, charcoal production, and activated carbon industries. Leaves and stems are used for house construction, roofing, baskets, and fencing materials. The inflorescence is tapped to produce sugar, jaggery, vinegar, toddy, and alcoholic beverages. Coconut oil is extensively used in food, cosmetic, pharmaceutical, soap, and nutraceutical industries. Virgin coconut oil is increasingly valued as a functional food due to its health-promoting properties (Marina et al., 2009; Srivastava et al., 2016; Yong et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Not Evaluated",
      "details": "Cocos nucifera has not been evaluated by the IUCN Red List."
    },

    "references": [
      {
        "authors": "DebMandal, M., & Mandal, S.",
        "year": 2011,
        "title": "Coconut (Cocos nucifera L.: Arecaceae): In health promotion and disease prevention",
        "journal": "Asian Pacific Journal of Tropical Medicine",
        "volume": "4",
        "issue": "3",
        "pages": "241-247"
      },
      {
        "authors": "Lima, E. B. C., Sousa, C. N. S., Meneses, L. N., Ximenes, N. C., Santos Júnior, M. A., Vasconcelos, G. S., Lima, N. B. C., Patrocínio, M. C. A., Macedo, D., & Vasconcelos, S. M. M.",
        "year": 2015,
        "title": "Cocos nucifera (L.) (Arecaceae): A phytochemical and pharmacological review",
        "journal": "Brazilian Journal of Medical and Biological Research",
        "volume": "48",
        "issue": "11",
        "pages": "953-964"
      },
      {
        "authors": "Marina, A. M., Che Man, Y. B., & Amin, I.",
        "year": 2009,
        "title": "Virgin coconut oil: Emerging functional food oil",
        "journal": "Trends in Food Science and Technology",
        "volume": "20",
        "issue": "10",
        "pages": "481-487"
      },
      {
        "authors": "Nevin, K. G., & Rajamohan, T.",
        "year": 2010,
        "title": "Effect of topical application of virgin coconut oil on skin components and antioxidant status during dermal wound healing in young rats",
        "journal": "Skin Pharmacology and Physiology",
        "volume": "23",
        "issue": "6",
        "pages": "290-297"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Srivastava, Y., Semwal, A. D., Sharma, G. K., & Kumar, D.",
        "year": 2016,
        "title": "Virgin Coconut Oil as Functional Oil",
        "journal": "International Journal of Pharmaceutical Sciences and Research",
        "volume": "7",
        "issue": "8",
        "pages": "3071-3079"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Yong, J. W. H., Ge, L., Ng, Y. F., & Tan, S. N.",
        "year": 2009,
        "title": "The Chemical Composition and Biological Properties of Coconut (Cocos nucifera L.) Water",
        "journal": "Molecules",
        "volume": "14",
        "issue": "12",
        "pages": "5144-5164"
      }
    ]
  },
  {
    plant: 72,
    "id": "Bismarckia-nobilis",

    "scientific_name": "Bismarckia nobilis ",

    "aname": "Hildebr. & H.Wendl.",
    "common_name": "Bismarckia Palm",

    "local_name": "Bismarckia Palm",

    "image": "/Flora/plant72.jpeg",
    gallery: {

      bark: "/Flora/plant72a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant72b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Bismarckia-nobilis",
    'qr_code': '/Flora/qrcodes/Bismarckia-nobilis.png',

    "botanical_profile": {
      "scientific_name": "Bismarckia nobilis ",
      "aname": "Hildebr. & H.Wendl.",
      "common_name": "Bismarckia Palm",
      "local_name": "Bismarckia Palm",
      "family": "Arecaceae (Palmae)"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "class": "Monocotyledones",
      "series": "Calycinae",
      "family": "Arecaceae (Palmae)",
      "genus": "Bismarckia",
      "species": "nobilis"
    },

    "morphological_characters": "B. nobilis is a large solitary evergreen palm attaining a height of 12–25 m. The trunk is stout, straight, unbranched, greyish-brown and marked with prominent leaf scars. Leaves are large, costapalmate, rigid and arranged in a circular crown. The leaf blades are silver-blue to bluish-green and may reach 2–3 m in diameter. Numerous narrow, stiff and deeply divided leaflets radiate symmetrically from the centre. Inflorescences are large branched spadices emerging between the leaves. The species is dioecious, with male and female flowers occurring on separate plants. Flowers are small, cream-coloured to pale yellow. Fruits are globose to ovoid drupes, brown to dark brown when mature, measuring 3–5 cm in diameter and containing a single hard seed enclosed within a tough endocarp (Pullaiah & Karuppusamy, 2018; Dhanoliya et al., 2025; Dransfield et al., 2008).",

    "digital_identification": {
      "habit": "Large solitary evergreen palm",
      "trunk": "Stout, straight, unbranched, greyish-brown with leaf scars",
      "leaves": "Costapalmate, rigid, silver-blue to bluish-green",
      "leaflets": "Numerous, narrow, stiff and deeply divided",
      "inflorescence": "Large branched spadix",
      "flowers": "Dioecious, cream-coloured to pale yellow",
      "fruit": "Globose to ovoid drupe, brown to dark brown",
      "seed": "Single hard seed enclosed within a tough endocarp"
    },

    "phytochemical_constituents": "Phytochemical investigations of B. nobilis have revealed the presence of alkaloids, flavonoids, tannins, phenolic compounds, coumarins, sterols, saponins, terpenoids, anthraquinones, essential oils, monoterpenes, sesquiterpenes, glycosylated flavonoids and dietary fibres. These secondary metabolites contribute significantly to the antioxidant, antihyperglycemic, antimicrobial and anti-inflammatory activities reported for the species. Phenolic compounds and flavonoids are considered the major bioactive constituents responsible for its pharmacological potential (Dhanoliya et al., 2025; Saqib et al., 2019; Harborne, 1998).",

    "medicinal_importance": "B. nobilis possesses significant medicinal value. Hydroalcoholic extracts have demonstrated antidiabetic activity by reducing blood glucose levels and improving insulin sensitivity in experimental models. The plant also exhibits antihyperlipidemic activity by lowering serum cholesterol, triglycerides and LDL levels. Flavonoids and phenolics contribute to strong antioxidant activity through free-radical scavenging mechanisms. Experimental studies further indicate antidiarrheal, antispasmodic, bronchodilatory, antihypertensive, antimicrobial and wound-healing properties. These findings suggest that B. nobilis may serve as a promising source of natural therapeutic agents for metabolic and cardiovascular disorders (Dhanoliya et al., 2025; Saqib et al., 2019).",

    "economic_importance": "B. nobilis is among the most attractive ornamental palms cultivated worldwide. It is extensively planted in avenues, parks, resorts, botanical gardens and urban landscapes due to its majestic architecture, silver-blue foliage and drought tolerance. The species contributes significantly to the nursery and ornamental horticulture industries. Leaves are occasionally utilized in decorative crafts and landscaping designs. Because of its adaptability and aesthetic appeal, the palm is highly valued in tropical and subtropical horticultural markets (Orwa et al., 2009; Dransfield et al., 2008).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2012,
      "details": "Bismarckia nobilis was assessed by the IUCN Red List and categorized as Least Concern owing to its relatively stable populations and widespread cultivation."
    },

    "references": [
      {
        "authors": "Dhanoliya, K. K., Yadav, Y., Dubey, P. K., & Sharma, J.",
        "year": 2025,
        "title": "Evaluation of in-vivo antidiabetic and antihyperlipidemic potential of Bismarckia nobilis extract",
        "journal": "International Journal of Pharmaceutical Sciences",
        "volume": "3",
        "issue": "8",
        "pages": "855-865"
      },
      {
        "authors": "Dransfield, J., Uhl, N. W., Asmussen, C. B., Baker, W. J., Harley, M. M., & Lewis, C. E.",
        "year": 2008,
        "title": "Genera Palmarum: The Evolution and Classification of Palms",
        "publisher": "Kew Publishing"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods: A Guide to Modern Techniques of Plant Analysis",
        "publisher": "Chapman and Hall"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rakotoarinivo, M., & Dransfield, J.",
        "year": 2012,
        "title": "Bismarckia nobilis",
        "source": "The IUCN Red List of Threatened Species 2012",
        "pages": "e.T195991A2440090"
      },
      {
        "authors": "Saqib, F., Jabeen, N., Riaz, M., & Sechel, G.",
        "year": 2019,
        "title": "Evaluation of smooth muscle relaxant potential of Bismarckia nobilis (Hildebr. & Wendl.) in diarrhea, hypertension and asthma by ex-vivo and in-vivo method",
        "journal": "Boletín Latinoamericano y del Caribe de Plantas Medicinales y Aromáticas",
        "volume": "18",
        "issue": "2",
        "pages": "204-222"
      }
    ]
  }
  ,
  {
    plant: 73,
    "id": "Conocarpus-erectus",

    "scientific_name": "Conocarpus erectus ",

    "aname": "L.",
    "common_name": "Buttonwood",

    "local_name": "Buttonwood, Button Mangrove, Silver Buttonwood",

    "image": "/Flora/plant73.jpeg",
    gallery: {

      bark: "/Flora/plant73a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant73b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Conocarpus-erectus",
    'qr_code': '/Flora/qrcodes/Conocarpus-erectus.png',

    "botanical_profile": {
      "scientific_name": "Conocarpus erectus ",
      "aname": "L.",
      "common_name": "Buttonwood",
      "local_name": "Buttonwood, Button Mangrove, Silver Buttonwood",
      "family": "Combretaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Combretaceae",
      "genus": "Conocarpus",
      "species": "erectus"
    },

    "morphological_characters": "C. erectus is an evergreen shrub or medium-sized tree commonly found in tropical and subtropical coastal regions. The plant possesses a well-developed root system consisting mainly of lateral, fine, dark-brown roots. The trunk may be single or multi-stemmed, and the bark is grey to brown, fibrous, rough, and moderately thin. Branches are slender, fragile, yellowish-green, and often flattened or winged. Leaves are simple, alternate, spirally arranged, oval to elliptic, leathery, and green to bluish-green in colour. Flowers are small, greenish, inconspicuous, and borne in dense globular or cone-like heads arranged in terminal panicles or axillary clusters. Fruits are small, dry, and aggregated into characteristic spherical button-like clusters. Seeds are numerous and enclosed within compact fruiting heads (Jasim et al., 2020; Tomlinson, 2016; Orwa et al., 2009).",

    "digital_identification": {
      "habit": "Evergreen shrub or tree",
      "roots": "Lateral, fine, dark-brown roots",
      "trunk": "Single or multi-stemmed",
      "bark": "Grey to brown, fibrous, rough",
      "branches": "Slender, fragile, yellowish-green, flattened or winged",
      "leaves": "Simple, alternate, spirally arranged, oval to elliptic, leathery",
      "flowers": "Small, greenish, globular or cone-like flower heads",
      "inflorescence": "Terminal panicles or axillary clusters",
      "fruit": "Button-like spherical clusters of dry fruits",
      "seed": "Small and numerous"
    },

    "phytochemical_constituents": "C. erectus contains a wide range of bioactive phytochemicals including phenolic compounds, flavonoids, tannins, gallic acid, catechin, quercetin, quercetin-3-O-glucoside, rutin, kaempferol derivatives, ellagic acid, lignans, conocarpol, methoxyconocarpol, conocarpan, sesquiterpenes, steroidal compounds, alkaloids, and dialdehydes. The leaves are particularly rich in polyphenols and antioxidant compounds that contribute to the plant's medicinal properties. These phytochemicals are responsible for antioxidant, antimicrobial, hepatoprotective, and anticancer activities (Rocha et al., 2012; Jasim et al., 2020; Trease & Evans, 2009).",

    "medicinal_importance": "C. erectus possesses significant medicinal value due to its rich phytochemical composition. Scientific studies have demonstrated strong antioxidant activity through free radical scavenging mechanisms. The plant exhibits antimicrobial activity against several Gram-positive and Gram-negative bacteria and pathogenic fungi. Extracts have shown hepatoprotective effects by protecting liver tissues from oxidative damage. Research also indicates anticancer activity against liver and breast cancer cell lines. Traditional applications include treatment of infections, inflammatory disorders, and wound management. The high tannin and flavonoid content contributes to its antibacterial, antifungal, anti-inflammatory, and cytoprotective properties (Jasim et al., 2020; Rocha et al., 2012; Warrier et al., 1995).",

    "economic_importance": "C. erectus is widely cultivated as an ornamental tree in parks, gardens, avenues, coastal landscapes, and urban greening projects because of its dense evergreen canopy, drought tolerance, and adaptability to saline conditions. The species contributes to environmental protection through soil stabilization, erosion control, and carbon sequestration. Its wood is strong and durable and may be used as fuelwood and small timber. The plant is also recognized as a potential source of pharmaceutical compounds due to its antioxidant, antimicrobial, and anticancer constituents. Its popularity in landscaping and nursery industries provides substantial economic value (Orwa et al., 2009; Kathiresan & Bingham, 2001; World Agroforestry Centre, 2023).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2010,
      "details": "Conocarpus erectus was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Ellison et al., 2010)."
    },

    "references": [
      {
        "authors": "Ellison, A., Farnsworth, E., & Moore, G.",
        "year": 2010,
        "title": "Conocarpus erectus",
        "source": "The IUCN Red List of Threatened Species 2010",
        "pages": "e.T178806A7612125"
      },
      {
        "authors": "Jasim, N. O., Shadhaan, B. K., Kadhim, A., & Almohsi, A. A.",
        "year": 2020,
        "title": "Pharmacological and antimicrobial properties of Conocarpus erectus: A review",
        "journal": "Plant Archives",
        "volume": "20",
        "issue": "2",
        "pages": "6097–6100"
      },
      {
        "authors": "Kathiresan, K., & Bingham, B. L.",
        "year": 2001,
        "title": "Biology of mangroves and mangrove ecosystems",
        "journal": "Advances in Marine Biology",
        "volume": "40",
        "pages": "81–251"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rocha, J. A., Barbosa Filho, J. M., Lima, C. S. A., Silva, M. S., & Santos, R. L.",
        "year": 2012,
        "title": "Phenolic compounds and antioxidant activity of Conocarpus erectus leaves",
        "journal": "Journal of Medicinal Plants Research",
        "volume": "6",
        "issue": "28",
        "pages": "4464–4470"
      },
      {
        "authors": "Tomlinson, P. B.",
        "year": 2016,
        "title": "The Botany of Mangroves",
        "edition": "2nd Edition",
        "publisher": "Cambridge University Press"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Pharmacognosy",
        "edition": "16th Edition",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "World Agroforestry Centre (ICRAF)",
        "year": 2023,
        "title": "Conocarpus erectus Species Profile and Agroforestry Uses",
        "publisher": "ICRAF"
      }
    ]
  }
  ,
  {
    plant: 74,
    "id": "Cycas-revoluta",

    "scientific_name": "Cycas revoluta ",

    "aname": "Thunb.",
    "common_name": "Sago Palm",

    "local_name": "Sago Palm, King Sago",

    "image": "/Flora/plant74.jpeg",
    gallery: {

      bark: "/Flora/plant74a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Cycas-revoluta",
    'qr_code': '/Flora/qrcodes/Cycas-revoluta.png',

    "botanical_profile": {
      "scientific_name": "Cycas revoluta ",
      "aname": "Thunb.",
      "common_name": "Sago Palm",
      "local_name": "Sago Palm, King Sago",
      "family": "Cycadaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "class": "Gymnospermae",
      "order": "Cycadales",
      "family": "Cycadaceae",
      "genus": "Cycas",
      "species": "revoluta"
    },

    "morphological_characters": "C. revoluta is a palm-like evergreen, slow-growing, medium-sized, perennial, woody, dioecious gymnosperm. The plant generally reaches 0.5–2 m in height with a stout columnar trunk that may attain 35–95 cm in diameter. Young plants possess a tuberous stem, while mature plants develop a rough trunk covered with persistent leaf bases. Leaves are glossy dark green, pinnately compound, 0.5–1.5 m long, and arranged in a crown at the apex. More than 100 narrow linear leaflets are borne on each frond, exhibiting revolute margins and a prominent midrib. Young leaves emerge in a circinate manner. The petiole is thick and quadrangular. The species is dioecious, with male and female reproductive structures borne on separate plants. Male cones are narrowly ovoid to cylindrical, brown, and densely hairy, whereas female megasporophylls are loosely arranged, densely tomentose, and bear ovules along their margins. Pollination occurs through both wind and insects. Seeds are large, red to orange-red when mature, ovoid, and enclosed by a fleshy sarcotesta (Deora et al., 2020; Jones, 2002; Stevenson, 1990; Whitelock, 2002).",

    "digital_identification": {
      "habit": "Palm-like evergreen, perennial, woody, dioecious gymnosperm",
      "stem": "Young plants tuberous; mature plants with thick rough columnar trunk",
      "leaves": "Glossy green, pinnately compound, arranged in terminal crown",
      "leaflets": "Numerous, linear, revolute margins, prominent midrib",
      "petiole": "Thick and quadrangular",
      "pollination": "Wind and insect pollination",
      "male_cones": "Narrowly ovoid to cylindrical, brown and hairy",
      "female_cones": "Loose megasporophylls, densely hairy with laciniate margins",
      "seeds": "Large, red-coated, ovoid seeds"
    },

    "phytochemical_constituents": "C. revoluta contains diverse phytochemicals including biflavonoids, flavonoids, glycosides, lectins, alkaloids, sterols, peptides, lipids, phenolic compounds, essential oils, amino acids, and chitinase enzymes. Important constituents reported from leaves, seeds, and cones include amentoflavone, hinokiflavone, cycasin, neocycasin, macrozamin, β-N-methylamino-L-alanine (BMAA), rutin, quercetin derivatives, β-sitosterol, stigmasterol, estragole, linolenic acid, oleic acid, and palmitic acid. These compounds contribute significantly to the antioxidant, antimicrobial, anti-inflammatory, and pharmacological properties of the plant (Deora et al., 2020; La Meña et al., 2019; Moretti et al., 1993; Norstog & Nicholls, 1997).",

    "medicinal_importance": "C. revoluta has long been used in traditional medicine for the treatment of wounds, ulcers, piles, flatulence, painful urination, dysentery, diarrhea, rheumatism, and inflammatory disorders. Scientific studies have demonstrated antioxidant, antimicrobial, antibacterial, antifungal, antiviral, antidiabetic, anti-inflammatory, antileishmanial, cytotoxic, anticancer, hepatoprotective, and antirheumatic activities. Extracts from leaves and seeds exhibit strong free radical scavenging activity due to their high flavonoid and phenolic content. Biflavonoids such as amentoflavone and hinokiflavone possess antimicrobial and anticancer potential. Several studies have reported inhibitory activity against pathogenic bacteria and fungi, highlighting the pharmaceutical significance of the species (Deora et al., 2020; Das et al., 2014; Singh et al., 2008; La Meña et al., 2019).",

    "economic_importance": "C. revoluta is an economically important ornamental gymnosperm cultivated extensively in gardens, landscapes, institutional campuses, parks, and indoor decorative settings. The starch-rich stem and seeds are processed into sago and flour after detoxification. Young leaves are occasionally consumed as vegetables in some regions. Fibres from leaves and stems are used for ropes, mats, baskets, handicrafts, brooms, and thatching materials. The plant is highly valued in the nursery industry and international ornamental plant trade. Its phytochemical constituents have also attracted attention for pharmaceutical and nutraceutical applications (Deora et al., 2020; Jones, 2002; Whitelock, 2002; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2023,
      "details": "Cycas revoluta was assessed by the IUCN Red List and categorized as Least Concern (Bösenberg, 2023)."
    },

    "references": [
      {
        "authors": "Bösenberg, J. D.",
        "year": 2023,
        "title": "Cycas revoluta",
        "source": "The IUCN Red List of Threatened Species 2023",
        "pages": "e.T42080A69155560"
      },
      {
        "authors": "Das, A., Singh, S., & Ahmed, F.",
        "year": 2014,
        "title": "Biological Activities and Therapeutic Potential of Cycas Species: A Review",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "24",
        "issue": "2",
        "pages": "212-218"
      },
      {
        "authors": "Deora, G. S., Shekhawat, M. K., & Sarswati",
        "year": 2020,
        "title": "Ethnobotanical, Phytochemical and Pharmacological Potential of Cycas revoluta Thunb. – A Review",
        "journal": "Pharmacognosy Journal",
        "volume": "12",
        "issue": "5",
        "pages": "1165-1171"
      },
      {
        "authors": "Hill, K. D.",
        "year": 2004,
        "title": "The Cycads of the World",
        "publisher": "Timber Press"
      },
      {
        "authors": "Jones, D. L.",
        "year": 2002,
        "title": "Cycads of the World: Ancient Plants in Today's Landscape",
        "publisher": "Smithsonian Institution Press"
      },
      {
        "authors": "La Meña, A. C., Vilela, J. C., & Chaves, M. H.",
        "year": 2019,
        "title": "Phytochemical Constituents and Biological Activities of Cycadaceae: A Review",
        "journal": "Journal of Applied Pharmaceutical Science",
        "volume": "9",
        "issue": "10",
        "pages": "110-118"
      },
      {
        "authors": "Moretti, A., Sabato, S., & Siniscalco Gigliano, G.",
        "year": 1993,
        "title": "Taxonomic Significance of Biflavonoids in Cycadaceae",
        "journal": "Biochemical Systematics and Ecology",
        "volume": "21",
        "issue": "5",
        "pages": "589-593"
      },
      {
        "authors": "Norstog, K. J., & Nicholls, T. J.",
        "year": 1997,
        "title": "The Biology of the Cycads",
        "publisher": "Cornell University Press"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Singh, R., Singh, S., & Kumar, S.",
        "year": 2008,
        "title": "Antimicrobial and Antioxidant Activities of Cycas revoluta Extracts",
        "journal": "Indian Journal of Natural Products and Resources",
        "volume": "7",
        "issue": "3",
        "pages": "221-226"
      },
      {
        "authors": "Stevenson, D. W.",
        "year": 1990,
        "title": "Morphology and Systematics of the Cycadales",
        "journal": "Memoirs of the New York Botanical Garden",
        "volume": "57",
        "pages": "8-55"
      },
      {
        "authors": "Whitelock, L. M.",
        "year": 2002,
        "title": "The Cycads",
        "publisher": "Timber Press"
      }
    ]
  }
  ,
  {
    plant: 75,
    "id": "Ziziphus-jujuba",

    "scientific_name": "Ziziphus jujuba ",

    "aname": "Mill.",
    "common_name": "Jujube, Chinese Date",

    "local_name": "Regu Chettu, Jujube, Chinese Date, Indian Jujube, Indian Plum, Chinee Apple",

    "image": "/Flora/plant75.jpeg",
    gallery: {

      bark: "/Flora/plant75a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      // flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant75b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Ziziphus-jujuba",
    'qr_code': '/Flora/qrcodes/Ziziphus-jujuba.png',

    "botanical_profile": {
      "scientific_name": "Ziziphus jujuba ",
      "aname": "Mill.",
      "common_name": "Jujube, Chinese Date",
      "local_name": "Regu Chettu, Indian Jujube",
      "family": "Rhamnaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Disciflorae",
      "order": "Rhamnales",
      "family": "Rhamnaceae",
      "genus": "Ziziphus",
      "species": "jujuba"
    },

    "morphological_characters": "Z. jujuba is a small deciduous tree or shrub with a spreading crown. The bark is rough, dark grey to brown, and often fissured. Stems are woody, branched, and frequently armed with sharp spines. Leaves are simple, alternate, ovate to elliptical, glossy green, and characterized by three prominent veins arising from the base. Inflorescences are axillary cymes bearing clusters of small yellowish-green bisexual flowers. The flowers are pentamerous and fragrant. Fruits are fleshy drupes, oval to round, changing from green to reddish-brown upon ripening. Seeds are enclosed within a hard, stony endocarp, usually one or two per fruit (Mahajan & Chopda, 2009; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small deciduous tree or shrub",
      "bark": "Rough, dark grey to brown",
      "stem": "Woody, branched, often with sharp spines",
      "leaves": "Simple, alternate, ovate to elliptical, glossy green",
      "leaf_venation": "Three prominent veins arising from the base",
      "inflorescence": "Axillary cymes",
      "flowers": "Yellowish-green, bisexual, pentamerous",
      "fruit": "Fleshy drupe, oval to round, reddish-brown when ripe",
      "seed": "Enclosed in a hard stony endocarp, usually 1–2 seeds"
    },

    "phytochemical_constituents": "Z. jujuba contains a wide range of bioactive compounds including alkaloids, flavonoids, triterpenoids, phenolic acids, saponins, polysaccharides, cyclopeptide alkaloids, vitamins, amino acids, and dietary fibers. Major constituents include mauritine-A, amphibine-H, jubanine-A, jubanine-B, nummularine-B, betulinic acid, oleanolic acid, ursolic acid, alphitolic acid, jujubosides A, B, and C, spinosin, rutin, quercetin, kaempferol, vitamin C, thiamine, riboflavin, pectin, and polysaccharides. These compounds contribute significantly to the antioxidant, neuroprotective, immunomodulatory, and therapeutic properties of the plant (Mahajan & Chopda, 2009; Gao et al., 2013; Wang et al., 2016; Shahrajabian et al., 2022).",

    "medicinal_importance": "Z. jujuba is widely used in traditional medicine as a tonic, sedative, and aphrodisiac. Scientific studies have demonstrated antioxidant, antimicrobial, anti-inflammatory, hepatoprotective, immunomodulatory, anticancer, antidiabetic, cardioprotective, anti-ulcer, wound-healing, neuroprotective, anxiolytic, sedative-hypnotic, and cognitive-enhancing activities. The seeds are particularly valued for treating insomnia, anxiety, nervous disorders, and stress-related conditions. The fruits are used as immune boosters and nutritional supplements due to their high vitamin and antioxidant content. Polysaccharides, flavonoids, triterpenoids, and jujubosides are considered the major compounds responsible for these pharmacological effects (Peng et al., 2000; Huang et al., 2007; Wang et al., 2016; Shahrajabian et al., 2022).",

    "economic_importance": "Z. jujuba is an economically important fruit and medicinal plant. Its fruits are consumed fresh, dried, candied, or processed into juices, jams, beverages, syrups, and confectionery products. The plant is widely utilized in traditional herbal medicine and pharmaceutical industries. Because of its high nutritional value, antioxidant content, and therapeutic properties, it contributes significantly to local economies and nutraceutical industries. The wood is also used for fuel and small timber applications, while the plant serves as a valuable component in agroforestry systems and dryland horticulture (Mahajan & Chopda, 2009; Gao et al., 2013).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2007,
      "details": "Ziziphus jujuba was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (Participants of the FFI/IUCN SSC Central Asian Regional Tree Red Listing Workshop, 2007)."
    },

    "references": [
      {
        "authors": "Gao, Q. H., Wu, C. S., & Wang, M.",
        "year": 2013,
        "title": "The jujube (Ziziphus jujuba Mill.) fruit: A review of current knowledge of fruit composition and health benefits",
        "journal": "Journal of Agricultural and Food Chemistry",
        "volume": "61",
        "issue": "14",
        "pages": "3351-3363"
      },
      {
        "authors": "Guo, S., Duan, J. A., Qian, D., Tang, Y., Qian, Y., Wu, D., & Su, S.",
        "year": 2015,
        "title": "Content variations of triterpenic acids, nucleosides, nucleobases, and saccharides in jujube fruits",
        "journal": "Food Chemistry",
        "volume": "167",
        "pages": "468-474"
      },
      {
        "authors": "Huang, X., Kojima-Yuasa, A., Norikura, T., Kennedy, D. O., Hasuma, T., & Matsui-Yuasa, I.",
        "year": 2007,
        "title": "Mechanism of the anti-cancer activity of Ziziphus jujuba in HepG2 cells",
        "journal": "American Journal of Chinese Medicine",
        "volume": "35",
        "issue": "3",
        "pages": "517-532"
      },
      {
        "authors": "Li, J., Shan, L., Liu, Y., Fan, L., Ai, L., & Zhu, Y.",
        "year": 2011,
        "title": "Screening of antioxidant activities and active compounds of Ziziphus jujuba fruits",
        "journal": "Food Chemistry",
        "volume": "123",
        "issue": "3",
        "pages": "909-915"
      },
      {
        "authors": "Mahajan, R. T., & Chopda, M. Z.",
        "year": 2009,
        "title": "Phyto-pharmacology of Ziziphus jujuba Mill – A plant review",
        "journal": "Pharmacognosy Reviews",
        "volume": "3",
        "issue": "6",
        "pages": "320-329"
      },
      {
        "authors": "Participants of the FFI/IUCN SSC Central Asian Regional Tree Red Listing Workshop, Bishkek, Kyrgyzstan",
        "year": 2007,
        "title": "Ziziphus jujuba",
        "source": "The IUCN Red List of Threatened Species 2007",
        "pages": "e.T63538A12688176"
      },
      {
        "authors": "Peng, W. H., Hsieh, M. T., Lee, Y. S., Lin, Y. C., & Liao, J.",
        "year": 2000,
        "title": "Anxiolytic effect of seed extracts of Ziziphus jujuba in mice",
        "journal": "Journal of Ethnopharmacology",
        "volume": "72",
        "issue": "3",
        "pages": "435-441"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "San, B., & Yildirim, A. N.",
        "year": 2010,
        "title": "Phenolic, alpha-tocopherol, beta-carotene and fatty acid composition of four promising jujube selections",
        "journal": "Journal of Food Composition and Analysis",
        "volume": "23",
        "issue": "7",
        "pages": "706-710"
      },
      {
        "authors": "Shahrajabian, M. H., Sun, W., & Cheng, Q.",
        "year": 2022,
        "title": "Chinese jujube (Ziziphus jujuba Mill.): A review of traditional uses, phytochemistry and pharmacology",
        "journal": "Notulae Botanicae Horti Agrobotanici Cluj-Napoca",
        "volume": "50",
        "issue": "1",
        "pages": "12530"
      },
      {
        "authors": "Wang, B., Huang, Q., Venkitasamy, C., Chai, Z., Gao, H., Cheng, N., Pan, Z., & Lv, W.",
        "year": 2016,
        "title": "Bioactive compounds and biological functions of jujube (Ziziphus jujuba Mill.): A review",
        "journal": "Food Chemistry",
        "volume": "188",
        "pages": "443-453"
      },
      {
        "authors": "Wojdyło, A., Carbonell-Barrachina, Á. A., Legua, P., Hernández, F., & Díaz-Mula, H. M.",
        "year": 2016,
        "title": "Phenolic composition, antioxidant and biological activities of jujube fruits",
        "journal": "Food Chemistry",
        "volume": "201",
        "pages": "307-314"
      }
    ]
  }
  ,
  {
    plant: 76,
    "id": "Ficus-altissima",

    "scientific_name": "Ficus altissima ",

    "aname": "Blume",
    "common_name": "False Banyan, Council Tree",

    "local_name": "False Banyan, Council Tree",

    "image": "/Flora/plant76.jpeg",
    gallery: {

      bark: "/Flora/plant76a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant76b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Ficus-altissima",
    'qr_code': '/Flora/qrcodes/Ficus-altissima.png',

    "botanical_profile": {
      "scientific_name": "Ficus altissima ",
      "aname": "Blume",
      "common_name": "False Banyan",
      "local_name": "Council Tree",
      "family": "Moraceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Monochlamydeae",
      "series": "Unisexuales",
      "order": "Urticales",
      "family": "Moraceae",
      "genus": "Ficus",
      "species": "altissima"
    },

    "morphological_characters": "F. altissima is a large evergreen tree with a broad spreading crown. The bark is greyish to pale brown, relatively smooth when young and becoming slightly fissured with age. Leaves are simple, alternate, leathery, glossy, elliptic to oblong-elliptic with entire margins. Young leaves often display a yellowish-green coloration. Flowers are minute, unisexual and enclosed within a specialized fleshy receptacle called a syconium. Male and female flowers occur inside the fig structure. The inflorescence is a syconium arising singly or in pairs from leaf axils. Fruits are globose figs that become yellow to orange-yellow when mature and contain numerous tiny seeds embedded within the fleshy receptacle (Pullaiah & Karuppusamy, 2018; Corner, 1965; Berg & Corner, 2005; Elbadawy et al., 2026).",

    "digital_identification": {
      "habit": "Large evergreen tree",
      "bark": "Greyish to pale brown, smooth when young and slightly fissured with age",
      "leaves": "Simple, alternate, leathery, glossy, elliptic to oblong-elliptic",
      "inflorescence": "Syconium (fig)",
      "flowers": "Minute, unisexual, enclosed within syconium",
      "fruit": "Globose fig, yellow to orange-yellow when mature",
      "seed": "Numerous small seeds embedded in fleshy fig"
    },

    "phytochemical_constituents": "F. altissima contains a rich diversity of phytochemicals including chlorogenic acid, gallic acid, methyl gallate, syringic acid, p-coumaric acid, vanillin, ferulic acid, rosmarinic acid, cinnamic acid, rutin, quercetin, kaempferol, naringenin, daidzein, catechin, epicatechin, tannins, flavonoids, phenolic acids, glycosides, triterpenoids, sterols, fatty acids and antioxidant polyphenols. These compounds contribute significantly to the antioxidant, anti-inflammatory, antimicrobial and wound-healing properties of the species (Elbadawy et al., 2026; Wang et al., 2019; Mahmoudi et al., 2016; Chang et al., 2018; Zhang et al., 2020).",

    "medicinal_importance": "F. altissima possesses diverse medicinal properties. Experimental studies have demonstrated significant wound-healing activity through enhanced tissue regeneration and collagen deposition. The plant exhibits potent antioxidant activity owing to its high phenolic and flavonoid content. Anti-inflammatory activity has been associated with suppression of inflammatory mediators including TNF-α and NF-κB. Extracts have shown antimicrobial activity against Bacillus subtilis, Staphylococcus aureus, Escherichia coli, Klebsiella pneumoniae and Candida albicans. Additional studies indicate hepatoprotective, cytoprotective, antidiabetic, anticancer, immunomodulatory and free radical scavenging activities. In traditional medicine, roots, bark and leaves are used to improve blood circulation, treat inflammatory conditions, skin disorders and cardiovascular ailments (Elbadawy et al., 2026; Lansky et al., 2008; Joseph & Raj, 2011; Singh et al., 2018; Zhou et al., 2021; Rahman & Akter, 2013).",

    "economic_importance": "F. altissima is widely cultivated as an ornamental and avenue tree because of its dense evergreen canopy and attractive foliage. It is extensively planted in parks, gardens, institutional campuses and urban landscapes. The tree provides shade, improves environmental quality and supports biodiversity by supplying food and habitat for birds and wildlife. Due to its rich phytochemical profile and medicinal potential, the species is also considered a promising source of bioactive compounds for pharmaceutical, nutraceutical and cosmetic industries. Its ecological role in carbon sequestration and urban greening further enhances its economic value (Orwa et al., 2009; Warrier et al., 1993; Nadkarni, 2007; Berg & Corner, 2005).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Ficus altissima was assessed by the IUCN Red List and categorized as Least Concern (Shao et al., 2019)."
    },

    "references": [
      {
        "authors": "Berg, C. C., & Corner, E. J. H.",
        "year": 2005,
        "title": "Moraceae (Ficus)",
        "publisher": "Flora Malesiana Series I",
        "volume": "17",
        "pages": "1-730"
      },
      {
        "authors": "Chang, M. S., Yang, Y. C., Kuo, Y. H., & Chen, I. S.",
        "year": 2018,
        "title": "Phenolic constituents and antioxidant activity of Ficus species",
        "journal": "Natural Product Communications",
        "volume": "13",
        "issue": "4",
        "pages": "457-462"
      },
      {
        "authors": "Corner, E. J. H.",
        "year": 1965,
        "title": "Check-list of Ficus in Asia and Australasia with keys to identification",
        "journal": "Gardens' Bulletin Singapore",
        "volume": "21",
        "pages": "1-186"
      },
      {
        "authors": "Elbadawy, H. M., Alharbi, A. S., Aljohani, A. K. B., Alhazmi, A. B., Hudhayri, M. N., Ibrahim, S. A., et al.",
        "year": 2026,
        "title": "Phytochemical analysis, in vitro and in vivo evaluation of Ficus altissima extract-based ointment and hydrogel on wound healing",
        "journal": "BioMed Research International",
        "volume": "2026",
        "pages": "Article 5137800"
      },
      {
        "authors": "Joseph, B., & Raj, S. J.",
        "year": 2011,
        "title": "Pharmacognostic and phytochemical properties of Ficus species: An overview",
        "journal": "International Journal of Pharma and Bio Sciences",
        "volume": "2",
        "issue": "4",
        "pages": "246-253"
      },
      {
        "authors": "Lansky, E. P., Paavilainen, H. M., Pawlus, A. D., & Newman, R. A.",
        "year": 2008,
        "title": "Ficus spp. (fig): Ethnobotany and potential as anticancer and anti-inflammatory agents",
        "journal": "Journal of Ethnopharmacology",
        "volume": "119",
        "issue": "2",
        "pages": "195-213"
      },
      {
        "authors": "Mahmoudi, S., Khali, M., Benkhaled, A., Benamirouche, K., & Baiti, I.",
        "year": 2016,
        "title": "Phenolic and flavonoid contents, antioxidant and antimicrobial activities of Ficus species",
        "journal": "South African Journal of Botany",
        "volume": "105",
        "pages": "104-112"
      },
      {
        "authors": "Morton, J. F.",
        "year": 1987,
        "title": "Fruits of Warm Climates",
        "publisher": "Creative Resource Systems"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rahman, A. H. M. M., & Akter, M.",
        "year": 2013,
        "title": "Taxonomy and medicinal uses of Ficus species",
        "journal": "International Journal of Botany Studies",
        "volume": "1",
        "issue": "2",
        "pages": "15-22"
      },
      {
        "authors": "Shao, Q., Zhao, L., Botanic Gardens Conservation International (BGCI), & IUCN SSC Global Tree Specialist Group",
        "year": 2019,
        "title": "Ficus altissima",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T147483545A147650743"
      },
      {
        "authors": "Singh, D., Chaudhuri, P. K., & Kumar, V.",
        "year": 2018,
        "title": "Antioxidant and antimicrobial potential of Ficus species: A review",
        "journal": "Journal of Applied Pharmaceutical Science",
        "volume": "8",
        "issue": "6",
        "pages": "152-160"
      },
      {
        "authors": "Subramanian, P. M., & Misra, G. S.",
        "year": 1978,
        "title": "Chemical constituents of Ficus species",
        "journal": "Current Science",
        "volume": "47",
        "pages": "605-607"
      },
      {
        "authors": "Verkerke, W.",
        "year": 1989,
        "title": "Structure and function of the fig",
        "journal": "Experientia",
        "volume": "45",
        "pages": "612-622"
      },
      {
        "authors": "Wang, Y., Li, X., Zhang, H., & Liu, J.",
        "year": 2019,
        "title": "Phytochemical composition and antioxidant properties of Ficus species",
        "journal": "Molecules",
        "volume": "24",
        "issue": "14",
        "pages": "2563"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1993,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman",
        "volume": "3"
      },
      {
        "authors": "Zhang, Y., Chen, L., Zhao, X., & Huang, R.",
        "year": 2020,
        "title": "Bioactive flavonoids and pharmacological activities of Ficus species: A review",
        "journal": "Phytochemistry Reviews",
        "volume": "19",
        "issue": "6",
        "pages": "1461-1482"
      },
      {
        "authors": "Zhou, H., Wang, H., & Li, J.",
        "year": 2021,
        "title": "Recent advances in phytochemistry and biological activities of Ficus species",
        "journal": "Frontiers in Pharmacology",
        "volume": "12",
        "pages": "678-689"
      }
    ]
  }
  ,
  {
    plant: 77,
    "id": "Millingtonia-hortensis",

    "scientific_name": "Millingtonia hortensis .",

    "aname": "L.f",
    "common_name": "Indian Cork Tree, Tree Jasmine",

    "local_name": "Boddu Malli, Punnaga Malli, Indian Cork Tree, Tree Jasmine",

    "image": "/Flora/plant77.jpeg",
    gallery: {

      bark: "/Flora/plant77a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plan77b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Millingtonia-hortensis",
    'qr_code': '/Flora/qrcodes/Millingtonia-hortensis.png',

    "botanical_profile": {
      "scientific_name": "Millingtonia hortensis ",
      "aname": "L.f",
      "common_name": "Indian Cork Tree, Tree Jasmine",
      "local_name": "Boddu Malli, Punnaga Malli",
      "family": "Bignoniaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Personales",
      "family": "Bignoniaceae",
      "genus": "Millingtonia",
      "species": "hortensis"
    },

    "morphological_characters": "M. hortensis is a medium to large-sized evergreen or semi-deciduous tree reaching up to 25 m in height. The trunk is straight with greyish-brown bark that is smooth in young trees and becomes rough and fissured with age. Leaves are opposite, bipinnate, and compound with 2–3 pairs of pinnae. Leaflets are oval to lanceolate, pointed at the apex, and slightly serrated along the margins. Flowers are large, white, funnel-shaped, highly fragrant, and arranged in terminal clusters. Each flower possesses a long tubular corolla with five lobes and a yellowish throat. Fruits are elongated capsules that split open at maturity, releasing numerous winged seeds dispersed by wind (Ashokkumar et al., 2025; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large evergreen or semi-deciduous tree",
      "bark": "Greyish-brown; smooth when young, rough and fissured with age",
      "leaves": "Opposite, bipinnate, compound",
      "leaflets": "Oval to lanceolate, pointed apex, slightly serrated margins",
      "inflorescence": "Terminal clusters",
      "flowers": "White, funnel-shaped, highly fragrant",
      "fruit": "Elongated capsule",
      "seeds": "Numerous small winged seeds"
    },

    "phytochemical_constituents": "M. hortensis contains numerous bioactive compounds including flavonoids, tannins, alkaloids, terpenoids, cyclohexylethanoids, phenolic compounds, coumarins, sterols, fatty acids, and volatile aromatic constituents. Major compounds reported include hispidulin, dinatin, scutellarein, scutellarein-5-galactoside, hortensin, β-sitosterol, stigmasterol derivatives, coumarin, phytol, phytol acetate, methyl palmitate, palmitic acid, linoleic acid, linolenic acid, oleic acid derivatives, trans-isoeugenol, linalool, nerolidol, trans-farnesol, solanesol, vanillin, α-terpineol, α-farnesene, β-farnesene, β-caryophyllene, trans-β-caryophyllene, methyl anthranilate, indole, and α-curcumene. These constituents are responsible for antioxidant, antimicrobial, anti-inflammatory, antiviral, anticancer, and other biological activities (Ashokkumar et al., 2025; Choudhary et al., 2010; Kirtikar & Basu, 2006).",

    "medicinal_importance": "M. hortensis is an important medicinal plant in traditional systems of medicine. Leaves are used as antipyretic, tonic, cholagogue, and sinusitis remedies. Flowers are employed as pulmonary tonics and treatments for cough and respiratory disorders. Roots are used as antiasthmatic and lung tonic preparations. Scientific investigations have demonstrated antioxidant, antimicrobial, antibacterial, antifungal, anti-inflammatory, antiviral, anticancer, cytotoxic, antidiabetic, hepatoprotective, diuretic, sedative, anthelmintic, larvicidal, antifertility, antimutagenic, and cardiovascular protective activities. Extracts and essential oils have shown activity against Zika virus, Chikungunya virus, Mayaro virus, colon cancer cells, hepatocellular carcinoma cells, and neuroblastoma cell lines. The pharmacological activities are mainly attributed to flavonoids, terpenoids, linalool, hispidulin, solanesol, nerolidol, and trans-farnesol (Ashokkumar et al., 2025; Nadkarni, 2007; Warrier et al., 1995).",

    "economic_importance": "M. hortensis is widely cultivated as an ornamental avenue and garden tree because of its attractive foliage and fragrant flowers. The flowers are extensively used in religious ceremonies, floral decorations, and traditional cultural practices. Essential oils extracted from flowers possess commercial value in perfume, cosmetic, aromatherapy, and fragrance industries. Bioactive compounds such as linalool, nerolidol, β-caryophyllene, and solanesol have potential pharmaceutical applications. The plant also serves as a source of natural antioxidants, antimicrobial agents, and agricultural biopesticides. Its timber is occasionally utilized for light construction and handicraft purposes. The species contributes significantly to urban landscaping, environmental beautification, and pharmaceutical research (Ashokkumar et al., 2025; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2024,
      "details": "Millingtonia hortensis was assessed in the IUCN Red List of Threatened Species and categorized as Least Concern (de Kok, 2024)."
    },

    "references": [
      {
        "authors": "Ashokkumar, K., Murugan, M., Murugesan, P., & Venkatesh, T.",
        "year": 2025,
        "title": "Millingtonia hortensis L.f. (tree jasmine): Botany, ethnopharmacology, chemical constituents, biological activities of extracts and essential oils—An updated review",
        "journal": "Discover Plants",
        "volume": "2",
        "pages": "22"
      },
      {
        "authors": "Choudhary, G. P., Sharma, S. K., & Singh, K. P.",
        "year": 2010,
        "title": "Phytochemical and pharmacological profile of Millingtonia hortensis",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "5",
        "issue": "2",
        "pages": "120-126"
      },
      {
        "authors": "de Kok, R.",
        "year": 2024,
        "title": "Millingtonia hortensis",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T33708A213398360"
      },
      {
        "authors": "Duke, J. A.",
        "year": 2002,
        "title": "Handbook of Medicinal Herbs",
        "publisher": "CRC Press"
      },
      {
        "authors": "Harborne, J. B.",
        "year": 1998,
        "title": "Phytochemical Methods: A Guide to Modern Techniques of Plant Analysis",
        "publisher": "Chapman and Hall"
      },
      {
        "authors": "Joy, P. P., Thomas, J., Mathew, S., & Skaria, B. P.",
        "year": 2001,
        "title": "Medicinal Plants",
        "publisher": "Kerala Agricultural University"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Kokate, C. K., Purohit, A. P., & Gokhale, S. B.",
        "year": 2010,
        "title": "Pharmacognosy",
        "publisher": "Nirali Prakashan"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 2009,
        "title": "Compendium of Indian Medicinal Plants",
        "publisher": "CSIR"
      },
      {
        "authors": "Sharma, P. C., Yelne, M. B., & Dennis, T. J.",
        "year": 2005,
        "title": "Database on Medicinal Plants Used in Ayurveda",
        "publisher": "CCRAS"
      },
      {
        "authors": "Sivarajan, V. V., & Balachandran, I.",
        "year": 1994,
        "title": "Ayurvedic Drugs and Their Plant Sources",
        "publisher": "Oxford and IBH Publishing"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      }
    ]
  }
  ,
  {
    plant: 78,
    "id": "Plumeria-alba",

    "scientific_name": "Plumeria alba ",

    "aname": "L.",
    "common_name": "White Frangipani, West Indian Jasmine",

    "local_name": "Deva Ganneru, White Frangipani, West Indian Jasmine",

    "image": "/Flora/plant78.jpeg",
    gallery: {

      bark: "/Flora/plant78a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant78b.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Plumeria-alba",
    'qr_code': '/Flora/qrcodes/Pulmeria-alba.png',

    "botanical_profile": {
      "scientific_name": "Plumeria alba ",
      "aname": "L.",
      "common_name": "White Frangipani, West Indian Jasmine",
      "local_name": "Deva Ganneru",
      "family": "Apocynaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Magnoliopsida (Dicotyledonae)",
      "sub_class": "Asteridae (Gamopetalae)",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Plumeria",
      "species": "alba"
    },

    "morphological_characters": "P. alba is a small shrub or tree ranging from 0.9–6.1 m in height with thick, succulent, widely spaced branches bearing characteristic knobby protuberances. Leaves are clustered near the branch tips, large, dark green, leathery, glossy, obovate, and possess conspicuous parallel secondary veins extending from the midrib to the margins. Flowers occur in terminal or axillary cymes and are borne in clusters at the ends of branches. Each flower is white with a yellow center and consists of five petals fused at the base into a funnel-shaped tube. Fruits are paired dry follicles that split open upon maturity, releasing numerous winged seeds (Sura et al., 2016; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Small shrub or tree",
      "branches": "Succulent, thick, with knobby protuberances",
      "leaves": "Large, obovate, dark green, leathery and glossy",
      "inflorescence": "Terminal or axillary cyme",
      "flowers": "White flowers with yellow center, five petals fused at base",
      "fruit": "Dry follicle",
      "seeds": "Winged seeds"
    },

    "phytochemical_constituents": "P. alba contains a wide variety of phytochemicals including alkaloids, carbohydrates, flavonoids, tannins, phenolics, sterols, terpenoids, triterpenoids, glycosides, iridoid glycosides, saponins, and coumarins. Important compounds reported from different plant parts include α-amyrin, β-amyrin, amyrin acetate, β-sitosterol, scopoletin, plumericin, isoplumericin, plumieride, plumieride coumarate, plumieride coumarate glucoside, fulvoplumierin, allamcin, resinic acid, quercetin, kaempferol, rutin, lupeol, ursolic acid, and oleanolic acid. The flowers contain volatile aromatic compounds such as geraniol, citronellol, linalool, farnesol, benzyl salicylate, phenyl ethyl alcohol, and eugenol, which are responsible for the characteristic fragrance and biological activities of the plant (Sura et al., 2016; Gupta et al., 2011; Zahid et al., 2010).",

    "medicinal_importance": "P. alba has long been utilized in Ayurveda and traditional medicine for treating ulcers, herpes, scabies, skin diseases, wounds, fever, inflammation, and digestive disorders. The latex is applied externally for skin infections and ulcers, while bark preparations are used as purgative, cardiotonic, diuretic, and hypotensive remedies. Scientific studies have demonstrated antimicrobial activity against Escherichia coli, Staphylococcus aureus, Klebsiella pneumoniae, Proteus vulgaris, Pseudomonas aeruginosa, Enterococcus faecalis, and Serratia marcescens. Extracts exhibit antioxidant, anti-inflammatory, hepatoprotective, antiarthritic, antifungal, analgesic, antipyretic, larvicidal, wound-healing, and cytotoxic activities. Methanolic extracts protect against paracetamol-induced liver damage, while several iridoids and triterpenoids contribute to anti-inflammatory and antimicrobial effects. The plant is considered a promising source of natural therapeutic agents for pharmaceutical development (Sura et al., 2016; Gupta et al., 2011; Zahid et al., 2010; Warrier et al., 1995).",

    "economic_importance": "P. alba possesses considerable ornamental, medicinal, industrial, and commercial importance. It is extensively cultivated in gardens, parks, temples, roadsides, and landscapes because of its attractive foliage and fragrant flowers. Flowers are widely used in garlands, floral decorations, religious ceremonies, perfumes, cosmetics, essential oil production, and aromatherapy products. The plant serves as a valuable source of bioactive compounds utilized in herbal medicine, nutraceuticals, and pharmaceutical research. Increasing interest in its antimicrobial, hepatoprotective, antiarthritic, antioxidant, and anti-inflammatory properties has enhanced its commercial value in the herbal drug industry. The species also contributes significantly to ornamental horticulture and nursery trade in tropical and subtropical regions (Sura et al., 2016; Orwa et al., 2009).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2022,
      "details": "Plumeria alba was assessed in The IUCN Red List of Threatened Species and categorized as Least Concern (IUCN SSC Global Tree Specialist Group & BGCI, 2022)."
    },

    "references": [
      {
        "authors": "Gupta, M., Mazumder, U. K., Gomathi, P., & Selvan, V. T.",
        "year": 2011,
        "title": "Phytochemical and pharmacological profile of Plumeria alba Linn.",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "8",
        "issue": "2",
        "pages": "101-106"
      },
      {
        "authors": "IUCN SSC Global Tree Specialist Group & Botanic Gardens Conservation International (BGCI)",
        "year": 2022,
        "title": "Plumeria alba",
        "source": "The IUCN Red List of Threatened Species 2022",
        "pages": "e.T208165050A208357728"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2006,
        "title": "Indian Medicinal Plants",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2007,
        "title": "Indian Materia Medica",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 2009,
        "title": "Compendium of Indian Medicinal Plants",
        "publisher": "CSIR"
      },
      {
        "authors": "Sharma, P. C., Yelne, M. B., & Dennis, T. J.",
        "year": 2005,
        "title": "Database on Medicinal Plants Used in Ayurveda",
        "publisher": "CCRAS"
      },
      {
        "authors": "Sura, J., Dwivedi, S., & Dubey, R.",
        "year": 2016,
        "title": "Pharmacological, phytochemical, and traditional uses of Plumeria alba Linn., an Indian medicinal plant",
        "journal": "SPER Journal of Analysis and Drug Regulatory Affairs",
        "volume": "1",
        "issue": "1",
        "pages": "14-17"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Pharmacognosy",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "Zahid, N. Y., Mahmood, T., & Arshad, M.",
        "year": 2010,
        "title": "Chemical constituents and biological activities of Plumeria species: A review",
        "journal": "Journal of Medicinal Plants Research",
        "volume": "4",
        "issue": "15",
        "pages": "1523-1528"
      }
    ]
  },
  {
    plant: 79,
    "id": "Plumeria-pudica",
    "scientific_name": "Plumeria pudica ",
    "aname": "Jacq.",
    "common_name": "White Frangipani",
    "local_name": "White Frangipani, Bridal Bouquet, Fiddle-Leaf Plumeria, Deva Ganneru, Nag Champa",
    "image": "/Flora/plant79.jpeg",
    gallery: {

      bark: "/Flora/plant79a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant79b.jpeg",
      // fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },
    "qr_url": "https://rukap.edu.in/digital-flora/Plumeria-pudica",
    'qr_code': '/Flora/qrcodes/Pulmeria-pudica.png',

    "botanical_profile": {
      "scientific_name": "Plumeria pudica ",
      "aname": "Jacq.",
      "common_name": "White Frangipani",
      "local_name": "White Frangipani, Bridal Bouquet, Fiddle-Leaf Plumeria, Deva Ganneru, Nag Champa",
      "family": "Apocynaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledons",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Plumeria",
      "species": "pudica"
    },

    "morphological_characters": "P. pudica is an ornamental evergreen shrub or small tree belonging to the family Apocynaceae. It usually possesses one or two slender trunks branching near the ground and forming a broad crown. The leaves are deep green, smooth, glossy, oblong to fiddle-shaped, measuring about 5–12 cm long, with a characteristic odor and acrid taste. The inflorescence is terminal cymose. The plant bears large clusters of bright white flowers with yellow centers, giving the appearance of a bridal bouquet. Flowering is profuse and often continuous throughout the year in tropical climates. Fruits occur as paired elongated follicles that turn from green to brown when mature and contain numerous flattened seeds with membranous wings adapted for wind dispersal (Chamakuri et al., 2020).",

    "digital_identification": {
      "habit": "Ornamental evergreen shrub or small tree",
      "stem": "One or two slender trunks branching near the ground",
      "leaves": "Deep green, smooth, glossy, oblong to fiddle-shaped",
      "inflorescence": "Terminal cymose",
      "flowers": "Bright white flowers with yellow center arranged in large clusters",
      "fruit": "Paired elongated follicles turning brown at maturity",
      "seed": "Numerous flattened winged seeds"
    },

    "phytochemical_constituents": "P. pudica contains numerous bioactive phytochemicals including alkaloids, carbohydrates, glycosides, fixed oils, flavonoids, saponins, tannins, phenolic compounds, steroids, triterpenoids, terpenoids, and iridoid glycosides. Flower oil analysis has revealed the presence of benzyl salicylate, benzyl benzoate, geraniol, geranyl linalool, linalool, nerolidol, nonadecane, tricosane, pentacosane, farnesol, and other volatile aromatic constituents. The genus Plumeria is also reported to contain plumieride, plumericin, isoplumericin, fulvoplumierin, β-sitosterol, α-amyrin, β-amyrin, and related secondary metabolites responsible for various biological activities (Chamakuri et al., 2020; Bihani, 2014; Singh et al., 2017).",

    "medicinal_importance": "P. pudica has been traditionally used for the treatment of diarrhea, dysentery, cough, asthma, bronchitis, piles, fever, skin itching, blood disorders, tumors, and inflammatory diseases. Scientific studies have demonstrated antidiarrheal, anti-inflammatory, analgesic, antioxidant, antimicrobial, antifungal, anthelmintic, anti-leishmanial, hepatoprotective, cytotoxic, neuroprotective, wound-healing, antiarthritic, and larvicidal activities. Extracts have shown potential in managing ulcerative colitis, gynecological disorders, and neurodegenerative diseases including Alzheimer's disease. The pharmacological activities are mainly attributed to flavonoids, alkaloids, iridoid glycosides, terpenoids, and volatile constituents present in different plant parts (Chamakuri et al., 2020; Sura et al., 2016; Singh et al., 2017; Gupta et al., 2006; Panda & Luyten, 2018; Singh et al., 2021).",

    "economic_importance": "P. pudica is widely cultivated as an ornamental landscape plant because of its elegant foliage, attractive white flowers, and year-round blooming habit. It is extensively planted in gardens, parks, institutional campuses, road medians, temples, and urban landscapes. The flowers are used for decoration, religious offerings, garlands, and landscaping. Due to its medicinal significance and bioactive constituents, the plant is also considered a valuable resource for herbal medicine, pharmaceutical research, cosmetic products, and nutraceutical development. The ornamental nursery industry benefits significantly from its commercial cultivation.",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "Plumeria pudica was assessed by the IUCN Red List and categorized as Least Concern (Condit, 2019)."
    },

    "references": [
      {
        "authors": "Ahmad, I., Aqil, F., & Owais, M.",
        "year": 2006,
        "title": "Modern phytomedicine: Turning medicinal plants into drugs",
        "publisher": "Wiley-VCH Verlag GmbH & Co. KGaA"
      },
      {
        "authors": "Bihani, G. V.",
        "year": 2014,
        "title": "Plumeria rubra L. and Plumeria alba Linn.: A comparative review",
        "journal": "International Journal of Pharmacy and Pharmaceutical Sciences",
        "volume": "6",
        "issue": "12",
        "pages": "41–45"
      },
      {
        "authors": "Chamakuri, S. R., Suttee, A., & Mondal, P.",
        "year": 2020,
        "title": "An eye-catching and comprehensive review on Plumeria pudica Jacq. (Bridal Bouquet)",
        "journal": "Plant Archives",
        "volume": "20",
        "issue": "Supplement 2",
        "pages": "2076–2079"
      },
      {
        "authors": "Condit, R.",
        "year": 2019,
        "title": "Plumeria pudica",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T151953739A151953741"
      },
      {
        "authors": "Gupta, M., Mazumder, U. K., Gomathi, P., & Selvan, V. T.",
        "year": 2006,
        "title": "Antioxidant and hepatoprotective effects of medicinal plants",
        "journal": "Indian Journal of Experimental Biology",
        "volume": "44",
        "pages": "530–535"
      },
      {
        "authors": "Hegnauer, R.",
        "year": 1989,
        "title": "Chemotaxonomie der Pflanzen (Vol. 8)",
        "publisher": "Birkhäuser Verlag"
      },
      {
        "authors": "Kirtikar, K. R., & Basu, B. D.",
        "year": 2008,
        "title": "Indian Medicinal Plants (Vol. III)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Kumar, S., Malhotra, R., & Kumar, D.",
        "year": 2008,
        "title": "Euphoric medicinal and pharmacological potential of ornamental plants",
        "journal": "Journal of Medicinal Plants Research",
        "volume": "2",
        "issue": "12",
        "pages": "372–379"
      },
      {
        "authors": "Morton, J. F.",
        "year": 1981,
        "title": "Atlas of Medicinal Plants of Middle America",
        "publisher": "Charles C. Thomas Publishers"
      },
      {
        "authors": "Nadkarni, K. M.",
        "year": 2009,
        "title": "Indian Materia Medica (Vol. I)",
        "publisher": "Popular Prakashan"
      },
      {
        "authors": "Omino, E. A., & Kokwaro, J. O.",
        "year": 1993,
        "title": "Ethnobotany of Apocynaceae species in East Africa",
        "journal": "Journal of Ethnopharmacology",
        "volume": "40",
        "issue": "3",
        "pages": "167–180"
      },
      {
        "authors": "Panda, S. K., & Luyten, W.",
        "year": 2018,
        "title": "Antioxidant and antimicrobial activities of medicinal plants",
        "journal": "Evidence-Based Complementary and Alternative Medicine",
        "volume": "2018",
        "pages": "5498705"
      },
      {
        "authors": "Patel, R., Sharma, P., & Verma, S.",
        "year": 2018,
        "title": "Medicinal significance and pharmacological activities of Plumeria species",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "49",
        "issue": "2",
        "pages": "120–126"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rahmatullah, M., Mollik, M. A. H., & Alam, J.",
        "year": 2010,
        "title": "Medicinal plants used by folk medicinal practitioners in Bangladesh",
        "journal": "American-Eurasian Journal of Sustainable Agriculture",
        "volume": "4",
        "issue": "2",
        "pages": "170–195"
      },
      {
        "authors": "Rastogi, R. P., & Mehrotra, B. N.",
        "year": 1993,
        "title": "Compendium of Indian Medicinal Plants (Vol. 3)",
        "publisher": "Central Drug Research Institute"
      },
      {
        "authors": "Sharma, P. C., Yelne, M. B., & Dennis, T. J.",
        "year": 2005,
        "title": "Database on Medicinal Plants Used in Ayurveda (Vol. 3)",
        "publisher": "CCRAS"
      },
      {
        "authors": "Sharma, V., & Kumar, A.",
        "year": 2019,
        "title": "Phytochemistry and therapeutic applications of Plumeria species: A review",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "8",
        "issue": "5",
        "pages": "1642–1648"
      },
      {
        "authors": "Singh, A., Singh, P. K., & Kumar, V.",
        "year": 2017,
        "title": "Phytochemical screening and antimicrobial activity of Plumeria species",
        "journal": "International Journal of Pharmaceutical Sciences and Research",
        "volume": "8",
        "issue": "5",
        "pages": "2154–2161"
      },
      {
        "authors": "Singh, D., Mishra, P., & Tiwari, A.",
        "year": 2021,
        "title": "Bioactive constituents and pharmacological potential of ornamental medicinal plants of Apocynaceae",
        "journal": "Pharmacognosy Journal",
        "volume": "13",
        "issue": "3",
        "pages": "711–720"
      },
      {
        "authors": "Sura, J., Dwivedi, S., & Dubey, R.",
        "year": 2016,
        "title": "Pharmacological, phytochemical and traditional uses of Plumeria alba Linn., an Indian medicinal plant",
        "journal": "SPER Journal of Analysis and Drug Regulatory Affairs",
        "volume": "1",
        "issue": "1",
        "pages": "14–17"
      },
      {
        "authors": "Trease, G. E., & Evans, W. C.",
        "year": 2009,
        "title": "Trease and Evans Pharmacognosy (16th ed.)",
        "publisher": "Saunders Elsevier"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1995,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species (Vol. 4)",
        "publisher": "Orient Longman"
      },
      {
        "authors": "World Health Organization (WHO)",
        "year": 2003,
        "title": "WHO Guidelines on Good Agricultural and Collection Practices (GACP) for Medicinal Plants",
        "publisher": "World Health Organization"
      }
    ]
  }
  ,
  {
    plant: 80,
    "id": "Tectona-grandis",

    "scientific_name": "Tectona grandis .",
    "aname": "L.f",

   
    "common_name": "Teak",

    "local_name": "Teak",

    "image": "/Flora/plant80.jpeg",
    gallery: {

      bark: "/Flora/plant80a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant80bjpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Tectona-grandis",
    'qr_code': '/Flora/qrcodes/Tectona-grandis.png',

    "botanical_profile": {
      "scientific_name": "Tectona grandis ",
      "aname": "L.f",
      "common_name": "Teak",
      "local_name": "Teak",
      "family": "Verbenaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Lamiales",
      "family": "Verbenaceae",
      "genus": "Tectona",
      "species": "grandis"
    },

    "morphological_characters": "T. grandis is a large deciduous tree attaining heights of 30–40 m with a straight cylindrical bole. The stem is quadrangular in young branches and covered with stellate hairs. Bark is grey to brown, fibrous and longitudinally fissured. Leaves are opposite, very large, broadly elliptic to ovate, with rounded to acute base and obtuse apex, glabrescent above and densely stellate-pubescent beneath. Inflorescence is a large terminal or axillary dichotomously branched panicle. Flowers are small, white to pale yellow, bisexual, and borne in large clusters. Calyx campanulate, shortly 5–6 lobed and enlarging during fruit development. Corolla tubular with spreading lobes. Fruit is a drupe enclosed within the persistent enlarged calyx. Seeds are oblong and enclosed within a hard endocarp. The species occurs naturally in tropical deciduous forests and is extensively cultivated for timber production (Pullaiah & Chennaiah, 1997; Pullaiah & Karuppusamy, 2018).",

    "digital_identification": {
      "habit": "Large deciduous tree",
      "stem": "Quadrangular in young branches, stellately tomentose",
      "bark": "Grey-brown, fibrous and fissured",
      "leaves": "Very large, broadly elliptic to ovate, opposite, glabrescent above and stellate pubescent below",
      "inflorescence": "Large terminal or axillary dichotomous panicles",
      "flowers": "Small, white or pale yellow, bisexual",
      "calyx": "Campanulate, shortly 5–6 lobed",
      "fruit": "Drupe enclosed within enlarged persistent calyx",
      "seeds": "Oblong"
    },

    "phytochemical_constituents": "T. grandis contains a rich diversity of phytochemicals distributed in roots, bark, leaves, seeds, heartwood and flowers. Major compounds include quinones such as tectoquinone, lapachol, deoxylapachol, dehydro-α-lapachone, tecomaquinone-I and anthraquinones. Other constituents include tectol, tectograndinol, betulinic acid, β-sitosterol, squalene, polyisoprene, gallic acid, ellagic acid, rutin, quercetin, acetovanillone, lignans (syringaresinol, medioresinol, lariciresinol), norlignans (tectonoelin A and B), apocarotenoids (tectoionols A and B), cardiac glycosides, alkaloids, flavonoids, tannins, phenolics, terpenoids, steroids, carbohydrates, proteins and saponins. These compounds contribute significantly to the biological and medicinal activities of teak (Kolli et al., 2022; Prabhanjan et al., 2022).",

    "medicinal_importance": "T. grandis possesses extensive medicinal applications in traditional and modern medicine. Different parts of the plant are used for treating bronchitis, urinary disorders, inflammation, skin diseases, wounds, dysentery, headache and diabetes. Scientific studies have demonstrated antioxidant, antibacterial, antifungal, antiviral, antiplasmodial, anti-inflammatory, analgesic, antipyretic, antidiabetic, antiarthritic, hepatoprotective, immunomodulatory, antiulcer, wound-healing, cytotoxic, anticancer and hair growth-promoting activities. Quinones, flavonoids, tannins and phenolic compounds are considered the major contributors to these pharmacological properties. Extracts from leaves, bark, roots and seeds have shown significant antimicrobial activity against several pathogenic microorganisms and potential therapeutic value in drug development (Kolli et al., 2022; Prabhanjan et al., 2022; Sandermann & Simatupang, 1966; Nayeem & Karvekar, 2011).",

    "economic_importance": "T. grandis is among the most valuable commercial timber species worldwide. Teak wood is renowned for its durability, dimensional stability, attractive grain pattern and natural resistance to termites, fungi and decay. It is extensively used in shipbuilding, furniture manufacturing, flooring, paneling, construction, railway sleepers and luxury interior decoration. Seed oil is used in hair-care products and traditional medicine. Natural dyes obtained from leaves and wood are utilized in textile industries. Teak plantations contribute substantially to forestry economies in Asia, Africa and Latin America. The species is also cultivated in agroforestry systems and environmental restoration programs because of its adaptability and economic returns (Pandey & Brown, 2000; Kolli et al., 2022).",

    "conservation_status": {
      "IUCN_status": "Endangered",
      "assessment_year": 2022,
      "details": "T. grandis was assessed in the IUCN Red List of Threatened Species and categorized as Endangered under criterion A2cd (Gua et al., 2022)."
    },

    "references": [
      {
        "authors": "Bhat, K. M., Priya, P. B., & Rugmini, P.",
        "year": 2001,
        "title": "Characterisation of juvenile wood in teak",
        "journal": "Wood Science and Technology",
        "volume": "34",
        "pages": "517-532"
      },
      {
        "authors": "Gua, B., Pedersen, A., & Barstow, M.",
        "year": 2022,
        "title": "Tectona grandis",
        "source": "The IUCN Red List of Threatened Species 2022",
        "pages": "e.T62019830A62019832"
      },
      {
        "authors": "Hillis, W. E.",
        "year": 1987,
        "title": "Heartwood and Tree Exudates",
        "publisher": "Springer-Verlag"
      },
      {
        "authors": "Kjaer, E. D., Lauridsen, E. B., & Wellendorf, H.",
        "year": 1999,
        "title": "Second evaluation of an international series of teak provenance trials",
        "journal": "Danida Forest Seed Centre"
      },
      {
        "authors": "Kolli, P. K., Obbalareddy, S., Yejella, R. P., Athili, L. D., & Ponnada, S.",
        "year": 2022,
        "title": "A review on Tectona grandis",
        "journal": "International Journal of Research in Pharmacy and Chemistry",
        "volume": "12",
        "issue": "3",
        "pages": "359-394"
      },
      {
        "authors": "Krishnapillay, B.",
        "year": 2000,
        "title": "Silviculture and Management of Teak Plantations",
        "publisher": "Unasylva"
      },
      {
        "authors": "Lukmandaru, G., Takahashi, K., & Otani, M.",
        "year": 2009,
        "title": "Extractives of teak heartwood and their biological activity",
        "journal": "Journal of Wood Science",
        "volume": "55",
        "pages": "469-476"
      },
      {
        "authors": "Nayeem, N., & Karvekar, M. D.",
        "year": 2011,
        "title": "Anti-inflammatory and antioxidant activity of Tectona grandis leaves",
        "journal": "International Journal of Pharmacy and Pharmaceutical Sciences",
        "volume": "3",
        "issue": "1",
        "pages": "160-164"
      },
      {
        "authors": "Pandey, D., & Brown, C.",
        "year": 2000,
        "title": "Teak: A Global Overview",
        "publisher": "FAO Forestry Department"
      },
      {
        "authors": "Prabhanjan, P., Rao, K. V., Kumar, P. S., & Reddy, M. S.",
        "year": 2022,
        "title": "Phytochemistry and pharmacological activities of Tectona grandis: A comprehensive review",
        "journal": "Journal of Pharmacognosy and Phytochemistry",
        "volume": "11",
        "issue": "4",
        "pages": "105-118"
      },
      {
        "authors": "Pullaiah, T., & Chennaiah, E.",
        "year": 1997,
        "title": "Flora of Andhra Pradesh (Vol. 2)",
        "publisher": "Scientific Publishers"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rao, K. S., & Ganeshaiah, K. N.",
        "year": 2001,
        "title": "Conservation and utilization of teak genetic resources",
        "journal": "Current Science",
        "volume": "80",
        "issue": "3",
        "pages": "340-344"
      },
      {
        "authors": "Reddy, N. S., & Rao, J. V.",
        "year": 2014,
        "title": "Antimicrobial activity of Tectona grandis leaf extracts",
        "journal": "International Journal of Pharmacy and Biological Sciences",
        "volume": "4",
        "issue": "2",
        "pages": "124-131"
      },
      {
        "authors": "Sandermann, W., & Simatupang, M. H.",
        "year": 1966,
        "title": "On the chemistry and biochemistry of teak wood",
        "journal": "Holzforschung",
        "volume": "20",
        "pages": "190-192"
      },
      {
        "authors": "Shukla, S., Mehta, A., John, J., Singh, S., & Mehta, P.",
        "year": 2009,
        "title": "Antioxidant activity and total phenolic content of ethanolic extracts of Tectona grandis leaves",
        "journal": "Food and Chemical Toxicology",
        "volume": "47",
        "issue": "8",
        "pages": "1848-1854"
      },
      {
        "authors": "Tewari, D. N.",
        "year": 1992,
        "title": "A Monograph on Teak (Tectona grandis Linn. f.)",
        "publisher": "International Book Distributors"
      },
      {
        "authors": "Verhaegen, D., Fofana, I. J., Logossa, Z. A., & Ofori, D.",
        "year": 2010,
        "title": "What is the genetic origin of teak planted in Africa and in Indonesia?",
        "journal": "Tree Genetics & Genomes",
        "volume": "6",
        "pages": "717-733"
      },
      {
        "authors": "White, K.",
        "year": 1991,
        "title": "Teak: Some aspects of research and development",
        "journal": "FAO Regional Office for Asia and the Pacific"
      },
      {
        "authors": "Yasodha, R., Sumathi, R., Gurumurthi, K., & Kumar, P.",
        "year": 2008,
        "title": "Micropropagation of teak (Tectona grandis L.f.) and its applications",
        "journal": "New Forests",
        "volume": "37",
        "pages": "205-218"
      }
    ]
  }
  ,
  {
    plant: 81,
    "id": "Carissa-carandas",

    "scientific_name": "Carissa carandas ",

    "aname": "L.",
    "common_name": "Karonda, Christ's Thorn, Carandas Plum",

    "local_name": "Pedda Kalivi",

    "image": "/Flora/plant81.jpeg",
    gallery: {

      bark: "/Flora/plant81a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      flower: "/Flora/plant81b.jpeg",
      fruit: "/Flora/plant81c.jpeg",
      seed: "/Flora/plant81d.jpeg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Carissa-carandas",
    'qr_code': '/Flora/qrcodes/Carissa-carandas.png',

    "botanical_profile": {
      "scientific_name": "Carissa carandas ",
      "aname": "L.",
      "common_name": "Karonda, Christ's Thorn, Carandas Plum",
      "local_name": "Pedda Kalivi",
      "family": "Apocynaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "division": "Angiosperms",
      "class": "Dicotyledonae",
      "sub_class": "Gamopetalae",
      "series": "Bicarpellatae",
      "order": "Gentianales",
      "family": "Apocynaceae",
      "genus": "Carissa",
      "species": "carandas"
    },

    "morphological_characters": "Carissa carandas is a thorny evergreen shrub or small tree commonly known as Karonda. The bark is rough, grey to dark brown in color and exudes milky latex when injured. Branches are numerous, rigid, spreading, and armed with characteristic sharp forked (Y-shaped) thorns. Leaves are simple, opposite, thick, leathery, smooth, glossy dark green, and elliptic to ovate in shape. Flowers are small, fragrant, white or pinkish-white, tubular, and five-petaled. Inflorescences occur as terminal or axillary cymes. Fruits are fleshy berries, round to oval, changing from green when immature to red, purple, or nearly black at maturity. Each fruit contains 3–8 small, flat, brown seeds (Pullaiah & Karuppusamy, 2018; Orwa et al., 2009; Bhosale et al., 2020).",

    "digital_identification": {
      "habit": "Evergreen shrub or small tree",
      "bark": "Rough, grey to dark brown, exudes milky latex",
      "branches": "Rigid, spreading with forked Y-shaped thorns",
      "leaves": "Simple, opposite, thick, leathery and glossy",
      "flowers": "Small, white or pinkish-white, tubular, fragrant",
      "inflorescence": "Terminal or axillary cymes",
      "fruit": "Fleshy berry, green turning red, purple or black",
      "seeds": "Small, flat, brown, 3–8 per fruit"
    },

    "phytochemical_constituents": "C. carandas contains a rich diversity of bioactive phytochemicals including alkaloids, flavonoids, tannins, saponins, terpenoids, cardiac glycosides, phenolic compounds, triterpenoids, steroids, carbohydrates, and organic acids. Fruits are particularly rich in vitamin C, iron, anthocyanins, and antioxidant compounds. Important constituents reported include carissone, carindone, lupeol, ursolic acid, oleanolic acid, β-sitosterol, flavonoids, phenolics, and anthocyanins. These phytochemicals are responsible for the antioxidant, antimicrobial, anti-inflammatory, hepatoprotective, and nutraceutical properties of the species (Bhosale et al., 2020; Mali et al., 2013; Singh et al., 2020; Dhatwalia et al., 2021; Kaunda & Zhang, 2017).",

    "medicinal_importance": "C. carandas is extensively utilized in Ayurveda, Unani, Siddha, and folk medicine. The roots are used as stomachic, vermifuge, anthelmintic, antidiarrheal, and antiscorbutic agents. Unripe fruits possess astringent properties, whereas ripe fruits are used to alleviate vitamin C deficiency, anemia, and digestive disorders. Leaf decoctions are traditionally administered for fever, diarrhea, earache, oral inflammation, and skin ailments. Pharmacological investigations have demonstrated antioxidant, anti-inflammatory, anticonvulsant, antimicrobial, antiviral, cardiotonic, hepatoprotective, antirheumatic, wound-healing, antidiabetic, and free-radical scavenging activities. These therapeutic effects are largely attributed to flavonoids, phenolics, triterpenoids, and vitamin-rich fruit extracts (Bhosale et al., 2020; Mali et al., 2013; Singh et al., 2020; Kaunda & Zhang, 2017; Dhatwalia et al., 2021; Saeed et al., 2024; Warrier et al., 1996).",

    "economic_importance": "C. carandas has substantial economic importance as a fruit crop, medicinal plant, and protective hedge species. The fruits are widely processed into pickles, jams, jellies, squashes, syrups, chutneys, candies, and preserves owing to their characteristic acidic flavor and high nutritional value. The thorny nature of the plant makes it ideal for live fencing and boundary plantations. The fruits serve as a valuable source of natural antioxidants, vitamin C, iron, and anthocyanins, increasing their demand in nutraceutical and functional food industries. Additionally, the wood is occasionally used as fuel and for small agricultural implements. Growing interest in herbal medicine and natural health products has further enhanced its pharmaceutical and commercial significance (Orwa et al., 2009; Azeez et al., 2016; Dhatwalia et al., 2021; Thakur et al., 2025; Bhosale et al., 2020).",

    "conservation_status": {
      "IUCN_status": "Data Deficient",
      "assessment_year": 2024,
      "details": "C. carandas was assessed for the IUCN Red List and categorized as Data Deficient (DD) by the IUCN SSC Global Tree Specialist Group and Botanic Gardens Conservation International (BGCI) (IUCN SSC Global Tree Specialist Group & BGCI, 2024)."
    },

    "references": [
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Bhosale, S. V., Shete, R. V., Adak, V. S., & Murthy, K.",
        "year": 2020,
        "title": "A Review on Carissa carandas: Traditional Use, Phytochemical Constituents, and Pharmacological Properties",
        "journal": "Journal of Drug Delivery and Therapeutics",
        "volume": "10",
        "issue": "6-s",
        "pages": "145-150"
      },
      {
        "authors": "Mali, P. Y., Panchal, S. S., & Patel, J. A.",
        "year": 2013,
        "title": "Carissa carandas Linn.: An Ethnopharmacological Review",
        "journal": "International Journal of Pharmaceutical Sciences Review and Research",
        "volume": "20",
        "issue": "2",
        "pages": "18-25"
      },
      {
        "authors": "Singh, S., Bajpai, M., & Mishra, P.",
        "year": 2020,
        "title": "Carissa carandas L. – Phyto-pharmacological Review",
        "journal": "Journal of Pharmacy and Pharmacology",
        "volume": "72",
        "issue": "12",
        "pages": "1694-1714",
        "doi": "10.1111/jphp.13328"
      },
      {
        "authors": "Dhatwalia, J., Kumari, A., Verma, R., Upadhyay, N., Guleria, I., Lal, S., et al.",
        "year": 2021,
        "title": "Phytochemistry, Pharmacology and Nutraceutical Profile of Carissa Species: An Updated Review",
        "journal": "Molecules",
        "volume": "26",
        "issue": "22",
        "pages": "7010",
        "doi": "10.3390/molecules26227010"
      },
      {
        "authors": "Kaunda, J. S., & Zhang, Y. J.",
        "year": 2017,
        "title": "The Genus Carissa: An Ethnopharmacological, Phytochemical and Pharmacological Review",
        "journal": "Natural Products and Bioprospecting",
        "volume": "7",
        "issue": "2",
        "pages": "181-199",
        "doi": "10.1007/s13659-017-0123-0"
      },
      {
        "authors": "Saeed, W., Ismail, T., Qamar, M., & Esatbeyoglu, T.",
        "year": 2024,
        "title": "Bioactivity Profiling and Phytochemical Analysis of Carissa carandas Extracts",
        "journal": "Antioxidants",
        "volume": "13",
        "issue": "9",
        "pages": "1037",
        "doi": "10.3390/antiox13091037"
      },
      {
        "authors": "Azeez, S., Karunakaran, G., Tripathi, P. C., Shivashankara, K. S., & Roy, T. K.",
        "year": 2016,
        "title": "Evaluation of Antioxidant Activity, Total Phenolics and Phytochemical Content of Selected Varieties of Karonda Fruits",
        "journal": "Indian Journal of Agricultural Sciences",
        "volume": "86",
        "issue": "6",
        "pages": "779-784"
      },
      {
        "authors": "Thakur, S., Kathuria, D., Bhardwaj, G., Kaur, R., & Sharma, A.",
        "year": 2025,
        "title": "Phytochemistry, Traditional Uses, Pharmacology, Nutritional Composition and Agrotechnology of Underutilized Wild Fruit Plant Carissa carandas L.",
        "journal": "Chemistry & Biodiversity",
        "volume": "22",
        "issue": "8",
        "pages": "e202402193",
        "doi": "10.1002/cbdv.202402193"
      },
      {
        "authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
        "year": 2009,
        "title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
        "publisher": "World Agroforestry Centre (ICRAF)"
      },
      {
        "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
        "year": 1996,
        "title": "Indian Medicinal Plants: A Compendium of 500 Species",
        "publisher": "Orient Longman"
      },
      {
        "authors": "IUCN SSC Global Tree Specialist Group & Botanic Gardens Conservation International (BGCI)",
        "year": 2024,
        "title": "Carissa carandas",
        "source": "The IUCN Red List of Threatened Species 2024",
        "pages": "e.T226776145A227965792",
        "doi": "10.2305/IUCN.UK.2024-2.RLTS.T226776145A227965792.en"
      }
    ]
  }
  ,
  {
    plant: 82,
    "id": "Terminalia-mantaly",

    "scientific_name": "Terminalia mantaly ",

    "aname": "H.Perrier",
    "common_name": "Madagascar Almond, Umbrella Tree",

    "local_name": "Madagascar Almond, Umbrella Tree",

    "image": "/Flora/plant82.jpeg",
    gallery: {

      bark: "/Flora/plant82a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      //fruit: "/Flora/plant5b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },

    "qr_url": "https://rukap.edu.in/digital-flora/Terminalia-mantaly",
    'qr_code': '/Flora/qrcodes/Terminalia-mantaly.png',

    "botanical_profile": {
      "scientific_name": "Terminalia mantaly ",
      "aname": "H.Perrier",
      "common_name": "Madagascar Almond, Umbrella Tree",
      "local_name": "Madagascar Almond, Umbrella Tree",
      "family": "Combretaceae"
    },

    "taxonomic_classification": {
      "kingdom": "Plantae",
      "class": "Dicotyledonae",
      "sub_class": "Polypetalae",
      "series": "Calyciflorae",
      "order": "Myrtales",
      "family": "Combretaceae",
      "genus": "Terminalia",
      "species": "mantaly"
    },

    "morphological_characters": "T. mantaly is a mesophytic woody tree native to Madagascar and widely cultivated in tropical and subtropical regions as a shade and ornamental tree. It grows up to 20–25 m tall and develops a distinctive flat-topped crown with horizontally arranged branches. The trunk is straight, unarmed, and covered with smooth ashy-grey bark. Leaves are simple, obovate, glabrous, bright green when young and dark green at maturity, arranged in terminal rosettes along branchlets. Leaf margins are characteristically undulating (wavy), apex obtuse, base acute, and petioles very short or sub-sessile. Venation is cladodromous, an important diagnostic feature. Inflorescences are clustered axillary spikes bearing small cream-white actinomorphic flowers. Sepals are connate and acute, petals absent, and stamens conspicuous. Fruits are one-seeded fleshy drupes, ovoid to elliptic, changing from green or purplish when immature to yellow-red at maturity. Seeds are spindle-shaped, smooth, and glabrous (Akinsulire et al., 2018).",

    "digital_identification": {
      "habit": "Mesophytic woody tree",
      "stem": "Straight, unarmed, smooth ashy-grey bark",
      "leaves": "Obovate, glabrous, terminal rosettes, undulating margins, cladodromous venation",
      "petiole": "Very short and sub-sessile",
      "inflorescence": "Clustered axillary spikes",
      "flowers": "Small, cream-white, actinomorphic, petals absent",
      "sepals": "Connate and acute",
      "fruit": "One-seeded fleshy drupe, ovoid to elliptic",
      "seeds": "Spindle-shaped and glabrous"
    },

    "phytochemical_constituents": "T. mantaly contains numerous bioactive phytochemicals including alkaloids, flavonoids, tannins, phenolic compounds, saponins, cardiac glycosides, steroids, triterpenoids, anthraquinones, coumarins, reducing sugars, proteins, and carbohydrates. FTIR studies revealed the presence of alcohol, phenol, aldehyde, ketone, ester, and carboxylic acid functional groups. Several Terminalia-specific polyphenols such as gallic acid, ellagic acid, chebulagic acid, chebulinic acid, corilagin, punicalagin, rutin, quercetin, kaempferol, and luteolin derivatives have also been reported from related studies. These compounds contribute significantly to the plant's antioxidant, antimicrobial, and therapeutic activities (Yunusa et al., 2025; Masoko & Eloff, 2005; Cock, 2015).",

    "medicinal_importance": "T. mantaly possesses significant medicinal properties. Leaf extracts exhibit strong antioxidant activity through free-radical scavenging mechanisms and have demonstrated antibacterial activity against Staphylococcus aureus, Escherichia coli, Salmonella typhi, Pseudomonas aeruginosa, and other pathogenic microorganisms. Traditional uses include the treatment of wounds, gastrointestinal disorders, diarrhea, dysentery, fever, skin infections, and inflammatory conditions. Scientific investigations have reported antimicrobial, antioxidant, anti-inflammatory, hepatoprotective, antidiabetic, cytotoxic, antiparasitic, and wound-healing activities. The abundance of phenolics, flavonoids, tannins, and triterpenes contributes to these biological effects, highlighting the species as a potential source of pharmaceutical agents (Yunusa et al., 2025; Masoko & Eloff, 2005; Cock, 2015; Fyhrquist et al., 2002).",

    "economic_importance": "T. mantaly is widely cultivated as an ornamental and avenue tree because of its attractive umbrella-shaped canopy and tolerance to urban environments. It is extensively planted in parks, gardens, institutional campuses, highways, and landscaping projects. The species provides shade, improves urban aesthetics, and contributes to environmental conservation. Its phytochemical-rich extracts have potential applications in pharmaceutical, nutraceutical, cosmetic, and herbal medicine industries. Bioactive compounds exhibiting antimicrobial and antioxidant properties may be utilized in developing natural health products. Toxicity observed against brine shrimp larvae suggests possible applications in eco-friendly biopesticide development and agricultural pest management (Yunusa et al., 2025).",

    "conservation_status": {
      "IUCN_status": "Least Concern",
      "assessment_year": 2019,
      "details": "T. mantaly was assessed in the IUCN Red List of Threatened Species and categorized as Least Concern (Rajaovelona, 2019)."
    },

    "references": [
      {
        "authors": "Akinsulire, O. P., Oladipo, O. T., Illoh, H. C., & Mudasiru, O. M.",
        "year": 2018,
        "title": "Vegetative and reproductive morphological study of some species in the family Combretaceae in Nigeria",
        "journal": "Ife Journal of Science",
        "volume": "20",
        "issue": "2",
        "pages": "371-389"
      },
      {
        "authors": "Cock, I. E.",
        "year": 2015,
        "title": "The medicinal properties and phytochemistry of plants of the genus Terminalia",
        "journal": "Progress in Drug Research",
        "volume": "69",
        "pages": "65-109"
      },
      {
        "authors": "Eloff, J. N., Katerere, D. R., & McGaw, L. J.",
        "year": 2008,
        "title": "The biological activity and chemistry of the southern African Combretaceae",
        "journal": "Journal of Ethnopharmacology",
        "volume": "119",
        "issue": "3",
        "pages": "686-699"
      },
      {
        "authors": "Fyhrquist, P., Mwasumbi, L., Hæggström, C. A., Vuorela, H., Hiltunen, R., & Vuorela, P.",
        "year": 2002,
        "title": "Ethnobotanical and antimicrobial investigation on selected species of Terminalia",
        "journal": "Journal of Ethnopharmacology",
        "volume": "79",
        "issue": "2",
        "pages": "169-177"
      },
      {
        "authors": "Masoko, P., & Eloff, J. N.",
        "year": 2005,
        "title": "The diversity of antifungal compounds of Terminalia species",
        "journal": "South African Journal of Botany",
        "volume": "71",
        "issue": "3-4",
        "pages": "444-448"
      },
      {
        "authors": "Pullaiah, T., & Karuppusamy, S.",
        "year": 2018,
        "title": "Taxonomy of Angiosperms",
        "publisher": "Regency Publications"
      },
      {
        "authors": "Rajaovelona, L. R.",
        "year": 2019,
        "title": "Terminalia mantaly",
        "source": "The IUCN Red List of Threatened Species 2019",
        "pages": "e.T128091369A128098506"
      },
      {
        "authors": "Randrianarivelojosia, M., Rasidimanana, V., Rabarison, H., Cheplogoi, P. K., & Ratsimamanga, S.",
        "year": 2010,
        "title": "Chemical constituents and biological activities of Malagasy medicinal plants including Terminalia species",
        "journal": "Natural Product Communications",
        "volume": "5",
        "issue": "7",
        "pages": "1091-1096"
      },
      {
        "authors": "Yunusa, A. Y., Yakasai, M. A., & Namadina, M. M.",
        "year": 2025,
        "title": "Evaluation of phytochemical composition, antioxidant activity, and antibacterial properties of Terminalia mantaly H. Perrier leaf extract",
        "journal": "Dutse Journal of Pure and Applied Sciences",
        "volume": "10",
        "issue": "4A",
        "pages": "60-69"
      }
    ]
  },
  {
    'plant': 83,
  "id": "Phyllanthus-emblica",

  "scientific_name": "Phyllanthus emblica L.",

  "common_name": "Indian Gooseberry, Amla",

  "local_name": "Usiri, Amla",

  "image": "/Flora/plant83.jpeg",

  "qr_url": "https://rukap.edu.in/plants/Phyllanthus-emblica",
  'qr_code': '/Flora/qrcodes/Phyllanthus-emblica.png',

  gallery: {

      bark: "/Flora/plant83a.jpeg",
      // leaf: "/Flora/plant5/leaf.jpg",
      //flower: "/Flora/plant5c.jpeg",
      fruit: "/Flora/plant83b.jpeg",
      // seed: "/Flora/plant5/seed.jpg"
    },
  "botanical_profile": {
    "scientific_name": "Phyllanthus emblica L.",
    "common_name": "Indian Gooseberry, Amla",
    "local_name": "Usiri, Amla",
    "family": "Phyllanthaceae"
  },

  "taxonomic_classification": {
    "kingdom": "Plantae",
    "division": "Angiosperms",
    "class": "Dicotyledonae",
    "sub_class": "Monochlamydeae",
    "series": "Unisexuales",
    "order": "Malpighiales",
    "family": "Phyllanthaceae",
    "genus": "Phyllanthus",
    "species": "emblica"
  },

  "morphological_characters": "P. emblica is a small to medium-sized deciduous tree reaching 8–18 m in height. The bark is light grey to brown and exfoliates in irregular flakes. Branchlets are terete, finely pubescent and bear numerous closely arranged leaves, giving a pinnate appearance. Leaves are simple, oblong, subsessile, entire, truncate to subcordate at the base and apiculate at the apex. Flowers are greenish-yellow and borne in axillary fascicles; male flowers are numerous and occur in the upper axils, whereas female flowers are fewer and found in the lower axils. Fruits are nearly spherical, smooth, fleshy drupes, pale greenish-yellow when ripe, with six vertical furrows. Seeds are trigonous and enclosed within a hard endocarp. The species is widely distributed in tropical and subtropical regions of India, particularly in dry deciduous forests and cultivated lands (Pullaiah & Moulali, 1997; Pullaiah & Karuppusamy, 2018).",

  "digital_identification": {
    "habit": "Small to medium-sized deciduous tree",
    "bark": "Light grey to brown, exfoliating",
    "branches": "Terete, finely pubescent",
    "leaves": "Simple, oblong, subsessile, entire",
    "leaf_base": "Truncate to subcordate",
    "inflorescence": "Axillary fascicles",
    "flowers": "Greenish-yellow; male flowers numerous in upper axils, female flowers few in lower axils",
    "fruit": "Globose fleshy drupe with six furrows",
    "seed": "Trigonous, crustaceous"
  },

  "phytochemical_constituents": "P. emblica is one of the richest natural sources of vitamin C and contains numerous biologically active phytochemicals. Major constituents include hydrolysable tannins such as emblicanin A, emblicanin B, punigluconin, pedunculagin and chebulagic acid. The fruits are also rich in gallic acid, ellagic acid, corilagin, flavonoids, quercetin, kaempferol, phyllembelic acid, alkaloids, amino acids, pectin and various polyphenols. Studies have demonstrated strong antioxidant activity attributed to the synergistic action of vitamin C and tannoid compounds. These metabolites contribute significantly to free-radical scavenging, anti-inflammatory and therapeutic properties of the plant (Baliga & Dsouza, 2011; Gupta et al., 2024; Krishnaveni & Mirunalini, 2010).",

  "medicinal_importance": "P. emblica is one of the most important medicinal plants in Ayurveda and is a principal ingredient of formulations such as Triphala and Chyawanprash. Scientific studies have reported antioxidant, antidiabetic, hepatoprotective, cardioprotective, gastroprotective, antimicrobial, anti-inflammatory, immunomodulatory and anticancer activities. Fruit extracts have been shown to reduce oxidative stress, improve lipid profiles, enhance liver function and regulate blood glucose levels. Experimental studies also indicate protective effects against neurodegenerative disorders and age-related diseases. Due to its exceptionally high antioxidant potential, the species is widely utilized in preventive healthcare and nutraceutical formulations (Baliga & Dsouza, 2011; Krishnaveni & Mirunalini, 2010; Gupta et al., 2024).",

  "economic_importance": "P. emblica possesses enormous economic value in pharmaceutical, nutraceutical, food-processing and cosmetic industries. Fruits are extensively used for the preparation of Chyawanprash, Triphala, herbal medicines, syrups, candies, pickles, juices, jams and dietary supplements. The fruit extract is incorporated into hair oils, shampoos, conditioners, face packs and anti-aging cosmetic formulations due to its antioxidant and rejuvenating properties. The timber is occasionally used for small implements, while fruits generate substantial income for rural communities and herbal industries. Large-scale cultivation of amla contributes significantly to the medicinal plant economy of India and supports export-oriented herbal product manufacturing (Government of India, 2023; Gupta et al., 2024; Baliga & Dsouza, 2011).",

  "conservation_status": {
    "IUCN_status": "Least Concern",
    "assessment_year": 2020,
    "details": "Phyllanthus emblica was assessed for the IUCN Red List and categorized as Least Concern (LC). The species is widely distributed across South and Southeast Asia and maintains stable populations in both natural and cultivated habitats (Chaudhary, 2020)."
  },

  "traditional_uses": "In traditional Indian medicine, fruits are used as a rejuvenating tonic, digestive aid and immunity enhancer. The fruit is prescribed for cough, asthma, dyspepsia, anemia, constipation and diabetes. Leaves and bark are employed in treating diarrhea, wounds and inflammatory conditions. In Ayurveda, the plant is regarded as a Rasayana drug that promotes longevity and overall health.",

  "ecological_significance": "P. emblica contributes to biodiversity conservation and ecological restoration in dry deciduous ecosystems. The fruits serve as a food source for birds, mammals and other wildlife, aiding seed dispersal. The species is frequently planted in agroforestry systems, wasteland reclamation projects and medicinal plant gardens because of its drought tolerance and adaptability to varied soil conditions (Orwa et al., 2009; Warrier et al., 1996; Pullaiah & Moulali, 1997).",

  "references": [
    {
      "authors": "Baliga, M. S., & Dsouza, J. J.",
      "year": 2011,
      "title": "Amla (Emblica officinalis Gaertn), a wonder berry in the treatment and prevention of cancer",
      "journal": "European Journal of Cancer Prevention",
      "volume": "20",
      "issue": "3",
      "pages": "225-239"
    },
    {
      "authors": "Chaudhary, R.",
      "year": 2020,
      "title": "Phyllanthus emblica",
      "journal": "The IUCN Red List of Threatened Species",
      "identifier": "e.T149444430A149548926"
    },
    {
      "authors": "Government of India",
      "year": 2023,
      "title": "National Medicinal Plants Board: Amla cultivation and utilization",
      "publisher": "Ministry of AYUSH"
    },
    {
      "authors": "Gupta, A., Kumar, A., & Ghosh, T.",
      "year": 2024,
      "title": "An in-depth review on phytochemistry and pharmacological significance of Phyllanthus emblica Linn",
      "source": "ResearchGate Review Article"
    },
    {
      "authors": "Krishnaveni, M., & Mirunalini, S.",
      "year": 2010,
      "title": "Therapeutic potential of Phyllanthus emblica (Amla): The Ayurvedic wonder",
      "journal": "Journal of Basic and Clinical Physiology and Pharmacology",
      "volume": "21",
      "issue": "1",
      "pages": "93-105"
    },
    {
      "authors": "Nadkarni, K. M.",
      "year": 2009,
      "title": "Indian Materia Medica",
      "publisher": "Popular Prakashan"
    },
    {
"authors": "Orwa, C., Mutua, A., Kindt, R., Jamnadass, R., & Simons, A.",
"year": 2009,
"title": "Agroforestree Database: A Tree Reference and Selection Guide Version 4.0",
"publisher": "World Agroforestry Centre (ICRAF)"
},
{
      "authors": "Pullaiah, T., & Moulali, D. A.",
      "year": 1997,
      "title": "Flora of Andhra Pradesh (Vol. 2)",
      "publisher": "Scientific Publishers, Jodhpur"
    },
    {
      "authors": "Pullaiah, T., & Karuppusamy, S.",
      "year": 2018,
      "title": "Taxonomy of Angiosperms",
      "publisher": "Regency Publications"
    },
    {
      "authors": "Warrier, P. K., Nambiar, V. P. K., & Ramankutty, C.",
      "year": 1996,
      "title": "Indian Medicinal Plants: A Compendium of 500 Species (Vol. 4)",
      "publisher": "Orient Longman"
    }
  ]
}








































































];
export default digitalFloraData;